/*!
 * enquire.min.js
 *
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!(function (e, t, n) {
    var i = window.matchMedia;
    "undefined" != typeof module && module.exports
        ? (module.exports = n(i))
        : "function" == typeof define && define.amd
          ? define(function () {
                return (t[e] = n(i));
            })
          : (t[e] = n(i));
})("enquire", this, function (e) {
    "use strict";
    function t(e, t) {
        var n,
            i = 0,
            o = e.length;
        for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
    }
    function n(e) {
        return "[object Array]" === Object.prototype.toString.apply(e);
    }
    function i(e) {
        return "function" == typeof e;
    }
    function o(e) {
        (this.options = e), !e.deferSetup && this.setup();
    }
    function r(t, n) {
        (this.query = t), (this.isUnconditional = n), (this.handlers = []), (this.mql = e(t));
        var i = this;
        (this.listener = function (e) {
            (i.mql = e), i.assess();
        }),
            this.mql.addListener(this.listener);
    }
    function s() {
        if (!e) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
    }
    return (
        (o.prototype = {
            setup: function () {
                this.options.setup && this.options.setup(), (this.initialised = !0);
            },
            on: function () {
                !this.initialised && this.setup(), this.options.match && this.options.match();
            },
            off: function () {
                this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (e) {
                return this.options === e || this.options.match === e;
            },
        }),
        (r.prototype = {
            addHandler: function (e) {
                var t = new o(e);
                this.handlers.push(t), this.matches() && t.on();
            },
            removeHandler: function (e) {
                var n = this.handlers;
                t(n, function (t, i) {
                    return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
                });
            },
            matches: function () {
                return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
                t(this.handlers, function (e) {
                    e.destroy();
                }),
                    this.mql.removeListener(this.listener),
                    (this.handlers.length = 0);
            },
            assess: function () {
                var e = this.matches() ? "on" : "off";
                t(this.handlers, function (t) {
                    t[e]();
                });
            },
        }),
        (s.prototype = {
            register: function (e, o, s) {
                var a = this.queries,
                    l = s && this.browserIsIncapable;
                return (
                    a[e] || (a[e] = new r(e, l)),
                    i(o) && (o = { match: o }),
                    n(o) || (o = [o]),
                    t(o, function (t) {
                        i(t) && (t = { match: t }), a[e].addHandler(t);
                    }),
                    this
                );
            },
            unregister: function (e, t) {
                var n = this.queries[e];
                return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this;
            },
        }),
        new s()
    );
}) /*!

/*! 
 * jquery.min.js
 *
 * jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license
 */,
    !(function (e, t) {
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (e, t) {
        function n(e) {
            var t = !!e && "length" in e && e.length,
                n = re.type(e);
            return (
                "function" !== n &&
                !re.isWindow(e) &&
                ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e))
            );
        }
        function i(e, t, n) {
            if (re.isFunction(t))
                return re.grep(e, function (e, i) {
                    return !!t.call(e, i, e) !== n;
                });
            if (t.nodeType)
                return re.grep(e, function (e) {
                    return (e === t) !== n;
                });
            if ("string" == typeof t) {
                if (ve.test(t)) return re.filter(t, e, n);
                t = re.filter(t, e);
            }
            return re.grep(e, function (e) {
                return K.call(t, e) > -1 !== n;
            });
        }
        function o(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
        }
        function r(e) {
            var t = {};
            return (
                re.each(e.match(xe) || [], function (e, n) {
                    t[n] = !0;
                }),
                t
            );
        }
        function s() {
            G.removeEventListener("DOMContentLoaded", s), e.removeEventListener("load", s), re.ready();
        }
        function a() {
            this.expando = re.expando + a.uid++;
        }
        function l(e, t, n) {
            var i;
            if (void 0 === n && 1 === e.nodeType)
                if (
                    ((i = "data-" + t.replace(Ae, "-$&").toLowerCase()), (n = e.getAttribute(i)), "string" == typeof n)
                ) {
                    try {
                        n =
                            "true" === n ||
                            ("false" !== n &&
                                ("null" === n ? null : +n + "" === n ? +n : Ee.test(n) ? re.parseJSON(n) : n));
                    } catch (e) {}
                    $e.set(e, t, n);
                } else n = void 0;
            return n;
        }
        function u(e, t, n, i) {
            var o,
                r = 1,
                s = 20,
                a = i
                    ? function () {
                          return i.cur();
                      }
                    : function () {
                          return re.css(e, t, "");
                      },
                l = a(),
                u = (n && n[3]) || (re.cssNumber[t] ? "" : "px"),
                c = (re.cssNumber[t] || ("px" !== u && +l)) && Ne.exec(re.css(e, t));
            if (c && c[3] !== u) {
                (u = u || c[3]), (n = n || []), (c = +l || 1);
                do (r = r || ".5"), (c /= r), re.style(e, t, c + u);
                while (r !== (r = a() / l) && 1 !== r && --s);
            }
            return (
                n &&
                    ((c = +c || +l || 0),
                    (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
                    i && ((i.unit = u), (i.start = c), (i.end = o))),
                o
            );
        }
        function c(e, t) {
            var n =
                "undefined" != typeof e.getElementsByTagName
                    ? e.getElementsByTagName(t || "*")
                    : "undefined" != typeof e.querySelectorAll
                      ? e.querySelectorAll(t || "*")
                      : [];
            return void 0 === t || (t && re.nodeName(e, t)) ? re.merge([e], n) : n;
        }
        function d(e, t) {
            for (var n = 0, i = e.length; i > n; n++) Ce.set(e[n], "globalEval", !t || Ce.get(t[n], "globalEval"));
        }
        function p(e, t, n, i, o) {
            for (var r, s, a, l, u, p, f = t.createDocumentFragment(), h = [], v = 0, g = e.length; g > v; v++)
                if (((r = e[v]), r || 0 === r))
                    if ("object" === re.type(r)) re.merge(h, r.nodeType ? [r] : r);
                    else if (_e.test(r)) {
                        for (
                            s = s || f.appendChild(t.createElement("div")),
                                a = (qe.exec(r) || ["", ""])[1].toLowerCase(),
                                l = Le[a] || Le._default,
                                s.innerHTML = l[1] + re.htmlPrefilter(r) + l[2],
                                p = l[0];
                            p--;

                        )
                            s = s.lastChild;
                        re.merge(h, s.childNodes), (s = f.firstChild), (s.textContent = "");
                    } else h.push(t.createTextNode(r));
            for (f.textContent = "", v = 0; (r = h[v++]); )
                if (i && re.inArray(r, i) > -1) o && o.push(r);
                else if (((u = re.contains(r.ownerDocument, r)), (s = c(f.appendChild(r), "script")), u && d(s), n))
                    for (p = 0; (r = s[p++]); ) Pe.test(r.type || "") && n.push(r);
            return f;
        }
        function f() {
            return !0;
        }
        function h() {
            return !1;
        }
        function v() {
            try {
                return G.activeElement;
            } catch (e) {}
        }
        function g(e, t, n, i, o, r) {
            var s, a;
            if ("object" == typeof t) {
                "string" != typeof n && ((i = i || n), (n = void 0));
                for (a in t) g(e, a, n, i, t[a], r);
                return e;
            }
            if (
                (null == i && null == o
                    ? ((o = n), (i = n = void 0))
                    : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))),
                o === !1)
            )
                o = h;
            else if (!o) return e;
            return (
                1 === r &&
                    ((s = o),
                    (o = function (e) {
                        return re().off(e), s.apply(this, arguments);
                    }),
                    (o.guid = s.guid || (s.guid = re.guid++))),
                e.each(function () {
                    re.event.add(this, t, o, i, n);
                })
            );
        }
        function m(e, t) {
            return re.nodeName(e, "table") && re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
                ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody"))
                : e;
        }
        function y(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function b(e) {
            var t = Be.exec(e.type);
            return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
        }
        function w(e, t) {
            var n, i, o, r, s, a, l, u;
            if (1 === t.nodeType) {
                if (Ce.hasData(e) && ((r = Ce.access(e)), (s = Ce.set(t, r)), (u = r.events))) {
                    delete s.handle, (s.events = {});
                    for (o in u) for (n = 0, i = u[o].length; i > n; n++) re.event.add(t, o, u[o][n]);
                }
                $e.hasData(e) && ((a = $e.access(e)), (l = re.extend({}, a)), $e.set(t, l));
            }
        }
        function x(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && He.test(e.type)
                ? (t.checked = e.checked)
                : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
        }
        function k(e, t, n, i) {
            t = J.apply([], t);
            var o,
                r,
                s,
                a,
                l,
                u,
                d = 0,
                f = e.length,
                h = f - 1,
                v = t[0],
                g = re.isFunction(v);
            if (g || (f > 1 && "string" == typeof v && !ie.checkClone && We.test(v)))
                return e.each(function (o) {
                    var r = e.eq(o);
                    g && (t[0] = v.call(this, o, r.html())), k(r, t, n, i);
                });
            if (
                f &&
                ((o = p(t, e[0].ownerDocument, !1, e, i)),
                (r = o.firstChild),
                1 === o.childNodes.length && (o = r),
                r || i)
            ) {
                for (s = re.map(c(o, "script"), y), a = s.length; f > d; d++)
                    (l = o),
                        d !== h && ((l = re.clone(l, !0, !0)), a && re.merge(s, c(l, "script"))),
                        n.call(e[d], l, d);
                if (a)
                    for (u = s[s.length - 1].ownerDocument, re.map(s, b), d = 0; a > d; d++)
                        (l = s[d]),
                            Pe.test(l.type || "") &&
                                !Ce.access(l, "globalEval") &&
                                re.contains(u, l) &&
                                (l.src
                                    ? re._evalUrl && re._evalUrl(l.src)
                                    : re.globalEval(l.textContent.replace(Ue, "")));
            }
            return e;
        }
        function T(e, t, n) {
            for (var i, o = t ? re.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
                n || 1 !== i.nodeType || re.cleanData(c(i)),
                    i.parentNode &&
                        (n && re.contains(i.ownerDocument, i) && d(c(i, "script")), i.parentNode.removeChild(i));
            return e;
        }
        function S(e, t) {
            var n = re(t.createElement(e)).appendTo(t.body),
                i = re.css(n[0], "display");
            return n.detach(), i;
        }
        function C(e) {
            var t = G,
                n = Ye[e];
            return (
                n ||
                    ((n = S(e, t)),
                    ("none" !== n && n) ||
                        ((Xe = (Xe || re("<iframe frameborder='0' width='0' height='0'/>")).appendTo(
                            t.documentElement
                        )),
                        (t = Xe[0].contentDocument),
                        t.write(),
                        t.close(),
                        (n = S(e, t)),
                        Xe.detach()),
                    (Ye[e] = n)),
                n
            );
        }
        function $(e, t, n) {
            var i,
                o,
                r,
                s,
                a = e.style;
            return (
                (n = n || Qe(e)),
                (s = n ? n.getPropertyValue(t) || n[t] : void 0),
                ("" !== s && void 0 !== s) || re.contains(e.ownerDocument, e) || (s = re.style(e, t)),
                n &&
                    !ie.pixelMarginRight() &&
                    Ge.test(s) &&
                    Ve.test(t) &&
                    ((i = a.width),
                    (o = a.minWidth),
                    (r = a.maxWidth),
                    (a.minWidth = a.maxWidth = a.width = s),
                    (s = n.width),
                    (a.width = i),
                    (a.minWidth = o),
                    (a.maxWidth = r)),
                void 0 !== s ? s + "" : s
            );
        }
        function E(e, t) {
            return {
                get: function () {
                    return e() ? void delete this.get : (this.get = t).apply(this, arguments);
                },
            };
        }
        function A(e) {
            if (e in it) return e;
            for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--; )
                if (((e = nt[n] + t), e in it)) return e;
        }
        function j(e, t, n) {
            var i = Ne.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
        }
        function N(e, t, n, i, o) {
            for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > r; r += 2)
                "margin" === n && (s += re.css(e, n + De[r], !0, o)),
                    i
                        ? ("content" === n && (s -= re.css(e, "padding" + De[r], !0, o)),
                          "margin" !== n && (s -= re.css(e, "border" + De[r] + "Width", !0, o)))
                        : ((s += re.css(e, "padding" + De[r], !0, o)),
                          "padding" !== n && (s += re.css(e, "border" + De[r] + "Width", !0, o)));
            return s;
        }
        function D(t, n, i) {
            var o = !0,
                r = "width" === n ? t.offsetWidth : t.offsetHeight,
                s = Qe(t),
                a = "border-box" === re.css(t, "boxSizing", !1, s);
            if (
                (G.msFullscreenElement &&
                    e.top !== e &&
                    t.getClientRects().length &&
                    (r = Math.round(100 * t.getBoundingClientRect()[n])),
                0 >= r || null == r)
            ) {
                if (((r = $(t, n, s)), (0 > r || null == r) && (r = t.style[n]), Ge.test(r))) return r;
                (o = a && (ie.boxSizingReliable() || r === t.style[n])), (r = parseFloat(r) || 0);
            }
            return r + N(t, n, i || (a ? "border" : "content"), o, s) + "px";
        }
        function O(e, t) {
            for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++)
                (i = e[s]),
                    i.style &&
                        ((r[s] = Ce.get(i, "olddisplay")),
                        (n = i.style.display),
                        t
                            ? (r[s] || "none" !== n || (i.style.display = ""),
                              "" === i.style.display && Oe(i) && (r[s] = Ce.access(i, "olddisplay", C(i.nodeName))))
                            : ((o = Oe(i)),
                              ("none" === n && o) || Ce.set(i, "olddisplay", o ? n : re.css(i, "display"))));
            for (s = 0; a > s; s++)
                (i = e[s]),
                    i.style &&
                        ((t && "none" !== i.style.display && "" !== i.style.display) ||
                            (i.style.display = t ? r[s] || "" : "none"));
            return e;
        }
        function H(e, t, n, i, o) {
            return new H.prototype.init(e, t, n, i, o);
        }
        function q() {
            return (
                e.setTimeout(function () {
                    ot = void 0;
                }),
                (ot = re.now())
            );
        }
        function P(e, t) {
            var n,
                i = 0,
                o = { height: e };
            for (t = t ? 1 : 0; 4 > i; i += 2 - t) (n = De[i]), (o["margin" + n] = o["padding" + n] = e);
            return t && (o.opacity = o.width = e), o;
        }
        function L(e, t, n) {
            for (var i, o = (I.tweeners[t] || []).concat(I.tweeners["*"]), r = 0, s = o.length; s > r; r++)
                if ((i = o[r].call(n, t, e))) return i;
        }
        function _(e, t, n) {
            var i,
                o,
                r,
                s,
                a,
                l,
                u,
                c,
                d = this,
                p = {},
                f = e.style,
                h = e.nodeType && Oe(e),
                v = Ce.get(e, "fxshow");
            n.queue ||
                ((a = re._queueHooks(e, "fx")),
                null == a.unqueued &&
                    ((a.unqueued = 0),
                    (l = a.empty.fire),
                    (a.empty.fire = function () {
                        a.unqueued || l();
                    })),
                a.unqueued++,
                d.always(function () {
                    d.always(function () {
                        a.unqueued--, re.queue(e, "fx").length || a.empty.fire();
                    });
                })),
                1 === e.nodeType &&
                    ("height" in t || "width" in t) &&
                    ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                    (u = re.css(e, "display")),
                    (c = "none" === u ? Ce.get(e, "olddisplay") || C(e.nodeName) : u),
                    "inline" === c && "none" === re.css(e, "float") && (f.display = "inline-block")),
                n.overflow &&
                    ((f.overflow = "hidden"),
                    d.always(function () {
                        (f.overflow = n.overflow[0]), (f.overflowX = n.overflow[1]), (f.overflowY = n.overflow[2]);
                    }));
            for (i in t)
                if (((o = t[i]), st.exec(o))) {
                    if ((delete t[i], (r = r || "toggle" === o), o === (h ? "hide" : "show"))) {
                        if ("show" !== o || !v || void 0 === v[i]) continue;
                        h = !0;
                    }
                    p[i] = (v && v[i]) || re.style(e, i);
                } else u = void 0;
            if (re.isEmptyObject(p)) "inline" === ("none" === u ? C(e.nodeName) : u) && (f.display = u);
            else {
                v ? "hidden" in v && (h = v.hidden) : (v = Ce.access(e, "fxshow", {})),
                    r && (v.hidden = !h),
                    h
                        ? re(e).show()
                        : d.done(function () {
                              re(e).hide();
                          }),
                    d.done(function () {
                        var t;
                        Ce.remove(e, "fxshow");
                        for (t in p) re.style(e, t, p[t]);
                    });
                for (i in p)
                    (s = L(h ? v[i] : 0, i, d)),
                        i in v ||
                            ((v[i] = s.start),
                            h && ((s.end = s.start), (s.start = "width" === i || "height" === i ? 1 : 0)));
            }
        }
        function z(e, t) {
            var n, i, o, r, s;
            for (n in e)
                if (
                    ((i = re.camelCase(n)),
                    (o = t[i]),
                    (r = e[n]),
                    re.isArray(r) && ((o = r[1]), (r = e[n] = r[0])),
                    n !== i && ((e[i] = r), delete e[n]),
                    (s = re.cssHooks[i]),
                    s && "expand" in s)
                ) {
                    (r = s.expand(r)), delete e[i];
                    for (n in r) n in e || ((e[n] = r[n]), (t[n] = o));
                } else t[i] = o;
        }
        function I(e, t, n) {
            var i,
                o,
                r = 0,
                s = I.prefilters.length,
                a = re.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (o) return !1;
                    for (
                        var t = ot || q(),
                            n = Math.max(0, u.startTime + u.duration - t),
                            i = n / u.duration || 0,
                            r = 1 - i,
                            s = 0,
                            l = u.tweens.length;
                        l > s;
                        s++
                    )
                        u.tweens[s].run(r);
                    return a.notifyWith(e, [u, r, n]), 1 > r && l ? n : (a.resolveWith(e, [u]), !1);
                },
                u = a.promise({
                    elem: e,
                    props: re.extend({}, t),
                    opts: re.extend(!0, { specialEasing: {}, easing: re.easing._default }, n),
                    originalProperties: t,
                    originalOptions: n,
                    startTime: ot || q(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function (t, n) {
                        var i = re.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                        return u.tweens.push(i), i;
                    },
                    stop: function (t) {
                        var n = 0,
                            i = t ? u.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; i > n; n++) u.tweens[n].run(1);
                        return (
                            t ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t])) : a.rejectWith(e, [u, t]), this
                        );
                    },
                }),
                c = u.props;
            for (z(c, u.opts.specialEasing); s > r; r++)
                if ((i = I.prefilters[r].call(u, e, c, u.opts)))
                    return (
                        re.isFunction(i.stop) && (re._queueHooks(u.elem, u.opts.queue).stop = re.proxy(i.stop, i)), i
                    );
            return (
                re.map(c, L, u),
                re.isFunction(u.opts.start) && u.opts.start.call(e, u),
                re.fx.timer(re.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
                u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
            );
        }
        function F(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function M(e) {
            return function (t, n) {
                "string" != typeof t && ((n = t), (t = "*"));
                var i,
                    o = 0,
                    r = t.toLowerCase().match(xe) || [];
                if (re.isFunction(n))
                    for (; (i = r[o++]); )
                        "+" === i[0]
                            ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
                            : (e[i] = e[i] || []).push(n);
            };
        }
        function R(e, t, n, i) {
            function o(a) {
                var l;
                return (
                    (r[a] = !0),
                    re.each(e[a] || [], function (e, a) {
                        var u = a(t, n, i);
                        return "string" != typeof u || s || r[u]
                            ? s
                                ? !(l = u)
                                : void 0
                            : (t.dataTypes.unshift(u), o(u), !1);
                    }),
                    l
                );
            }
            var r = {},
                s = e === $t;
            return o(t.dataTypes[0]) || (!r["*"] && o("*"));
        }
        function W(e, t) {
            var n,
                i,
                o = re.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
            return i && re.extend(!0, e, i), e;
        }
        function B(e, t, n) {
            for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
                l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
            if (i)
                for (o in a)
                    if (a[o] && a[o].test(i)) {
                        l.unshift(o);
                        break;
                    }
            if (l[0] in n) r = l[0];
            else {
                for (o in n) {
                    if (!l[0] || e.converters[o + " " + l[0]]) {
                        r = o;
                        break;
                    }
                    s || (s = o);
                }
                r = r || s;
            }
            return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0;
        }
        function U(e, t, n, i) {
            var o,
                r,
                s,
                a,
                l,
                u = {},
                c = e.dataTypes.slice();
            if (c[1]) for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
            for (r = c.shift(); r; )
                if (
                    (e.responseFields[r] && (n[e.responseFields[r]] = t),
                    !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                    (l = r),
                    (r = c.shift()))
                )
                    if ("*" === r) r = l;
                    else if ("*" !== l && l !== r) {
                        if (((s = u[l + " " + r] || u["* " + r]), !s))
                            for (o in u)
                                if (((a = o.split(" ")), a[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]]))) {
                                    s === !0 ? (s = u[o]) : u[o] !== !0 && ((r = a[0]), c.unshift(a[1]));
                                    break;
                                }
                        if (s !== !0)
                            if (s && e.throws) t = s(t);
                            else
                                try {
                                    t = s(t);
                                } catch (e) {
                                    return {
                                        state: "parsererror",
                                        error: s ? e : "No conversion from " + l + " to " + r,
                                    };
                                }
                    }
            return { state: "success", data: t };
        }
        function X(e, t, n, i) {
            var o;
            if (re.isArray(t))
                re.each(t, function (t, o) {
                    n || Nt.test(e)
                        ? i(e, o)
                        : X(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, i);
                });
            else if (n || "object" !== re.type(t)) i(e, t);
            else for (o in t) X(e + "[" + o + "]", t[o], n, i);
        }
        function Y(e) {
            return re.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
        }
        var V = [],
            G = e.document,
            Q = V.slice,
            J = V.concat,
            Z = V.push,
            K = V.indexOf,
            ee = {},
            te = ee.toString,
            ne = ee.hasOwnProperty,
            ie = {},
            oe = "2.2.3",
            re = function (e, t) {
                return new re.fn.init(e, t);
            },
            se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            ae = /^-ms-/,
            le = /-([\da-z])/gi,
            ue = function (e, t) {
                return t.toUpperCase();
            };
        (re.fn = re.prototype =
            {
                jquery: oe,
                constructor: re,
                selector: "",
                length: 0,
                toArray: function () {
                    return Q.call(this);
                },
                get: function (e) {
                    return null != e ? (0 > e ? this[e + this.length] : this[e]) : Q.call(this);
                },
                pushStack: function (e) {
                    var t = re.merge(this.constructor(), e);
                    return (t.prevObject = this), (t.context = this.context), t;
                },
                each: function (e) {
                    return re.each(this, e);
                },
                map: function (e) {
                    return this.pushStack(
                        re.map(this, function (t, n) {
                            return e.call(t, n, t);
                        })
                    );
                },
                slice: function () {
                    return this.pushStack(Q.apply(this, arguments));
                },
                first: function () {
                    return this.eq(0);
                },
                last: function () {
                    return this.eq(-1);
                },
                eq: function (e) {
                    var t = this.length,
                        n = +e + (0 > e ? t : 0);
                    return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
                },
                end: function () {
                    return this.prevObject || this.constructor();
                },
                push: Z,
                sort: V.sort,
                splice: V.splice,
            }),
            (re.extend = re.fn.extend =
                function () {
                    var e,
                        t,
                        n,
                        i,
                        o,
                        r,
                        s = arguments[0] || {},
                        a = 1,
                        l = arguments.length,
                        u = !1;
                    for (
                        "boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++),
                            "object" == typeof s || re.isFunction(s) || (s = {}),
                            a === l && ((s = this), a--);
                        l > a;
                        a++
                    )
                        if (null != (e = arguments[a]))
                            for (t in e)
                                (n = s[t]),
                                    (i = e[t]),
                                    s !== i &&
                                        (u && i && (re.isPlainObject(i) || (o = re.isArray(i)))
                                            ? (o
                                                  ? ((o = !1), (r = n && re.isArray(n) ? n : []))
                                                  : (r = n && re.isPlainObject(n) ? n : {}),
                                              (s[t] = re.extend(u, r, i)))
                                            : void 0 !== i && (s[t] = i));
                    return s;
                }),
            re.extend({
                expando: "jQuery" + (oe + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isFunction: function (e) {
                    return "function" === re.type(e);
                },
                isArray: Array.isArray,
                isWindow: function (e) {
                    return null != e && e === e.window;
                },
                isNumeric: function (e) {
                    var t = e && e.toString();
                    return !re.isArray(e) && t - parseFloat(t) + 1 >= 0;
                },
                isPlainObject: function (e) {
                    var t;
                    if ("object" !== re.type(e) || e.nodeType || re.isWindow(e)) return !1;
                    if (
                        e.constructor &&
                        !ne.call(e, "constructor") &&
                        !ne.call(e.constructor.prototype || {}, "isPrototypeOf")
                    )
                        return !1;
                    for (t in e);
                    return void 0 === t || ne.call(e, t);
                },
                isEmptyObject: function (e) {
                    var t;
                    for (t in e) return !1;
                    return !0;
                },
                type: function (e) {
                    return null == e
                        ? e + ""
                        : "object" == typeof e || "function" == typeof e
                          ? ee[te.call(e)] || "object"
                          : typeof e;
                },
                globalEval: function (e) {
                    var t,
                        n = eval;
                    (e = re.trim(e)),
                        e &&
                            (1 === e.indexOf("use strict")
                                ? ((t = G.createElement("script")),
                                  (t.text = e),
                                  G.head.appendChild(t).parentNode.removeChild(t))
                                : n(e));
                },
                camelCase: function (e) {
                    return e.replace(ae, "ms-").replace(le, ue);
                },
                nodeName: function (e, t) {
                    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                },
                each: function (e, t) {
                    var i,
                        o = 0;
                    if (n(e)) for (i = e.length; i > o && t.call(e[o], o, e[o]) !== !1; o++);
                    else for (o in e) if (t.call(e[o], o, e[o]) === !1) break;
                    return e;
                },
                trim: function (e) {
                    return null == e ? "" : (e + "").replace(se, "");
                },
                makeArray: function (e, t) {
                    var i = t || [];
                    return null != e && (n(Object(e)) ? re.merge(i, "string" == typeof e ? [e] : e) : Z.call(i, e)), i;
                },
                inArray: function (e, t, n) {
                    return null == t ? -1 : K.call(t, e, n);
                },
                merge: function (e, t) {
                    for (var n = +t.length, i = 0, o = e.length; n > i; i++) e[o++] = t[i];
                    return (e.length = o), e;
                },
                grep: function (e, t, n) {
                    for (var i, o = [], r = 0, s = e.length, a = !n; s > r; r++)
                        (i = !t(e[r], r)), i !== a && o.push(e[r]);
                    return o;
                },
                map: function (e, t, i) {
                    var o,
                        r,
                        s = 0,
                        a = [];
                    if (n(e)) for (o = e.length; o > s; s++) (r = t(e[s], s, i)), null != r && a.push(r);
                    else for (s in e) (r = t(e[s], s, i)), null != r && a.push(r);
                    return J.apply([], a);
                },
                guid: 1,
                proxy: function (e, t) {
                    var n, i, o;
                    return (
                        "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
                        re.isFunction(e)
                            ? ((i = Q.call(arguments, 2)),
                              (o = function () {
                                  return e.apply(t || this, i.concat(Q.call(arguments)));
                              }),
                              (o.guid = e.guid = e.guid || re.guid++),
                              o)
                            : void 0
                    );
                },
                now: Date.now,
                support: ie,
            }),
            "function" == typeof Symbol && (re.fn[Symbol.iterator] = V[Symbol.iterator]),
            re.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                ee["[object " + t + "]"] = t.toLowerCase();
            });
        var ce = (function (e) {
            function t(e, t, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    u,
                    d,
                    f,
                    h = t && t.ownerDocument,
                    v = t ? t.nodeType : 9;
                if (((n = n || []), "string" != typeof e || !e || (1 !== v && 9 !== v && 11 !== v))) return n;
                if (!i && ((t ? t.ownerDocument || t : F) !== O && D(t), (t = t || O), q)) {
                    if (11 !== v && (u = me.exec(e)))
                        if ((o = u[1])) {
                            if (9 === v) {
                                if (!(s = t.getElementById(o))) return n;
                                if (s.id === o) return n.push(s), n;
                            } else if (h && (s = h.getElementById(o)) && z(t, s) && s.id === o) return n.push(s), n;
                        } else {
                            if (u[2]) return Z.apply(n, t.getElementsByTagName(e)), n;
                            if ((o = u[3]) && x.getElementsByClassName && t.getElementsByClassName)
                                return Z.apply(n, t.getElementsByClassName(o)), n;
                        }
                    if (x.qsa && !U[e + " "] && (!P || !P.test(e))) {
                        if (1 !== v) (h = t), (f = e);
                        else if ("object" !== t.nodeName.toLowerCase()) {
                            for (
                                (a = t.getAttribute("id"))
                                    ? (a = a.replace(be, "\\$&"))
                                    : t.setAttribute("id", (a = I)),
                                    d = C(e),
                                    r = d.length,
                                    l = pe.test(a) ? "#" + a : "[id='" + a + "']";
                                r--;

                            )
                                d[r] = l + " " + p(d[r]);
                            (f = d.join(",")), (h = (ye.test(e) && c(t.parentNode)) || t);
                        }
                        if (f)
                            try {
                                return Z.apply(n, h.querySelectorAll(f)), n;
                            } catch (e) {
                            } finally {
                                a === I && t.removeAttribute("id");
                            }
                    }
                }
                return E(e.replace(ae, "$1"), t, n, i);
            }
            function n() {
                function e(n, i) {
                    return t.push(n + " ") > k.cacheLength && delete e[t.shift()], (e[n + " "] = i);
                }
                var t = [];
                return e;
            }
            function i(e) {
                return (e[I] = !0), e;
            }
            function o(e) {
                var t = O.createElement("div");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function r(e, t) {
                for (var n = e.split("|"), i = n.length; i--; ) k.attrHandle[n[i]] = t;
            }
            function s(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || Y) - (~e.sourceIndex || Y);
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                return e ? 1 : -1;
            }
            function a(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();
                    return "input" === n && t.type === e;
                };
            }
            function l(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();
                    return ("input" === n || "button" === n) && t.type === e;
                };
            }
            function u(e) {
                return i(function (t) {
                    return (
                        (t = +t),
                        i(function (n, i) {
                            for (var o, r = e([], n.length, t), s = r.length; s--; )
                                n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
                        })
                    );
                });
            }
            function c(e) {
                return e && "undefined" != typeof e.getElementsByTagName && e;
            }
            function d() {}
            function p(e) {
                for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
                return i;
            }
            function f(e, t, n) {
                var i = t.dir,
                    o = n && "parentNode" === i,
                    r = R++;
                return t.first
                    ? function (t, n, r) {
                          for (; (t = t[i]); ) if (1 === t.nodeType || o) return e(t, n, r);
                      }
                    : function (t, n, s) {
                          var a,
                              l,
                              u,
                              c = [M, r];
                          if (s) {
                              for (; (t = t[i]); ) if ((1 === t.nodeType || o) && e(t, n, s)) return !0;
                          } else
                              for (; (t = t[i]); )
                                  if (1 === t.nodeType || o) {
                                      if (
                                          ((u = t[I] || (t[I] = {})),
                                          (l = u[t.uniqueID] || (u[t.uniqueID] = {})),
                                          (a = l[i]) && a[0] === M && a[1] === r)
                                      )
                                          return (c[2] = a[2]);
                                      if (((l[i] = c), (c[2] = e(t, n, s)))) return !0;
                                  }
                      };
            }
            function h(e) {
                return e.length > 1
                    ? function (t, n, i) {
                          for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                          return !0;
                      }
                    : e[0];
            }
            function v(e, n, i) {
                for (var o = 0, r = n.length; r > o; o++) t(e, n[o], i);
                return i;
            }
            function g(e, t, n, i, o) {
                for (var r, s = [], a = 0, l = e.length, u = null != t; l > a; a++)
                    (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), u && t.push(a)));
                return s;
            }
            function m(e, t, n, o, r, s) {
                return (
                    o && !o[I] && (o = m(o)),
                    r && !r[I] && (r = m(r, s)),
                    i(function (i, s, a, l) {
                        var u,
                            c,
                            d,
                            p = [],
                            f = [],
                            h = s.length,
                            m = i || v(t || "*", a.nodeType ? [a] : a, []),
                            y = !e || (!i && t) ? m : g(m, p, e, a, l),
                            b = n ? (r || (i ? e : h || o) ? [] : s) : y;
                        if ((n && n(y, b, a, l), o))
                            for (u = g(b, f), o(u, [], a, l), c = u.length; c--; )
                                (d = u[c]) && (b[f[c]] = !(y[f[c]] = d));
                        if (i) {
                            if (r || e) {
                                if (r) {
                                    for (u = [], c = b.length; c--; ) (d = b[c]) && u.push((y[c] = d));
                                    r(null, (b = []), u, l);
                                }
                                for (c = b.length; c--; )
                                    (d = b[c]) && (u = r ? ee(i, d) : p[c]) > -1 && (i[u] = !(s[u] = d));
                            }
                        } else (b = g(b === s ? b.splice(h, b.length) : b)), r ? r(null, s, b, l) : Z.apply(s, b);
                    })
                );
            }
            function y(e) {
                for (
                    var t,
                        n,
                        i,
                        o = e.length,
                        r = k.relative[e[0].type],
                        s = r || k.relative[" "],
                        a = r ? 1 : 0,
                        l = f(
                            function (e) {
                                return e === t;
                            },
                            s,
                            !0
                        ),
                        u = f(
                            function (e) {
                                return ee(t, e) > -1;
                            },
                            s,
                            !0
                        ),
                        c = [
                            function (e, n, i) {
                                var o = (!r && (i || n !== A)) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                                return (t = null), o;
                            },
                        ];
                    o > a;
                    a++
                )
                    if ((n = k.relative[e[a].type])) c = [f(h(c), n)];
                    else {
                        if (((n = k.filter[e[a].type].apply(null, e[a].matches)), n[I])) {
                            for (i = ++a; o > i && !k.relative[e[i].type]; i++);
                            return m(
                                a > 1 && h(c),
                                a > 1 &&
                                    p(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(
                                        ae,
                                        "$1"
                                    ),
                                n,
                                i > a && y(e.slice(a, i)),
                                o > i && y((e = e.slice(i))),
                                o > i && p(e)
                            );
                        }
                        c.push(n);
                    }
                return h(c);
            }
            function b(e, n) {
                var o = n.length > 0,
                    r = e.length > 0,
                    s = function (i, s, a, l, u) {
                        var c,
                            d,
                            p,
                            f = 0,
                            h = "0",
                            v = i && [],
                            m = [],
                            y = A,
                            b = i || (r && k.find.TAG("*", u)),
                            w = (M += null == y ? 1 : Math.random() || 0.1),
                            x = b.length;
                        for (u && (A = s === O || s || u); h !== x && null != (c = b[h]); h++) {
                            if (r && c) {
                                for (d = 0, s || c.ownerDocument === O || (D(c), (a = !q)); (p = e[d++]); )
                                    if (p(c, s || O, a)) {
                                        l.push(c);
                                        break;
                                    }
                                u && (M = w);
                            }
                            o && ((c = !p && c) && f--, i && v.push(c));
                        }
                        if (((f += h), o && h !== f)) {
                            for (d = 0; (p = n[d++]); ) p(v, m, s, a);
                            if (i) {
                                if (f > 0) for (; h--; ) v[h] || m[h] || (m[h] = Q.call(l));
                                m = g(m);
                            }
                            Z.apply(l, m), u && !i && m.length > 0 && f + n.length > 1 && t.uniqueSort(l);
                        }
                        return u && ((M = w), (A = y)), v;
                    };
                return o ? i(s) : s;
            }
            var w,
                x,
                k,
                T,
                S,
                C,
                $,
                E,
                A,
                j,
                N,
                D,
                O,
                H,
                q,
                P,
                L,
                _,
                z,
                I = "sizzle" + 1 * new Date(),
                F = e.document,
                M = 0,
                R = 0,
                W = n(),
                B = n(),
                U = n(),
                X = function (e, t) {
                    return e === t && (N = !0), 0;
                },
                Y = 1 << 31,
                V = {}.hasOwnProperty,
                G = [],
                Q = G.pop,
                J = G.push,
                Z = G.push,
                K = G.slice,
                ee = function (e, t) {
                    for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
                    return -1;
                },
                te =
                    "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                ne = "[\\x20\\t\\r\\n\\f]",
                ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                oe =
                    "\\[" +
                    ne +
                    "*(" +
                    ie +
                    ")(?:" +
                    ne +
                    "*([*^$|!~]?=)" +
                    ne +
                    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                    ie +
                    "))|)" +
                    ne +
                    "*\\]",
                re =
                    ":(" +
                    ie +
                    ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                    oe +
                    ")*)|.*)\\)|)",
                se = new RegExp(ne + "+", "g"),
                ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"),
                le = new RegExp("^" + ne + "*," + ne + "*"),
                ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
                ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
                de = new RegExp(re),
                pe = new RegExp("^" + ie + "$"),
                fe = {
                    ID: new RegExp("^#(" + ie + ")"),
                    CLASS: new RegExp("^\\.(" + ie + ")"),
                    TAG: new RegExp("^(" + ie + "|[*])"),
                    ATTR: new RegExp("^" + oe),
                    PSEUDO: new RegExp("^" + re),
                    CHILD: new RegExp(
                        "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                            ne +
                            "*(even|odd|(([+-]|)(\\d*)n|)" +
                            ne +
                            "*(?:([+-]|)" +
                            ne +
                            "*(\\d+)|))" +
                            ne +
                            "*\\)|)",
                        "i"
                    ),
                    bool: new RegExp("^(?:" + te + ")$", "i"),
                    needsContext: new RegExp(
                        "^" +
                            ne +
                            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                            ne +
                            "*((?:-\\d)?\\d*)" +
                            ne +
                            "*\\)|)(?=[^-]|$)",
                        "i"
                    ),
                },
                he = /^(?:input|select|textarea|button)$/i,
                ve = /^h\d$/i,
                ge = /^[^{]+\{\s*\[native \w/,
                me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                ye = /[+~]/,
                be = /'|\\/g,
                we = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
                xe = function (e, t, n) {
                    var i = "0x" + t - 65536;
                    return i !== i || n
                        ? t
                        : 0 > i
                          ? String.fromCharCode(i + 65536)
                          : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
                },
                ke = function () {
                    D();
                };
            try {
                Z.apply((G = K.call(F.childNodes)), F.childNodes), G[F.childNodes.length].nodeType;
            } catch (e) {
                Z = {
                    apply: G.length
                        ? function (e, t) {
                              J.apply(e, K.call(t));
                          }
                        : function (e, t) {
                              for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                              e.length = n - 1;
                          },
                };
            }
            (x = t.support = {}),
                (S = t.isXML =
                    function (e) {
                        var t = e && (e.ownerDocument || e).documentElement;
                        return !!t && "HTML" !== t.nodeName;
                    }),
                (D = t.setDocument =
                    function (e) {
                        var t,
                            n,
                            i = e ? e.ownerDocument || e : F;
                        return i !== O && 9 === i.nodeType && i.documentElement
                            ? ((O = i),
                              (H = O.documentElement),
                              (q = !S(O)),
                              (n = O.defaultView) &&
                                  n.top !== n &&
                                  (n.addEventListener
                                      ? n.addEventListener("unload", ke, !1)
                                      : n.attachEvent && n.attachEvent("onunload", ke)),
                              (x.attributes = o(function (e) {
                                  return (e.className = "i"), !e.getAttribute("className");
                              })),
                              (x.getElementsByTagName = o(function (e) {
                                  return e.appendChild(O.createComment("")), !e.getElementsByTagName("*").length;
                              })),
                              (x.getElementsByClassName = ge.test(O.getElementsByClassName)),
                              (x.getById = o(function (e) {
                                  return (
                                      (H.appendChild(e).id = I), !O.getElementsByName || !O.getElementsByName(I).length
                                  );
                              })),
                              x.getById
                                  ? ((k.find.ID = function (e, t) {
                                        if ("undefined" != typeof t.getElementById && q) {
                                            var n = t.getElementById(e);
                                            return n ? [n] : [];
                                        }
                                    }),
                                    (k.filter.ID = function (e) {
                                        var t = e.replace(we, xe);
                                        return function (e) {
                                            return e.getAttribute("id") === t;
                                        };
                                    }))
                                  : (delete k.find.ID,
                                    (k.filter.ID = function (e) {
                                        var t = e.replace(we, xe);
                                        return function (e) {
                                            var n =
                                                "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                            return n && n.value === t;
                                        };
                                    })),
                              (k.find.TAG = x.getElementsByTagName
                                  ? function (e, t) {
                                        return "undefined" != typeof t.getElementsByTagName
                                            ? t.getElementsByTagName(e)
                                            : x.qsa
                                              ? t.querySelectorAll(e)
                                              : void 0;
                                    }
                                  : function (e, t) {
                                        var n,
                                            i = [],
                                            o = 0,
                                            r = t.getElementsByTagName(e);
                                        if ("*" === e) {
                                            for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                                            return i;
                                        }
                                        return r;
                                    }),
                              (k.find.CLASS =
                                  x.getElementsByClassName &&
                                  function (e, t) {
                                      return "undefined" != typeof t.getElementsByClassName && q
                                          ? t.getElementsByClassName(e)
                                          : void 0;
                                  }),
                              (L = []),
                              (P = []),
                              (x.qsa = ge.test(O.querySelectorAll)) &&
                                  (o(function (e) {
                                      (H.appendChild(e).innerHTML =
                                          "<a id='" +
                                          I +
                                          "'></a><select id='" +
                                          I +
                                          "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                          e.querySelectorAll("[msallowcapture^='']").length &&
                                              P.push("[*^$]=" + ne + "*(?:''|\"\")"),
                                          e.querySelectorAll("[selected]").length ||
                                              P.push("\\[" + ne + "*(?:value|" + te + ")"),
                                          e.querySelectorAll("[id~=" + I + "-]").length || P.push("~="),
                                          e.querySelectorAll(":checked").length || P.push(":checked"),
                                          e.querySelectorAll("a#" + I + "+*").length || P.push(".#.+[+~]");
                                  }),
                                  o(function (e) {
                                      var t = O.createElement("input");
                                      t.setAttribute("type", "hidden"),
                                          e.appendChild(t).setAttribute("name", "D"),
                                          e.querySelectorAll("[name=d]").length && P.push("name" + ne + "*[*^$|!~]?="),
                                          e.querySelectorAll(":enabled").length || P.push(":enabled", ":disabled"),
                                          e.querySelectorAll("*,:x"),
                                          P.push(",.*:");
                                  })),
                              (x.matchesSelector = ge.test(
                                  (_ =
                                      H.matches ||
                                      H.webkitMatchesSelector ||
                                      H.mozMatchesSelector ||
                                      H.oMatchesSelector ||
                                      H.msMatchesSelector)
                              )) &&
                                  o(function (e) {
                                      (x.disconnectedMatch = _.call(e, "div")),
                                          _.call(e, "[s!='']:x"),
                                          L.push("!=", re);
                                  }),
                              (P = P.length && new RegExp(P.join("|"))),
                              (L = L.length && new RegExp(L.join("|"))),
                              (t = ge.test(H.compareDocumentPosition)),
                              (z =
                                  t || ge.test(H.contains)
                                      ? function (e, t) {
                                            var n = 9 === e.nodeType ? e.documentElement : e,
                                                i = t && t.parentNode;
                                            return (
                                                e === i ||
                                                !(
                                                    !i ||
                                                    1 !== i.nodeType ||
                                                    !(n.contains
                                                        ? n.contains(i)
                                                        : e.compareDocumentPosition &&
                                                          16 & e.compareDocumentPosition(i))
                                                )
                                            );
                                        }
                                      : function (e, t) {
                                            if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                            return !1;
                                        }),
                              (X = t
                                  ? function (e, t) {
                                        if (e === t) return (N = !0), 0;
                                        var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                        return n
                                            ? n
                                            : ((n =
                                                  (e.ownerDocument || e) === (t.ownerDocument || t)
                                                      ? e.compareDocumentPosition(t)
                                                      : 1),
                                              1 & n || (!x.sortDetached && t.compareDocumentPosition(e) === n)
                                                  ? e === O || (e.ownerDocument === F && z(F, e))
                                                      ? -1
                                                      : t === O || (t.ownerDocument === F && z(F, t))
                                                        ? 1
                                                        : j
                                                          ? ee(j, e) - ee(j, t)
                                                          : 0
                                                  : 4 & n
                                                    ? -1
                                                    : 1);
                                    }
                                  : function (e, t) {
                                        if (e === t) return (N = !0), 0;
                                        var n,
                                            i = 0,
                                            o = e.parentNode,
                                            r = t.parentNode,
                                            a = [e],
                                            l = [t];
                                        if (!o || !r)
                                            return e === O
                                                ? -1
                                                : t === O
                                                  ? 1
                                                  : o
                                                    ? -1
                                                    : r
                                                      ? 1
                                                      : j
                                                        ? ee(j, e) - ee(j, t)
                                                        : 0;
                                        if (o === r) return s(e, t);
                                        for (n = e; (n = n.parentNode); ) a.unshift(n);
                                        for (n = t; (n = n.parentNode); ) l.unshift(n);
                                        for (; a[i] === l[i]; ) i++;
                                        return i ? s(a[i], l[i]) : a[i] === F ? -1 : l[i] === F ? 1 : 0;
                                    }),
                              O)
                            : O;
                    }),
                (t.matches = function (e, n) {
                    return t(e, null, null, n);
                }),
                (t.matchesSelector = function (e, n) {
                    if (
                        ((e.ownerDocument || e) !== O && D(e),
                        (n = n.replace(ce, "='$1']")),
                        x.matchesSelector && q && !U[n + " "] && (!L || !L.test(n)) && (!P || !P.test(n)))
                    )
                        try {
                            var i = _.call(e, n);
                            if (i || x.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                        } catch (e) {}
                    return t(n, O, null, [e]).length > 0;
                }),
                (t.contains = function (e, t) {
                    return (e.ownerDocument || e) !== O && D(e), z(e, t);
                }),
                (t.attr = function (e, t) {
                    (e.ownerDocument || e) !== O && D(e);
                    var n = k.attrHandle[t.toLowerCase()],
                        i = n && V.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !q) : void 0;
                    return void 0 !== i
                        ? i
                        : x.attributes || !q
                          ? e.getAttribute(t)
                          : (i = e.getAttributeNode(t)) && i.specified
                            ? i.value
                            : null;
                }),
                (t.error = function (e) {
                    throw new Error("Syntax error, unrecognized expression: " + e);
                }),
                (t.uniqueSort = function (e) {
                    var t,
                        n = [],
                        i = 0,
                        o = 0;
                    if (((N = !x.detectDuplicates), (j = !x.sortStable && e.slice(0)), e.sort(X), N)) {
                        for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
                        for (; i--; ) e.splice(n[i], 1);
                    }
                    return (j = null), e;
                }),
                (T = t.getText =
                    function (e) {
                        var t,
                            n = "",
                            i = 0,
                            o = e.nodeType;
                        if (o) {
                            if (1 === o || 9 === o || 11 === o) {
                                if ("string" == typeof e.textContent) return e.textContent;
                                for (e = e.firstChild; e; e = e.nextSibling) n += T(e);
                            } else if (3 === o || 4 === o) return e.nodeValue;
                        } else for (; (t = e[i++]); ) n += T(t);
                        return n;
                    }),
                (k = t.selectors =
                    {
                        cacheLength: 50,
                        createPseudo: i,
                        match: fe,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": { dir: "parentNode", first: !0 },
                            " ": { dir: "parentNode" },
                            "+": { dir: "previousSibling", first: !0 },
                            "~": { dir: "previousSibling" },
                        },
                        preFilter: {
                            ATTR: function (e) {
                                return (
                                    (e[1] = e[1].replace(we, xe)),
                                    (e[3] = (e[3] || e[4] || e[5] || "").replace(we, xe)),
                                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                                    e.slice(0, 4)
                                );
                            },
                            CHILD: function (e) {
                                return (
                                    (e[1] = e[1].toLowerCase()),
                                    "nth" === e[1].slice(0, 3)
                                        ? (e[3] || t.error(e[0]),
                                          (e[4] = +(e[4]
                                              ? e[5] + (e[6] || 1)
                                              : 2 * ("even" === e[3] || "odd" === e[3]))),
                                          (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                                        : e[3] && t.error(e[0]),
                                    e
                                );
                            },
                            PSEUDO: function (e) {
                                var t,
                                    n = !e[6] && e[2];
                                return fe.CHILD.test(e[0])
                                    ? null
                                    : (e[3]
                                          ? (e[2] = e[4] || e[5] || "")
                                          : n &&
                                            de.test(n) &&
                                            (t = C(n, !0)) &&
                                            (t = n.indexOf(")", n.length - t) - n.length) &&
                                            ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                                      e.slice(0, 3));
                            },
                        },
                        filter: {
                            TAG: function (e) {
                                var t = e.replace(we, xe).toLowerCase();
                                return "*" === e
                                    ? function () {
                                          return !0;
                                      }
                                    : function (e) {
                                          return e.nodeName && e.nodeName.toLowerCase() === t;
                                      };
                            },
                            CLASS: function (e) {
                                var t = W[e + " "];
                                return (
                                    t ||
                                    ((t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) &&
                                        W(e, function (e) {
                                            return t.test(
                                                ("string" == typeof e.className && e.className) ||
                                                    ("undefined" != typeof e.getAttribute && e.getAttribute("class")) ||
                                                    ""
                                            );
                                        }))
                                );
                            },
                            ATTR: function (e, n, i) {
                                return function (o) {
                                    var r = t.attr(o, e);
                                    return null == r
                                        ? "!=" === n
                                        : !n ||
                                              ((r += ""),
                                              "=" === n
                                                  ? r === i
                                                  : "!=" === n
                                                    ? r !== i
                                                    : "^=" === n
                                                      ? i && 0 === r.indexOf(i)
                                                      : "*=" === n
                                                        ? i && r.indexOf(i) > -1
                                                        : "$=" === n
                                                          ? i && r.slice(-i.length) === i
                                                          : "~=" === n
                                                            ? (" " + r.replace(se, " ") + " ").indexOf(i) > -1
                                                            : "|=" === n &&
                                                              (r === i || r.slice(0, i.length + 1) === i + "-"));
                                };
                            },
                            CHILD: function (e, t, n, i, o) {
                                var r = "nth" !== e.slice(0, 3),
                                    s = "last" !== e.slice(-4),
                                    a = "of-type" === t;
                                return 1 === i && 0 === o
                                    ? function (e) {
                                          return !!e.parentNode;
                                      }
                                    : function (t, n, l) {
                                          var u,
                                              c,
                                              d,
                                              p,
                                              f,
                                              h,
                                              v = r !== s ? "nextSibling" : "previousSibling",
                                              g = t.parentNode,
                                              m = a && t.nodeName.toLowerCase(),
                                              y = !l && !a,
                                              b = !1;
                                          if (g) {
                                              if (r) {
                                                  for (; v; ) {
                                                      for (p = t; (p = p[v]); )
                                                          if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType)
                                                              return !1;
                                                      h = v = "only" === e && !h && "nextSibling";
                                                  }
                                                  return !0;
                                              }
                                              if (((h = [s ? g.firstChild : g.lastChild]), s && y)) {
                                                  for (
                                                      p = g,
                                                          d = p[I] || (p[I] = {}),
                                                          c = d[p.uniqueID] || (d[p.uniqueID] = {}),
                                                          u = c[e] || [],
                                                          f = u[0] === M && u[1],
                                                          b = f && u[2],
                                                          p = f && g.childNodes[f];
                                                      (p = (++f && p && p[v]) || (b = f = 0) || h.pop());

                                                  )
                                                      if (1 === p.nodeType && ++b && p === t) {
                                                          c[e] = [M, f, b];
                                                          break;
                                                      }
                                              } else if (
                                                  (y &&
                                                      ((p = t),
                                                      (d = p[I] || (p[I] = {})),
                                                      (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                                                      (u = c[e] || []),
                                                      (f = u[0] === M && u[1]),
                                                      (b = f)),
                                                  b === !1)
                                              )
                                                  for (
                                                      ;
                                                      (p = (++f && p && p[v]) || (b = f = 0) || h.pop()) &&
                                                      ((a ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) ||
                                                          !++b ||
                                                          (y &&
                                                              ((d = p[I] || (p[I] = {})),
                                                              (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                                                              (c[e] = [M, b])),
                                                          p !== t));

                                                  );
                                              return (b -= o), b === i || (b % i === 0 && b / i >= 0);
                                          }
                                      };
                            },
                            PSEUDO: function (e, n) {
                                var o,
                                    r =
                                        k.pseudos[e] ||
                                        k.setFilters[e.toLowerCase()] ||
                                        t.error("unsupported pseudo: " + e);
                                return r[I]
                                    ? r(n)
                                    : r.length > 1
                                      ? ((o = [e, e, "", n]),
                                        k.setFilters.hasOwnProperty(e.toLowerCase())
                                            ? i(function (e, t) {
                                                  for (var i, o = r(e, n), s = o.length; s--; )
                                                      (i = ee(e, o[s])), (e[i] = !(t[i] = o[s]));
                                              })
                                            : function (e) {
                                                  return r(e, 0, o);
                                              })
                                      : r;
                            },
                        },
                        pseudos: {
                            not: i(function (e) {
                                var t = [],
                                    n = [],
                                    o = $(e.replace(ae, "$1"));
                                return o[I]
                                    ? i(function (e, t, n, i) {
                                          for (var r, s = o(e, null, i, []), a = e.length; a--; )
                                              (r = s[a]) && (e[a] = !(t[a] = r));
                                      })
                                    : function (e, i, r) {
                                          return (t[0] = e), o(t, null, r, n), (t[0] = null), !n.pop();
                                      };
                            }),
                            has: i(function (e) {
                                return function (n) {
                                    return t(e, n).length > 0;
                                };
                            }),
                            contains: i(function (e) {
                                return (
                                    (e = e.replace(we, xe)),
                                    function (t) {
                                        return (t.textContent || t.innerText || T(t)).indexOf(e) > -1;
                                    }
                                );
                            }),
                            lang: i(function (e) {
                                return (
                                    pe.test(e || "") || t.error("unsupported lang: " + e),
                                    (e = e.replace(we, xe).toLowerCase()),
                                    function (t) {
                                        var n;
                                        do
                                            if ((n = q ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")))
                                                return (n = n.toLowerCase()), n === e || 0 === n.indexOf(e + "-");
                                        while ((t = t.parentNode) && 1 === t.nodeType);
                                        return !1;
                                    }
                                );
                            }),
                            target: function (t) {
                                var n = e.location && e.location.hash;
                                return n && n.slice(1) === t.id;
                            },
                            root: function (e) {
                                return e === H;
                            },
                            focus: function (e) {
                                return (
                                    e === O.activeElement &&
                                    (!O.hasFocus || O.hasFocus()) &&
                                    !!(e.type || e.href || ~e.tabIndex)
                                );
                            },
                            enabled: function (e) {
                                return e.disabled === !1;
                            },
                            disabled: function (e) {
                                return e.disabled === !0;
                            },
                            checked: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                            },
                            selected: function (e) {
                                return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
                            },
                            empty: function (e) {
                                for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                                return !0;
                            },
                            parent: function (e) {
                                return !k.pseudos.empty(e);
                            },
                            header: function (e) {
                                return ve.test(e.nodeName);
                            },
                            input: function (e) {
                                return he.test(e.nodeName);
                            },
                            button: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && "button" === e.type) || "button" === t;
                            },
                            text: function (e) {
                                var t;
                                return (
                                    "input" === e.nodeName.toLowerCase() &&
                                    "text" === e.type &&
                                    (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                                );
                            },
                            first: u(function () {
                                return [0];
                            }),
                            last: u(function (e, t) {
                                return [t - 1];
                            }),
                            eq: u(function (e, t, n) {
                                return [0 > n ? n + t : n];
                            }),
                            even: u(function (e, t) {
                                for (var n = 0; t > n; n += 2) e.push(n);
                                return e;
                            }),
                            odd: u(function (e, t) {
                                for (var n = 1; t > n; n += 2) e.push(n);
                                return e;
                            }),
                            lt: u(function (e, t, n) {
                                for (var i = 0 > n ? n + t : n; --i >= 0; ) e.push(i);
                                return e;
                            }),
                            gt: u(function (e, t, n) {
                                for (var i = 0 > n ? n + t : n; ++i < t; ) e.push(i);
                                return e;
                            }),
                        },
                    }),
                (k.pseudos.nth = k.pseudos.eq);
            for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) k.pseudos[w] = a(w);
            for (w in { submit: !0, reset: !0 }) k.pseudos[w] = l(w);
            return (
                (d.prototype = k.filters = k.pseudos),
                (k.setFilters = new d()),
                (C = t.tokenize =
                    function (e, n) {
                        var i,
                            o,
                            r,
                            s,
                            a,
                            l,
                            u,
                            c = B[e + " "];
                        if (c) return n ? 0 : c.slice(0);
                        for (a = e, l = [], u = k.preFilter; a; ) {
                            (i && !(o = le.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                                (i = !1),
                                (o = ue.exec(a)) &&
                                    ((i = o.shift()),
                                    r.push({ value: i, type: o[0].replace(ae, " ") }),
                                    (a = a.slice(i.length)));
                            for (s in k.filter)
                                !(o = fe[s].exec(a)) ||
                                    (u[s] && !(o = u[s](o))) ||
                                    ((i = o.shift()),
                                    r.push({ value: i, type: s, matches: o }),
                                    (a = a.slice(i.length)));
                            if (!i) break;
                        }
                        return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
                    }),
                ($ = t.compile =
                    function (e, t) {
                        var n,
                            i = [],
                            o = [],
                            r = U[e + " "];
                        if (!r) {
                            for (t || (t = C(e)), n = t.length; n--; ) (r = y(t[n])), r[I] ? i.push(r) : o.push(r);
                            (r = U(e, b(o, i))), (r.selector = e);
                        }
                        return r;
                    }),
                (E = t.select =
                    function (e, t, n, i) {
                        var o,
                            r,
                            s,
                            a,
                            l,
                            u = "function" == typeof e && e,
                            d = !i && C((e = u.selector || e));
                        if (((n = n || []), 1 === d.length)) {
                            if (
                                ((r = d[0] = d[0].slice(0)),
                                r.length > 2 &&
                                    "ID" === (s = r[0]).type &&
                                    x.getById &&
                                    9 === t.nodeType &&
                                    q &&
                                    k.relative[r[1].type])
                            ) {
                                if (((t = (k.find.ID(s.matches[0].replace(we, xe), t) || [])[0]), !t)) return n;
                                u && (t = t.parentNode), (e = e.slice(r.shift().value.length));
                            }
                            for (
                                o = fe.needsContext.test(e) ? 0 : r.length;
                                o-- && ((s = r[o]), !k.relative[(a = s.type)]);

                            )
                                if (
                                    (l = k.find[a]) &&
                                    (i = l(s.matches[0].replace(we, xe), (ye.test(r[0].type) && c(t.parentNode)) || t))
                                ) {
                                    if ((r.splice(o, 1), (e = i.length && p(r)), !e)) return Z.apply(n, i), n;
                                    break;
                                }
                        }
                        return (u || $(e, d))(i, t, !q, n, !t || (ye.test(e) && c(t.parentNode)) || t), n;
                    }),
                (x.sortStable = I.split("").sort(X).join("") === I),
                (x.detectDuplicates = !!N),
                D(),
                (x.sortDetached = o(function (e) {
                    return 1 & e.compareDocumentPosition(O.createElement("div"));
                })),
                o(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    r("type|href|height|width", function (e, t, n) {
                        return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (x.attributes &&
                    o(function (e) {
                        return (
                            (e.innerHTML = "<input/>"),
                            e.firstChild.setAttribute("value", ""),
                            "" === e.firstChild.getAttribute("value")
                        );
                    })) ||
                    r("value", function (e, t, n) {
                        return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
                    }),
                o(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    r(te, function (e, t, n) {
                        var i;
                        return n
                            ? void 0
                            : e[t] === !0
                              ? t.toLowerCase()
                              : (i = e.getAttributeNode(t)) && i.specified
                                ? i.value
                                : null;
                    }),
                t
            );
        })(e);
        (re.find = ce),
            (re.expr = ce.selectors),
            (re.expr[":"] = re.expr.pseudos),
            (re.uniqueSort = re.unique = ce.uniqueSort),
            (re.text = ce.getText),
            (re.isXMLDoc = ce.isXML),
            (re.contains = ce.contains);
        var de = function (e, t, n) {
                for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                    if (1 === e.nodeType) {
                        if (o && re(e).is(n)) break;
                        i.push(e);
                    }
                return i;
            },
            pe = function (e, t) {
                for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                return n;
            },
            fe = re.expr.match.needsContext,
            he = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
            ve = /^.[^:#\[\.,]*$/;
        (re.filter = function (e, t, n) {
            var i = t[0];
            return (
                n && (e = ":not(" + e + ")"),
                1 === t.length && 1 === i.nodeType
                    ? re.find.matchesSelector(i, e)
                        ? [i]
                        : []
                    : re.find.matches(
                          e,
                          re.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            re.fn.extend({
                find: function (e) {
                    var t,
                        n = this.length,
                        i = [],
                        o = this;
                    if ("string" != typeof e)
                        return this.pushStack(
                            re(e).filter(function () {
                                for (t = 0; n > t; t++) if (re.contains(o[t], this)) return !0;
                            })
                        );
                    for (t = 0; n > t; t++) re.find(e, o[t], i);
                    return (
                        (i = this.pushStack(n > 1 ? re.unique(i) : i)),
                        (i.selector = this.selector ? this.selector + " " + e : e),
                        i
                    );
                },
                filter: function (e) {
                    return this.pushStack(i(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(i(this, e || [], !0));
                },
                is: function (e) {
                    return !!i(this, "string" == typeof e && fe.test(e) ? re(e) : e || [], !1).length;
                },
            });
        var ge,
            me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
            ye = (re.fn.init = function (e, t, n) {
                var i, o;
                if (!e) return this;
                if (((n = n || ge), "string" == typeof e)) {
                    if (
                        ((i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : me.exec(e)),
                        !i || (!i[1] && t))
                    )
                        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                    if (i[1]) {
                        if (
                            ((t = t instanceof re ? t[0] : t),
                            re.merge(this, re.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : G, !0)),
                            he.test(i[1]) && re.isPlainObject(t))
                        )
                            for (i in t) re.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                        return this;
                    }
                    return (
                        (o = G.getElementById(i[2])),
                        o && o.parentNode && ((this.length = 1), (this[0] = o)),
                        (this.context = G),
                        (this.selector = e),
                        this
                    );
                }
                return e.nodeType
                    ? ((this.context = this[0] = e), (this.length = 1), this)
                    : re.isFunction(e)
                      ? void 0 !== n.ready
                          ? n.ready(e)
                          : e(re)
                      : (void 0 !== e.selector && ((this.selector = e.selector), (this.context = e.context)),
                        re.makeArray(e, this));
            });
        (ye.prototype = re.fn), (ge = re(G));
        var be = /^(?:parents|prev(?:Until|All))/,
            we = { children: !0, contents: !0, next: !0, prev: !0 };
        re.fn.extend({
            has: function (e) {
                var t = re(e, this),
                    n = t.length;
                return this.filter(function () {
                    for (var e = 0; n > e; e++) if (re.contains(this, t[e])) return !0;
                });
            },
            closest: function (e, t) {
                for (
                    var n,
                        i = 0,
                        o = this.length,
                        r = [],
                        s = fe.test(e) || "string" != typeof e ? re(e, t || this.context) : 0;
                    o > i;
                    i++
                )
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (
                            n.nodeType < 11 &&
                            (s ? s.index(n) > -1 : 1 === n.nodeType && re.find.matchesSelector(n, e))
                        ) {
                            r.push(n);
                            break;
                        }
                return this.pushStack(r.length > 1 ? re.uniqueSort(r) : r);
            },
            index: function (e) {
                return e
                    ? "string" == typeof e
                        ? K.call(re(e), this[0])
                        : K.call(this, e.jquery ? e[0] : e)
                    : this[0] && this[0].parentNode
                      ? this.first().prevAll().length
                      : -1;
            },
            add: function (e, t) {
                return this.pushStack(re.uniqueSort(re.merge(this.get(), re(e, t))));
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
        }),
            re.each(
                {
                    parent: function (e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function (e) {
                        return de(e, "parentNode");
                    },
                    parentsUntil: function (e, t, n) {
                        return de(e, "parentNode", n);
                    },
                    next: function (e) {
                        return o(e, "nextSibling");
                    },
                    prev: function (e) {
                        return o(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return de(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return de(e, "previousSibling");
                    },
                    nextUntil: function (e, t, n) {
                        return de(e, "nextSibling", n);
                    },
                    prevUntil: function (e, t, n) {
                        return de(e, "previousSibling", n);
                    },
                    siblings: function (e) {
                        return pe((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return pe(e.firstChild);
                    },
                    contents: function (e) {
                        return e.contentDocument || re.merge([], e.childNodes);
                    },
                },
                function (e, t) {
                    re.fn[e] = function (n, i) {
                        var o = re.map(this, t, n);
                        return (
                            "Until" !== e.slice(-5) && (i = n),
                            i && "string" == typeof i && (o = re.filter(i, o)),
                            this.length > 1 && (we[e] || re.uniqueSort(o), be.test(e) && o.reverse()),
                            this.pushStack(o)
                        );
                    };
                }
            );
        var xe = /\S+/g;
        (re.Callbacks = function (e) {
            e = "string" == typeof e ? r(e) : re.extend({}, e);
            var t,
                n,
                i,
                o,
                s = [],
                a = [],
                l = -1,
                u = function () {
                    for (o = e.once, i = t = !0; a.length; l = -1)
                        for (n = a.shift(); ++l < s.length; )
                            s[l].apply(n[0], n[1]) === !1 && e.stopOnFalse && ((l = s.length), (n = !1));
                    e.memory || (n = !1), (t = !1), o && (s = n ? [] : "");
                },
                c = {
                    add: function () {
                        return (
                            s &&
                                (n && !t && ((l = s.length - 1), a.push(n)),
                                (function t(n) {
                                    re.each(n, function (n, i) {
                                        re.isFunction(i)
                                            ? (e.unique && c.has(i)) || s.push(i)
                                            : i && i.length && "string" !== re.type(i) && t(i);
                                    });
                                })(arguments),
                                n && !t && u()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            re.each(arguments, function (e, t) {
                                for (var n; (n = re.inArray(t, s, n)) > -1; ) s.splice(n, 1), l >= n && l--;
                            }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? re.inArray(e, s) > -1 : s.length > 0;
                    },
                    empty: function () {
                        return s && (s = []), this;
                    },
                    disable: function () {
                        return (o = a = []), (s = n = ""), this;
                    },
                    disabled: function () {
                        return !s;
                    },
                    lock: function () {
                        return (o = a = []), n || (s = n = ""), this;
                    },
                    locked: function () {
                        return !!o;
                    },
                    fireWith: function (e, n) {
                        return o || ((n = n || []), (n = [e, n.slice ? n.slice() : n]), a.push(n), t || u()), this;
                    },
                    fire: function () {
                        return c.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!i;
                    },
                };
            return c;
        }),
            re.extend({
                Deferred: function (e) {
                    var t = [
                            ["resolve", "done", re.Callbacks("once memory"), "resolved"],
                            ["reject", "fail", re.Callbacks("once memory"), "rejected"],
                            ["notify", "progress", re.Callbacks("memory")],
                        ],
                        n = "pending",
                        i = {
                            state: function () {
                                return n;
                            },
                            always: function () {
                                return o.done(arguments).fail(arguments), this;
                            },
                            then: function () {
                                var e = arguments;
                                return re
                                    .Deferred(function (n) {
                                        re.each(t, function (t, r) {
                                            var s = re.isFunction(e[t]) && e[t];
                                            o[r[1]](function () {
                                                var e = s && s.apply(this, arguments);
                                                e && re.isFunction(e.promise)
                                                    ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject)
                                                    : n[r[0] + "With"](
                                                          this === i ? n.promise() : this,
                                                          s ? [e] : arguments
                                                      );
                                            });
                                        }),
                                            (e = null);
                                    })
                                    .promise();
                            },
                            promise: function (e) {
                                return null != e ? re.extend(e, i) : i;
                            },
                        },
                        o = {};
                    return (
                        (i.pipe = i.then),
                        re.each(t, function (e, r) {
                            var s = r[2],
                                a = r[3];
                            (i[r[1]] = s.add),
                                a &&
                                    s.add(
                                        function () {
                                            n = a;
                                        },
                                        t[1 ^ e][2].disable,
                                        t[2][2].lock
                                    ),
                                (o[r[0]] = function () {
                                    return o[r[0] + "With"](this === o ? i : this, arguments), this;
                                }),
                                (o[r[0] + "With"] = s.fireWith);
                        }),
                        i.promise(o),
                        e && e.call(o, o),
                        o
                    );
                },
                when: function (e) {
                    var t,
                        n,
                        i,
                        o = 0,
                        r = Q.call(arguments),
                        s = r.length,
                        a = 1 !== s || (e && re.isFunction(e.promise)) ? s : 0,
                        l = 1 === a ? e : re.Deferred(),
                        u = function (e, n, i) {
                            return function (o) {
                                (n[e] = this),
                                    (i[e] = arguments.length > 1 ? Q.call(arguments) : o),
                                    i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i);
                            };
                        };
                    if (s > 1)
                        for (t = new Array(s), n = new Array(s), i = new Array(s); s > o; o++)
                            r[o] && re.isFunction(r[o].promise)
                                ? r[o]
                                      .promise()
                                      .progress(u(o, n, t))
                                      .done(u(o, i, r))
                                      .fail(l.reject)
                                : --a;
                    return a || l.resolveWith(i, r), l.promise();
                },
            });
        var ke;
        (re.fn.ready = function (e) {
            return re.ready.promise().done(e), this;
        }),
            re.extend({
                isReady: !1,
                readyWait: 1,
                holdReady: function (e) {
                    e ? re.readyWait++ : re.ready(!0);
                },
                ready: function (e) {
                    (e === !0 ? --re.readyWait : re.isReady) ||
                        ((re.isReady = !0),
                        (e !== !0 && --re.readyWait > 0) ||
                            (ke.resolveWith(G, [re]),
                            re.fn.triggerHandler && (re(G).triggerHandler("ready"), re(G).off("ready"))));
                },
            }),
            (re.ready.promise = function (t) {
                return (
                    ke ||
                        ((ke = re.Deferred()),
                        "complete" === G.readyState || ("loading" !== G.readyState && !G.documentElement.doScroll)
                            ? e.setTimeout(re.ready)
                            : (G.addEventListener("DOMContentLoaded", s), e.addEventListener("load", s))),
                    ke.promise(t)
                );
            }),
            re.ready.promise();
        var Te = function (e, t, n, i, o, r, s) {
                var a = 0,
                    l = e.length,
                    u = null == n;
                if ("object" === re.type(n)) {
                    o = !0;
                    for (a in n) Te(e, t, a, n[a], !0, r, s);
                } else if (
                    void 0 !== i &&
                    ((o = !0),
                    re.isFunction(i) || (s = !0),
                    u &&
                        (s
                            ? (t.call(e, i), (t = null))
                            : ((u = t),
                              (t = function (e, t, n) {
                                  return u.call(re(e), n);
                              }))),
                    t)
                )
                    for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
                return o ? e : u ? t.call(e) : l ? t(e[0], n) : r;
            },
            Se = function (e) {
                return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
            };
        (a.uid = 1),
            (a.prototype = {
                register: function (e, t) {
                    var n = t || {};
                    return (
                        e.nodeType
                            ? (e[this.expando] = n)
                            : Object.defineProperty(e, this.expando, { value: n, writable: !0, configurable: !0 }),
                        e[this.expando]
                    );
                },
                cache: function (e) {
                    if (!Se(e)) return {};
                    var t = e[this.expando];
                    return (
                        t ||
                            ((t = {}),
                            Se(e) &&
                                (e.nodeType
                                    ? (e[this.expando] = t)
                                    : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                        t
                    );
                },
                set: function (e, t, n) {
                    var i,
                        o = this.cache(e);
                    if ("string" == typeof t) o[t] = n;
                    else for (i in t) o[i] = t[i];
                    return o;
                },
                get: function (e, t) {
                    return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t];
                },
                access: function (e, t, n) {
                    var i;
                    return void 0 === t || (t && "string" == typeof t && void 0 === n)
                        ? ((i = this.get(e, t)), void 0 !== i ? i : this.get(e, re.camelCase(t)))
                        : (this.set(e, t, n), void 0 !== n ? n : t);
                },
                remove: function (e, t) {
                    var n,
                        i,
                        o,
                        r = e[this.expando];
                    if (void 0 !== r) {
                        if (void 0 === t) this.register(e);
                        else {
                            re.isArray(t)
                                ? (i = t.concat(t.map(re.camelCase)))
                                : ((o = re.camelCase(t)),
                                  t in r ? (i = [t, o]) : ((i = o), (i = i in r ? [i] : i.match(xe) || []))),
                                (n = i.length);
                            for (; n--; ) delete r[i[n]];
                        }
                        (void 0 === t || re.isEmptyObject(r)) &&
                            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                    }
                },
                hasData: function (e) {
                    var t = e[this.expando];
                    return void 0 !== t && !re.isEmptyObject(t);
                },
            });
        var Ce = new a(),
            $e = new a(),
            Ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            Ae = /[A-Z]/g;
        re.extend({
            hasData: function (e) {
                return $e.hasData(e) || Ce.hasData(e);
            },
            data: function (e, t, n) {
                return $e.access(e, t, n);
            },
            removeData: function (e, t) {
                $e.remove(e, t);
            },
            _data: function (e, t, n) {
                return Ce.access(e, t, n);
            },
            _removeData: function (e, t) {
                Ce.remove(e, t);
            },
        }),
            re.fn.extend({
                data: function (e, t) {
                    var n,
                        i,
                        o,
                        r = this[0],
                        s = r && r.attributes;
                    if (void 0 === e) {
                        if (this.length && ((o = $e.get(r)), 1 === r.nodeType && !Ce.get(r, "hasDataAttrs"))) {
                            for (n = s.length; n--; )
                                s[n] &&
                                    ((i = s[n].name),
                                    0 === i.indexOf("data-") && ((i = re.camelCase(i.slice(5))), l(r, i, o[i])));
                            Ce.set(r, "hasDataAttrs", !0);
                        }
                        return o;
                    }
                    return "object" == typeof e
                        ? this.each(function () {
                              $e.set(this, e);
                          })
                        : Te(
                              this,
                              function (t) {
                                  var n, i;
                                  if (r && void 0 === t) {
                                      if (
                                          ((n = $e.get(r, e) || $e.get(r, e.replace(Ae, "-$&").toLowerCase())),
                                          void 0 !== n)
                                      )
                                          return n;
                                      if (((i = re.camelCase(e)), (n = $e.get(r, i)), void 0 !== n)) return n;
                                      if (((n = l(r, i, void 0)), void 0 !== n)) return n;
                                  } else
                                      (i = re.camelCase(e)),
                                          this.each(function () {
                                              var n = $e.get(this, i);
                                              $e.set(this, i, t),
                                                  e.indexOf("-") > -1 && void 0 !== n && $e.set(this, e, t);
                                          });
                              },
                              null,
                              t,
                              arguments.length > 1,
                              null,
                              !0
                          );
                },
                removeData: function (e) {
                    return this.each(function () {
                        $e.remove(this, e);
                    });
                },
            }),
            re.extend({
                queue: function (e, t, n) {
                    var i;
                    return e
                        ? ((t = (t || "fx") + "queue"),
                          (i = Ce.get(e, t)),
                          n && (!i || re.isArray(n) ? (i = Ce.access(e, t, re.makeArray(n))) : i.push(n)),
                          i || [])
                        : void 0;
                },
                dequeue: function (e, t) {
                    t = t || "fx";
                    var n = re.queue(e, t),
                        i = n.length,
                        o = n.shift(),
                        r = re._queueHooks(e, t),
                        s = function () {
                            re.dequeue(e, t);
                        };
                    "inprogress" === o && ((o = n.shift()), i--),
                        o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, s, r)),
                        !i && r && r.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var n = t + "queueHooks";
                    return (
                        Ce.get(e, n) ||
                        Ce.access(e, n, {
                            empty: re.Callbacks("once memory").add(function () {
                                Ce.remove(e, [t + "queue", n]);
                            }),
                        })
                    );
                },
            }),
            re.fn.extend({
                queue: function (e, t) {
                    var n = 2;
                    return (
                        "string" != typeof e && ((t = e), (e = "fx"), n--),
                        arguments.length < n
                            ? re.queue(this[0], e)
                            : void 0 === t
                              ? this
                              : this.each(function () {
                                    var n = re.queue(this, e, t);
                                    re._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e);
                                })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        re.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    var n,
                        i = 1,
                        o = re.Deferred(),
                        r = this,
                        s = this.length,
                        a = function () {
                            --i || o.resolveWith(r, [r]);
                        };
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--; )
                        (n = Ce.get(r[s], e + "queueHooks")), n && n.empty && (i++, n.empty.add(a));
                    return a(), o.promise(t);
                },
            });
        var je = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            Ne = new RegExp("^(?:([+-])=|)(" + je + ")([a-z%]*)$", "i"),
            De = ["Top", "Right", "Bottom", "Left"],
            Oe = function (e, t) {
                return (e = t || e), "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e);
            },
            He = /^(?:checkbox|radio)$/i,
            qe = /<([\w:-]+)/,
            Pe = /^$|\/(?:java|ecma)script/i,
            Le = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        (Le.optgroup = Le.option), (Le.tbody = Le.tfoot = Le.colgroup = Le.caption = Le.thead), (Le.th = Le.td);
        var _e = /<|&#?\w+;/;
        !(function () {
            var e = G.createDocumentFragment(),
                t = e.appendChild(G.createElement("div")),
                n = G.createElement("input");
            n.setAttribute("type", "radio"),
                n.setAttribute("checked", "checked"),
                n.setAttribute("name", "t"),
                t.appendChild(n),
                (ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (t.innerHTML = "<textarea>x</textarea>"),
                (ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
        })();
        var ze = /^key/,
            Ie = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            Fe = /^([^.]*)(?:\.(.+)|)/;
        (re.event = {
            global: {},
            add: function (e, t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p,
                    f,
                    h,
                    v,
                    g = Ce.get(e);
                if (g)
                    for (
                        n.handler && ((r = n), (n = r.handler), (o = r.selector)),
                            n.guid || (n.guid = re.guid++),
                            (l = g.events) || (l = g.events = {}),
                            (s = g.handle) ||
                                (s = g.handle =
                                    function (t) {
                                        return "undefined" != typeof re && re.event.triggered !== t.type
                                            ? re.event.dispatch.apply(e, arguments)
                                            : void 0;
                                    }),
                            t = (t || "").match(xe) || [""],
                            u = t.length;
                        u--;

                    )
                        (a = Fe.exec(t[u]) || []),
                            (f = v = a[1]),
                            (h = (a[2] || "").split(".").sort()),
                            f &&
                                ((d = re.event.special[f] || {}),
                                (f = (o ? d.delegateType : d.bindType) || f),
                                (d = re.event.special[f] || {}),
                                (c = re.extend(
                                    {
                                        type: f,
                                        origType: v,
                                        data: i,
                                        handler: n,
                                        guid: n.guid,
                                        selector: o,
                                        needsContext: o && re.expr.match.needsContext.test(o),
                                        namespace: h.join("."),
                                    },
                                    r
                                )),
                                (p = l[f]) ||
                                    ((p = l[f] = []),
                                    (p.delegateCount = 0),
                                    (d.setup && d.setup.call(e, i, h, s) !== !1) ||
                                        (e.addEventListener && e.addEventListener(f, s))),
                                d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                                o ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                                (re.event.global[f] = !0));
            },
            remove: function (e, t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p,
                    f,
                    h,
                    v,
                    g = Ce.hasData(e) && Ce.get(e);
                if (g && (l = g.events)) {
                    for (t = (t || "").match(xe) || [""], u = t.length; u--; )
                        if (((a = Fe.exec(t[u]) || []), (f = v = a[1]), (h = (a[2] || "").split(".").sort()), f)) {
                            for (
                                d = re.event.special[f] || {},
                                    f = (i ? d.delegateType : d.bindType) || f,
                                    p = l[f] || [],
                                    a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                                    s = r = p.length;
                                r--;

                            )
                                (c = p[r]),
                                    (!o && v !== c.origType) ||
                                        (n && n.guid !== c.guid) ||
                                        (a && !a.test(c.namespace)) ||
                                        (i && i !== c.selector && ("**" !== i || !c.selector)) ||
                                        (p.splice(r, 1),
                                        c.selector && p.delegateCount--,
                                        d.remove && d.remove.call(e, c));
                            s &&
                                !p.length &&
                                ((d.teardown && d.teardown.call(e, h, g.handle) !== !1) ||
                                    re.removeEvent(e, f, g.handle),
                                delete l[f]);
                        } else for (f in l) re.event.remove(e, f + t[u], n, i, !0);
                    re.isEmptyObject(l) && Ce.remove(e, "handle events");
                }
            },
            dispatch: function (e) {
                e = re.event.fix(e);
                var t,
                    n,
                    i,
                    o,
                    r,
                    s = [],
                    a = Q.call(arguments),
                    l = (Ce.get(this, "events") || {})[e.type] || [],
                    u = re.event.special[e.type] || {};
                if (((a[0] = e), (e.delegateTarget = this), !u.preDispatch || u.preDispatch.call(this, e) !== !1)) {
                    for (s = re.event.handlers.call(this, e, l), t = 0; (o = s[t++]) && !e.isPropagationStopped(); )
                        for (
                            e.currentTarget = o.elem, n = 0;
                            (r = o.handlers[n++]) && !e.isImmediatePropagationStopped();

                        )
                            (e.rnamespace && !e.rnamespace.test(r.namespace)) ||
                                ((e.handleObj = r),
                                (e.data = r.data),
                                (i = ((re.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)),
                                void 0 !== i && (e.result = i) === !1 && (e.preventDefault(), e.stopPropagation()));
                    return u.postDispatch && u.postDispatch.call(this, e), e.result;
                }
            },
            handlers: function (e, t) {
                var n,
                    i,
                    o,
                    r,
                    s = [],
                    a = t.delegateCount,
                    l = e.target;
                if (a && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1))
                    for (; l !== this; l = l.parentNode || this)
                        if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
                            for (i = [], n = 0; a > n; n++)
                                (r = t[n]),
                                    (o = r.selector + " "),
                                    void 0 === i[o] &&
                                        (i[o] = r.needsContext
                                            ? re(o, this).index(l) > -1
                                            : re.find(o, this, null, [l]).length),
                                    i[o] && i.push(r);
                            i.length && s.push({ elem: l, handlers: i });
                        }
                return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
            },
            props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
                " "
            ),
            fixHooks: {},
            keyHooks: {
                props: "char charCode key keyCode".split(" "),
                filter: function (e, t) {
                    return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
                },
            },
            mouseHooks: {
                props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
                    " "
                ),
                filter: function (e, t) {
                    var n,
                        i,
                        o,
                        r = t.button;
                    return (
                        null == e.pageX &&
                            null != t.clientX &&
                            ((n = e.target.ownerDocument || G),
                            (i = n.documentElement),
                            (o = n.body),
                            (e.pageX =
                                t.clientX +
                                ((i && i.scrollLeft) || (o && o.scrollLeft) || 0) -
                                ((i && i.clientLeft) || (o && o.clientLeft) || 0)),
                            (e.pageY =
                                t.clientY +
                                ((i && i.scrollTop) || (o && o.scrollTop) || 0) -
                                ((i && i.clientTop) || (o && o.clientTop) || 0))),
                        e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0),
                        e
                    );
                },
            },
            fix: function (e) {
                if (e[re.expando]) return e;
                var t,
                    n,
                    i,
                    o = e.type,
                    r = e,
                    s = this.fixHooks[o];
                for (
                    s || (this.fixHooks[o] = s = Ie.test(o) ? this.mouseHooks : ze.test(o) ? this.keyHooks : {}),
                        i = s.props ? this.props.concat(s.props) : this.props,
                        e = new re.Event(r),
                        t = i.length;
                    t--;

                )
                    (n = i[t]), (e[n] = r[n]);
                return (
                    e.target || (e.target = G),
                    3 === e.target.nodeType && (e.target = e.target.parentNode),
                    s.filter ? s.filter(e, r) : e
                );
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        return this !== v() && this.focus ? (this.focus(), !1) : void 0;
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        return this === v() && this.blur ? (this.blur(), !1) : void 0;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        return "checkbox" === this.type && this.click && re.nodeName(this, "input")
                            ? (this.click(), !1)
                            : void 0;
                    },
                    _default: function (e) {
                        return re.nodeName(e.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
        }),
            (re.removeEvent = function (e, t, n) {
                e.removeEventListener && e.removeEventListener(t, n);
            }),
            (re.Event = function (e, t) {
                return this instanceof re.Event
                    ? (e && e.type
                          ? ((this.originalEvent = e),
                            (this.type = e.type),
                            (this.isDefaultPrevented =
                                e.defaultPrevented || (void 0 === e.defaultPrevented && e.returnValue === !1) ? f : h))
                          : (this.type = e),
                      t && re.extend(this, t),
                      (this.timeStamp = (e && e.timeStamp) || re.now()),
                      void (this[re.expando] = !0))
                    : new re.Event(e, t);
            }),
            (re.Event.prototype = {
                constructor: re.Event,
                isDefaultPrevented: h,
                isPropagationStopped: h,
                isImmediatePropagationStopped: h,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = f), e && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = f), e && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = f), e && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            re.each(
                {
                    mouseenter: "mouseover",
                    mouseleave: "mouseout",
                    pointerenter: "pointerover",
                    pointerleave: "pointerout",
                },
                function (e, t) {
                    re.event.special[e] = {
                        delegateType: t,
                        bindType: t,
                        handle: function (e) {
                            var n,
                                i = this,
                                o = e.relatedTarget,
                                r = e.handleObj;
                            return (
                                (o && (o === i || re.contains(i, o))) ||
                                    ((e.type = r.origType), (n = r.handler.apply(this, arguments)), (e.type = t)),
                                n
                            );
                        },
                    };
                }
            ),
            re.fn.extend({
                on: function (e, t, n, i) {
                    return g(this, e, t, n, i);
                },
                one: function (e, t, n, i) {
                    return g(this, e, t, n, i, 1);
                },
                off: function (e, t, n) {
                    var i, o;
                    if (e && e.preventDefault && e.handleObj)
                        return (
                            (i = e.handleObj),
                            re(e.delegateTarget).off(
                                i.namespace ? i.origType + "." + i.namespace : i.origType,
                                i.selector,
                                i.handler
                            ),
                            this
                        );
                    if ("object" == typeof e) {
                        for (o in e) this.off(o, t, e[o]);
                        return this;
                    }
                    return (
                        (t !== !1 && "function" != typeof t) || ((n = t), (t = void 0)),
                        n === !1 && (n = h),
                        this.each(function () {
                            re.event.remove(this, e, n, t);
                        })
                    );
                },
            });
        var Me = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
            Re = /<script|<style|<link/i,
            We = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Be = /^true\/(.*)/,
            Ue = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        re.extend({
            htmlPrefilter: function (e) {
                return e.replace(Me, "<$1></$2>");
            },
            clone: function (e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a = e.cloneNode(!0),
                    l = re.contains(e.ownerDocument, e);
                if (!(ie.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || re.isXMLDoc(e)))
                    for (s = c(a), r = c(e), i = 0, o = r.length; o > i; i++) x(r[i], s[i]);
                if (t)
                    if (n) for (r = r || c(e), s = s || c(a), i = 0, o = r.length; o > i; i++) w(r[i], s[i]);
                    else w(e, a);
                return (s = c(a, "script")), s.length > 0 && d(s, !l && c(e, "script")), a;
            },
            cleanData: function (e) {
                for (var t, n, i, o = re.event.special, r = 0; void 0 !== (n = e[r]); r++)
                    if (Se(n)) {
                        if ((t = n[Ce.expando])) {
                            if (t.events)
                                for (i in t.events) o[i] ? re.event.remove(n, i) : re.removeEvent(n, i, t.handle);
                            n[Ce.expando] = void 0;
                        }
                        n[$e.expando] && (n[$e.expando] = void 0);
                    }
            },
        }),
            re.fn.extend({
                domManip: k,
                detach: function (e) {
                    return T(this, e, !0);
                },
                remove: function (e) {
                    return T(this, e);
                },
                text: function (e) {
                    return Te(
                        this,
                        function (e) {
                            return void 0 === e
                                ? re.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                                          (this.textContent = e);
                                  });
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return k(this, arguments, function (e) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var t = m(this, e);
                            t.appendChild(e);
                        }
                    });
                },
                prepend: function () {
                    return k(this, arguments, function (e) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var t = m(this, e);
                            t.insertBefore(e, t.firstChild);
                        }
                    });
                },
                before: function () {
                    return k(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return k(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++)
                        1 === e.nodeType && (re.cleanData(c(e, !1)), (e.textContent = ""));
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return re.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return Te(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !Re.test(e) && !Le[(qe.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = re.htmlPrefilter(e);
                                try {
                                    for (; i > n; n++)
                                        (t = this[n] || {}),
                                            1 === t.nodeType && (re.cleanData(c(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var e = [];
                    return k(
                        this,
                        arguments,
                        function (t) {
                            var n = this.parentNode;
                            re.inArray(this, e) < 0 && (re.cleanData(c(this)), n && n.replaceChild(t, this));
                        },
                        e
                    );
                },
            }),
            re.each(
                {
                    appendTo: "append",
                    prependTo: "prepend",
                    insertBefore: "before",
                    insertAfter: "after",
                    replaceAll: "replaceWith",
                },
                function (e, t) {
                    re.fn[e] = function (e) {
                        for (var n, i = [], o = re(e), r = o.length - 1, s = 0; r >= s; s++)
                            (n = s === r ? this : this.clone(!0)), re(o[s])[t](n), Z.apply(i, n.get());
                        return this.pushStack(i);
                    };
                }
            );
        var Xe,
            Ye = { HTML: "block", BODY: "block" },
            Ve = /^margin/,
            Ge = new RegExp("^(" + je + ")(?!px)[a-z%]+$", "i"),
            Qe = function (t) {
                var n = t.ownerDocument.defaultView;
                return (n && n.opener) || (n = e), n.getComputedStyle(t);
            },
            Je = function (e, t, n, i) {
                var o,
                    r,
                    s = {};
                for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
                o = n.apply(e, i || []);
                for (r in t) e.style[r] = s[r];
                return o;
            },
            Ze = G.documentElement;
        !(function () {
            function t() {
                (a.style.cssText =
                    "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
                    (a.innerHTML = ""),
                    Ze.appendChild(s);
                var t = e.getComputedStyle(a);
                (n = "1%" !== t.top),
                    (r = "2px" === t.marginLeft),
                    (i = "4px" === t.width),
                    (a.style.marginRight = "50%"),
                    (o = "4px" === t.marginRight),
                    Ze.removeChild(s);
            }
            var n,
                i,
                o,
                r,
                s = G.createElement("div"),
                a = G.createElement("div");
            a.style &&
                ((a.style.backgroundClip = "content-box"),
                (a.cloneNode(!0).style.backgroundClip = ""),
                (ie.clearCloneStyle = "content-box" === a.style.backgroundClip),
                (s.style.cssText =
                    "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
                s.appendChild(a),
                re.extend(ie, {
                    pixelPosition: function () {
                        return t(), n;
                    },
                    boxSizingReliable: function () {
                        return null == i && t(), i;
                    },
                    pixelMarginRight: function () {
                        return null == i && t(), o;
                    },
                    reliableMarginLeft: function () {
                        return null == i && t(), r;
                    },
                    reliableMarginRight: function () {
                        var t,
                            n = a.appendChild(G.createElement("div"));
                        return (
                            (n.style.cssText = a.style.cssText =
                                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
                            (n.style.marginRight = n.style.width = "0"),
                            (a.style.width = "1px"),
                            Ze.appendChild(s),
                            (t = !parseFloat(e.getComputedStyle(n).marginRight)),
                            Ze.removeChild(s),
                            a.removeChild(n),
                            t
                        );
                    },
                }));
        })();
        var Ke = /^(none|table(?!-c[ea]).+)/,
            et = { position: "absolute", visibility: "hidden", display: "block" },
            tt = { letterSpacing: "0", fontWeight: "400" },
            nt = ["Webkit", "O", "Moz", "ms"],
            it = G.createElement("div").style;
        re.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) {
                            var n = $(e, "opacity");
                            return "" === n ? "1" : n;
                        }
                    },
                },
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
            },
            cssProps: { float: "cssFloat" },
            style: function (e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        r,
                        s,
                        a = re.camelCase(t),
                        l = e.style;
                    return (
                        (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
                        (s = re.cssHooks[t] || re.cssHooks[a]),
                        void 0 === n
                            ? s && "get" in s && void 0 !== (o = s.get(e, !1, i))
                                ? o
                                : l[t]
                            : ((r = typeof n),
                              "string" === r && (o = Ne.exec(n)) && o[1] && ((n = u(e, t, o)), (r = "number")),
                              void (
                                  null != n &&
                                  n === n &&
                                  ("number" === r && (n += (o && o[3]) || (re.cssNumber[a] ? "" : "px")),
                                  ie.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                                  (s && "set" in s && void 0 === (n = s.set(e, n, i))) || (l[t] = n))
                              ))
                    );
                }
            },
            css: function (e, t, n, i) {
                var o,
                    r,
                    s,
                    a = re.camelCase(t);
                return (
                    (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
                    (s = re.cssHooks[t] || re.cssHooks[a]),
                    s && "get" in s && (o = s.get(e, !0, n)),
                    void 0 === o && (o = $(e, t, i)),
                    "normal" === o && t in tt && (o = tt[t]),
                    "" === n || n ? ((r = parseFloat(o)), n === !0 || isFinite(r) ? r || 0 : o) : o
                );
            },
        }),
            re.each(["height", "width"], function (e, t) {
                re.cssHooks[t] = {
                    get: function (e, n, i) {
                        return n
                            ? Ke.test(re.css(e, "display")) && 0 === e.offsetWidth
                                ? Je(e, et, function () {
                                      return D(e, t, i);
                                  })
                                : D(e, t, i)
                            : void 0;
                    },
                    set: function (e, n, i) {
                        var o,
                            r = i && Qe(e),
                            s = i && N(e, t, i, "border-box" === re.css(e, "boxSizing", !1, r), r);
                        return (
                            s && (o = Ne.exec(n)) && "px" !== (o[3] || "px") && ((e.style[t] = n), (n = re.css(e, t))),
                            j(e, n, s)
                        );
                    },
                };
            }),
            (re.cssHooks.marginLeft = E(ie.reliableMarginLeft, function (e, t) {
                return t
                    ? (parseFloat($(e, "marginLeft")) ||
                          e.getBoundingClientRect().left -
                              Je(e, { marginLeft: 0 }, function () {
                                  return e.getBoundingClientRect().left;
                              })) + "px"
                    : void 0;
            })),
            (re.cssHooks.marginRight = E(ie.reliableMarginRight, function (e, t) {
                return t ? Je(e, { display: "inline-block" }, $, [e, "marginRight"]) : void 0;
            })),
            re.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                (re.cssHooks[e + t] = {
                    expand: function (n) {
                        for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++)
                            o[e + De[i] + t] = r[i] || r[i - 2] || r[0];
                        return o;
                    },
                }),
                    Ve.test(e) || (re.cssHooks[e + t].set = j);
            }),
            re.fn.extend({
                css: function (e, t) {
                    return Te(
                        this,
                        function (e, t, n) {
                            var i,
                                o,
                                r = {},
                                s = 0;
                            if (re.isArray(t)) {
                                for (i = Qe(e), o = t.length; o > s; s++) r[t[s]] = re.css(e, t[s], !1, i);
                                return r;
                            }
                            return void 0 !== n ? re.style(e, t, n) : re.css(e, t);
                        },
                        e,
                        t,
                        arguments.length > 1
                    );
                },
                show: function () {
                    return O(this, !0);
                },
                hide: function () {
                    return O(this);
                },
                toggle: function (e) {
                    return "boolean" == typeof e
                        ? e
                            ? this.show()
                            : this.hide()
                        : this.each(function () {
                              Oe(this) ? re(this).show() : re(this).hide();
                          });
                },
            }),
            (re.Tween = H),
            (H.prototype = {
                constructor: H,
                init: function (e, t, n, i, o, r) {
                    (this.elem = e),
                        (this.prop = n),
                        (this.easing = o || re.easing._default),
                        (this.options = t),
                        (this.start = this.now = this.cur()),
                        (this.end = i),
                        (this.unit = r || (re.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                    var e = H.propHooks[this.prop];
                    return e && e.get ? e.get(this) : H.propHooks._default.get(this);
                },
                run: function (e) {
                    var t,
                        n = H.propHooks[this.prop];
                    return (
                        this.options.duration
                            ? (this.pos = t =
                                  re.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                            : (this.pos = t = e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        n && n.set ? n.set(this) : H.propHooks._default.set(this),
                        this
                    );
                },
            }),
            (H.prototype.init.prototype = H.prototype),
            (H.propHooks = {
                _default: {
                    get: function (e) {
                        var t;
                        return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                            ? e.elem[e.prop]
                            : ((t = re.css(e.elem, e.prop, "")), t && "auto" !== t ? t : 0);
                    },
                    set: function (e) {
                        re.fx.step[e.prop]
                            ? re.fx.step[e.prop](e)
                            : 1 !== e.elem.nodeType ||
                                (null == e.elem.style[re.cssProps[e.prop]] && !re.cssHooks[e.prop])
                              ? (e.elem[e.prop] = e.now)
                              : re.style(e.elem, e.prop, e.now + e.unit);
                    },
                },
            }),
            (H.propHooks.scrollTop = H.propHooks.scrollLeft =
                {
                    set: function (e) {
                        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                    },
                }),
            (re.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (re.fx = H.prototype.init),
            (re.fx.step = {});
        var ot,
            rt,
            st = /^(?:toggle|show|hide)$/,
            at = /queueHooks$/;
        (re.Animation = re.extend(I, {
            tweeners: {
                "*": [
                    function (e, t) {
                        var n = this.createTween(e, t);
                        return u(n.elem, e, Ne.exec(t), n), n;
                    },
                ],
            },
            tweener: function (e, t) {
                re.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(xe));
                for (var n, i = 0, o = e.length; o > i; i++)
                    (n = e[i]), (I.tweeners[n] = I.tweeners[n] || []), I.tweeners[n].unshift(t);
            },
            prefilters: [_],
            prefilter: function (e, t) {
                t ? I.prefilters.unshift(e) : I.prefilters.push(e);
            },
        })),
            (re.speed = function (e, t, n) {
                var i =
                    e && "object" == typeof e
                        ? re.extend({}, e)
                        : {
                              complete: n || (!n && t) || (re.isFunction(e) && e),
                              duration: e,
                              easing: (n && t) || (t && !re.isFunction(t) && t),
                          };
                return (
                    (i.duration = re.fx.off
                        ? 0
                        : "number" == typeof i.duration
                          ? i.duration
                          : i.duration in re.fx.speeds
                            ? re.fx.speeds[i.duration]
                            : re.fx.speeds._default),
                    (null != i.queue && i.queue !== !0) || (i.queue = "fx"),
                    (i.old = i.complete),
                    (i.complete = function () {
                        re.isFunction(i.old) && i.old.call(this), i.queue && re.dequeue(this, i.queue);
                    }),
                    i
                );
            }),
            re.fn.extend({
                fadeTo: function (e, t, n, i) {
                    return this.filter(Oe).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                },
                animate: function (e, t, n, i) {
                    var o = re.isEmptyObject(e),
                        r = re.speed(t, n, i),
                        s = function () {
                            var t = I(this, re.extend({}, e), r);
                            (o || Ce.get(this, "finish")) && t.stop(!0);
                        };
                    return (s.finish = s), o || r.queue === !1 ? this.each(s) : this.queue(r.queue, s);
                },
                stop: function (e, t, n) {
                    var i = function (e) {
                        var t = e.stop;
                        delete e.stop, t(n);
                    };
                    return (
                        "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                        t && e !== !1 && this.queue(e || "fx", []),
                        this.each(function () {
                            var t = !0,
                                o = null != e && e + "queueHooks",
                                r = re.timers,
                                s = Ce.get(this);
                            if (o) s[o] && s[o].stop && i(s[o]);
                            else for (o in s) s[o] && s[o].stop && at.test(o) && i(s[o]);
                            for (o = r.length; o--; )
                                r[o].elem !== this ||
                                    (null != e && r[o].queue !== e) ||
                                    (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
                            (!t && n) || re.dequeue(this, e);
                        })
                    );
                },
                finish: function (e) {
                    return (
                        e !== !1 && (e = e || "fx"),
                        this.each(function () {
                            var t,
                                n = Ce.get(this),
                                i = n[e + "queue"],
                                o = n[e + "queueHooks"],
                                r = re.timers,
                                s = i ? i.length : 0;
                            for (
                                n.finish = !0,
                                    re.queue(this, e, []),
                                    o && o.stop && o.stop.call(this, !0),
                                    t = r.length;
                                t--;

                            )
                                r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                            for (t = 0; s > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
                            delete n.finish;
                        })
                    );
                },
            }),
            re.each(["toggle", "show", "hide"], function (e, t) {
                var n = re.fn[t];
                re.fn[t] = function (e, i, o) {
                    return null == e || "boolean" == typeof e
                        ? n.apply(this, arguments)
                        : this.animate(P(t, !0), e, i, o);
                };
            }),
            re.each(
                {
                    slideDown: P("show"),
                    slideUp: P("hide"),
                    slideToggle: P("toggle"),
                    fadeIn: { opacity: "show" },
                    fadeOut: { opacity: "hide" },
                    fadeToggle: { opacity: "toggle" },
                },
                function (e, t) {
                    re.fn[e] = function (e, n, i) {
                        return this.animate(t, e, n, i);
                    };
                }
            ),
            (re.timers = []),
            (re.fx.tick = function () {
                var e,
                    t = 0,
                    n = re.timers;
                for (ot = re.now(); t < n.length; t++) (e = n[t]), e() || n[t] !== e || n.splice(t--, 1);
                n.length || re.fx.stop(), (ot = void 0);
            }),
            (re.fx.timer = function (e) {
                re.timers.push(e), e() ? re.fx.start() : re.timers.pop();
            }),
            (re.fx.interval = 13),
            (re.fx.start = function () {
                rt || (rt = e.setInterval(re.fx.tick, re.fx.interval));
            }),
            (re.fx.stop = function () {
                e.clearInterval(rt), (rt = null);
            }),
            (re.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (re.fn.delay = function (t, n) {
                return (
                    (t = re.fx ? re.fx.speeds[t] || t : t),
                    (n = n || "fx"),
                    this.queue(n, function (n, i) {
                        var o = e.setTimeout(n, t);
                        i.stop = function () {
                            e.clearTimeout(o);
                        };
                    })
                );
            }),
            (function () {
                var e = G.createElement("input"),
                    t = G.createElement("select"),
                    n = t.appendChild(G.createElement("option"));
                (e.type = "checkbox"),
                    (ie.checkOn = "" !== e.value),
                    (ie.optSelected = n.selected),
                    (t.disabled = !0),
                    (ie.optDisabled = !n.disabled),
                    (e = G.createElement("input")),
                    (e.value = "t"),
                    (e.type = "radio"),
                    (ie.radioValue = "t" === e.value);
            })();
        var lt,
            ut = re.expr.attrHandle;
        re.fn.extend({
            attr: function (e, t) {
                return Te(this, re.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    re.removeAttr(this, e);
                });
            },
        }),
            re.extend({
                attr: function (e, t, n) {
                    var i,
                        o,
                        r = e.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return "undefined" == typeof e.getAttribute
                            ? re.prop(e, t, n)
                            : ((1 === r && re.isXMLDoc(e)) ||
                                  ((t = t.toLowerCase()),
                                  (o = re.attrHooks[t] || (re.expr.match.bool.test(t) ? lt : void 0))),
                              void 0 !== n
                                  ? null === n
                                      ? void re.removeAttr(e, t)
                                      : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                        ? i
                                        : (e.setAttribute(t, n + ""), n)
                                  : o && "get" in o && null !== (i = o.get(e, t))
                                    ? i
                                    : ((i = re.find.attr(e, t)), null == i ? void 0 : i));
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!ie.radioValue && "radio" === t && re.nodeName(e, "input")) {
                                var n = e.value;
                                return e.setAttribute("type", t), n && (e.value = n), t;
                            }
                        },
                    },
                },
                removeAttr: function (e, t) {
                    var n,
                        i,
                        o = 0,
                        r = t && t.match(xe);
                    if (r && 1 === e.nodeType)
                        for (; (n = r[o++]); )
                            (i = re.propFix[n] || n), re.expr.match.bool.test(n) && (e[i] = !1), e.removeAttribute(n);
                },
            }),
            (lt = {
                set: function (e, t, n) {
                    return t === !1 ? re.removeAttr(e, n) : e.setAttribute(n, n), n;
                },
            }),
            re.each(re.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var n = ut[t] || re.find.attr;
                ut[t] = function (e, t, i) {
                    var o, r;
                    return (
                        i || ((r = ut[t]), (ut[t] = o), (o = null != n(e, t, i) ? t.toLowerCase() : null), (ut[t] = r)),
                        o
                    );
                };
            });
        var ct = /^(?:input|select|textarea|button)$/i,
            dt = /^(?:a|area)$/i;
        re.fn.extend({
            prop: function (e, t) {
                return Te(this, re.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
                return this.each(function () {
                    delete this[re.propFix[e] || e];
                });
            },
        }),
            re.extend({
                prop: function (e, t, n) {
                    var i,
                        o,
                        r = e.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return (
                            (1 === r && re.isXMLDoc(e)) || ((t = re.propFix[t] || t), (o = re.propHooks[t])),
                            void 0 !== n
                                ? o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                    ? i
                                    : (e[t] = n)
                                : o && "get" in o && null !== (i = o.get(e, t))
                                  ? i
                                  : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = re.find.attr(e, "tabindex");
                            return t
                                ? parseInt(t, 10)
                                : ct.test(e.nodeName) || (dt.test(e.nodeName) && e.href)
                                  ? 0
                                  : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            ie.optSelected ||
                (re.propHooks.selected = {
                    get: function (e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex, null;
                    },
                    set: function (e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                    },
                }),
            re.each(
                [
                    "tabIndex",
                    "readOnly",
                    "maxLength",
                    "cellSpacing",
                    "cellPadding",
                    "rowSpan",
                    "colSpan",
                    "useMap",
                    "frameBorder",
                    "contentEditable",
                ],
                function () {
                    re.propFix[this.toLowerCase()] = this;
                }
            );
        var pt = /[\t\r\n\f]/g;
        re.fn.extend({
            addClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (re.isFunction(e))
                    return this.each(function (t) {
                        re(this).addClass(e.call(this, t, F(this)));
                    });
                if ("string" == typeof e && e)
                    for (t = e.match(xe) || []; (n = this[l++]); )
                        if (((o = F(n)), (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))) {
                            for (s = 0; (r = t[s++]); ) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                            (a = re.trim(i)), o !== a && n.setAttribute("class", a);
                        }
                return this;
            },
            removeClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (re.isFunction(e))
                    return this.each(function (t) {
                        re(this).removeClass(e.call(this, t, F(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ("string" == typeof e && e)
                    for (t = e.match(xe) || []; (n = this[l++]); )
                        if (((o = F(n)), (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))) {
                            for (s = 0; (r = t[s++]); )
                                for (; i.indexOf(" " + r + " ") > -1; ) i = i.replace(" " + r + " ", " ");
                            (a = re.trim(i)), o !== a && n.setAttribute("class", a);
                        }
                return this;
            },
            toggleClass: function (e, t) {
                var n = typeof e;
                return "boolean" == typeof t && "string" === n
                    ? t
                        ? this.addClass(e)
                        : this.removeClass(e)
                    : re.isFunction(e)
                      ? this.each(function (n) {
                            re(this).toggleClass(e.call(this, n, F(this), t), t);
                        })
                      : this.each(function () {
                            var t, i, o, r;
                            if ("string" === n)
                                for (i = 0, o = re(this), r = e.match(xe) || []; (t = r[i++]); )
                                    o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                            else
                                (void 0 !== e && "boolean" !== n) ||
                                    ((t = F(this)),
                                    t && Ce.set(this, "__className__", t),
                                    this.setAttribute &&
                                        this.setAttribute(
                                            "class",
                                            t || e === !1 ? "" : Ce.get(this, "__className__") || ""
                                        ));
                        });
            },
            hasClass: function (e) {
                var t,
                    n,
                    i = 0;
                for (t = " " + e + " "; (n = this[i++]); )
                    if (1 === n.nodeType && (" " + F(n) + " ").replace(pt, " ").indexOf(t) > -1) return !0;
                return !1;
            },
        });
        var ft = /\r/g,
            ht = /[\x20\t\r\n\f]+/g;
        re.fn.extend({
            val: function (e) {
                var t,
                    n,
                    i,
                    o = this[0];
                return arguments.length
                    ? ((i = re.isFunction(e)),
                      this.each(function (n) {
                          var o;
                          1 === this.nodeType &&
                              ((o = i ? e.call(this, n, re(this).val()) : e),
                              null == o
                                  ? (o = "")
                                  : "number" == typeof o
                                    ? (o += "")
                                    : re.isArray(o) &&
                                      (o = re.map(o, function (e) {
                                          return null == e ? "" : e + "";
                                      })),
                              (t = re.valHooks[this.type] || re.valHooks[this.nodeName.toLowerCase()]),
                              (t && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                      }))
                    : o
                      ? ((t = re.valHooks[o.type] || re.valHooks[o.nodeName.toLowerCase()]),
                        t && "get" in t && void 0 !== (n = t.get(o, "value"))
                            ? n
                            : ((n = o.value), "string" == typeof n ? n.replace(ft, "") : null == n ? "" : n))
                      : void 0;
            },
        }),
            re.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = re.find.attr(e, "value");
                            return null != t ? t : re.trim(re.text(e)).replace(ht, " ");
                        },
                    },
                    select: {
                        get: function (e) {
                            for (
                                var t,
                                    n,
                                    i = e.options,
                                    o = e.selectedIndex,
                                    r = "select-one" === e.type || 0 > o,
                                    s = r ? null : [],
                                    a = r ? o + 1 : i.length,
                                    l = 0 > o ? a : r ? o : 0;
                                a > l;
                                l++
                            )
                                if (
                                    ((n = i[l]),
                                    (n.selected || l === o) &&
                                        (ie.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) &&
                                        (!n.parentNode.disabled || !re.nodeName(n.parentNode, "optgroup")))
                                ) {
                                    if (((t = re(n).val()), r)) return t;
                                    s.push(t);
                                }
                            return s;
                        },
                        set: function (e, t) {
                            for (var n, i, o = e.options, r = re.makeArray(t), s = o.length; s--; )
                                (i = o[s]), (i.selected = re.inArray(re.valHooks.option.get(i), r) > -1) && (n = !0);
                            return n || (e.selectedIndex = -1), r;
                        },
                    },
                },
            }),
            re.each(["radio", "checkbox"], function () {
                (re.valHooks[this] = {
                    set: function (e, t) {
                        return re.isArray(t) ? (e.checked = re.inArray(re(e).val(), t) > -1) : void 0;
                    },
                }),
                    ie.checkOn ||
                        (re.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            });
        var vt = /^(?:focusinfocus|focusoutblur)$/;
        re.extend(re.event, {
            trigger: function (t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d,
                    p = [i || G],
                    f = ne.call(t, "type") ? t.type : t,
                    h = ne.call(t, "namespace") ? t.namespace.split(".") : [];
                if (
                    ((s = a = i = i || G),
                    3 !== i.nodeType &&
                        8 !== i.nodeType &&
                        !vt.test(f + re.event.triggered) &&
                        (f.indexOf(".") > -1 && ((h = f.split(".")), (f = h.shift()), h.sort()),
                        (u = f.indexOf(":") < 0 && "on" + f),
                        (t = t[re.expando] ? t : new re.Event(f, "object" == typeof t && t)),
                        (t.isTrigger = o ? 2 : 3),
                        (t.namespace = h.join(".")),
                        (t.rnamespace = t.namespace
                            ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")
                            : null),
                        (t.result = void 0),
                        t.target || (t.target = i),
                        (n = null == n ? [t] : re.makeArray(n, [t])),
                        (d = re.event.special[f] || {}),
                        o || !d.trigger || d.trigger.apply(i, n) !== !1))
                ) {
                    if (!o && !d.noBubble && !re.isWindow(i)) {
                        for (l = d.delegateType || f, vt.test(l + f) || (s = s.parentNode); s; s = s.parentNode)
                            p.push(s), (a = s);
                        a === (i.ownerDocument || G) && p.push(a.defaultView || a.parentWindow || e);
                    }
                    for (r = 0; (s = p[r++]) && !t.isPropagationStopped(); )
                        (t.type = r > 1 ? l : d.bindType || f),
                            (c = (Ce.get(s, "events") || {})[t.type] && Ce.get(s, "handle")),
                            c && c.apply(s, n),
                            (c = u && s[u]),
                            c &&
                                c.apply &&
                                Se(s) &&
                                ((t.result = c.apply(s, n)), t.result === !1 && t.preventDefault());
                    return (
                        (t.type = f),
                        o ||
                            t.isDefaultPrevented() ||
                            (d._default && d._default.apply(p.pop(), n) !== !1) ||
                            !Se(i) ||
                            (u &&
                                re.isFunction(i[f]) &&
                                !re.isWindow(i) &&
                                ((a = i[u]),
                                a && (i[u] = null),
                                (re.event.triggered = f),
                                i[f](),
                                (re.event.triggered = void 0),
                                a && (i[u] = a))),
                        t.result
                    );
                }
            },
            simulate: function (e, t, n) {
                var i = re.extend(new re.Event(), n, { type: e, isSimulated: !0 });
                re.event.trigger(i, null, t), i.isDefaultPrevented() && n.preventDefault();
            },
        }),
            re.fn.extend({
                trigger: function (e, t) {
                    return this.each(function () {
                        re.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var n = this[0];
                    return n ? re.event.trigger(e, t, n, !0) : void 0;
                },
            }),
            re.each(
                "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
                    " "
                ),
                function (e, t) {
                    re.fn[t] = function (e, n) {
                        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                    };
                }
            ),
            re.fn.extend({
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
            }),
            (ie.focusin = "onfocusin" in e),
            ie.focusin ||
                re.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    var n = function (e) {
                        re.event.simulate(t, e.target, re.event.fix(e));
                    };
                    re.event.special[t] = {
                        setup: function () {
                            var i = this.ownerDocument || this,
                                o = Ce.access(i, t);
                            o || i.addEventListener(e, n, !0), Ce.access(i, t, (o || 0) + 1);
                        },
                        teardown: function () {
                            var i = this.ownerDocument || this,
                                o = Ce.access(i, t) - 1;
                            o ? Ce.access(i, t, o) : (i.removeEventListener(e, n, !0), Ce.remove(i, t));
                        },
                    };
                });
        var gt = e.location,
            mt = re.now(),
            yt = /\?/;
        (re.parseJSON = function (e) {
            return JSON.parse(e + "");
        }),
            (re.parseXML = function (t) {
                var n;
                if (!t || "string" != typeof t) return null;
                try {
                    n = new e.DOMParser().parseFromString(t, "text/xml");
                } catch (e) {
                    n = void 0;
                }
                return (n && !n.getElementsByTagName("parsererror").length) || re.error("Invalid XML: " + t), n;
            });
        var bt = /#.*$/,
            wt = /([?&])_=[^&]*/,
            xt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            kt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            Tt = /^(?:GET|HEAD)$/,
            St = /^\/\//,
            Ct = {},
            $t = {},
            Et = "*/".concat("*"),
            At = G.createElement("a");
        (At.href = gt.href),
            re.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: gt.href,
                    type: "GET",
                    isLocal: kt.test(gt.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: {
                        "*": Et,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript",
                    },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: {
                        "* text": String,
                        "text html": !0,
                        "text json": re.parseJSON,
                        "text xml": re.parseXML,
                    },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? W(W(e, re.ajaxSettings), t) : W(re.ajaxSettings, e);
                },
                ajaxPrefilter: M(Ct),
                ajaxTransport: M($t),
                ajax: function (t, n) {
                    function i(t, n, i, a) {
                        var u,
                            d,
                            y,
                            b,
                            x,
                            T = n;
                        2 !== w &&
                            ((w = 2),
                            l && e.clearTimeout(l),
                            (o = void 0),
                            (s = a || ""),
                            (k.readyState = t > 0 ? 4 : 0),
                            (u = (t >= 200 && 300 > t) || 304 === t),
                            i && (b = B(p, k, i)),
                            (b = U(p, b, k, u)),
                            u
                                ? (p.ifModified &&
                                      ((x = k.getResponseHeader("Last-Modified")),
                                      x && (re.lastModified[r] = x),
                                      (x = k.getResponseHeader("etag")),
                                      x && (re.etag[r] = x)),
                                  204 === t || "HEAD" === p.type
                                      ? (T = "nocontent")
                                      : 304 === t
                                        ? (T = "notmodified")
                                        : ((T = b.state), (d = b.data), (y = b.error), (u = !y)))
                                : ((y = T), (!t && T) || ((T = "error"), 0 > t && (t = 0))),
                            (k.status = t),
                            (k.statusText = (n || T) + ""),
                            u ? v.resolveWith(f, [d, T, k]) : v.rejectWith(f, [k, T, y]),
                            k.statusCode(m),
                            (m = void 0),
                            c && h.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? d : y]),
                            g.fireWith(f, [k, T]),
                            c && (h.trigger("ajaxComplete", [k, p]), --re.active || re.event.trigger("ajaxStop")));
                    }
                    "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
                    var o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c,
                        d,
                        p = re.ajaxSetup({}, n),
                        f = p.context || p,
                        h = p.context && (f.nodeType || f.jquery) ? re(f) : re.event,
                        v = re.Deferred(),
                        g = re.Callbacks("once memory"),
                        m = p.statusCode || {},
                        y = {},
                        b = {},
                        w = 0,
                        x = "canceled",
                        k = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (2 === w) {
                                    if (!a) for (a = {}; (t = xt.exec(s)); ) a[t[1].toLowerCase()] = t[2];
                                    t = a[e.toLowerCase()];
                                }
                                return null == t ? null : t;
                            },
                            getAllResponseHeaders: function () {
                                return 2 === w ? s : null;
                            },
                            setRequestHeader: function (e, t) {
                                var n = e.toLowerCase();
                                return w || ((e = b[n] = b[n] || e), (y[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return w || (p.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                var t;
                                if (e)
                                    if (2 > w) for (t in e) m[t] = [m[t], e[t]];
                                    else k.always(e[k.status]);
                                return this;
                            },
                            abort: function (e) {
                                var t = e || x;
                                return o && o.abort(t), i(0, t), this;
                            },
                        };
                    if (
                        ((v.promise(k).complete = g.add),
                        (k.success = k.done),
                        (k.error = k.fail),
                        (p.url = ((t || p.url || gt.href) + "").replace(bt, "").replace(St, gt.protocol + "//")),
                        (p.type = n.method || n.type || p.method || p.type),
                        (p.dataTypes = re
                            .trim(p.dataType || "*")
                            .toLowerCase()
                            .match(xe) || [""]),
                        null == p.crossDomain)
                    ) {
                        u = G.createElement("a");
                        try {
                            (u.href = p.url),
                                (u.href = u.href),
                                (p.crossDomain = At.protocol + "//" + At.host != u.protocol + "//" + u.host);
                        } catch (e) {
                            p.crossDomain = !0;
                        }
                    }
                    if (
                        (p.data &&
                            p.processData &&
                            "string" != typeof p.data &&
                            (p.data = re.param(p.data, p.traditional)),
                        R(Ct, p, n, k),
                        2 === w)
                    )
                        return k;
                    (c = re.event && p.global),
                        c && 0 === re.active++ && re.event.trigger("ajaxStart"),
                        (p.type = p.type.toUpperCase()),
                        (p.hasContent = !Tt.test(p.type)),
                        (r = p.url),
                        p.hasContent ||
                            (p.data && ((r = p.url += (yt.test(r) ? "&" : "?") + p.data), delete p.data),
                            p.cache === !1 &&
                                (p.url = wt.test(r)
                                    ? r.replace(wt, "$1_=" + mt++)
                                    : r + (yt.test(r) ? "&" : "?") + "_=" + mt++)),
                        p.ifModified &&
                            (re.lastModified[r] && k.setRequestHeader("If-Modified-Since", re.lastModified[r]),
                            re.etag[r] && k.setRequestHeader("If-None-Match", re.etag[r])),
                        ((p.data && p.hasContent && p.contentType !== !1) || n.contentType) &&
                            k.setRequestHeader("Content-Type", p.contentType),
                        k.setRequestHeader(
                            "Accept",
                            p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                                ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Et + "; q=0.01" : "")
                                : p.accepts["*"]
                        );
                    for (d in p.headers) k.setRequestHeader(d, p.headers[d]);
                    if (p.beforeSend && (p.beforeSend.call(f, k, p) === !1 || 2 === w)) return k.abort();
                    x = "abort";
                    for (d in { success: 1, error: 1, complete: 1 }) k[d](p[d]);
                    if ((o = R($t, p, n, k))) {
                        if (((k.readyState = 1), c && h.trigger("ajaxSend", [k, p]), 2 === w)) return k;
                        p.async &&
                            p.timeout > 0 &&
                            (l = e.setTimeout(function () {
                                k.abort("timeout");
                            }, p.timeout));
                        try {
                            (w = 1), o.send(y, i);
                        } catch (e) {
                            if (!(2 > w)) throw e;
                            i(-1, e);
                        }
                    } else i(-1, "No Transport");
                    return k;
                },
                getJSON: function (e, t, n) {
                    return re.get(e, t, n, "json");
                },
                getScript: function (e, t) {
                    return re.get(e, void 0, t, "script");
                },
            }),
            re.each(["get", "post"], function (e, t) {
                re[t] = function (e, n, i, o) {
                    return (
                        re.isFunction(n) && ((o = o || i), (i = n), (n = void 0)),
                        re.ajax(
                            re.extend({ url: e, type: t, dataType: o, data: n, success: i }, re.isPlainObject(e) && e)
                        )
                    );
                };
            }),
            (re._evalUrl = function (e) {
                return re.ajax({ url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
            }),
            re.fn.extend({
                wrapAll: function (e) {
                    var t;
                    return re.isFunction(e)
                        ? this.each(function (t) {
                              re(this).wrapAll(e.call(this, t));
                          })
                        : (this[0] &&
                              ((t = re(e, this[0].ownerDocument).eq(0).clone(!0)),
                              this[0].parentNode && t.insertBefore(this[0]),
                              t
                                  .map(function () {
                                      for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                      return e;
                                  })
                                  .append(this)),
                          this);
                },
                wrapInner: function (e) {
                    return re.isFunction(e)
                        ? this.each(function (t) {
                              re(this).wrapInner(e.call(this, t));
                          })
                        : this.each(function () {
                              var t = re(this),
                                  n = t.contents();
                              n.length ? n.wrapAll(e) : t.append(e);
                          });
                },
                wrap: function (e) {
                    var t = re.isFunction(e);
                    return this.each(function (n) {
                        re(this).wrapAll(t ? e.call(this, n) : e);
                    });
                },
                unwrap: function () {
                    return this.parent()
                        .each(function () {
                            re.nodeName(this, "body") || re(this).replaceWith(this.childNodes);
                        })
                        .end();
                },
            }),
            (re.expr.filters.hidden = function (e) {
                return !re.expr.filters.visible(e);
            }),
            (re.expr.filters.visible = function (e) {
                return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0;
            });
        var jt = /%20/g,
            Nt = /\[\]$/,
            Dt = /\r?\n/g,
            Ot = /^(?:submit|button|image|reset|file)$/i,
            Ht = /^(?:input|select|textarea|keygen)/i;
        (re.param = function (e, t) {
            var n,
                i = [],
                o = function (e, t) {
                    (t = re.isFunction(t) ? t() : null == t ? "" : t),
                        (i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
                };
            if (
                (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional),
                re.isArray(e) || (e.jquery && !re.isPlainObject(e)))
            )
                re.each(e, function () {
                    o(this.name, this.value);
                });
            else for (n in e) X(n, e[n], t, o);
            return i.join("&").replace(jt, "+");
        }),
            re.fn.extend({
                serialize: function () {
                    return re.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = re.prop(this, "elements");
                        return e ? re.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return (
                                this.name &&
                                !re(this).is(":disabled") &&
                                Ht.test(this.nodeName) &&
                                !Ot.test(e) &&
                                (this.checked || !He.test(e))
                            );
                        })
                        .map(function (e, t) {
                            var n = re(this).val();
                            return null == n
                                ? null
                                : re.isArray(n)
                                  ? re.map(n, function (e) {
                                        return { name: t.name, value: e.replace(Dt, "\r\n") };
                                    })
                                  : { name: t.name, value: n.replace(Dt, "\r\n") };
                        })
                        .get();
                },
            }),
            (re.ajaxSettings.xhr = function () {
                try {
                    return new e.XMLHttpRequest();
                } catch (e) {}
            });
        var qt = { 0: 200, 1223: 204 },
            Pt = re.ajaxSettings.xhr();
        (ie.cors = !!Pt && "withCredentials" in Pt),
            (ie.ajax = Pt = !!Pt),
            re.ajaxTransport(function (t) {
                var n, i;
                return ie.cors || (Pt && !t.crossDomain)
                    ? {
                          send: function (o, r) {
                              var s,
                                  a = t.xhr();
                              if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
                                  for (s in t.xhrFields) a[s] = t.xhrFields[s];
                              t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType),
                                  t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest");
                              for (s in o) a.setRequestHeader(s, o[s]);
                              (n = function (e) {
                                  return function () {
                                      n &&
                                          ((n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null),
                                          "abort" === e
                                              ? a.abort()
                                              : "error" === e
                                                ? "number" != typeof a.status
                                                    ? r(0, "error")
                                                    : r(a.status, a.statusText)
                                                : r(
                                                      qt[a.status] || a.status,
                                                      a.statusText,
                                                      "text" !== (a.responseType || "text") ||
                                                          "string" != typeof a.responseText
                                                          ? { binary: a.response }
                                                          : { text: a.responseText },
                                                      a.getAllResponseHeaders()
                                                  ));
                                  };
                              }),
                                  (a.onload = n()),
                                  (i = a.onerror = n("error")),
                                  void 0 !== a.onabort
                                      ? (a.onabort = i)
                                      : (a.onreadystatechange = function () {
                                            4 === a.readyState &&
                                                e.setTimeout(function () {
                                                    n && i();
                                                });
                                        }),
                                  (n = n("abort"));
                              try {
                                  a.send((t.hasContent && t.data) || null);
                              } catch (e) {
                                  if (n) throw e;
                              }
                          },
                          abort: function () {
                              n && n();
                          },
                      }
                    : void 0;
            }),
            re.ajaxSetup({
                accepts: {
                    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
                },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (e) {
                        return re.globalEval(e), e;
                    },
                },
            }),
            re.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            re.ajaxTransport("script", function (e) {
                if (e.crossDomain) {
                    var t, n;
                    return {
                        send: function (i, o) {
                            (t = re("<script>")
                                .prop({ charset: e.scriptCharset, src: e.url })
                                .on(
                                    "load error",
                                    (n = function (e) {
                                        t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                    })
                                )),
                                G.head.appendChild(t[0]);
                        },
                        abort: function () {
                            n && n();
                        },
                    };
                }
            });
        var Lt = [],
            _t = /(=)\?(?=&|$)|\?\?/;
        re.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Lt.pop() || re.expando + "_" + mt++;
                return (this[e] = !0), e;
            },
        }),
            re.ajaxPrefilter("json jsonp", function (t, n, i) {
                var o,
                    r,
                    s,
                    a =
                        t.jsonp !== !1 &&
                        (_t.test(t.url)
                            ? "url"
                            : "string" == typeof t.data &&
                              0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                              _t.test(t.data) &&
                              "data");
                return a || "jsonp" === t.dataTypes[0]
                    ? ((o = t.jsonpCallback = re.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                      a
                          ? (t[a] = t[a].replace(_t, "$1" + o))
                          : t.jsonp !== !1 && (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                      (t.converters["script json"] = function () {
                          return s || re.error(o + " was not called"), s[0];
                      }),
                      (t.dataTypes[0] = "json"),
                      (r = e[o]),
                      (e[o] = function () {
                          s = arguments;
                      }),
                      i.always(function () {
                          void 0 === r ? re(e).removeProp(o) : (e[o] = r),
                              t[o] && ((t.jsonpCallback = n.jsonpCallback), Lt.push(o)),
                              s && re.isFunction(r) && r(s[0]),
                              (s = r = void 0);
                      }),
                      "script")
                    : void 0;
            }),
            (re.parseHTML = function (e, t, n) {
                if (!e || "string" != typeof e) return null;
                "boolean" == typeof t && ((n = t), (t = !1)), (t = t || G);
                var i = he.exec(e),
                    o = !n && [];
                return i
                    ? [t.createElement(i[1])]
                    : ((i = p([e], t, o)), o && o.length && re(o).remove(), re.merge([], i.childNodes));
            });
        var zt = re.fn.load;
        (re.fn.load = function (e, t, n) {
            if ("string" != typeof e && zt) return zt.apply(this, arguments);
            var i,
                o,
                r,
                s = this,
                a = e.indexOf(" ");
            return (
                a > -1 && ((i = re.trim(e.slice(a))), (e = e.slice(0, a))),
                re.isFunction(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                s.length > 0 &&
                    re
                        .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (r = arguments), s.html(i ? re("<div>").append(re.parseHTML(e)).find(i) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    s.each(function () {
                                        n.apply(this, r || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
            re.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                re.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            (re.expr.filters.animated = function (e) {
                return re.grep(re.timers, function (t) {
                    return e === t.elem;
                }).length;
            }),
            (re.offset = {
                setOffset: function (e, t, n) {
                    var i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c = re.css(e, "position"),
                        d = re(e),
                        p = {};
                    "static" === c && (e.style.position = "relative"),
                        (a = d.offset()),
                        (r = re.css(e, "top")),
                        (l = re.css(e, "left")),
                        (u = ("absolute" === c || "fixed" === c) && (r + l).indexOf("auto") > -1),
                        u
                            ? ((i = d.position()), (s = i.top), (o = i.left))
                            : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                        re.isFunction(t) && (t = t.call(e, n, re.extend({}, a))),
                        null != t.top && (p.top = t.top - a.top + s),
                        null != t.left && (p.left = t.left - a.left + o),
                        "using" in t ? t.using.call(e, p) : d.css(p);
                },
            }),
            re.fn.extend({
                offset: function (e) {
                    if (arguments.length)
                        return void 0 === e
                            ? this
                            : this.each(function (t) {
                                  re.offset.setOffset(this, e, t);
                              });
                    var t,
                        n,
                        i = this[0],
                        o = { top: 0, left: 0 },
                        r = i && i.ownerDocument;
                    return r
                        ? ((t = r.documentElement),
                          re.contains(t, i)
                              ? ((o = i.getBoundingClientRect()),
                                (n = Y(r)),
                                {
                                    top: o.top + n.pageYOffset - t.clientTop,
                                    left: o.left + n.pageXOffset - t.clientLeft,
                                })
                              : o)
                        : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            n = this[0],
                            i = { top: 0, left: 0 };
                        return (
                            "fixed" === re.css(n, "position")
                                ? (t = n.getBoundingClientRect())
                                : ((e = this.offsetParent()),
                                  (t = this.offset()),
                                  re.nodeName(e[0], "html") || (i = e.offset()),
                                  (i.top += re.css(e[0], "borderTopWidth", !0)),
                                  (i.left += re.css(e[0], "borderLeftWidth", !0))),
                            {
                                top: t.top - i.top - re.css(n, "marginTop", !0),
                                left: t.left - i.left - re.css(n, "marginLeft", !0),
                            }
                        );
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent; e && "static" === re.css(e, "position"); ) e = e.offsetParent;
                        return e || Ze;
                    });
                },
            }),
            re.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                var n = "pageYOffset" === t;
                re.fn[e] = function (i) {
                    return Te(
                        this,
                        function (e, i, o) {
                            var r = Y(e);
                            return void 0 === o
                                ? r
                                    ? r[t]
                                    : e[i]
                                : void (r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : (e[i] = o));
                        },
                        e,
                        i,
                        arguments.length
                    );
                };
            }),
            re.each(["top", "left"], function (e, t) {
                re.cssHooks[t] = E(ie.pixelPosition, function (e, n) {
                    return n ? ((n = $(e, t)), Ge.test(n) ? re(e).position()[t] + "px" : n) : void 0;
                });
            }),
            re.each({ Height: "height", Width: "width" }, function (e, t) {
                re.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                    re.fn[i] = function (i, o) {
                        var r = arguments.length && (n || "boolean" != typeof i),
                            s = n || (i === !0 || o === !0 ? "margin" : "border");
                        return Te(
                            this,
                            function (t, n, i) {
                                var o;
                                return re.isWindow(t)
                                    ? t.document.documentElement["client" + e]
                                    : 9 === t.nodeType
                                      ? ((o = t.documentElement),
                                        Math.max(
                                            t.body["scroll" + e],
                                            o["scroll" + e],
                                            t.body["offset" + e],
                                            o["offset" + e],
                                            o["client" + e]
                                        ))
                                      : void 0 === i
                                        ? re.css(t, n, s)
                                        : re.style(t, n, i, s);
                            },
                            t,
                            r ? i : void 0,
                            r,
                            null
                        );
                    };
                });
            }),
            re.fn.extend({
                bind: function (e, t, n) {
                    return this.on(e, null, t, n);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, n, i) {
                    return this.on(t, e, n, i);
                },
                undelegate: function (e, t, n) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                },
                size: function () {
                    return this.length;
                },
            }),
            (re.fn.andSelf = re.fn.addBack),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return re;
                });
        var It = e.jQuery,
            Ft = e.$;
        return (
            (re.noConflict = function (t) {
                return e.$ === re && (e.$ = Ft), t && e.jQuery === re && (e.jQuery = It), re;
            }),
            t || (e.jQuery = e.$ = re),
            re
        );
    }) /*!

/*! 
 * jquery.zoom.min.js
 *
 * Zoom 1.7.21
 * license: MIT
 * http://www.jacklmoore.com/zoom
 */,
    (function (e) {
        var t = {
            url: !1,
            callback: !1,
            target: !1,
            duration: 120,
            on: "mouseover",
            touch: !0,
            onZoomIn: !1,
            onZoomOut: !1,
            magnify: 1,
        };
        (e.zoom = function (t, n, i, o) {
            var r,
                s,
                a,
                l,
                u,
                c,
                d,
                p = e(t),
                f = p.css("position"),
                h = e(n);
            return (
                (t.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
                (t.style.overflow = "hidden"),
                (i.style.width = i.style.height = ""),
                e(i)
                    .addClass("zoomImg")
                    .css({
                        position: "absolute",
                        top: 0,
                        left: 0,
                        opacity: 0,
                        width: i.width * o,
                        height: i.height * o,
                        border: "none",
                        maxWidth: "none",
                        maxHeight: "none",
                    })
                    .appendTo(t),
                {
                    init: function () {
                        (s = p.outerWidth()),
                            (r = p.outerHeight()),
                            n === t ? ((l = s), (a = r)) : ((l = h.outerWidth()), (a = h.outerHeight())),
                            (u = (i.width - s) / l),
                            (c = (i.height - r) / a),
                            (d = h.offset());
                    },
                    move: function (e) {
                        var t = e.pageX - d.left,
                            n = e.pageY - d.top;
                        (n = Math.max(Math.min(n, a), 0)),
                            (t = Math.max(Math.min(t, l), 0)),
                            (i.style.left = t * -u + "px"),
                            (i.style.top = n * -c + "px");
                    },
                }
            );
        }),
            (e.fn.zoom = function (n) {
                return this.each(function () {
                    var i = e.extend({}, t, n || {}),
                        o = (i.target && e(i.target)[0]) || this,
                        r = this,
                        s = e(r),
                        a = document.createElement("img"),
                        l = e(a),
                        u = "mousemove.zoom",
                        c = !1,
                        d = !1;
                    if (!i.url) {
                        var p = r.querySelector("img");
                        if ((p && (i.url = p.getAttribute("data-src") || p.currentSrc || p.src), !i.url)) return;
                    }
                    s.one(
                        "zoom.destroy",
                        function (e, t) {
                            s.off(".zoom"),
                                (o.style.position = e),
                                (o.style.overflow = t),
                                (a.onload = null),
                                l.remove();
                        }.bind(this, o.style.position, o.style.overflow)
                    ),
                        (a.onload = function () {
                            function t(t) {
                                p.init(),
                                    p.move(t),
                                    l
                                        .stop()
                                        .fadeTo(
                                            e.support.opacity ? i.duration : 0,
                                            1,
                                            !!e.isFunction(i.onZoomIn) && i.onZoomIn.call(a)
                                        );
                            }
                            function n() {
                                l.stop().fadeTo(i.duration, 0, !!e.isFunction(i.onZoomOut) && i.onZoomOut.call(a));
                            }
                            var p = e.zoom(o, r, a, i.magnify);
                            "grab" === i.on
                                ? s.on("mousedown.zoom", function (i) {
                                      1 === i.which &&
                                          (e(document).one("mouseup.zoom", function () {
                                              n(), e(document).off(u, p.move);
                                          }),
                                          t(i),
                                          e(document).on(u, p.move),
                                          i.preventDefault());
                                  })
                                : "click" === i.on
                                  ? s.on("click.zoom", function (i) {
                                        return c
                                            ? void 0
                                            : ((c = !0),
                                              t(i),
                                              e(document).on(u, p.move),
                                              e(document).one("click.zoom", function () {
                                                  n(), (c = !1), e(document).off(u, p.move);
                                              }),
                                              !1);
                                    })
                                  : "toggle" === i.on
                                    ? s.on("click.zoom", function (e) {
                                          c ? n() : t(e), (c = !c);
                                      })
                                    : "mouseover" === i.on &&
                                      (p.init(), s.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(u, p.move)),
                                i.touch &&
                                    s
                                        .on("touchstart.zoom", function (e) {
                                            e.preventDefault(),
                                                d
                                                    ? ((d = !1), n())
                                                    : ((d = !0),
                                                      t(
                                                          e.originalEvent.touches[0] ||
                                                              e.originalEvent.changedTouches[0]
                                                      ));
                                        })
                                        .on("touchmove.zoom", function (e) {
                                            e.preventDefault(),
                                                p.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                                        })
                                        .on("touchend.zoom", function (e) {
                                            e.preventDefault(), d && ((d = !1), n());
                                        }),
                                e.isFunction(i.callback) && i.callback.call(a);
                        }),
                        a.setAttribute("role", "presentation"),
                        (a.alt = ""),
                        (a.src = i.url);
                });
            }),
            (e.fn.zoom.defaults = t);
    })(window.jQuery),
    function () {
        function e(e, t) {
            for (var n = -1, i = t.length, o = e.length; ++n < i; ) e[o + n] = t[n];
            return e;
        }
        function t(e, t, n) {
            for (var i = -1, o = e.length; ++i < o; ) {
                var r = e[i],
                    s = t(r);
                if (null != s && (a === le ? s === s : n(s, a)))
                    var a = s,
                        l = r;
            }
            return l;
        }
        function n(e, t, n) {
            var i;
            return (
                n(e, function (e, n, o) {
                    return t(e, n, o) ? ((i = e), !1) : void 0;
                }),
                i
            );
        }
        function i(e, t, n, i, o) {
            return (
                o(e, function (e, o, r) {
                    n = i ? ((i = !1), e) : t(n, e, o, r);
                }),
                n
            );
        }
        function o(e, t) {
            return T(t, function (t) {
                return e[t];
            });
        }
        function r(e) {
            return e && e.Object === Object ? e : null;
        }
        function s(e) {
            return fe[e];
        }
        function a(e) {
            var t = !1;
            if (null != e && "function" != typeof e.toString)
                try {
                    t = !!(e + "");
                } catch (e) {}
            return t;
        }
        function l(e, t) {
            return (
                (e = "number" == typeof e || pe.test(e) ? +e : -1),
                e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
            );
        }
        function u(e) {
            if (Z(e) && !Re(e)) {
                if (e instanceof c) return e;
                if (Se.call(e, "__wrapped__")) {
                    var t = new c(e.__wrapped__, e.__chain__);
                    return (t.__actions__ = A(e.__actions__)), t;
                }
            }
            return new c(e);
        }
        function c(e, t) {
            (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
        }
        function d(e, t, n, i) {
            var o;
            return (
                (o = e === le) || ((o = Te[n]), (o = (e === o || (e !== e && o !== o)) && !Se.call(i, n))), o ? t : e
            );
        }
        function p(e) {
            return J(e) ? Ne(e) : {};
        }
        function f(e, t, n) {
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return setTimeout(function () {
                e.apply(le, n);
            }, t);
        }
        function h(e, t) {
            var n = !0;
            return (
                Pe(e, function (e, i, o) {
                    return (n = !!t(e, i, o));
                }),
                n
            );
        }
        function v(e, t) {
            var n = [];
            return (
                Pe(e, function (e, i, o) {
                    t(e, i, o) && n.push(e);
                }),
                n
            );
        }
        function g(t, n, i, o) {
            o || (o = []);
            for (var r = -1, s = t.length; ++r < s; ) {
                var a = t[r];
                n > 0 && Z(a) && V(a) && (i || Re(a) || Y(a))
                    ? n > 1
                        ? g(a, n - 1, i, o)
                        : e(o, a)
                    : i || (o[o.length] = a);
            }
            return o;
        }
        function m(e, t) {
            return e && Le(e, t, ie);
        }
        function y(e, t) {
            return v(t, function (t) {
                return G(e[t]);
            });
        }
        function b(e, t, n, i, o) {
            return e === t || (null == e || null == t || (!J(e) && !Z(t)) ? e !== e && t !== t : w(e, t, b, n, i, o));
        }
        function w(e, t, n, i, o, r) {
            var s = Re(e),
                l = Re(t),
                u = "[object Array]",
                c = "[object Array]";
            s || ((u = $e.call(e)), "[object Arguments]" == u && (u = "[object Object]")),
                l || ((c = $e.call(t)), "[object Arguments]" == c && (c = "[object Object]"));
            var d = "[object Object]" == u && !a(e),
                l = "[object Object]" == c && !a(t);
            return !(c = u == c) || s || d
                ? 2 & o || ((u = d && Se.call(e, "__wrapped__")), (l = l && Se.call(t, "__wrapped__")), !u && !l)
                    ? !!c &&
                      (r || (r = []),
                      (u = M(r, function (t) {
                          return t[0] === e;
                      })) && u[1]
                          ? u[1] == t
                          : (r.push([e, t]), (t = (s ? P : _)(e, t, n, i, o, r)), r.pop(), t))
                    : n(u ? e.value() : e, l ? t.value() : t, i, o, r)
                : L(e, t, u);
        }
        function x(e) {
            var t = typeof e;
            return "function" == t ? e : null == e ? se : ("object" == t ? S : $)(e);
        }
        function k(e) {
            e = null == e ? e : Object(e);
            var t,
                n = [];
            for (t in e) n.push(t);
            return n;
        }
        function T(e, t) {
            var n = -1,
                i = V(e) ? Array(e.length) : [];
            return (
                Pe(e, function (e, o, r) {
                    i[++n] = t(e, o, r);
                }),
                i
            );
        }
        function S(e) {
            var t = ie(e);
            return function (n) {
                var i = t.length;
                if (null == n) return !i;
                for (n = Object(n); i--; ) {
                    var o = t[i];
                    if (!(o in n && b(e[o], n[o], le, 3))) return !1;
                }
                return !0;
            };
        }
        function C(e, t) {
            return (
                (e = Object(e)),
                W(
                    t,
                    function (t, n) {
                        return n in e && (t[n] = e[n]), t;
                    },
                    {}
                )
            );
        }
        function $(e) {
            return function (t) {
                return null == t ? le : t[e];
            };
        }
        function E(e, t, n) {
            var i = -1,
                o = e.length;
            for (
                0 > t && (t = -t > o ? 0 : o + t),
                    n = n > o ? o : n,
                    0 > n && (n += o),
                    o = t > n ? 0 : (n - t) >>> 0,
                    t >>>= 0,
                    n = Array(o);
                ++i < o;

            )
                n[i] = e[i + t];
            return n;
        }
        function A(e) {
            return E(e, 0, e.length);
        }
        function j(e, t) {
            var n;
            return (
                Pe(e, function (e, i, o) {
                    return (n = t(e, i, o)), !n;
                }),
                !!n
            );
        }
        function N(t, n) {
            return W(
                n,
                function (t, n) {
                    return n.func.apply(n.thisArg, e([t], n.args));
                },
                t
            );
        }
        function D(e, t, n, i) {
            n || (n = {});
            for (var o = -1, r = t.length; ++o < r; ) {
                var s = t[o],
                    a = i ? i(n[s], e[s], s, n, e) : e[s],
                    l = n,
                    u = l[s];
                (Se.call(l, s) && (u === a || (u !== u && a !== a)) && (a !== le || s in l)) || (l[s] = a);
            }
            return n;
        }
        function O(e) {
            return U(function (t, n) {
                var i = -1,
                    o = n.length,
                    r = o > 1 ? n[o - 1] : le,
                    r = "function" == typeof r ? (o--, r) : le;
                for (t = Object(t); ++i < o; ) {
                    var s = n[i];
                    s && e(t, s, i, r);
                }
                return t;
            });
        }
        function H(e) {
            return function () {
                var t = arguments,
                    n = p(e.prototype),
                    t = e.apply(n, t);
                return J(t) ? t : n;
            };
        }
        function q(e, t, n) {
            function i() {
                for (
                    var r = -1,
                        s = arguments.length,
                        a = -1,
                        l = n.length,
                        u = Array(l + s),
                        c = this && this !== xe && this instanceof i ? o : e;
                    ++a < l;

                )
                    u[a] = n[a];
                for (; s--; ) u[a++] = arguments[++r];
                return c.apply(t, u);
            }
            if ("function" != typeof e) throw new TypeError("Expected a function");
            var o = H(e);
            return i;
        }
        function P(e, t, n, i, o, r) {
            var s = -1,
                a = 1 & o,
                l = e.length,
                u = t.length;
            if (l != u && !(2 & o && u > l)) return !1;
            for (u = !0; ++s < l; ) {
                var c = e[s],
                    d = t[s];
                if (void 0 !== le) {
                    u = !1;
                    break;
                }
                if (a) {
                    if (
                        !j(t, function (e) {
                            return c === e || n(c, e, i, o, r);
                        })
                    ) {
                        u = !1;
                        break;
                    }
                } else if (c !== d && !n(c, d, i, o, r)) {
                    u = !1;
                    break;
                }
            }
            return u;
        }
        function L(e, t, n) {
            switch (n) {
                case "[object Boolean]":
                case "[object Date]":
                    return +e == +t;
                case "[object Error]":
                    return e.name == t.name && e.message == t.message;
                case "[object Number]":
                    return e != +e ? t != +t : e == +t;
                case "[object RegExp]":
                case "[object String]":
                    return e == t + "";
            }
            return !1;
        }
        function _(e, t, n, i, o, r) {
            var s = 2 & o,
                a = ie(e),
                l = a.length,
                u = ie(t).length;
            if (l != u && !s) return !1;
            for (var c = l; c--; ) {
                var d = a[c];
                if (!(s ? d in t : Se.call(t, d))) return !1;
            }
            for (u = !0; ++c < l; ) {
                var d = a[c],
                    p = e[d],
                    f = t[d];
                if (void 0 !== le || (p !== f && !n(p, f, i, o, r))) {
                    u = !1;
                    break;
                }
                s || (s = "constructor" == d);
            }
            return (
                u &&
                    !s &&
                    ((n = e.constructor),
                    (i = t.constructor),
                    n != i &&
                        "constructor" in e &&
                        "constructor" in t &&
                        !("function" == typeof n && n instanceof n && "function" == typeof i && i instanceof i) &&
                        (u = !1)),
                u
            );
        }
        function z(e) {
            var t = e ? e.length : le;
            if (Q(t) && (Re(e) || ee(e) || Y(e))) {
                e = String;
                for (var n = -1, i = Array(t); ++n < t; ) i[n] = e(n);
                t = i;
            } else t = null;
            return t;
        }
        function I(e) {
            var t = e && e.constructor,
                t = (G(t) && t.prototype) || Te;
            return e === t;
        }
        function F(e) {
            return e ? e[0] : le;
        }
        function M(e, t) {
            return n(e, x(t), Pe);
        }
        function R(e, t) {
            return Pe(e, "function" == typeof t ? t : se);
        }
        function W(e, t, n) {
            return i(e, x(t), n, 3 > arguments.length, Pe);
        }
        function B(e, t) {
            var n;
            if ("function" != typeof t) throw new TypeError("Expected a function");
            return (
                (e = We(e)),
                function () {
                    return 0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = le), n;
                }
            );
        }
        function U(e) {
            var t;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return (
                (t = qe(t === le ? e.length - 1 : We(t), 0)),
                function () {
                    for (var n = arguments, i = -1, o = qe(n.length - t, 0), r = Array(o); ++i < o; ) r[i] = n[t + i];
                    for (o = Array(t + 1), i = -1; ++i < t; ) o[i] = n[i];
                    return (o[t] = r), e.apply(this, o);
                }
            );
        }
        function X(e, t) {
            return e > t;
        }
        function Y(e) {
            return (
                Z(e) && V(e) && Se.call(e, "callee") && (!De.call(e, "callee") || "[object Arguments]" == $e.call(e))
            );
        }
        function V(e) {
            return null != e && !("function" == typeof e && G(e)) && Q(_e(e));
        }
        function G(e) {
            return (e = J(e) ? $e.call(e) : ""), "[object Function]" == e || "[object GeneratorFunction]" == e;
        }
        function Q(e) {
            return "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e;
        }
        function J(e) {
            var t = typeof e;
            return !!e && ("object" == t || "function" == t);
        }
        function Z(e) {
            return !!e && "object" == typeof e;
        }
        function K(e) {
            return "number" == typeof e || (Z(e) && "[object Number]" == $e.call(e));
        }
        function ee(e) {
            return "string" == typeof e || (!Re(e) && Z(e) && "[object String]" == $e.call(e));
        }
        function te(e, t) {
            return t > e;
        }
        function ne(e) {
            return "string" == typeof e ? e : null == e ? "" : e + "";
        }
        function ie(e) {
            var t = I(e);
            if (!t && !V(e)) return He(Object(e));
            var n,
                i = z(e),
                o = !!i,
                i = i || [],
                r = i.length;
            for (n in e) !Se.call(e, n) || (o && ("length" == n || l(n, r))) || (t && "constructor" == n) || i.push(n);
            return i;
        }
        function oe(e) {
            for (
                var t = -1, n = I(e), i = k(e), o = i.length, r = z(e), s = !!r, r = r || [], a = r.length;
                ++t < o;

            ) {
                var u = i[t];
                (s && ("length" == u || l(u, a))) || ("constructor" == u && (n || !Se.call(e, u))) || r.push(u);
            }
            return r;
        }
        function re(e) {
            return e ? o(e, ie(e)) : [];
        }
        function se(e) {
            return e;
        }
        function ae(t, n, i) {
            var o = ie(n),
                r = y(n, o);
            null != i || (J(n) && (r.length || !o.length)) || ((i = n), (n = t), (t = this), (r = y(n, ie(n))));
            var s = !(J(i) && "chain" in i) || i.chain,
                a = G(t);
            return (
                Pe(r, function (i) {
                    var o = n[i];
                    (t[i] = o),
                        a &&
                            (t.prototype[i] = function () {
                                var n = this.__chain__;
                                if (s || n) {
                                    var i = t(this.__wrapped__);
                                    return (
                                        (i.__actions__ = A(this.__actions__)).push({
                                            func: o,
                                            args: arguments,
                                            thisArg: t,
                                        }),
                                        (i.__chain__ = n),
                                        i
                                    );
                                }
                                return o.apply(t, e([this.value()], arguments));
                            });
                }),
                t
            );
        }
        var le,
            ue = 1 / 0,
            ce = /[&<>"'`]/g,
            de = RegExp(ce.source),
            pe = /^(?:0|[1-9]\d*)$/,
            fe = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
            he = { function: !0, object: !0 },
            ve = he[typeof exports] && exports && !exports.nodeType ? exports : le,
            ge = he[typeof module] && module && !module.nodeType ? module : le,
            me = ge && ge.exports === ve ? ve : le,
            ye = r(he[typeof self] && self),
            be = r(he[typeof window] && window),
            we = r(he[typeof this] && this),
            xe =
                r(ve && ge && "object" == typeof global && global) ||
                (be !== (we && we.window) && be) ||
                ye ||
                we ||
                Function("return this")(),
            ke = Array.prototype,
            Te = Object.prototype,
            Se = Te.hasOwnProperty,
            Ce = 0,
            $e = Te.toString,
            Ee = xe._,
            Ae = xe.Reflect,
            je = Ae ? Ae.f : le,
            Ne = Object.create,
            De = Te.propertyIsEnumerable,
            Oe = xe.isFinite,
            He = Object.keys,
            qe = Math.max,
            Pe = (function (e, t) {
                return function (n, i) {
                    if (null == n) return n;
                    if (!V(n)) return e(n, i);
                    for (
                        var o = n.length, r = t ? o : -1, s = Object(n);
                        (t ? r-- : ++r < o) && !1 !== i(s[r], r, s);

                    );
                    return n;
                };
            })(m),
            Le = (function (e) {
                return function (t, n, i) {
                    var o = -1,
                        r = Object(t);
                    i = i(t);
                    for (var s = i.length; s--; ) {
                        var a = i[e ? s : ++o];
                        if (!1 === n(r[a], a, r)) break;
                    }
                    return t;
                };
            })();
        je &&
            !De.call({ valueOf: 1 }, "valueOf") &&
            (k = function (e) {
                e = je(e);
                for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
                return n;
            });
        var _e = $("length"),
            ze = U(function (t, n) {
                return Re(t) || (t = null == t ? [] : [Object(t)]), g(n, 1), e(A(t), re);
            }),
            Ie = U(function (e, t, n) {
                return q(e, t, n);
            }),
            Fe = U(function (e, t) {
                return f(e, 1, t);
            }),
            Me = U(function (e, t, n) {
                return f(e, Be(t) || 0, n);
            }),
            Re = Array.isArray,
            We = Number,
            Be = Number,
            Ue = O(function (e, t) {
                D(t, ie(t), e);
            }),
            Xe = O(function (e, t) {
                D(t, oe(t), e);
            }),
            Ye = O(function (e, t, n, i) {
                D(t, oe(t), e, i);
            }),
            Ve = U(function (e) {
                return e.push(le, d), Ye.apply(le, e);
            }),
            Ge = U(function (e, t) {
                return null == e ? {} : C(e, g(t, 1));
            }),
            Qe = x;
        (c.prototype = p(u.prototype)),
            (c.prototype.constructor = c),
            (u.assignIn = Xe),
            (u.before = B),
            (u.bind = Ie),
            (u.chain = function (e) {
                return (e = u(e)), (e.__chain__ = !0), e;
            }),
            (u.compact = function (e) {
                return v(e, Boolean);
            }),
            (u.concat = ze),
            (u.create = function (e, t) {
                var n = p(e);
                return t ? Ue(n, t) : n;
            }),
            (u.defaults = Ve),
            (u.defer = Fe),
            (u.delay = Me),
            (u.filter = function (e, t) {
                return v(e, x(t));
            }),
            (u.flatten = function (e) {
                return e && e.length ? g(e, 1) : [];
            }),
            (u.flattenDeep = function (e) {
                return e && e.length ? g(e, ue) : [];
            }),
            (u.iteratee = Qe),
            (u.keys = ie),
            (u.map = function (e, t) {
                return T(e, x(t));
            }),
            (u.matches = function (e) {
                return S(Ue({}, e));
            }),
            (u.mixin = ae),
            (u.negate = function (e) {
                if ("function" != typeof e) throw new TypeError("Expected a function");
                return function () {
                    return !e.apply(this, arguments);
                };
            }),
            (u.once = function (e) {
                return B(2, e);
            }),
            (u.pick = Ge),
            (u.slice = function (e, t, n) {
                var i = e ? e.length : 0;
                return (n = n === le ? i : +n), i ? E(e, null == t ? 0 : +t, n) : [];
            }),
            (u.sortBy = function (e, t) {
                var n = 0;
                return (
                    (t = x(t)),
                    T(
                        T(e, function (e, i, o) {
                            return { c: e, b: n++, a: t(e, i, o) };
                        }).sort(function (e, t) {
                            var n;
                            e: {
                                n = e.a;
                                var i = t.a;
                                if (n !== i) {
                                    var o = null === n,
                                        r = n === le,
                                        s = n === n,
                                        a = null === i,
                                        l = i === le,
                                        u = i === i;
                                    if ((n > i && !a) || !s || (o && !l && u) || (r && u)) {
                                        n = 1;
                                        break e;
                                    }
                                    if ((i > n && !o) || !u || (a && !r && s) || (l && s)) {
                                        n = -1;
                                        break e;
                                    }
                                }
                                n = 0;
                            }
                            return n || e.b - t.b;
                        }),
                        $("c")
                    )
                );
            }),
            (u.tap = function (e, t) {
                return t(e), e;
            }),
            (u.thru = function (e, t) {
                return t(e);
            }),
            (u.toArray = function (e) {
                return V(e) ? (e.length ? A(e) : []) : re(e);
            }),
            (u.values = re),
            (u.extend = Xe),
            ae(u, u),
            (u.clone = function (e) {
                return J(e) ? (Re(e) ? A(e) : D(e, ie(e))) : e;
            }),
            (u.escape = function (e) {
                return (e = ne(e)) && de.test(e) ? e.replace(ce, s) : e;
            }),
            (u.every = function (e, t, n) {
                return (t = n ? le : t), h(e, x(t));
            }),
            (u.find = M),
            (u.forEach = R),
            (u.has = function (e, t) {
                return null != e && Se.call(e, t);
            }),
            (u.head = F),
            (u.identity = se),
            (u.indexOf = function (e, t, n) {
                var i = e ? e.length : 0;
                (n = "number" == typeof n ? (0 > n ? qe(i + n, 0) : n) : 0), (n = (n || 0) - 1);
                for (var o = t === t; ++n < i; ) {
                    var r = e[n];
                    if (o ? r === t : r !== r) return n;
                }
                return -1;
            }),
            (u.isArguments = Y),
            (u.isArray = Re),
            (u.isBoolean = function (e) {
                return !0 === e || !1 === e || (Z(e) && "[object Boolean]" == $e.call(e));
            }),
            (u.isDate = function (e) {
                return Z(e) && "[object Date]" == $e.call(e);
            }),
            (u.isEmpty = function (e) {
                if (V(e) && (Re(e) || ee(e) || G(e.splice) || Y(e))) return !e.length;
                for (var t in e) if (Se.call(e, t)) return !1;
                return !0;
            }),
            (u.isEqual = function (e, t) {
                return b(e, t);
            }),
            (u.isFinite = function (e) {
                return "number" == typeof e && Oe(e);
            }),
            (u.isFunction = G),
            (u.isNaN = function (e) {
                return K(e) && e != +e;
            }),
            (u.isNull = function (e) {
                return null === e;
            }),
            (u.isNumber = K),
            (u.isObject = J),
            (u.isRegExp = function (e) {
                return J(e) && "[object RegExp]" == $e.call(e);
            }),
            (u.isString = ee),
            (u.isUndefined = function (e) {
                return e === le;
            }),
            (u.last = function (e) {
                var t = e ? e.length : 0;
                return t ? e[t - 1] : le;
            }),
            (u.max = function (e) {
                return e && e.length ? t(e, se, X) : le;
            }),
            (u.min = function (e) {
                return e && e.length ? t(e, se, te) : le;
            }),
            (u.noConflict = function () {
                return xe._ === this && (xe._ = Ee), this;
            }),
            (u.noop = function () {}),
            (u.reduce = W),
            (u.result = function (e, t, n) {
                return (t = null == e ? le : e[t]), t === le && (t = n), G(t) ? t.call(e) : t;
            }),
            (u.size = function (e) {
                return null == e ? 0 : ((e = V(e) ? e : ie(e)), e.length);
            }),
            (u.some = function (e, t, n) {
                return (t = n ? le : t), j(e, x(t));
            }),
            (u.uniqueId = function (e) {
                var t = ++Ce;
                return ne(e) + t;
            }),
            (u.each = R),
            (u.first = F),
            ae(
                u,
                (function () {
                    var e = {};
                    return (
                        m(u, function (t, n) {
                            Se.call(u.prototype, n) || (e[n] = t);
                        }),
                        e
                    );
                })(),
                { chain: !1 }
            ),
            (u.VERSION = "4.5.1"),
            Pe("pop join replace reverse split push shift sort splice unshift".split(" "), function (e) {
                var t = (/^(?:replace|split)$/.test(e) ? String.prototype : ke)[e],
                    n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                    i = /^(?:pop|join|replace|shift)$/.test(e);
                u.prototype[e] = function () {
                    var e = arguments;
                    return i && !this.__chain__
                        ? t.apply(this.value(), e)
                        : this[n](function (n) {
                              return t.apply(n, e);
                          });
                };
            }),
            (u.prototype.toJSON =
                u.prototype.valueOf =
                u.prototype.value =
                    function () {
                        return N(this.__wrapped__, this.__actions__);
                    }),
            ((be || ye || {})._ = u),
            "function" == typeof define && "object" == typeof define.amd && define.amd
                ? define(function () {
                      return u;
                  })
                : ve && ge
                  ? (me && ((ge.exports = u)._ = u), (ve._ = u))
                  : (xe._ = u);
    }.call(this) /*!


/*!
 * jqueryCookie.js
 *
 */,
    (function (e) {
        if (typeof define === "function" && define.amd) {
            define(["jquery"], e);
        } else {
            e(jQuery);
        }
    })(function (e) {
        function n(e) {
            return e;
        }
        function r(e) {
            return decodeURIComponent(e.replace(t, " "));
        }
        function i(e) {
            if (e.indexOf('"') === 0) {
                e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
            }
            try {
                return s.json ? JSON.parse(e) : e;
            } catch (t) {}
        }
        var t = /\+/g;
        var s = (e.cookie = function (t, o, u) {
            if (o !== undefined) {
                u = e.extend({}, s.defaults, u);
                if (typeof u.expires === "number") {
                    var a = u.expires,
                        f = (u.expires = new Date());
                    f.setDate(f.getDate() + a);
                }
                o = s.json ? JSON.stringify(o) : String(o);
                return (document.cookie = [
                    s.raw ? t : encodeURIComponent(t),
                    "=",
                    s.raw ? o : encodeURIComponent(o),
                    u.expires ? "; expires=" + u.expires.toUTCString() : "",
                    u.path ? "; path=" + u.path : "",
                    u.domain ? "; domain=" + u.domain : "",
                    u.secure ? "; secure" : "",
                ].join(""));
            }
            var l = s.raw ? n : r;
            var c = document.cookie.split("; ");
            var h = t ? undefined : {};
            for (var p = 0, d = c.length; p < d; p++) {
                var v = c[p].split("=");
                var m = l(v.shift());
                var g = l(v.join("="));
                if (t && t === m) {
                    h = i(g);
                    break;
                }
                if (!t) {
                    h[m] = i(g);
                }
            }
            return h;
        });
        s.defaults = {};
        e.removeCookie = function (t, n) {
            if (e.cookie(t) !== undefined) {
                e.cookie(t, "", e.extend({}, n, { expires: -1 }));
                return true;
            }
            return false;
        };
    }) /*!

/*!
 * mobile-sniff.min.js
 */,
    !(function () {
        window.mobileCheck = function () {
            var e = !1;
            return (
                (function (t) {
                    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                        t
                    ) ||
                        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                            t.substr(0, 4)
                        )) &&
                        (e = !0);
                })(navigator.userAgent || navigator.vendor || window.opera),
                e
            );
        };
    })() /*!

/*!
 * modernizr.min.js
 *
 * modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-flexbox-svg-setclasses
 */,
    !(function (e, t, n) {
        function i(e, t) {
            return typeof e === t;
        }
        function o() {
            var e, t, n, o, r, s, a;
            for (var l in b)
                if (b.hasOwnProperty(l)) {
                    if (
                        ((e = []),
                        (t = b[l]),
                        t.name &&
                            (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                    )
                        for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                    for (o = i(t.fn, "function") ? t.fn() : t.fn, r = 0; r < e.length; r++)
                        (s = e[r]),
                            (a = s.split(".")),
                            1 === a.length
                                ? (x[a[0]] = o)
                                : (!x[a[0]] || x[a[0]] instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])),
                                  (x[a[0]][a[1]] = o)),
                            y.push((o ? "" : "no-") + a.join("-"));
                }
        }
        function r(e) {
            var t = k.className,
                n = x._config.classPrefix || "";
            if ((T && (t = t.baseVal), x._config.enableJSClass)) {
                var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                t = t.replace(i, "$1" + n + "js$2");
            }
            x._config.enableClasses &&
                ((t += " " + n + e.join(" " + n)), T ? (k.className.baseVal = t) : (k.className = t));
        }
        function s(e, t) {
            return !!~("" + e).indexOf(t);
        }
        function a() {
            return "function" != typeof t.createElement
                ? t.createElement(arguments[0])
                : T
                  ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
                  : t.createElement.apply(t, arguments);
        }
        function l(e) {
            return e
                .replace(/([a-z])-([a-z])/g, function (e, t, n) {
                    return t + n.toUpperCase();
                })
                .replace(/^-/, "");
        }
        function u(e, t) {
            return function () {
                return e.apply(t, arguments);
            };
        }
        function c(e, t, n) {
            var o;
            for (var r in e)
                if (e[r] in t) return n === !1 ? e[r] : ((o = t[e[r]]), i(o, "function") ? u(o, n || t) : o);
            return !1;
        }
        function d(e) {
            return e
                .replace(/([A-Z])/g, function (e, t) {
                    return "-" + t.toLowerCase();
                })
                .replace(/^ms-/, "-ms-");
        }
        function p() {
            var e = t.body;
            return e || ((e = a(T ? "svg" : "body")), (e.fake = !0)), e;
        }
        function f(e, n, i, o) {
            var r,
                s,
                l,
                u,
                c = "modernizr",
                d = a("div"),
                f = p();
            if (parseInt(i, 10)) for (; i--; ) (l = a("div")), (l.id = o ? o[i] : c + (i + 1)), d.appendChild(l);
            return (
                (r = a("style")),
                (r.type = "text/css"),
                (r.id = "s" + c),
                (f.fake ? f : d).appendChild(r),
                f.appendChild(d),
                r.styleSheet ? (r.styleSheet.cssText = e) : r.appendChild(t.createTextNode(e)),
                (d.id = c),
                f.fake &&
                    ((f.style.background = ""),
                    (f.style.overflow = "hidden"),
                    (u = k.style.overflow),
                    (k.style.overflow = "hidden"),
                    k.appendChild(f)),
                (s = n(d, e)),
                f.fake
                    ? (f.parentNode.removeChild(f), (k.style.overflow = u), k.offsetHeight)
                    : d.parentNode.removeChild(d),
                !!s
            );
        }
        function h(t, i) {
            var o = t.length;
            if ("CSS" in e && "supports" in e.CSS) {
                for (; o--; ) if (e.CSS.supports(d(t[o]), i)) return !0;
                return !1;
            }
            if ("CSSSupportsRule" in e) {
                for (var r = []; o--; ) r.push("(" + d(t[o]) + ":" + i + ")");
                return (
                    (r = r.join(" or ")),
                    f("@supports (" + r + ") { #modernizr { position: absolute; } }", function (e) {
                        return "absolute" == getComputedStyle(e, null).position;
                    })
                );
            }
            return n;
        }
        function v(e, t, o, r) {
            function u() {
                d && (delete A.style, delete A.modElem);
            }
            if (((r = !i(r, "undefined") && r), !i(o, "undefined"))) {
                var c = h(e, o);
                if (!i(c, "undefined")) return c;
            }
            for (var d, p, f, v, g, m = ["modernizr", "tspan", "samp"]; !A.style && m.length; )
                (d = !0), (A.modElem = a(m.shift())), (A.style = A.modElem.style);
            for (f = e.length, p = 0; f > p; p++)
                if (((v = e[p]), (g = A.style[v]), s(v, "-") && (v = l(v)), A.style[v] !== n)) {
                    if (r || i(o, "undefined")) return u(), "pfx" != t || v;
                    try {
                        A.style[v] = o;
                    } catch (e) {}
                    if (A.style[v] != g) return u(), "pfx" != t || v;
                }
            return u(), !1;
        }
        function g(e, t, n, o, r) {
            var s = e.charAt(0).toUpperCase() + e.slice(1),
                a = (e + " " + C.join(s + " ") + s).split(" ");
            return i(t, "string") || i(t, "undefined")
                ? v(a, t, o, r)
                : ((a = (e + " " + $.join(s + " ") + s).split(" ")), c(a, t, n));
        }
        function m(e, t, i) {
            return g(e, n, n, t, i);
        }
        var y = [],
            b = [],
            w = {
                _version: "3.3.1",
                _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
                _q: [],
                on: function (e, t) {
                    var n = this;
                    setTimeout(function () {
                        t(n[e]);
                    }, 0);
                },
                addTest: function (e, t, n) {
                    b.push({ name: e, fn: t, options: n });
                },
                addAsyncTest: function (e) {
                    b.push({ name: null, fn: e });
                },
            },
            x = function () {};
        (x.prototype = w),
            (x = new x()),
            x.addTest(
                "svg",
                !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
            );
        var k = t.documentElement,
            T = "svg" === k.nodeName.toLowerCase(),
            S = "Moz O ms Webkit",
            C = w._config.usePrefixes ? S.split(" ") : [];
        w._cssomPrefixes = C;
        var $ = w._config.usePrefixes ? S.toLowerCase().split(" ") : [];
        w._domPrefixes = $;
        var E = { elem: a("modernizr") };
        x._q.push(function () {
            delete E.elem;
        });
        var A = { style: E.elem.style };
        x._q.unshift(function () {
            delete A.style;
        }),
            (w.testAllProps = g),
            (w.testAllProps = m),
            x.addTest("flexbox", m("flexBasis", "1px", !0)),
            x.addTest("csstransforms", function () {
                return -1 === navigator.userAgent.indexOf("Android 2.") && m("transform", "scale(1)", !0);
            }),
            o(),
            r(y),
            delete w.addTest,
            delete w.addAsyncTest;
        for (var j = 0; j < x._q.length; j++) x._q[j]();
        e.Modernizr = x;
    })(window, document) /*!

/*!
 * prepare-transition.min.js
 *
 * Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition
 */,
    !(function (e) {
        e.fn.prepareTransition = function () {
            return this.each(function () {
                var t = e(this);
                t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                    t.removeClass("is-transitioning");
                });
                var n = [
                        "transition-duration",
                        "-moz-transition-duration",
                        "-webkit-transition-duration",
                        "-o-transition-duration",
                    ],
                    i = 0;
                e.each(n, function (e, n) {
                    i || (i = parseFloat(t.css(n)));
                }),
                    0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
            });
        };
    })(jQuery) /*!

/*! 
 * slick-slim.min.js
 */,
    !(function (i) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["jquery"], i)
            : "undefined" != typeof exports
              ? (module.exports = i(require("jquery")))
              : i(jQuery);
    })(function (i) {
        "use strict";
        var e = window.Slick || {};
        ((e = (function () {
            var e = 0;
            return function (t, o) {
                var s,
                    n = this;
                (n.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: i(t),
                    appendDots: i(t),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (e, t) {
                        return i('<button type="button" />').text(t + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (n.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    i.extend(n, n.initials),
                    (n.activeBreakpoint = null),
                    (n.animType = null),
                    (n.animProp = null),
                    (n.breakpoints = []),
                    (n.breakpointSettings = []),
                    (n.cssTransitions = !1),
                    (n.focussed = !1),
                    (n.interrupted = !1),
                    (n.hidden = "hidden"),
                    (n.paused = !0),
                    (n.positionProp = null),
                    (n.respondTo = null),
                    (n.rowCount = 1),
                    (n.shouldClick = !0),
                    (n.$slider = i(t)),
                    (n.$slidesCache = null),
                    (n.transformType = null),
                    (n.transitionType = null),
                    (n.visibilityChange = "visibilitychange"),
                    (n.windowWidth = 0),
                    (n.windowTimer = null),
                    (s = i(t).data("slick") || {}),
                    (n.options = i.extend({}, n.defaults, o, s)),
                    (n.currentSlide = n.options.initialSlide),
                    (n.originalSettings = n.options),
                    void 0 !== document.mozHidden
                        ? ((n.hidden = "mozHidden"), (n.visibilityChange = "mozvisibilitychange"))
                        : void 0 !== document.webkitHidden &&
                          ((n.hidden = "webkitHidden"), (n.visibilityChange = "webkitvisibilitychange")),
                    (n.autoPlay = i.proxy(n.autoPlay, n)),
                    (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                    (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                    (n.changeSlide = i.proxy(n.changeSlide, n)),
                    (n.clickHandler = i.proxy(n.clickHandler, n)),
                    (n.selectHandler = i.proxy(n.selectHandler, n)),
                    (n.setPosition = i.proxy(n.setPosition, n)),
                    (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                    (n.dragHandler = i.proxy(n.dragHandler, n)),
                    (n.keyHandler = i.proxy(n.keyHandler, n)),
                    (n.instanceUid = e++),
                    (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    n.registerBreakpoints(),
                    n.init(!0);
            };
        })()).prototype.activateADA = function () {
            this.$slideTrack
                .find(".slick-active")
                .attr({ "aria-hidden": "false" })
                .find("a, input, button, select")
                .attr({ tabindex: "0" });
        }),
            (e.prototype.addSlide = e.prototype.slickAdd =
                function (e, t, o) {
                    var s = this;
                    if ("boolean" == typeof t) (o = t), (t = null);
                    else if (t < 0 || t >= s.slideCount) return !1;
                    s.unload(),
                        "number" == typeof t
                            ? 0 === t && 0 === s.$slides.length
                                ? i(e).appendTo(s.$slideTrack)
                                : o
                                  ? i(e).insertBefore(s.$slides.eq(t))
                                  : i(e).insertAfter(s.$slides.eq(t))
                            : !0 === o
                              ? i(e).prependTo(s.$slideTrack)
                              : i(e).appendTo(s.$slideTrack),
                        (s.$slides = s.$slideTrack.children(this.options.slide)),
                        s.$slideTrack.children(this.options.slide).detach(),
                        s.$slideTrack.append(s.$slides),
                        s.$slides.each(function (e, t) {
                            i(t).attr("data-slick-index", e);
                        }),
                        (s.$slidesCache = s.$slides),
                        s.reinit();
                }),
            (e.prototype.animateHeight = function () {
                var i = this;
                if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                    var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                    i.$list.animate({ height: e }, i.options.speed);
                }
            }),
            (e.prototype.animateSlide = function (e, t) {
                var o = {},
                    s = this;
                s.animateHeight(),
                    !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
                    !1 === s.transformsEnabled
                        ? !1 === s.options.vertical
                            ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t)
                            : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t)
                        : !1 === s.cssTransitions
                          ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                            i({ animStart: s.currentLeft }).animate(
                                { animStart: e },
                                {
                                    duration: s.options.speed,
                                    easing: s.options.easing,
                                    step: function (i) {
                                        (i = Math.ceil(i)),
                                            !1 === s.options.vertical
                                                ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                                                  s.$slideTrack.css(o))
                                                : ((o[s.animType] = "translate(0px," + i + "px)"),
                                                  s.$slideTrack.css(o));
                                    },
                                    complete: function () {
                                        t && t.call();
                                    },
                                }
                            ))
                          : (s.applyTransition(),
                            (e = Math.ceil(e)),
                            !1 === s.options.vertical
                                ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
                                : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
                            s.$slideTrack.css(o),
                            t &&
                                setTimeout(function () {
                                    s.disableTransition(), t.call();
                                }, s.options.speed));
            }),
            (e.prototype.getNavTarget = function () {
                var e = this.options.asNavFor;
                return e && null !== e && (e = i(e).not(this.$slider)), e;
            }),
            (e.prototype.asNavFor = function (e) {
                var t = this.getNavTarget();
                null !== t &&
                    "object" == typeof t &&
                    t.each(function () {
                        var t = i(this).slick("getSlick");
                        t.unslicked || t.slideHandler(e, !0);
                    });
            }),
            (e.prototype.applyTransition = function (i) {
                var e = this,
                    t = {};
                !1 === e.options.fade
                    ? (t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
                    : (t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase),
                    !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
            }),
            (e.prototype.autoPlay = function () {
                var i = this;
                i.autoPlayClear(),
                    i.slideCount > i.options.slidesToShow &&
                        (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
            }),
            (e.prototype.autoPlayClear = function () {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (e.prototype.autoPlayIterator = function () {
                var i = this,
                    e = i.currentSlide + i.options.slidesToScroll;
                i.paused ||
                    i.interrupted ||
                    i.focussed ||
                    (!1 === i.options.infinite &&
                        (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
                            ? (i.direction = 0)
                            : 0 === i.direction &&
                              ((e = i.currentSlide - i.options.slidesToScroll),
                              i.currentSlide - 1 == 0 && (i.direction = 1))),
                    i.slideHandler(e));
            }),
            (e.prototype.buildArrows = function () {
                var e = this;
                !0 === e.options.arrows &&
                    ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
                    (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
                    e.slideCount > e.options.slidesToShow
                        ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                          e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                          !0 !== e.options.infinite &&
                              e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : e.$prevArrow
                              .add(e.$nextArrow)
                              .addClass("slick-hidden")
                              .attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (e.prototype.buildDots = function () {
                var e,
                    t,
                    o = this;
                if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
                    for (
                        o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0;
                        e <= o.getDotCount();
                        e += 1
                    )
                        t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
                    (o.$dots = t.appendTo(o.options.appendDots)), o.$dots.find("li").first().addClass("slick-active");
                }
            }),
            (e.prototype.buildOut = function () {
                var e = this;
                (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.$slides.each(function (e, t) {
                        i(t)
                            .attr("data-slick-index", e)
                            .data("originalStyling", i(t).attr("style") || "");
                    }),
                    e.$slider.addClass("slick-slider"),
                    (e.$slideTrack =
                        0 === e.slideCount
                            ? i('<div class="slick-track"/>').appendTo(e.$slider)
                            : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                    e.$slideTrack.css("opacity", 0),
                    (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) || (e.options.slidesToScroll = 1),
                    i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.buildDots(),
                    e.updateDots(),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    !0 === e.options.draggable && e.$list.addClass("draggable");
            }),
            (e.prototype.buildRows = function () {
                var i,
                    e,
                    t,
                    o,
                    s,
                    n,
                    r,
                    l = this;
                if (((o = document.createDocumentFragment()), (n = l.$slider.children()), l.options.rows > 0)) {
                    for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                        var d = document.createElement("div");
                        for (e = 0; e < l.options.rows; e++) {
                            var a = document.createElement("div");
                            for (t = 0; t < l.options.slidesPerRow; t++) {
                                var c = i * r + (e * l.options.slidesPerRow + t);
                                n.get(c) && a.appendChild(n.get(c));
                            }
                            d.appendChild(a);
                        }
                        o.appendChild(d);
                    }
                    l.$slider.empty().append(o),
                        l.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (e.prototype.checkResponsive = function (e, t) {
                var o,
                    s,
                    n,
                    r = this,
                    l = !1,
                    d = r.$slider.width(),
                    a = window.innerWidth || i(window).width();
                if (
                    ("window" === r.respondTo
                        ? (n = a)
                        : "slider" === r.respondTo
                          ? (n = d)
                          : "min" === r.respondTo && (n = Math.min(a, d)),
                    r.options.responsive && r.options.responsive.length && null !== r.options.responsive)
                ) {
                    for (o in ((s = null), r.breakpoints))
                        r.breakpoints.hasOwnProperty(o) &&
                            (!1 === r.originalSettings.mobileFirst
                                ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                                : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                    null !== s
                        ? null !== r.activeBreakpoint
                            ? (s !== r.activeBreakpoint || t) &&
                              ((r.activeBreakpoint = s),
                              "unslick" === r.breakpointSettings[s]
                                  ? r.unslick(s)
                                  : ((r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s])),
                                    !0 === e && (r.currentSlide = r.options.initialSlide),
                                    r.refresh(e)),
                              (l = s))
                            : ((r.activeBreakpoint = s),
                              "unslick" === r.breakpointSettings[s]
                                  ? r.unslick(s)
                                  : ((r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s])),
                                    !0 === e && (r.currentSlide = r.options.initialSlide),
                                    r.refresh(e)),
                              (l = s))
                        : null !== r.activeBreakpoint &&
                          ((r.activeBreakpoint = null),
                          (r.options = r.originalSettings),
                          !0 === e && (r.currentSlide = r.options.initialSlide),
                          r.refresh(e),
                          (l = s)),
                        e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
                }
            }),
            (e.prototype.changeSlide = function (e, t) {
                var o,
                    s,
                    n = this,
                    r = i(e.currentTarget);
                switch (
                    (r.is("a") && e.preventDefault(),
                    r.is("li") || (r = r.closest("li")),
                    (o =
                        n.slideCount % n.options.slidesToScroll != 0
                            ? 0
                            : (n.slideCount - n.currentSlide) % n.options.slidesToScroll),
                    e.data.message)
                ) {
                    case "previous":
                        (s = 0 === o ? n.options.slidesToScroll : n.options.slidesToShow - o),
                            n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide - s, !1, t);
                        break;
                    case "next":
                        (s = 0 === o ? n.options.slidesToScroll : o),
                            n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide + s, !1, t);
                        break;
                    case "index":
                        var l = 0 === e.data.index ? 0 : e.data.index || r.index() * n.options.slidesToScroll;
                        n.slideHandler(n.checkNavigable(l), !1, t), r.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (e.prototype.checkNavigable = function (i) {
                var e, t;
                if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1])) i = e[e.length - 1];
                else
                    for (var o in e) {
                        if (i < e[o]) {
                            i = t;
                            break;
                        }
                        t = e[o];
                    }
                return i;
            }),
            (e.prototype.cleanUpEvents = function () {
                var e = this;
                e.options.dots &&
                    null !== e.$dots &&
                    (i("li", e.$dots)
                        .off("click.slick", e.changeSlide)
                        .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                        .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                    !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)),
                    e.$slider.off("focus.slick blur.slick"),
                    !0 === e.options.arrows &&
                        e.slideCount > e.options.slidesToShow &&
                        (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
                        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
                        !0 === e.options.accessibility &&
                            (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
                            e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
                    e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                    e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                    e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                    e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                    e.$list.off("click.slick", e.clickHandler),
                    i(document).off(e.visibilityChange, e.visibility),
                    e.cleanUpSlideEvents(),
                    !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
                    i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                    i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                    i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                    i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
            }),
            (e.prototype.cleanUpSlideEvents = function () {
                var e = this;
                e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                    e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
            }),
            (e.prototype.cleanUpRows = function () {
                var i,
                    e = this;
                e.options.rows > 0 &&
                    ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
            }),
            (e.prototype.clickHandler = function (i) {
                !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
            }),
            (e.prototype.destroy = function (e) {
                var t = this;
                t.autoPlayClear(),
                    (t.touchObject = {}),
                    t.cleanUpEvents(),
                    i(".slick-cloned", t.$slider).detach(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow &&
                        t.$prevArrow.length &&
                        (t.$prevArrow
                            .removeClass("slick-disabled slick-arrow slick-hidden")
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                    t.$nextArrow &&
                        t.$nextArrow.length &&
                        (t.$nextArrow
                            .removeClass("slick-disabled slick-arrow slick-hidden")
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                    t.$slides &&
                        (t.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                i(this).attr("style", i(this).data("originalStyling"));
                            }),
                        t.$slideTrack.children(this.options.slide).detach(),
                        t.$slideTrack.detach(),
                        t.$list.detach(),
                        t.$slider.append(t.$slides)),
                    t.cleanUpRows(),
                    t.$slider.removeClass("slick-slider"),
                    t.$slider.removeClass("slick-initialized"),
                    t.$slider.removeClass("slick-dotted"),
                    (t.unslicked = !0),
                    e || t.$slider.trigger("destroy", [t]);
            }),
            (e.prototype.disableTransition = function (i) {
                var e = this,
                    t = {};
                (t[e.transitionType] = ""), !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
            }),
            (e.prototype.fadeSlide = function (i, e) {
                var t = this;
                !1 === t.cssTransitions
                    ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
                      t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
                    : (t.applyTransition(i),
                      t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                      e &&
                          setTimeout(function () {
                              t.disableTransition(i), e.call();
                          }, t.options.speed));
            }),
            (e.prototype.fadeSlideOut = function (i) {
                var e = this;
                !1 === e.cssTransitions
                    ? e.$slides
                          .eq(i)
                          .animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing)
                    : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
            }),
            (e.prototype.filterSlides = e.prototype.slickFilter =
                function (i) {
                    var e = this;
                    null !== i &&
                        ((e.$slidesCache = e.$slides),
                        e.unload(),
                        e.$slideTrack.children(this.options.slide).detach(),
                        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
                        e.reinit());
                }),
            (e.prototype.focusHandler = function () {
                var e = this;
                e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
                    t.stopImmediatePropagation();
                    var o = i(this);
                    setTimeout(function () {
                        e.options.pauseOnFocus && ((e.focussed = o.is(":focus")), e.autoPlay());
                    }, 0);
                });
            }),
            (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
                function () {
                    return this.currentSlide;
                }),
            (e.prototype.getDotCount = function () {
                var i = this,
                    e = 0,
                    t = 0,
                    o = 0;
                if (!0 === i.options.infinite)
                    if (i.slideCount <= i.options.slidesToShow) ++o;
                    else
                        for (; e < i.slideCount; )
                            ++o,
                                (e = t + i.options.slidesToScroll),
                                (t +=
                                    i.options.slidesToScroll <= i.options.slidesToShow
                                        ? i.options.slidesToScroll
                                        : i.options.slidesToShow);
                else if (!0 === i.options.centerMode) o = i.slideCount;
                else if (i.options.asNavFor)
                    for (; e < i.slideCount; )
                        ++o,
                            (e = t + i.options.slidesToScroll),
                            (t +=
                                i.options.slidesToScroll <= i.options.slidesToShow
                                    ? i.options.slidesToScroll
                                    : i.options.slidesToShow);
                else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
                return o - 1;
            }),
            (e.prototype.getLeft = function (i) {
                var e,
                    t,
                    o,
                    s,
                    n = this,
                    r = 0;
                return (
                    (n.slideOffset = 0),
                    (t = n.$slides.first().outerHeight(!0)),
                    !0 === n.options.infinite
                        ? (n.slideCount > n.options.slidesToShow &&
                              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                              (s = -1),
                              !0 === n.options.vertical &&
                                  !0 === n.options.centerMode &&
                                  (2 === n.options.slidesToShow
                                      ? (s = -1.5)
                                      : 1 === n.options.slidesToShow && (s = -2)),
                              (r = t * n.options.slidesToShow * s)),
                          n.slideCount % n.options.slidesToScroll != 0 &&
                              i + n.options.slidesToScroll > n.slideCount &&
                              n.slideCount > n.options.slidesToShow &&
                              (i > n.slideCount
                                  ? ((n.slideOffset =
                                        (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1),
                                    (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                                  : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1),
                                    (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
                        : i + n.options.slidesToShow > n.slideCount &&
                          ((n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
                          (r = (i + n.options.slidesToShow - n.slideCount) * t)),
                    n.slideCount <= n.options.slidesToShow && ((n.slideOffset = 0), (r = 0)),
                    !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
                        ? (n.slideOffset =
                              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                              (n.slideWidth * n.slideCount) / 2)
                        : !0 === n.options.centerMode && !0 === n.options.infinite
                          ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
                          : !0 === n.options.centerMode &&
                            ((n.slideOffset = 0),
                            (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                    (e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r),
                    !0 === n.options.variableWidth &&
                        ((o =
                            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
                                ? n.$slideTrack.children(".slick-slide").eq(i)
                                : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow)),
                        (e =
                            !0 === n.options.rtl
                                ? o[0]
                                    ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                                    : 0
                                : o[0]
                                  ? -1 * o[0].offsetLeft
                                  : 0),
                        !0 === n.options.centerMode &&
                            ((o =
                                n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
                                    ? n.$slideTrack.children(".slick-slide").eq(i)
                                    : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1)),
                            (e =
                                !0 === n.options.rtl
                                    ? o[0]
                                        ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                                        : 0
                                    : o[0]
                                      ? -1 * o[0].offsetLeft
                                      : 0),
                            (e += (n.$list.width() - o.outerWidth()) / 2))),
                    e
                );
            }),
            (e.prototype.getOption = e.prototype.slickGetOption =
                function (i) {
                    return this.options[i];
                }),
            (e.prototype.getNavigableIndexes = function () {
                var i,
                    e = this,
                    t = 0,
                    o = 0,
                    s = [];
                for (
                    !1 === e.options.infinite
                        ? (i = e.slideCount)
                        : ((t = -1 * e.options.slidesToScroll),
                          (o = -1 * e.options.slidesToScroll),
                          (i = 2 * e.slideCount));
                    t < i;

                )
                    s.push(t),
                        (t = o + e.options.slidesToScroll),
                        (o +=
                            e.options.slidesToScroll <= e.options.slidesToShow
                                ? e.options.slidesToScroll
                                : e.options.slidesToShow);
                return s;
            }),
            (e.prototype.getSlick = function () {
                return this;
            }),
            (e.prototype.getSlideCount = function () {
                var e,
                    t,
                    o = this;
                return (
                    (t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
                    !0 === o.options.swipeToSlide
                        ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                              if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return (e = n), !1;
                          }),
                          Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
                        : o.options.slidesToScroll
                );
            }),
            (e.prototype.goTo = e.prototype.slickGoTo =
                function (i, e) {
                    this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
                }),
            (e.prototype.init = function (e) {
                var t = this;
                i(t.$slider).hasClass("slick-initialized") ||
                    (i(t.$slider).addClass("slick-initialized"),
                    t.buildRows(),
                    t.buildOut(),
                    t.setProps(),
                    t.startLoad(),
                    t.loadSlider(),
                    t.initializeEvents(),
                    t.updateArrows(),
                    t.updateDots(),
                    t.checkResponsive(!0),
                    t.focusHandler()),
                    e && t.$slider.trigger("init", [t]),
                    !0 === t.options.accessibility && t.initADA(),
                    t.options.autoplay && ((t.paused = !1), t.autoPlay());
            }),
            (e.prototype.initADA = function () {
                var e = this,
                    t = Math.ceil(e.slideCount / e.options.slidesToShow),
                    o = e.getNavigableIndexes().filter(function (i) {
                        return i >= 0 && i < e.slideCount;
                    });
                e.$slides
                    .add(e.$slideTrack.find(".slick-cloned"))
                    .attr({ "aria-hidden": "true", tabindex: "-1" })
                    .find("a, input, button, select")
                    .attr({ tabindex: "-1" }),
                    null !== e.$dots &&
                        (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
                            var s = o.indexOf(t);
                            if (
                                (i(this).attr({
                                    role: "tabpanel",
                                    id: "slick-slide" + e.instanceUid + t,
                                    tabindex: -1,
                                }),
                                -1 !== s)
                            ) {
                                var n = "slick-slide-control" + e.instanceUid + s;
                                i("#" + n).length && i(this).attr({ "aria-describedby": n });
                            }
                        }),
                        e.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (s) {
                                var n = o[s];
                                i(this).attr({ role: "presentation" }),
                                    i(this)
                                        .find("button")
                                        .first()
                                        .attr({
                                            role: "tab",
                                            id: "slick-slide-control" + e.instanceUid + s,
                                            "aria-controls": "slick-slide" + e.instanceUid + n,
                                            "aria-label": s + 1 + " of " + t,
                                            "aria-selected": null,
                                            tabindex: "-1",
                                        });
                            })
                            .eq(e.currentSlide)
                            .find("button")
                            .attr({ "aria-selected": "true", tabindex: "0" })
                            .end());
                for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
                    e.options.focusOnChange
                        ? e.$slides.eq(s).attr({ tabindex: "0" })
                        : e.$slides.eq(s).removeAttr("tabindex");
                e.activateADA();
            }),
            (e.prototype.initArrowEvents = function () {
                var i = this;
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide),
                    i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide),
                    !0 === i.options.accessibility &&
                        (i.$prevArrow.on("keydown.slick", i.keyHandler),
                        i.$nextArrow.on("keydown.slick", i.keyHandler)));
            }),
            (e.prototype.initDotEvents = function () {
                var e = this;
                !0 === e.options.dots &&
                    e.slideCount > e.options.slidesToShow &&
                    (i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                    !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)),
                    !0 === e.options.dots &&
                        !0 === e.options.pauseOnDotsHover &&
                        e.slideCount > e.options.slidesToShow &&
                        i("li", e.$dots)
                            .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                            .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
            }),
            (e.prototype.initSlideEvents = function () {
                var e = this;
                e.options.pauseOnHover &&
                    (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                    e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
            }),
            (e.prototype.initializeEvents = function () {
                var e = this;
                e.initArrowEvents(),
                    e.initDotEvents(),
                    e.initSlideEvents(),
                    e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                    e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                    e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("click.slick", e.clickHandler),
                    i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                    !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
                    i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
                    i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                    i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                    i(e.setPosition);
            }),
            (e.prototype.initUI = function () {
                var i = this;
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    (i.$prevArrow.show(), i.$nextArrow.show()),
                    !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
            }),
            (e.prototype.keyHandler = function (i) {
                var e = this;
                i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === i.keyCode && !0 === e.options.accessibility
                        ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } })
                        : 39 === i.keyCode &&
                          !0 === e.options.accessibility &&
                          e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
            }),
            (e.prototype.lazyLoad = function () {
                var e,
                    t,
                    o,
                    s = this;
                function n(e) {
                    i("img[data-lazy]", e).each(function () {
                        var e = i(this),
                            t = i(this).attr("data-lazy"),
                            o = i(this).attr("data-srcset"),
                            n = i(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                            r = document.createElement("img");
                        (r.onload = function () {
                            e.animate({ opacity: 0 }, 100, function () {
                                o && (e.attr("srcset", o), n && e.attr("sizes", n)),
                                    e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                        e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                    }),
                                    s.$slider.trigger("lazyLoaded", [s, e, t]);
                            });
                        }),
                            (r.onerror = function () {
                                e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                    s.$slider.trigger("lazyLoadError", [s, e, t]);
                            }),
                            (r.src = t);
                    });
                }
                if (
                    (!0 === s.options.centerMode
                        ? !0 === s.options.infinite
                            ? (o = (t = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2)
                            : ((t = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1))),
                              (o = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide))
                        : ((t = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide),
                          (o = Math.ceil(t + s.options.slidesToShow)),
                          !0 === s.options.fade && (t > 0 && t--, o <= s.slideCount && o++)),
                    (e = s.$slider.find(".slick-slide").slice(t, o)),
                    "anticipated" === s.options.lazyLoad)
                )
                    for (
                        var r = t - 1, l = o, d = s.$slider.find(".slick-slide"), a = 0;
                        a < s.options.slidesToScroll;
                        a++
                    )
                        r < 0 && (r = s.slideCount - 1), (e = (e = e.add(d.eq(r))).add(d.eq(l))), r--, l++;
                n(e),
                    s.slideCount <= s.options.slidesToShow
                        ? n(s.$slider.find(".slick-slide"))
                        : s.currentSlide >= s.slideCount - s.options.slidesToShow
                          ? n(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow))
                          : 0 === s.currentSlide &&
                            n(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow));
            }),
            (e.prototype.loadSlider = function () {
                var i = this;
                i.setPosition(),
                    i.$slideTrack.css({ opacity: 1 }),
                    i.$slider.removeClass("slick-loading"),
                    i.initUI(),
                    "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
            }),
            (e.prototype.next = e.prototype.slickNext =
                function () {
                    this.changeSlide({ data: { message: "next" } });
                }),
            (e.prototype.orientationChange = function () {
                this.checkResponsive(), this.setPosition();
            }),
            (e.prototype.pause = e.prototype.slickPause =
                function () {
                    this.autoPlayClear(), (this.paused = !0);
                }),
            (e.prototype.play = e.prototype.slickPlay =
                function () {
                    var i = this;
                    i.autoPlay(), (i.options.autoplay = !0), (i.paused = !1), (i.focussed = !1), (i.interrupted = !1);
                }),
            (e.prototype.postSlide = function (e) {
                var t = this;
                t.unslicked ||
                    (t.$slider.trigger("afterChange", [t, e]),
                    (t.animating = !1),
                    t.slideCount > t.options.slidesToShow && t.setPosition(),
                    (t.swipeLeft = null),
                    t.options.autoplay && t.autoPlay(),
                    !0 === t.options.accessibility &&
                        (t.initADA(),
                        t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
            }),
            (e.prototype.prev = e.prototype.slickPrev =
                function () {
                    this.changeSlide({ data: { message: "previous" } });
                }),
            (e.prototype.preventDefault = function (i) {
                i.preventDefault();
            }),
            (e.prototype.progressiveLazyLoad = function (e) {
                e = e || 1;
                var t,
                    o,
                    s,
                    n,
                    r,
                    l = this,
                    d = i("img[data-lazy]", l.$slider);
                d.length
                    ? ((t = d.first()),
                      (o = t.attr("data-lazy")),
                      (s = t.attr("data-srcset")),
                      (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
                      ((r = document.createElement("img")).onload = function () {
                          s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                              t
                                  .attr("src", o)
                                  .removeAttr("data-lazy data-srcset data-sizes")
                                  .removeClass("slick-loading"),
                              !0 === l.options.adaptiveHeight && l.setPosition(),
                              l.$slider.trigger("lazyLoaded", [l, t, o]),
                              l.progressiveLazyLoad();
                      }),
                      (r.onerror = function () {
                          e < 3
                              ? setTimeout(function () {
                                    l.progressiveLazyLoad(e + 1);
                                }, 500)
                              : (t
                                    .removeAttr("data-lazy")
                                    .removeClass("slick-loading")
                                    .addClass("slick-lazyload-error"),
                                l.$slider.trigger("lazyLoadError", [l, t, o]),
                                l.progressiveLazyLoad());
                      }),
                      (r.src = o))
                    : l.$slider.trigger("allImagesLoaded", [l]);
            }),
            (e.prototype.refresh = function (e) {
                var t,
                    o,
                    s = this;
                (o = s.slideCount - s.options.slidesToShow),
                    !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
                    s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                    (t = s.currentSlide),
                    s.destroy(!0),
                    i.extend(s, s.initials, { currentSlide: t }),
                    s.init(),
                    e || s.changeSlide({ data: { message: "index", index: t } }, !1);
            }),
            (e.prototype.registerBreakpoints = function () {
                var e,
                    t,
                    o,
                    s = this,
                    n = s.options.responsive || null;
                if ("array" === i.type(n) && n.length) {
                    for (e in ((s.respondTo = s.options.respondTo || "window"), n))
                        if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
                            for (t = n[e].breakpoint; o >= 0; )
                                s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
                        }
                    s.breakpoints.sort(function (i, e) {
                        return s.options.mobileFirst ? i - e : e - i;
                    });
                }
            }),
            (e.prototype.reinit = function () {
                var e = this;
                (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.currentSlide >= e.slideCount &&
                        0 !== e.currentSlide &&
                        (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                    e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                    e.registerBreakpoints(),
                    e.setProps(),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.updateArrows(),
                    e.initArrowEvents(),
                    e.buildDots(),
                    e.updateDots(),
                    e.initDotEvents(),
                    e.cleanUpSlideEvents(),
                    e.initSlideEvents(),
                    e.checkResponsive(!1, !0),
                    !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    e.setPosition(),
                    e.focusHandler(),
                    (e.paused = !e.options.autoplay),
                    e.autoPlay(),
                    e.$slider.trigger("reInit", [e]);
            }),
            (e.prototype.resize = function () {
                var e = this;
                i(window).width() !== e.windowWidth &&
                    (clearTimeout(e.windowDelay),
                    (e.windowDelay = window.setTimeout(function () {
                        (e.windowWidth = i(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                    }, 50)));
            }),
            (e.prototype.removeSlide = e.prototype.slickRemove =
                function (i, e, t) {
                    var o = this;
                    if (
                        ((i = "boolean" == typeof i ? (!0 === (e = i) ? 0 : o.slideCount - 1) : !0 === e ? --i : i),
                        o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
                    )
                        return !1;
                    o.unload(),
                        !0 === t
                            ? o.$slideTrack.children().remove()
                            : o.$slideTrack.children(this.options.slide).eq(i).remove(),
                        (o.$slides = o.$slideTrack.children(this.options.slide)),
                        o.$slideTrack.children(this.options.slide).detach(),
                        o.$slideTrack.append(o.$slides),
                        (o.$slidesCache = o.$slides),
                        o.reinit();
                }),
            (e.prototype.setCSS = function (i) {
                var e,
                    t,
                    o = this,
                    s = {};
                !0 === o.options.rtl && (i = -i),
                    (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                    (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                    (s[o.positionProp] = i),
                    !1 === o.transformsEnabled
                        ? o.$slideTrack.css(s)
                        : ((s = {}),
                          !1 === o.cssTransitions
                              ? ((s[o.animType] = "translate(" + e + ", " + t + ")"), o.$slideTrack.css(s))
                              : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"), o.$slideTrack.css(s)));
            }),
            (e.prototype.setDimensions = function () {
                var i = this;
                !1 === i.options.vertical
                    ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding })
                    : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
                      !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })),
                    (i.listWidth = i.$list.width()),
                    (i.listHeight = i.$list.height()),
                    !1 === i.options.vertical && !1 === i.options.variableWidth
                        ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
                          i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length)))
                        : !0 === i.options.variableWidth
                          ? i.$slideTrack.width(5e3 * i.slideCount)
                          : ((i.slideWidth = Math.ceil(i.listWidth)),
                            i.$slideTrack.height(
                                Math.ceil(
                                    i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length
                                )
                            ));
                var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
                !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
            }),
            (e.prototype.setFade = function () {
                var e,
                    t = this;
                t.$slides.each(function (o, s) {
                    (e = t.slideWidth * o * -1),
                        !0 === t.options.rtl
                            ? i(s).css({
                                  position: "relative",
                                  right: e,
                                  top: 0,
                                  zIndex: t.options.zIndex - 2,
                                  opacity: 0,
                              })
                            : i(s).css({
                                  position: "relative",
                                  left: e,
                                  top: 0,
                                  zIndex: t.options.zIndex - 2,
                                  opacity: 0,
                              });
                }),
                    t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 });
            }),
            (e.prototype.setHeight = function () {
                var i = this;
                if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                    var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                    i.$list.css("height", e);
                }
            }),
            (e.prototype.setOption = e.prototype.slickSetOption =
                function () {
                    var e,
                        t,
                        o,
                        s,
                        n,
                        r = this,
                        l = !1;
                    if (
                        ("object" === i.type(arguments[0])
                            ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
                            : "string" === i.type(arguments[0]) &&
                              ((o = arguments[0]),
                              (s = arguments[1]),
                              (l = arguments[2]),
                              "responsive" === arguments[0] && "array" === i.type(arguments[1])
                                  ? (n = "responsive")
                                  : void 0 !== arguments[1] && (n = "single")),
                        "single" === n)
                    )
                        r.options[o] = s;
                    else if ("multiple" === n)
                        i.each(o, function (i, e) {
                            r.options[i] = e;
                        });
                    else if ("responsive" === n)
                        for (t in s)
                            if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];
                            else {
                                for (e = r.options.responsive.length - 1; e >= 0; )
                                    r.options.responsive[e].breakpoint === s[t].breakpoint &&
                                        r.options.responsive.splice(e, 1),
                                        e--;
                                r.options.responsive.push(s[t]);
                            }
                    l && (r.unload(), r.reinit());
                }),
            (e.prototype.setPosition = function () {
                var i = this;
                i.setDimensions(),
                    i.setHeight(),
                    !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
                    i.$slider.trigger("setPosition", [i]);
            }),
            (e.prototype.setProps = function () {
                var i = this,
                    e = document.body.style;
                (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                    "top" === i.positionProp
                        ? i.$slider.addClass("slick-vertical")
                        : i.$slider.removeClass("slick-vertical"),
                    (void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition) ||
                        (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                    i.options.fade &&
                        ("number" == typeof i.options.zIndex
                            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
                            : (i.options.zIndex = i.defaults.zIndex)),
                    void 0 !== e.OTransform &&
                        ((i.animType = "OTransform"),
                        (i.transformType = "-o-transform"),
                        (i.transitionType = "OTransition"),
                        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                    void 0 !== e.MozTransform &&
                        ((i.animType = "MozTransform"),
                        (i.transformType = "-moz-transform"),
                        (i.transitionType = "MozTransition"),
                        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
                    void 0 !== e.webkitTransform &&
                        ((i.animType = "webkitTransform"),
                        (i.transformType = "-webkit-transform"),
                        (i.transitionType = "webkitTransition"),
                        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                    void 0 !== e.msTransform &&
                        ((i.animType = "msTransform"),
                        (i.transformType = "-ms-transform"),
                        (i.transitionType = "msTransition"),
                        void 0 === e.msTransform && (i.animType = !1)),
                    void 0 !== e.transform &&
                        !1 !== i.animType &&
                        ((i.animType = "transform"),
                        (i.transformType = "transform"),
                        (i.transitionType = "transition")),
                    (i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType);
            }),
            (e.prototype.setSlideClasses = function (i) {
                var e,
                    t,
                    o,
                    s,
                    n = this;
                if (
                    ((t = n.$slider
                        .find(".slick-slide")
                        .removeClass("slick-active slick-center slick-current")
                        .attr("aria-hidden", "true")),
                    n.$slides.eq(i).addClass("slick-current"),
                    !0 === n.options.centerMode)
                ) {
                    var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                    (e = Math.floor(n.options.slidesToShow / 2)),
                        !0 === n.options.infinite &&
                            (i >= e && i <= n.slideCount - 1 - e
                                ? n.$slides
                                      .slice(i - e + r, i + e + 1)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : ((o = n.options.slidesToShow + i),
                                  t
                                      .slice(o - e + 1 + r, o + e + 2)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            0 === i
                                ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center")
                                : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
                        n.$slides.eq(i).addClass("slick-center");
                } else
                    i >= 0 && i <= n.slideCount - n.options.slidesToShow
                        ? n.$slides
                              .slice(i, i + n.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : t.length <= n.options.slidesToShow
                          ? t.addClass("slick-active").attr("aria-hidden", "false")
                          : ((s = n.slideCount % n.options.slidesToShow),
                            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
                            n.options.slidesToShow == n.options.slidesToScroll &&
                            n.slideCount - i < n.options.slidesToShow
                                ? t
                                      .slice(o - (n.options.slidesToShow - s), o + s)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : t
                                      .slice(o, o + n.options.slidesToShow)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false"));
                ("ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad) || n.lazyLoad();
            }),
            (e.prototype.setupInfinite = function () {
                var e,
                    t,
                    o,
                    s = this;
                if (
                    (!0 === s.options.fade && (s.options.centerMode = !1),
                    !0 === s.options.infinite &&
                        !1 === s.options.fade &&
                        ((t = null), s.slideCount > s.options.slidesToShow))
                ) {
                    for (
                        o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow,
                            e = s.slideCount;
                        e > s.slideCount - o;
                        e -= 1
                    )
                        (t = e - 1),
                            i(s.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t - s.slideCount)
                                .prependTo(s.$slideTrack)
                                .addClass("slick-cloned");
                    for (e = 0; e < o + s.slideCount; e += 1)
                        (t = e),
                            i(s.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t + s.slideCount)
                                .appendTo(s.$slideTrack)
                                .addClass("slick-cloned");
                    s.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            i(this).attr("id", "");
                        });
                }
            }),
            (e.prototype.interrupt = function (i) {
                i || this.autoPlay(), (this.interrupted = i);
            }),
            (e.prototype.selectHandler = function (e) {
                var t = this,
                    o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
                    s = parseInt(o.attr("data-slick-index"));
                s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
            }),
            (e.prototype.slideHandler = function (i, e, t) {
                var o,
                    s,
                    n,
                    r,
                    l,
                    d,
                    a = this;
                if (
                    ((e = e || !1),
                    !(
                        (!0 === a.animating && !0 === a.options.waitForAnimate) ||
                        (!0 === a.options.fade && a.currentSlide === i)
                    ))
                )
                    if (
                        (!1 === e && a.asNavFor(i),
                        (o = i),
                        (l = a.getLeft(o)),
                        (r = a.getLeft(a.currentSlide)),
                        (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
                        !1 === a.options.infinite &&
                            !1 === a.options.centerMode &&
                            (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                    )
                        !1 === a.options.fade &&
                            ((o = a.currentSlide),
                            !0 !== t && a.slideCount > a.options.slidesToShow
                                ? a.animateSlide(r, function () {
                                      a.postSlide(o);
                                  })
                                : a.postSlide(o));
                    else if (
                        !1 === a.options.infinite &&
                        !0 === a.options.centerMode &&
                        (i < 0 || i > a.slideCount - a.options.slidesToScroll)
                    )
                        !1 === a.options.fade &&
                            ((o = a.currentSlide),
                            !0 !== t && a.slideCount > a.options.slidesToShow
                                ? a.animateSlide(r, function () {
                                      a.postSlide(o);
                                  })
                                : a.postSlide(o));
                    else {
                        if (
                            (a.options.autoplay && clearInterval(a.autoPlayTimer),
                            (s =
                                o < 0
                                    ? a.slideCount % a.options.slidesToScroll != 0
                                        ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                                        : a.slideCount + o
                                    : o >= a.slideCount
                                      ? a.slideCount % a.options.slidesToScroll != 0
                                          ? 0
                                          : o - a.slideCount
                                      : o),
                            (a.animating = !0),
                            a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                            (n = a.currentSlide),
                            (a.currentSlide = s),
                            a.setSlideClasses(a.currentSlide),
                            a.options.asNavFor &&
                                (d = (d = a.getNavTarget()).slick("getSlick")).slideCount <= d.options.slidesToShow &&
                                d.setSlideClasses(a.currentSlide),
                            a.updateDots(),
                            a.updateArrows(),
                            !0 === a.options.fade)
                        )
                            return (
                                !0 !== t
                                    ? (a.fadeSlideOut(n),
                                      a.fadeSlide(s, function () {
                                          a.postSlide(s);
                                      }))
                                    : a.postSlide(s),
                                void a.animateHeight()
                            );
                        !0 !== t && a.slideCount > a.options.slidesToShow
                            ? a.animateSlide(l, function () {
                                  a.postSlide(s);
                              })
                            : a.postSlide(s);
                    }
            }),
            (e.prototype.startLoad = function () {
                var i = this;
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    (i.$prevArrow.hide(), i.$nextArrow.hide()),
                    !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
                    i.$slider.addClass("slick-loading");
            }),
            (e.prototype.swipeDirection = function () {
                var i,
                    e,
                    t,
                    o,
                    s = this;
                return (
                    (i = s.touchObject.startX - s.touchObject.curX),
                    (e = s.touchObject.startY - s.touchObject.curY),
                    (t = Math.atan2(e, i)),
                    (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
                    o <= 45 && o >= 0
                        ? !1 === s.options.rtl
                            ? "left"
                            : "right"
                        : o <= 360 && o >= 315
                          ? !1 === s.options.rtl
                              ? "left"
                              : "right"
                          : o >= 135 && o <= 225
                            ? !1 === s.options.rtl
                                ? "right"
                                : "left"
                            : !0 === s.options.verticalSwiping
                              ? o >= 35 && o <= 135
                                  ? "down"
                                  : "up"
                              : "vertical"
                );
            }),
            (e.prototype.swipeEnd = function (i) {
                var e,
                    t,
                    o = this;
                if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1), !1;
                if (
                    ((o.interrupted = !1),
                    (o.shouldClick = !(o.touchObject.swipeLength > 10)),
                    void 0 === o.touchObject.curX)
                )
                    return !1;
                if (
                    (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]),
                    o.touchObject.swipeLength >= o.touchObject.minSwipe)
                ) {
                    switch ((t = o.swipeDirection())) {
                        case "left":
                        case "down":
                            (e = o.options.swipeToSlide
                                ? o.checkNavigable(o.currentSlide + o.getSlideCount())
                                : o.currentSlide + o.getSlideCount()),
                                (o.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (e = o.options.swipeToSlide
                                ? o.checkNavigable(o.currentSlide - o.getSlideCount())
                                : o.currentSlide - o.getSlideCount()),
                                (o.currentDirection = 1);
                    }
                    "vertical" != t && (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger("swipe", [o, t]));
                } else
                    o.touchObject.startX !== o.touchObject.curX &&
                        (o.slideHandler(o.currentSlide), (o.touchObject = {}));
            }),
            (e.prototype.swipeHandler = function (i) {
                var e = this;
                if (
                    !(
                        !1 === e.options.swipe ||
                        ("ontouchend" in document && !1 === e.options.swipe) ||
                        (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
                    )
                )
                    switch (
                        ((e.touchObject.fingerCount =
                            i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1),
                        (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
                        !0 === e.options.verticalSwiping &&
                            (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
                        i.data.action)
                    ) {
                        case "start":
                            e.swipeStart(i);
                            break;
                        case "move":
                            e.swipeMove(i);
                            break;
                        case "end":
                            e.swipeEnd(i);
                    }
            }),
            (e.prototype.swipeMove = function (i) {
                var e,
                    t,
                    o,
                    s,
                    n,
                    r,
                    l = this;
                return (
                    (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
                    !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
                        ((e = l.getLeft(l.currentSlide)),
                        (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
                        (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
                        (l.touchObject.swipeLength = Math.round(
                            Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
                        )),
                        (r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2)))),
                        !l.options.verticalSwiping && !l.swiping && r > 4
                            ? ((l.scrolling = !0), !1)
                            : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
                              (t = l.swipeDirection()),
                              void 0 !== i.originalEvent &&
                                  l.touchObject.swipeLength > 4 &&
                                  ((l.swiping = !0), i.preventDefault()),
                              (s =
                                  (!1 === l.options.rtl ? 1 : -1) *
                                  (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                              !0 === l.options.verticalSwiping &&
                                  (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                              (o = l.touchObject.swipeLength),
                              (l.touchObject.edgeHit = !1),
                              !1 === l.options.infinite &&
                                  ((0 === l.currentSlide && "right" === t) ||
                                      (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                                  ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                                  (l.touchObject.edgeHit = !0)),
                              !1 === l.options.vertical
                                  ? (l.swipeLeft = e + o * s)
                                  : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
                              !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
                              !0 !== l.options.fade &&
                                  !1 !== l.options.touchMove &&
                                  (!0 === l.animating ? ((l.swipeLeft = null), !1) : void l.setCSS(l.swipeLeft))))
                );
            }),
            (e.prototype.swipeStart = function (i) {
                var e,
                    t = this;
                if (((t.interrupted = !0), 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow))
                    return (t.touchObject = {}), !1;
                void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
                    (t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX),
                    (t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY),
                    (t.dragging = !0);
            }),
            (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
                function () {
                    var i = this;
                    null !== i.$slidesCache &&
                        (i.unload(),
                        i.$slideTrack.children(this.options.slide).detach(),
                        i.$slidesCache.appendTo(i.$slideTrack),
                        i.reinit());
                }),
            (e.prototype.unload = function () {
                var e = this;
                i(".slick-cloned", e.$slider).remove(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                    e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                    e.$slides
                        .removeClass("slick-slide slick-active slick-visible slick-current")
                        .attr("aria-hidden", "true")
                        .css("width", "");
            }),
            (e.prototype.unslick = function (i) {
                var e = this;
                e.$slider.trigger("unslick", [e, i]), e.destroy();
            }),
            (e.prototype.updateArrows = function () {
                var i = this;
                Math.floor(i.options.slidesToShow / 2),
                    !0 === i.options.arrows &&
                        i.slideCount > i.options.slidesToShow &&
                        !i.options.infinite &&
                        (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === i.currentSlide
                            ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                              i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode
                              ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                              : i.currentSlide >= i.slideCount - 1 &&
                                !0 === i.options.centerMode &&
                                (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (e.prototype.updateDots = function () {
                var i = this;
                null !== i.$dots &&
                    (i.$dots.find("li").removeClass("slick-active").end(),
                    i.$dots
                        .find("li")
                        .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                        .addClass("slick-active"));
            }),
            (e.prototype.visibility = function () {
                var i = this;
                i.options.autoplay && (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
            }),
            (i.fn.slick = function () {
                var i,
                    t,
                    o = this,
                    s = arguments[0],
                    n = Array.prototype.slice.call(arguments, 1),
                    r = o.length;
                for (i = 0; i < r; i++)
                    if (
                        ("object" == typeof s || void 0 === s
                            ? (o[i].slick = new e(o[i], s))
                            : (t = o[i].slick[s].apply(o[i].slick, n)),
                        void 0 !== t)
                    )
                        return t;
                return o;
            });
    }) /*!

/*!
 * jquery.ba-throttle-debounce.min.js
 *
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */,
    (function (e, t) {
        var n,
            i = e.jQuery || e.Cowboy || (e.Cowboy = {});
        (i.throttle = n =
            function (e, n, o, r) {
                function s() {
                    function i() {
                        (l = +new Date()), o.apply(u, d);
                    }
                    function s() {
                        a = t;
                    }
                    var u = this,
                        c = +new Date() - l,
                        d = arguments;
                    r && !a && i(),
                        a && clearTimeout(a),
                        r === t && c > e ? i() : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - c : e));
                }
                var a,
                    l = 0;
                return (
                    "boolean" != typeof n && ((r = o), (o = n), (n = t)),
                    i.guid && (s.guid = o.guid = o.guid || i.guid++),
                    s
                );
            }),
            (i.debounce = function (e, i, o) {
                return o === t ? n(e, i, !1) : n(e, o, i !== !1);
            });
    })(this) /*!

/*!
 * Copyright (C) Federico Zivolo 2019
 * Distributed under the MIT License (license terms are at http://opensource.org/licenses/MIT).
 */,
    (function (e, t) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = t())
            : "function" == typeof define && define.amd
              ? define(t)
              : (e.Popper = t());
    })(this, function () {
        "use strict";
        function e(e) {
            return e && "[object Function]" === {}.toString.call(e);
        }
        function t(e, t) {
            if (1 !== e.nodeType) return [];
            var o = e.ownerDocument.defaultView,
                n = o.getComputedStyle(e, null);
            return t ? n[t] : n;
        }
        function o(e) {
            return "HTML" === e.nodeName ? e : e.parentNode || e.host;
        }
        function n(e) {
            if (!e) return document.body;
            switch (e.nodeName) {
                case "HTML":
                case "BODY":
                    return e.ownerDocument.body;
                case "#document":
                    return e.body;
            }
            var i = t(e),
                r = i.overflow,
                p = i.overflowX,
                s = i.overflowY;
            return /(auto|scroll|overlay)/.test(r + s + p) ? e : n(o(e));
        }
        function r(e) {
            return 11 === e ? pe : 10 === e ? se : pe || se;
        }
        function p(e) {
            if (!e) return document.documentElement;
            for (var o = r(10) ? document.body : null, n = e.offsetParent || null; n === o && e.nextElementSibling; )
                n = (e = e.nextElementSibling).offsetParent;
            var i = n && n.nodeName;
            return i && "BODY" !== i && "HTML" !== i
                ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === t(n, "position")
                    ? p(n)
                    : n
                : e
                  ? e.ownerDocument.documentElement
                  : document.documentElement;
        }
        function s(e) {
            var t = e.nodeName;
            return "BODY" !== t && ("HTML" === t || p(e.firstElementChild) === e);
        }
        function d(e) {
            return null === e.parentNode ? e : d(e.parentNode);
        }
        function a(e, t) {
            if (!e || !e.nodeType || !t || !t.nodeType) return document.documentElement;
            var o = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
                n = o ? e : t,
                i = o ? t : e,
                r = document.createRange();
            r.setStart(n, 0), r.setEnd(i, 0);
            var l = r.commonAncestorContainer;
            if ((e !== l && t !== l) || n.contains(i)) return s(l) ? l : p(l);
            var f = d(e);
            return f.host ? a(f.host, t) : a(e, d(t).host);
        }
        function l(e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "top",
                o = "top" === t ? "scrollTop" : "scrollLeft",
                n = e.nodeName;
            if ("BODY" === n || "HTML" === n) {
                var i = e.ownerDocument.documentElement,
                    r = e.ownerDocument.scrollingElement || i;
                return r[o];
            }
            return e[o];
        }
        function f(e, t) {
            var o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
                n = l(t, "top"),
                i = l(t, "left"),
                r = o ? -1 : 1;
            return (e.top += n * r), (e.bottom += n * r), (e.left += i * r), (e.right += i * r), e;
        }
        function m(e, t) {
            var o = "x" === t ? "Left" : "Top",
                n = "Left" == o ? "Right" : "Bottom";
            return parseFloat(e["border" + o + "Width"], 10) + parseFloat(e["border" + n + "Width"], 10);
        }
        function h(e, t, o, n) {
            return ee(
                t["offset" + e],
                t["scroll" + e],
                o["client" + e],
                o["offset" + e],
                o["scroll" + e],
                r(10)
                    ? parseInt(o["offset" + e]) +
                          parseInt(n["margin" + ("Height" === e ? "Top" : "Left")]) +
                          parseInt(n["margin" + ("Height" === e ? "Bottom" : "Right")])
                    : 0
            );
        }
        function c(e) {
            var t = e.body,
                o = e.documentElement,
                n = r(10) && getComputedStyle(o);
            return { height: h("Height", t, o, n), width: h("Width", t, o, n) };
        }
        function g(e) {
            return fe({}, e, { right: e.left + e.width, bottom: e.top + e.height });
        }
        function u(e) {
            var o = {};
            try {
                if (r(10)) {
                    o = e.getBoundingClientRect();
                    var n = l(e, "top"),
                        i = l(e, "left");
                    (o.top += n), (o.left += i), (o.bottom += n), (o.right += i);
                } else o = e.getBoundingClientRect();
            } catch (t) {}
            var p = { left: o.left, top: o.top, width: o.right - o.left, height: o.bottom - o.top },
                s = "HTML" === e.nodeName ? c(e.ownerDocument) : {},
                d = s.width || e.clientWidth || p.right - p.left,
                a = s.height || e.clientHeight || p.bottom - p.top,
                f = e.offsetWidth - d,
                h = e.offsetHeight - a;
            if (f || h) {
                var u = t(e);
                (f -= m(u, "x")), (h -= m(u, "y")), (p.width -= f), (p.height -= h);
            }
            return g(p);
        }
        function b(e, o) {
            var i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
                p = r(10),
                s = "HTML" === o.nodeName,
                d = u(e),
                a = u(o),
                l = n(e),
                m = t(o),
                h = parseFloat(m.borderTopWidth, 10),
                c = parseFloat(m.borderLeftWidth, 10);
            i && s && ((a.top = ee(a.top, 0)), (a.left = ee(a.left, 0)));
            var b = g({ top: d.top - a.top - h, left: d.left - a.left - c, width: d.width, height: d.height });
            if (((b.marginTop = 0), (b.marginLeft = 0), !p && s)) {
                var w = parseFloat(m.marginTop, 10),
                    y = parseFloat(m.marginLeft, 10);
                (b.top -= h - w),
                    (b.bottom -= h - w),
                    (b.left -= c - y),
                    (b.right -= c - y),
                    (b.marginTop = w),
                    (b.marginLeft = y);
            }
            return (p && !i ? o.contains(l) : o === l && "BODY" !== l.nodeName) && (b = f(b, o)), b;
        }
        function w(e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
                o = e.ownerDocument.documentElement,
                n = b(e, o),
                i = ee(o.clientWidth, window.innerWidth || 0),
                r = ee(o.clientHeight, window.innerHeight || 0),
                p = t ? 0 : l(o),
                s = t ? 0 : l(o, "left"),
                d = { top: p - n.top + n.marginTop, left: s - n.left + n.marginLeft, width: i, height: r };
            return g(d);
        }
        function y(e) {
            var n = e.nodeName;
            if ("BODY" === n || "HTML" === n) return !1;
            if ("fixed" === t(e, "position")) return !0;
            var i = o(e);
            return !!i && y(i);
        }
        function E(e) {
            if (!e || !e.parentElement || r()) return document.documentElement;
            for (var o = e.parentElement; o && "none" === t(o, "transform"); ) o = o.parentElement;
            return o || document.documentElement;
        }
        function v(e, t, i, r) {
            var p = 4 < arguments.length && void 0 !== arguments[4] && arguments[4],
                s = { top: 0, left: 0 },
                d = p ? E(e) : a(e, t);
            if ("viewport" === r) s = w(d, p);
            else {
                var l;
                "scrollParent" === r
                    ? ((l = n(o(t))), "BODY" === l.nodeName && (l = e.ownerDocument.documentElement))
                    : "window" === r
                      ? (l = e.ownerDocument.documentElement)
                      : (l = r);
                var f = b(l, d, p);
                if ("HTML" === l.nodeName && !y(d)) {
                    var m = c(e.ownerDocument),
                        h = m.height,
                        g = m.width;
                    (s.top += f.top - f.marginTop),
                        (s.bottom = h + f.top),
                        (s.left += f.left - f.marginLeft),
                        (s.right = g + f.left);
                } else s = f;
            }
            i = i || 0;
            var u = "number" == typeof i;
            return (
                (s.left += u ? i : i.left || 0),
                (s.top += u ? i : i.top || 0),
                (s.right -= u ? i : i.right || 0),
                (s.bottom -= u ? i : i.bottom || 0),
                s
            );
        }
        function x(e) {
            var t = e.width,
                o = e.height;
            return t * o;
        }
        function O(e, t, o, n, i) {
            var r = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
            if (-1 === e.indexOf("auto")) return e;
            var p = v(o, n, r, i),
                s = {
                    top: { width: p.width, height: t.top - p.top },
                    right: { width: p.right - t.right, height: p.height },
                    bottom: { width: p.width, height: p.bottom - t.bottom },
                    left: { width: t.left - p.left, height: p.height },
                },
                d = Object.keys(s)
                    .map(function (e) {
                        return fe({ key: e }, s[e], { area: x(s[e]) });
                    })
                    .sort(function (e, t) {
                        return t.area - e.area;
                    }),
                a = d.filter(function (e) {
                    var t = e.width,
                        n = e.height;
                    return t >= o.clientWidth && n >= o.clientHeight;
                }),
                l = 0 < a.length ? a[0].key : d[0].key,
                f = e.split("-")[1];
            return l + (f ? "-" + f : "");
        }
        function L(e, t, o) {
            var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null,
                i = n ? E(t) : a(t, o);
            return b(o, i, n);
        }
        function S(e) {
            var t = e.ownerDocument.defaultView,
                o = t.getComputedStyle(e),
                n = parseFloat(o.marginTop || 0) + parseFloat(o.marginBottom || 0),
                i = parseFloat(o.marginLeft || 0) + parseFloat(o.marginRight || 0),
                r = { width: e.offsetWidth + i, height: e.offsetHeight + n };
            return r;
        }
        function T(e) {
            var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
            return e.replace(/left|right|bottom|top/g, function (e) {
                return t[e];
            });
        }
        function D(e, t, o) {
            o = o.split("-")[0];
            var n = S(e),
                i = { width: n.width, height: n.height },
                r = -1 !== ["right", "left"].indexOf(o),
                p = r ? "top" : "left",
                s = r ? "left" : "top",
                d = r ? "height" : "width",
                a = r ? "width" : "height";
            return (i[p] = t[p] + t[d] / 2 - n[d] / 2), (i[s] = o === s ? t[s] - n[a] : t[T(s)]), i;
        }
        function C(e, t) {
            return Array.prototype.find ? e.find(t) : e.filter(t)[0];
        }
        function N(e, t, o) {
            if (Array.prototype.findIndex)
                return e.findIndex(function (e) {
                    return e[t] === o;
                });
            var n = C(e, function (e) {
                return e[t] === o;
            });
            return e.indexOf(n);
        }
        function P(t, o, n) {
            var i = void 0 === n ? t : t.slice(0, N(t, "name", n));
            return (
                i.forEach(function (t) {
                    t["function"] && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                    var n = t["function"] || t.fn;
                    t.enabled &&
                        e(n) &&
                        ((o.offsets.popper = g(o.offsets.popper)),
                        (o.offsets.reference = g(o.offsets.reference)),
                        (o = n(o, t)));
                }),
                o
            );
        }
        function k() {
            if (!this.state.isDestroyed) {
                var e = { instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {} };
                (e.offsets.reference = L(this.state, this.popper, this.reference, this.options.positionFixed)),
                    (e.placement = O(
                        this.options.placement,
                        e.offsets.reference,
                        this.popper,
                        this.reference,
                        this.options.modifiers.flip.boundariesElement,
                        this.options.modifiers.flip.padding
                    )),
                    (e.originalPlacement = e.placement),
                    (e.positionFixed = this.options.positionFixed),
                    (e.offsets.popper = D(this.popper, e.offsets.reference, e.placement)),
                    (e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute"),
                    (e = P(this.modifiers, e)),
                    this.state.isCreated
                        ? this.options.onUpdate(e)
                        : ((this.state.isCreated = !0), this.options.onCreate(e));
            }
        }
        function W(e, t) {
            return e.some(function (e) {
                var o = e.name,
                    n = e.enabled;
                return n && o === t;
            });
        }
        function H(e) {
            for (
                var t = [!1, "ms", "Webkit", "Moz", "O"], o = e.charAt(0).toUpperCase() + e.slice(1), n = 0;
                n < t.length;
                n++
            ) {
                var i = t[n],
                    r = i ? "" + i + o : e;
                if ("undefined" != typeof document.body.style[r]) return r;
            }
            return null;
        }
        function B() {
            return (
                (this.state.isDestroyed = !0),
                W(this.modifiers, "applyStyle") &&
                    (this.popper.removeAttribute("x-placement"),
                    (this.popper.style.position = ""),
                    (this.popper.style.top = ""),
                    (this.popper.style.left = ""),
                    (this.popper.style.right = ""),
                    (this.popper.style.bottom = ""),
                    (this.popper.style.willChange = ""),
                    (this.popper.style[H("transform")] = "")),
                this.disableEventListeners(),
                this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
                this
            );
        }
        function A(e) {
            var t = e.ownerDocument;
            return t ? t.defaultView : window;
        }
        function M(e, t, o, i) {
            var r = "BODY" === e.nodeName,
                p = r ? e.ownerDocument.defaultView : e;
            p.addEventListener(t, o, { passive: !0 }), r || M(n(p.parentNode), t, o, i), i.push(p);
        }
        function F(e, t, o, i) {
            (o.updateBound = i), A(e).addEventListener("resize", o.updateBound, { passive: !0 });
            var r = n(e);
            return M(r, "scroll", o.updateBound, o.scrollParents), (o.scrollElement = r), (o.eventsEnabled = !0), o;
        }
        function I() {
            this.state.eventsEnabled || (this.state = F(this.reference, this.options, this.state, this.scheduleUpdate));
        }
        function R(e, t) {
            return (
                A(e).removeEventListener("resize", t.updateBound),
                t.scrollParents.forEach(function (e) {
                    e.removeEventListener("scroll", t.updateBound);
                }),
                (t.updateBound = null),
                (t.scrollParents = []),
                (t.scrollElement = null),
                (t.eventsEnabled = !1),
                t
            );
        }
        function U() {
            this.state.eventsEnabled &&
                (cancelAnimationFrame(this.scheduleUpdate), (this.state = R(this.reference, this.state)));
        }
        function Y(e) {
            return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
        }
        function j(e, t) {
            Object.keys(t).forEach(function (o) {
                var n = "";
                -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(o) && Y(t[o]) && (n = "px"),
                    (e.style[o] = t[o] + n);
            });
        }
        function V(e, t) {
            Object.keys(t).forEach(function (o) {
                var n = t[o];
                !1 === n ? e.removeAttribute(o) : e.setAttribute(o, t[o]);
            });
        }
        function q(e, t) {
            var o = e.offsets,
                n = o.popper,
                i = o.reference,
                r = $,
                p = function (e) {
                    return e;
                },
                s = r(i.width),
                d = r(n.width),
                a = -1 !== ["left", "right"].indexOf(e.placement),
                l = -1 !== e.placement.indexOf("-"),
                f = t ? (a || l || s % 2 == d % 2 ? r : Z) : p,
                m = t ? r : p;
            return {
                left: f(1 == s % 2 && 1 == d % 2 && !l && t ? n.left - 1 : n.left),
                top: m(n.top),
                bottom: m(n.bottom),
                right: f(n.right),
            };
        }
        function K(e, t, o) {
            var n = C(e, function (e) {
                    var o = e.name;
                    return o === t;
                }),
                i =
                    !!n &&
                    e.some(function (e) {
                        return e.name === o && e.enabled && e.order < n.order;
                    });
            if (!i) {
                var r = "`" + t + "`";
                console.warn(
                    "`" +
                        o +
                        "`" +
                        " modifier is required by " +
                        r +
                        " modifier in order to work, be sure to include it before " +
                        r +
                        "!"
                );
            }
            return i;
        }
        function z(e) {
            return "end" === e ? "start" : "start" === e ? "end" : e;
        }
        function G(e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
                o = ce.indexOf(e),
                n = ce.slice(o + 1).concat(ce.slice(0, o));
            return t ? n.reverse() : n;
        }
        function _(e, t, o, n) {
            var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                r = +i[1],
                p = i[2];
            if (!r) return e;
            if (0 === p.indexOf("%")) {
                var s;
                switch (p) {
                    case "%p":
                        s = o;
                        break;
                    case "%":
                    case "%r":
                    default:
                        s = n;
                }
                var d = g(s);
                return (d[t] / 100) * r;
            }
            if ("vh" === p || "vw" === p) {
                var a;
                return (
                    (a =
                        "vh" === p
                            ? ee(document.documentElement.clientHeight, window.innerHeight || 0)
                            : ee(document.documentElement.clientWidth, window.innerWidth || 0)),
                    (a / 100) * r
                );
            }
            return r;
        }
        function X(e, t, o, n) {
            var i = [0, 0],
                r = -1 !== ["right", "left"].indexOf(n),
                p = e.split(/(\+|\-)/).map(function (e) {
                    return e.trim();
                }),
                s = p.indexOf(
                    C(p, function (e) {
                        return -1 !== e.search(/,|\s/);
                    })
                );
            p[s] &&
                -1 === p[s].indexOf(",") &&
                console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
            var d = /\s*,\s*|\s+/,
                a =
                    -1 === s
                        ? [p]
                        : [p.slice(0, s).concat([p[s].split(d)[0]]), [p[s].split(d)[1]].concat(p.slice(s + 1))];
            return (
                (a = a.map(function (e, n) {
                    var i = (1 === n ? !r : r) ? "height" : "width",
                        p = !1;
                    return e
                        .reduce(function (e, t) {
                            return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t)
                                ? ((e[e.length - 1] = t), (p = !0), e)
                                : p
                                  ? ((e[e.length - 1] += t), (p = !1), e)
                                  : e.concat(t);
                        }, [])
                        .map(function (e) {
                            return _(e, i, t, o);
                        });
                })),
                a.forEach(function (e, t) {
                    e.forEach(function (o, n) {
                        Y(o) && (i[t] += o * ("-" === e[n - 1] ? -1 : 1));
                    });
                }),
                i
            );
        }
        function J(e, t) {
            var o,
                n = t.offset,
                i = e.placement,
                r = e.offsets,
                p = r.popper,
                s = r.reference,
                d = i.split("-")[0];
            return (
                (o = Y(+n) ? [+n, 0] : X(n, p, s, d)),
                "left" === d
                    ? ((p.top += o[0]), (p.left -= o[1]))
                    : "right" === d
                      ? ((p.top += o[0]), (p.left += o[1]))
                      : "top" === d
                        ? ((p.left += o[0]), (p.top -= o[1]))
                        : "bottom" === d && ((p.left += o[0]), (p.top += o[1])),
                (e.popper = p),
                e
            );
        }
        for (
            var Q = Math.min,
                Z = Math.floor,
                $ = Math.round,
                ee = Math.max,
                te = "undefined" != typeof window && "undefined" != typeof document,
                oe = ["Edge", "Trident", "Firefox"],
                ne = 0,
                ie = 0;
            ie < oe.length;
            ie += 1
        )
            if (te && 0 <= navigator.userAgent.indexOf(oe[ie])) {
                ne = 1;
                break;
            }
        var i = te && window.Promise,
            re = i
                ? function (e) {
                      var t = !1;
                      return function () {
                          t ||
                              ((t = !0),
                              window.Promise.resolve().then(function () {
                                  (t = !1), e();
                              }));
                      };
                  }
                : function (e) {
                      var t = !1;
                      return function () {
                          t ||
                              ((t = !0),
                              setTimeout(function () {
                                  (t = !1), e();
                              }, ne));
                      };
                  },
            pe = te && !!(window.MSInputMethodContext && document.documentMode),
            se = te && /MSIE 10/.test(navigator.userAgent),
            de = function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            },
            ae = (function () {
                function e(e, t) {
                    for (var o, n = 0; n < t.length; n++)
                        (o = t[n]),
                            (o.enumerable = o.enumerable || !1),
                            (o.configurable = !0),
                            "value" in o && (o.writable = !0),
                            Object.defineProperty(e, o.key, o);
                }
                return function (t, o, n) {
                    return o && e(t.prototype, o), n && e(t, n), t;
                };
            })(),
            le = function (e, t, o) {
                return (
                    t in e
                        ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 })
                        : (e[t] = o),
                    e
                );
            },
            fe =
                Object.assign ||
                function (e) {
                    for (var t, o = 1; o < arguments.length; o++)
                        for (var n in ((t = arguments[o]), t))
                            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    return e;
                },
            me = te && /Firefox/i.test(navigator.userAgent),
            he = [
                "auto-start",
                "auto",
                "auto-end",
                "top-start",
                "top",
                "top-end",
                "right-start",
                "right",
                "right-end",
                "bottom-end",
                "bottom",
                "bottom-start",
                "left-end",
                "left",
                "left-start",
            ],
            ce = he.slice(3),
            ge = { FLIP: "flip", CLOCKWISE: "clockwise", COUNTERCLOCKWISE: "counterclockwise" },
            ue = (function () {
                function t(o, n) {
                    var i = this,
                        r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
                    de(this, t),
                        (this.scheduleUpdate = function () {
                            return requestAnimationFrame(i.update);
                        }),
                        (this.update = re(this.update.bind(this))),
                        (this.options = fe({}, t.Defaults, r)),
                        (this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }),
                        (this.reference = o && o.jquery ? o[0] : o),
                        (this.popper = n && n.jquery ? n[0] : n),
                        (this.options.modifiers = {}),
                        Object.keys(fe({}, t.Defaults.modifiers, r.modifiers)).forEach(function (e) {
                            i.options.modifiers[e] = fe(
                                {},
                                t.Defaults.modifiers[e] || {},
                                r.modifiers ? r.modifiers[e] : {}
                            );
                        }),
                        (this.modifiers = Object.keys(this.options.modifiers)
                            .map(function (e) {
                                return fe({ name: e }, i.options.modifiers[e]);
                            })
                            .sort(function (e, t) {
                                return e.order - t.order;
                            })),
                        this.modifiers.forEach(function (t) {
                            t.enabled && e(t.onLoad) && t.onLoad(i.reference, i.popper, i.options, t, i.state);
                        }),
                        this.update();
                    var p = this.options.eventsEnabled;
                    p && this.enableEventListeners(), (this.state.eventsEnabled = p);
                }
                return (
                    ae(t, [
                        {
                            key: "update",
                            value: function () {
                                return k.call(this);
                            },
                        },
                        {
                            key: "destroy",
                            value: function () {
                                return B.call(this);
                            },
                        },
                        {
                            key: "enableEventListeners",
                            value: function () {
                                return I.call(this);
                            },
                        },
                        {
                            key: "disableEventListeners",
                            value: function () {
                                return U.call(this);
                            },
                        },
                    ]),
                    t
                );
            })();
        return (
            (ue.Utils = ("undefined" == typeof window ? global : window).PopperUtils),
            (ue.placements = he),
            (ue.Defaults = {
                placement: "bottom",
                positionFixed: !1,
                eventsEnabled: !0,
                removeOnDestroy: !1,
                onCreate: function () {},
                onUpdate: function () {},
                modifiers: {
                    shift: {
                        order: 100,
                        enabled: !0,
                        fn: function (e) {
                            var t = e.placement,
                                o = t.split("-")[0],
                                n = t.split("-")[1];
                            if (n) {
                                var i = e.offsets,
                                    r = i.reference,
                                    p = i.popper,
                                    s = -1 !== ["bottom", "top"].indexOf(o),
                                    d = s ? "left" : "top",
                                    a = s ? "width" : "height",
                                    l = { start: le({}, d, r[d]), end: le({}, d, r[d] + r[a] - p[a]) };
                                e.offsets.popper = fe({}, p, l[n]);
                            }
                            return e;
                        },
                    },
                    offset: { order: 200, enabled: !0, fn: J, offset: 0 },
                    preventOverflow: {
                        order: 300,
                        enabled: !0,
                        fn: function (e, t) {
                            var o = t.boundariesElement || p(e.instance.popper);
                            e.instance.reference === o && (o = p(o));
                            var n = H("transform"),
                                i = e.instance.popper.style,
                                r = i.top,
                                s = i.left,
                                d = i[n];
                            (i.top = ""), (i.left = ""), (i[n] = "");
                            var a = v(e.instance.popper, e.instance.reference, t.padding, o, e.positionFixed);
                            (i.top = r), (i.left = s), (i[n] = d), (t.boundaries = a);
                            var l = t.priority,
                                f = e.offsets.popper,
                                m = {
                                    primary: function (e) {
                                        var o = f[e];
                                        return (
                                            f[e] < a[e] && !t.escapeWithReference && (o = ee(f[e], a[e])), le({}, e, o)
                                        );
                                    },
                                    secondary: function (e) {
                                        var o = "right" === e ? "left" : "top",
                                            n = f[o];
                                        return (
                                            f[e] > a[e] &&
                                                !t.escapeWithReference &&
                                                (n = Q(f[o], a[e] - ("right" === e ? f.width : f.height))),
                                            le({}, o, n)
                                        );
                                    },
                                };
                            return (
                                l.forEach(function (e) {
                                    var t = -1 === ["left", "top"].indexOf(e) ? "secondary" : "primary";
                                    f = fe({}, f, m[t](e));
                                }),
                                (e.offsets.popper = f),
                                e
                            );
                        },
                        priority: ["left", "right", "top", "bottom"],
                        padding: 5,
                        boundariesElement: "scrollParent",
                    },
                    keepTogether: {
                        order: 400,
                        enabled: !0,
                        fn: function (e) {
                            var t = e.offsets,
                                o = t.popper,
                                n = t.reference,
                                i = e.placement.split("-")[0],
                                r = Z,
                                p = -1 !== ["top", "bottom"].indexOf(i),
                                s = p ? "right" : "bottom",
                                d = p ? "left" : "top",
                                a = p ? "width" : "height";
                            return (
                                o[s] < r(n[d]) && (e.offsets.popper[d] = r(n[d]) - o[a]),
                                o[d] > r(n[s]) && (e.offsets.popper[d] = r(n[s])),
                                e
                            );
                        },
                    },
                    arrow: {
                        order: 500,
                        enabled: !0,
                        fn: function (e, o) {
                            var n;
                            if (!K(e.instance.modifiers, "arrow", "keepTogether")) return e;
                            var i = o.element;
                            if ("string" == typeof i) {
                                if (((i = e.instance.popper.querySelector(i)), !i)) return e;
                            } else if (!e.instance.popper.contains(i))
                                return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                            var r = e.placement.split("-")[0],
                                p = e.offsets,
                                s = p.popper,
                                d = p.reference,
                                a = -1 !== ["left", "right"].indexOf(r),
                                l = a ? "height" : "width",
                                f = a ? "Top" : "Left",
                                m = f.toLowerCase(),
                                h = a ? "left" : "top",
                                c = a ? "bottom" : "right",
                                u = S(i)[l];
                            d[c] - u < s[m] && (e.offsets.popper[m] -= s[m] - (d[c] - u)),
                                d[m] + u > s[c] && (e.offsets.popper[m] += d[m] + u - s[c]),
                                (e.offsets.popper = g(e.offsets.popper));
                            var b = d[m] + d[l] / 2 - u / 2,
                                w = t(e.instance.popper),
                                y = parseFloat(w["margin" + f], 10),
                                E = parseFloat(w["border" + f + "Width"], 10),
                                v = b - e.offsets.popper[m] - y - E;
                            return (
                                (v = ee(Q(s[l] - u, v), 0)),
                                (e.arrowElement = i),
                                (e.offsets.arrow = ((n = {}), le(n, m, $(v)), le(n, h, ""), n)),
                                e
                            );
                        },
                        element: "[x-arrow]",
                    },
                    flip: {
                        order: 600,
                        enabled: !0,
                        fn: function (e, t) {
                            if (W(e.instance.modifiers, "inner")) return e;
                            if (e.flipped && e.placement === e.originalPlacement) return e;
                            var o = v(
                                    e.instance.popper,
                                    e.instance.reference,
                                    t.padding,
                                    t.boundariesElement,
                                    e.positionFixed
                                ),
                                n = e.placement.split("-")[0],
                                i = T(n),
                                r = e.placement.split("-")[1] || "",
                                p = [];
                            switch (t.behavior) {
                                case ge.FLIP:
                                    p = [n, i];
                                    break;
                                case ge.CLOCKWISE:
                                    p = G(n);
                                    break;
                                case ge.COUNTERCLOCKWISE:
                                    p = G(n, !0);
                                    break;
                                default:
                                    p = t.behavior;
                            }
                            return (
                                p.forEach(function (s, d) {
                                    if (n !== s || p.length === d + 1) return e;
                                    (n = e.placement.split("-")[0]), (i = T(n));
                                    var a = e.offsets.popper,
                                        l = e.offsets.reference,
                                        f = Z,
                                        m =
                                            ("left" === n && f(a.right) > f(l.left)) ||
                                            ("right" === n && f(a.left) < f(l.right)) ||
                                            ("top" === n && f(a.bottom) > f(l.top)) ||
                                            ("bottom" === n && f(a.top) < f(l.bottom)),
                                        h = f(a.left) < f(o.left),
                                        c = f(a.right) > f(o.right),
                                        g = f(a.top) < f(o.top),
                                        u = f(a.bottom) > f(o.bottom),
                                        b =
                                            ("left" === n && h) ||
                                            ("right" === n && c) ||
                                            ("top" === n && g) ||
                                            ("bottom" === n && u),
                                        w = -1 !== ["top", "bottom"].indexOf(n),
                                        y =
                                            !!t.flipVariations &&
                                            ((w && "start" === r && h) ||
                                                (w && "end" === r && c) ||
                                                (!w && "start" === r && g) ||
                                                (!w && "end" === r && u));
                                    (m || b || y) &&
                                        ((e.flipped = !0),
                                        (m || b) && (n = p[d + 1]),
                                        y && (r = z(r)),
                                        (e.placement = n + (r ? "-" + r : "")),
                                        (e.offsets.popper = fe(
                                            {},
                                            e.offsets.popper,
                                            D(e.instance.popper, e.offsets.reference, e.placement)
                                        )),
                                        (e = P(e.instance.modifiers, e, "flip")));
                                }),
                                e
                            );
                        },
                        behavior: "flip",
                        padding: 5,
                        boundariesElement: "viewport",
                    },
                    inner: {
                        order: 700,
                        enabled: !1,
                        fn: function (e) {
                            var t = e.placement,
                                o = t.split("-")[0],
                                n = e.offsets,
                                i = n.popper,
                                r = n.reference,
                                p = -1 !== ["left", "right"].indexOf(o),
                                s = -1 === ["top", "left"].indexOf(o);
                            return (
                                (i[p ? "left" : "top"] = r[o] - (s ? i[p ? "width" : "height"] : 0)),
                                (e.placement = T(t)),
                                (e.offsets.popper = g(i)),
                                e
                            );
                        },
                    },
                    hide: {
                        order: 800,
                        enabled: !0,
                        fn: function (e) {
                            if (!K(e.instance.modifiers, "hide", "preventOverflow")) return e;
                            var t = e.offsets.reference,
                                o = C(e.instance.modifiers, function (e) {
                                    return "preventOverflow" === e.name;
                                }).boundaries;
                            if (t.bottom < o.top || t.left > o.right || t.top > o.bottom || t.right < o.left) {
                                if (!0 === e.hide) return e;
                                (e.hide = !0), (e.attributes["x-out-of-boundaries"] = "");
                            } else {
                                if (!1 === e.hide) return e;
                                (e.hide = !1), (e.attributes["x-out-of-boundaries"] = !1);
                            }
                            return e;
                        },
                    },
                    computeStyle: {
                        order: 850,
                        enabled: !0,
                        fn: function (e, t) {
                            var o = t.x,
                                n = t.y,
                                i = e.offsets.popper,
                                r = C(e.instance.modifiers, function (e) {
                                    return "applyStyle" === e.name;
                                }).gpuAcceleration;
                            void 0 !== r &&
                                console.warn(
                                    "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
                                );
                            var s,
                                d,
                                a = void 0 === r ? t.gpuAcceleration : r,
                                l = p(e.instance.popper),
                                f = u(l),
                                m = { position: i.position },
                                h = q(e, 2 > window.devicePixelRatio || !me),
                                c = "bottom" === o ? "top" : "bottom",
                                g = "right" === n ? "left" : "right",
                                b = H("transform");
                            if (
                                ((d =
                                    "bottom" == c
                                        ? "HTML" === l.nodeName
                                            ? -l.clientHeight + h.bottom
                                            : -f.height + h.bottom
                                        : h.top),
                                (s =
                                    "right" == g
                                        ? "HTML" === l.nodeName
                                            ? -l.clientWidth + h.right
                                            : -f.width + h.right
                                        : h.left),
                                a && b)
                            )
                                (m[b] = "translate3d(" + s + "px, " + d + "px, 0)"),
                                    (m[c] = 0),
                                    (m[g] = 0),
                                    (m.willChange = "transform");
                            else {
                                var w = "bottom" == c ? -1 : 1,
                                    y = "right" == g ? -1 : 1;
                                (m[c] = d * w), (m[g] = s * y), (m.willChange = c + ", " + g);
                            }
                            var E = { "x-placement": e.placement };
                            return (
                                (e.attributes = fe({}, E, e.attributes)),
                                (e.styles = fe({}, m, e.styles)),
                                (e.arrowStyles = fe({}, e.offsets.arrow, e.arrowStyles)),
                                e
                            );
                        },
                        gpuAcceleration: !0,
                        x: "bottom",
                        y: "right",
                    },
                    applyStyle: {
                        order: 900,
                        enabled: !0,
                        fn: function (e) {
                            return (
                                j(e.instance.popper, e.styles),
                                V(e.instance.popper, e.attributes),
                                e.arrowElement && Object.keys(e.arrowStyles).length && j(e.arrowElement, e.arrowStyles),
                                e
                            );
                        },
                        onLoad: function (e, t, o, n, i) {
                            var r = L(i, t, e, o.positionFixed),
                                p = O(
                                    o.placement,
                                    r,
                                    t,
                                    e,
                                    o.modifiers.flip.boundariesElement,
                                    o.modifiers.flip.padding
                                );
                            return (
                                t.setAttribute("x-placement", p),
                                j(t, { position: o.positionFixed ? "fixed" : "absolute" }),
                                o
                            );
                        },
                        gpuAcceleration: void 0,
                    },
                },
            }),
            ue
        );
    }) /*!

/*!
 * fancyBox v3.5.7
 *
 * http://fancyapps.com/fancybox/
 * Copyright 2019 fancyApps
 */,
    !(function (t, e, n, o) {
        "use strict";
        function i(t, e) {
            var o,
                i,
                a,
                s = [],
                r = 0;
            (t && t.isDefaultPrevented()) ||
                (t.preventDefault(),
                (e = e || {}),
                t && t.data && (e = h(t.data.options, e)),
                (o = e.$target || n(t.currentTarget).trigger("blur")),
                ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
                    (e.selector
                        ? (s = n(e.selector))
                        : ((i = o.attr("data-fancybox") || ""),
                          i
                              ? ((s = t.data ? t.data.items : []),
                                (s = s.length
                                    ? s.filter('[data-fancybox="' + i + '"]')
                                    : n('[data-fancybox="' + i + '"]')))
                              : (s = [o])),
                    (r = n(s).index(o)),
                    r < 0 && (r = 0),
                    (a = n.fancybox.open(s, e, r)),
                    (a.$trigger = o)));
        }
        if (((t.console = t.console || { info: function (t) {} }), n)) {
            if (n.fn.fancybox) return void console.info("fancyBox already initialized");
            var a = {
                    closeExisting: !1,
                    loop: !1,
                    gutter: 50,
                    keyboard: !0,
                    preventCaptionOverlap: !0,
                    arrows: !0,
                    infobar: !0,
                    smallBtn: "auto",
                    toolbar: "auto",
                    buttons: ["zoom", "slideShow", "thumbs", "close"],
                    idleTime: 3,
                    protect: !1,
                    modal: !1,
                    image: { preload: !1 },
                    ajax: { settings: { data: { fancybox: !0 } } },
                    iframe: {
                        tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                        preload: !0,
                        css: {},
                        attr: { scrolling: "auto" },
                    },
                    video: {
                        tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                        format: "",
                        autoStart: !0,
                    },
                    defaultType: "image",
                    animationEffect: "zoom",
                    animationDuration: 366,
                    zoomOpacity: "auto",
                    transitionEffect: "fade",
                    transitionDuration: 366,
                    slideClass: "",
                    baseClass: "",
                    baseTpl:
                        '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
                    spinnerTpl: '<div class="fancybox-loading"></div>',
                    errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
                    btnTpl: {
                        download:
                            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                        zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                        arrowLeft:
                            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                        arrowRight:
                            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                        smallBtn:
                            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
                    },
                    parentEl: "body",
                    hideScrollbar: !0,
                    autoFocus: !0,
                    backFocus: !0,
                    trapFocus: !0,
                    fullScreen: { autoStart: !1 },
                    touch: { vertical: !0, momentum: !0 },
                    hash: null,
                    media: {},
                    slideShow: { autoStart: !1, speed: 3e3 },
                    thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                    wheel: "auto",
                    onInit: n.noop,
                    beforeLoad: n.noop,
                    afterLoad: n.noop,
                    beforeShow: n.noop,
                    afterShow: n.noop,
                    beforeClose: n.noop,
                    afterClose: n.noop,
                    onActivate: n.noop,
                    onDeactivate: n.noop,
                    clickContent: function (t, e) {
                        return "image" === t.type && "zoom";
                    },
                    clickSlide: "close",
                    clickOutside: "close",
                    dblclickContent: !1,
                    dblclickSlide: !1,
                    dblclickOutside: !1,
                    mobile: {
                        preventCaptionOverlap: !1,
                        idleTime: !1,
                        clickContent: function (t, e) {
                            return "image" === t.type && "toggleControls";
                        },
                        clickSlide: function (t, e) {
                            return "image" === t.type ? "toggleControls" : "close";
                        },
                        dblclickContent: function (t, e) {
                            return "image" === t.type && "zoom";
                        },
                        dblclickSlide: function (t, e) {
                            return "image" === t.type && "zoom";
                        },
                    },
                    lang: "en",
                    i18n: {
                        en: {
                            CLOSE: "Close",
                            NEXT: "Next",
                            PREV: "Previous",
                            ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                            PLAY_START: "Start slideshow",
                            PLAY_STOP: "Pause slideshow",
                            FULL_SCREEN: "Full screen",
                            THUMBS: "Thumbnails",
                            DOWNLOAD: "Download",
                            SHARE: "Share",
                            ZOOM: "Zoom",
                        },
                        de: {
                            CLOSE: "Schlie&szlig;en",
                            NEXT: "Weiter",
                            PREV: "Zur&uuml;ck",
                            ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                            PLAY_START: "Diaschau starten",
                            PLAY_STOP: "Diaschau beenden",
                            FULL_SCREEN: "Vollbild",
                            THUMBS: "Vorschaubilder",
                            DOWNLOAD: "Herunterladen",
                            SHARE: "Teilen",
                            ZOOM: "Vergr&ouml;&szlig;ern",
                        },
                    },
                },
                s = n(t),
                r = n(e),
                c = 0,
                l = function (t) {
                    return t && t.hasOwnProperty && t instanceof n;
                },
                d = (function () {
                    return (
                        t.requestAnimationFrame ||
                        t.webkitRequestAnimationFrame ||
                        t.mozRequestAnimationFrame ||
                        t.oRequestAnimationFrame ||
                        function (e) {
                            return t.setTimeout(e, 1e3 / 60);
                        }
                    );
                })(),
                u = (function () {
                    return (
                        t.cancelAnimationFrame ||
                        t.webkitCancelAnimationFrame ||
                        t.mozCancelAnimationFrame ||
                        t.oCancelAnimationFrame ||
                        function (e) {
                            t.clearTimeout(e);
                        }
                    );
                })(),
                f = (function () {
                    var t,
                        n = e.createElement("fakeelement"),
                        o = {
                            transition: "transitionend",
                            OTransition: "oTransitionEnd",
                            MozTransition: "transitionend",
                            WebkitTransition: "webkitTransitionEnd",
                        };
                    for (t in o) if (void 0 !== n.style[t]) return o[t];
                    return "transitionend";
                })(),
                p = function (t) {
                    return t && t.length && t[0].offsetHeight;
                },
                h = function (t, e) {
                    var o = n.extend(!0, {}, t, e);
                    return (
                        n.each(e, function (t, e) {
                            n.isArray(e) && (o[t] = e);
                        }),
                        o
                    );
                },
                g = function (t) {
                    var o, i;
                    return (
                        !(!t || t.ownerDocument !== e) &&
                        (n(".fancybox-container").css("pointer-events", "none"),
                        (o = {
                            x: t.getBoundingClientRect().left + t.offsetWidth / 2,
                            y: t.getBoundingClientRect().top + t.offsetHeight / 2,
                        }),
                        (i = e.elementFromPoint(o.x, o.y) === t),
                        n(".fancybox-container").css("pointer-events", ""),
                        i)
                    );
                },
                b = function (t, e, o) {
                    var i = this;
                    (i.opts = h({ index: o }, n.fancybox.defaults)),
                        n.isPlainObject(e) && (i.opts = h(i.opts, e)),
                        n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
                        (i.id = i.opts.id || ++c),
                        (i.currIndex = parseInt(i.opts.index, 10) || 0),
                        (i.prevIndex = null),
                        (i.prevPos = null),
                        (i.currPos = 0),
                        (i.firstRun = !0),
                        (i.group = []),
                        (i.slides = {}),
                        i.addContent(t),
                        i.group.length && i.init();
                };
            n.extend(b.prototype, {
                init: function () {
                    var o,
                        i,
                        a = this,
                        s = a.group[a.currIndex],
                        r = s.opts;
                    r.closeExisting && n.fancybox.close(!0),
                        n("body").addClass("fancybox-active"),
                        !n.fancybox.getInstance() &&
                            !1 !== r.hideScrollbar &&
                            !n.fancybox.isMobile &&
                            e.body.scrollHeight > t.innerHeight &&
                            (n("head").append(
                                '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                                    (t.innerWidth - e.documentElement.clientWidth) +
                                    "px;}</style>"
                            ),
                            n("body").addClass("compensate-for-scrollbar")),
                        (i = ""),
                        n.each(r.buttons, function (t, e) {
                            i += r.btnTpl[e] || "";
                        }),
                        (o = n(
                            a.translate(
                                a,
                                r.baseTpl
                                    .replace("{{buttons}}", i)
                                    .replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)
                            )
                        )
                            .attr("id", "fancybox-container-" + a.id)
                            .addClass(r.baseClass)
                            .data("FancyBox", a)
                            .appendTo(r.parentEl)),
                        (a.$refs = { container: o }),
                        ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (t) {
                            a.$refs[t] = o.find(".fancybox-" + t);
                        }),
                        a.trigger("onInit"),
                        a.activate(),
                        a.jumpTo(a.currIndex);
                },
                translate: function (t, e) {
                    var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
                    return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
                        return void 0 === n[e] ? t : n[e];
                    });
                },
                addContent: function (t) {
                    var e,
                        o = this,
                        i = n.makeArray(t);
                    n.each(i, function (t, e) {
                        var i,
                            a,
                            s,
                            r,
                            c,
                            l = {},
                            d = {};
                        n.isPlainObject(e)
                            ? ((l = e), (d = e.opts || e))
                            : "object" === n.type(e) && n(e).length
                              ? ((i = n(e)),
                                (d = i.data() || {}),
                                (d = n.extend(!0, {}, d, d.options)),
                                (d.$orig = i),
                                (l.src = o.opts.src || d.src || i.attr("href")),
                                l.type || l.src || ((l.type = "inline"), (l.src = e)))
                              : (l = { type: "html", src: e + "" }),
                            (l.opts = n.extend(!0, {}, o.opts, d)),
                            n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
                            n.fancybox.isMobile && l.opts.mobile && (l.opts = h(l.opts, l.opts.mobile)),
                            (a = l.type || l.opts.type),
                            (r = l.src || ""),
                            !a &&
                                r &&
                                ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                                    ? ((a = "video"),
                                      l.opts.video.format ||
                                          (l.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                                    : r.match(
                                            /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
                                        )
                                      ? (a = "image")
                                      : r.match(/\.(pdf)((\?|#).*)?$/i)
                                        ? ((a = "iframe"),
                                          (l = n.extend(!0, l, {
                                              contentType: "pdf",
                                              opts: { iframe: { preload: !1 } },
                                          })))
                                        : "#" === r.charAt(0) && (a = "inline")),
                            a ? (l.type = a) : o.trigger("objectNeedsType", l),
                            l.contentType ||
                                (l.contentType = n.inArray(l.type, ["html", "inline", "ajax"]) > -1 ? "html" : l.type),
                            (l.index = o.group.length),
                            "auto" == l.opts.smallBtn &&
                                (l.opts.smallBtn = n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
                            "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
                            (l.$thumb = l.opts.$thumb || null),
                            l.opts.$trigger &&
                                l.index === o.opts.index &&
                                ((l.$thumb = l.opts.$trigger.find("img:first")),
                                l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
                            (l.$thumb && l.$thumb.length) ||
                                !l.opts.$orig ||
                                (l.$thumb = l.opts.$orig.find("img:first")),
                            l.$thumb && !l.$thumb.length && (l.$thumb = null),
                            (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
                            "function" === n.type(l.opts.caption) && (l.opts.caption = l.opts.caption.apply(e, [o, l])),
                            "function" === n.type(o.opts.caption) && (l.opts.caption = o.opts.caption.apply(e, [o, l])),
                            l.opts.caption instanceof n ||
                                (l.opts.caption = void 0 === l.opts.caption ? "" : l.opts.caption + ""),
                            "ajax" === l.type &&
                                ((c = r.split(/\s+/, 2)),
                                c.length > 1 && ((l.src = c.shift()), (l.opts.filter = c.shift()))),
                            l.opts.modal &&
                                (l.opts = n.extend(!0, l.opts, {
                                    trapFocus: !0,
                                    infobar: 0,
                                    toolbar: 0,
                                    smallBtn: 0,
                                    keyboard: 0,
                                    slideShow: 0,
                                    fullScreen: 0,
                                    thumbs: 0,
                                    touch: 0,
                                    clickContent: !1,
                                    clickSlide: !1,
                                    clickOutside: !1,
                                    dblclickContent: !1,
                                    dblclickSlide: !1,
                                    dblclickOutside: !1,
                                })),
                            o.group.push(l);
                    }),
                        Object.keys(o.slides).length &&
                            (o.updateControls(), (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
                },
                addEvents: function () {
                    var e = this;
                    e.removeEvents(),
                        e.$refs.container
                            .on("click.fb-close", "[data-fancybox-close]", function (t) {
                                t.stopPropagation(), t.preventDefault(), e.close(t);
                            })
                            .on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (t) {
                                t.stopPropagation(), t.preventDefault(), e.previous();
                            })
                            .on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (t) {
                                t.stopPropagation(), t.preventDefault(), e.next();
                            })
                            .on("click.fb", "[data-fancybox-zoom]", function (t) {
                                e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
                            }),
                        s.on("orientationchange.fb resize.fb", function (t) {
                            t && t.originalEvent && "resize" === t.originalEvent.type
                                ? (e.requestId && u(e.requestId),
                                  (e.requestId = d(function () {
                                      e.update(t);
                                  })))
                                : (e.current && "iframe" === e.current.type && e.$refs.stage.hide(),
                                  setTimeout(
                                      function () {
                                          e.$refs.stage.show(), e.update(t);
                                      },
                                      n.fancybox.isMobile ? 600 : 250
                                  ));
                        }),
                        r.on("keydown.fb", function (t) {
                            var o = n.fancybox ? n.fancybox.getInstance() : null,
                                i = o.current,
                                a = t.keyCode || t.which;
                            if (9 == a) return void (i.opts.trapFocus && e.focus(t));
                            if (
                                !(
                                    !i.opts.keyboard ||
                                    t.ctrlKey ||
                                    t.altKey ||
                                    t.shiftKey ||
                                    n(t.target).is("input,textarea,video,audio,select")
                                )
                            )
                                return 8 === a || 27 === a
                                    ? (t.preventDefault(), void e.close(t))
                                    : 37 === a || 38 === a
                                      ? (t.preventDefault(), void e.previous())
                                      : 39 === a || 40 === a
                                        ? (t.preventDefault(), void e.next())
                                        : void e.trigger("afterKeydown", t, a);
                        }),
                        e.group[e.currIndex].opts.idleTime &&
                            ((e.idleSecondsCounter = 0),
                            r.on(
                                "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
                                function (t) {
                                    (e.idleSecondsCounter = 0), e.isIdle && e.showControls(), (e.isIdle = !1);
                                }
                            ),
                            (e.idleInterval = t.setInterval(function () {
                                ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                                    !e.isDragging &&
                                    ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
                            }, 1e3)));
                },
                removeEvents: function () {
                    var e = this;
                    s.off("orientationchange.fb resize.fb"),
                        r.off("keydown.fb .fb-idle"),
                        this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                        e.idleInterval && (t.clearInterval(e.idleInterval), (e.idleInterval = null));
                },
                previous: function (t) {
                    return this.jumpTo(this.currPos - 1, t);
                },
                next: function (t) {
                    return this.jumpTo(this.currPos + 1, t);
                },
                jumpTo: function (t, e) {
                    var o,
                        i,
                        a,
                        s,
                        r,
                        c,
                        l,
                        d,
                        u,
                        f = this,
                        h = f.group.length;
                    if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
                        if (
                            ((t = parseInt(t, 10)),
                            !(a = f.current ? f.current.opts.loop : f.opts.loop) && (t < 0 || t >= h))
                        )
                            return !1;
                        if (
                            ((o = f.firstRun = !Object.keys(f.slides).length),
                            (r = f.current),
                            (f.prevIndex = f.currIndex),
                            (f.prevPos = f.currPos),
                            (s = f.createSlide(t)),
                            h > 1 &&
                                ((a || s.index < h - 1) && f.createSlide(t + 1),
                                (a || s.index > 0) && f.createSlide(t - 1)),
                            (f.current = s),
                            (f.currIndex = s.index),
                            (f.currPos = s.pos),
                            f.trigger("beforeShow", o),
                            f.updateControls(),
                            (s.forcedDuration = void 0),
                            n.isNumeric(e)
                                ? (s.forcedDuration = e)
                                : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
                            (e = parseInt(e, 10)),
                            (i = f.isMoved(s)),
                            s.$slide.addClass("fancybox-slide--current"),
                            o)
                        )
                            return (
                                s.opts.animationEffect && e && f.$refs.container.css("transition-duration", e + "ms"),
                                f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
                                f.loadSlide(s),
                                void f.preload("image")
                            );
                        (c = n.fancybox.getTranslate(r.$slide)),
                            (l = n.fancybox.getTranslate(f.$refs.stage)),
                            n.each(f.slides, function (t, e) {
                                n.fancybox.stop(e.$slide, !0);
                            }),
                            r.pos !== s.pos && (r.isComplete = !1),
                            r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),
                            i
                                ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                                  n.each(f.slides, function (t, o) {
                                      o.$slide.removeClass("fancybox-animated").removeClass(function (t, e) {
                                          return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                      });
                                      var i = o.pos * c.width + o.pos * o.opts.gutter;
                                      n.fancybox.setTranslate(o.$slide, { top: 0, left: i - l.left + u }),
                                          o.pos !== s.pos &&
                                              o.$slide.addClass(
                                                  "fancybox-slide--" + (o.pos > s.pos ? "next" : "previous")
                                              ),
                                          p(o.$slide),
                                          n.fancybox.animate(
                                              o.$slide,
                                              {
                                                  top: 0,
                                                  left: (o.pos - s.pos) * c.width + (o.pos - s.pos) * o.opts.gutter,
                                              },
                                              e,
                                              function () {
                                                  o.$slide
                                                      .css({ transform: "", opacity: "" })
                                                      .removeClass("fancybox-slide--next fancybox-slide--previous"),
                                                      o.pos === f.currPos && f.complete();
                                              }
                                          );
                                  }))
                                : e &&
                                  s.opts.transitionEffect &&
                                  ((d = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                                  r.$slide.addClass("fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")),
                                  n.fancybox.animate(
                                      r.$slide,
                                      d,
                                      e,
                                      function () {
                                          r.$slide
                                              .removeClass(d)
                                              .removeClass("fancybox-slide--next fancybox-slide--previous");
                                      },
                                      !1
                                  )),
                            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
                            f.preload("image");
                    }
                },
                createSlide: function (t) {
                    var e,
                        o,
                        i = this;
                    return (
                        (o = t % i.group.length),
                        (o = o < 0 ? i.group.length + o : o),
                        !i.slides[t] &&
                            i.group[o] &&
                            ((e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage)),
                            (i.slides[t] = n.extend(!0, {}, i.group[o], { pos: t, $slide: e, isLoaded: !1 })),
                            i.updateSlide(i.slides[t])),
                        i.slides[t]
                    );
                },
                scaleToActual: function (t, e, o) {
                    var i,
                        a,
                        s,
                        r,
                        c,
                        l = this,
                        d = l.current,
                        u = d.$content,
                        f = n.fancybox.getTranslate(d.$slide).width,
                        p = n.fancybox.getTranslate(d.$slide).height,
                        h = d.width,
                        g = d.height;
                    l.isAnimating ||
                        l.isMoved() ||
                        !u ||
                        "image" != d.type ||
                        !d.isLoaded ||
                        d.hasError ||
                        ((l.isAnimating = !0),
                        n.fancybox.stop(u),
                        (t = void 0 === t ? 0.5 * f : t),
                        (e = void 0 === e ? 0.5 * p : e),
                        (i = n.fancybox.getTranslate(u)),
                        (i.top -= n.fancybox.getTranslate(d.$slide).top),
                        (i.left -= n.fancybox.getTranslate(d.$slide).left),
                        (r = h / i.width),
                        (c = g / i.height),
                        (a = 0.5 * f - 0.5 * h),
                        (s = 0.5 * p - 0.5 * g),
                        h > f && ((a = i.left * r - (t * r - t)), a > 0 && (a = 0), a < f - h && (a = f - h)),
                        g > p && ((s = i.top * c - (e * c - e)), s > 0 && (s = 0), s < p - g && (s = p - g)),
                        l.updateCursor(h, g),
                        n.fancybox.animate(u, { top: s, left: a, scaleX: r, scaleY: c }, o || 366, function () {
                            l.isAnimating = !1;
                        }),
                        l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
                },
                scaleToFit: function (t) {
                    var e,
                        o = this,
                        i = o.current,
                        a = i.$content;
                    o.isAnimating ||
                        o.isMoved() ||
                        !a ||
                        "image" != i.type ||
                        !i.isLoaded ||
                        i.hasError ||
                        ((o.isAnimating = !0),
                        n.fancybox.stop(a),
                        (e = o.getFitPos(i)),
                        o.updateCursor(e.width, e.height),
                        n.fancybox.animate(
                            a,
                            { top: e.top, left: e.left, scaleX: e.width / a.width(), scaleY: e.height / a.height() },
                            t || 366,
                            function () {
                                o.isAnimating = !1;
                            }
                        ));
                },
                getFitPos: function (t) {
                    var e,
                        o,
                        i,
                        a,
                        s = this,
                        r = t.$content,
                        c = t.$slide,
                        l = t.width || t.opts.width,
                        d = t.height || t.opts.height,
                        u = {};
                    return (
                        !!(t.isLoaded && r && r.length) &&
                        ((e = n.fancybox.getTranslate(s.$refs.stage).width),
                        (o = n.fancybox.getTranslate(s.$refs.stage).height),
                        (e -=
                            parseFloat(c.css("paddingLeft")) +
                            parseFloat(c.css("paddingRight")) +
                            parseFloat(r.css("marginLeft")) +
                            parseFloat(r.css("marginRight"))),
                        (o -=
                            parseFloat(c.css("paddingTop")) +
                            parseFloat(c.css("paddingBottom")) +
                            parseFloat(r.css("marginTop")) +
                            parseFloat(r.css("marginBottom"))),
                        (l && d) || ((l = e), (d = o)),
                        (i = Math.min(1, e / l, o / d)),
                        (l *= i),
                        (d *= i),
                        l > e - 0.5 && (l = e),
                        d > o - 0.5 && (d = o),
                        "image" === t.type
                            ? ((u.top = Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))),
                              (u.left = Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
                            : "video" === t.contentType &&
                              ((a = t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9),
                              d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
                        (u.width = l),
                        (u.height = d),
                        u)
                    );
                },
                update: function (t) {
                    var e = this;
                    n.each(e.slides, function (n, o) {
                        e.updateSlide(o, t);
                    });
                },
                updateSlide: function (t, e) {
                    var o = this,
                        i = t && t.$content,
                        a = t.width || t.opts.width,
                        s = t.height || t.opts.height,
                        r = t.$slide;
                    o.adjustCaption(t),
                        i &&
                            (a || s || "video" === t.contentType) &&
                            !t.hasError &&
                            (n.fancybox.stop(i),
                            n.fancybox.setTranslate(i, o.getFitPos(t)),
                            t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
                        o.adjustLayout(t),
                        r.length &&
                            (r.trigger("refresh"),
                            t.pos === o.currPos &&
                                o.$refs.toolbar
                                    .add(o.$refs.navigation.find(".fancybox-button--arrow_right"))
                                    .toggleClass(
                                        "compensate-for-scrollbar",
                                        r.get(0).scrollHeight > r.get(0).clientHeight
                                    )),
                        o.trigger("onUpdate", t, e);
                },
                centerSlide: function (t) {
                    var e = this,
                        o = e.current,
                        i = o.$slide;
                    !e.isClosing &&
                        o &&
                        (i.siblings().css({ transform: "", opacity: "" }),
                        i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),
                        n.fancybox.animate(
                            i,
                            { top: 0, left: 0, opacity: 1 },
                            void 0 === t ? 0 : t,
                            function () {
                                i.css({ transform: "", opacity: "" }), o.isComplete || e.complete();
                            },
                            !1
                        ));
                },
                isMoved: function (t) {
                    var e,
                        o,
                        i = t || this.current;
                    return (
                        !!i &&
                        ((o = n.fancybox.getTranslate(this.$refs.stage)),
                        (e = n.fancybox.getTranslate(i.$slide)),
                        !i.$slide.hasClass("fancybox-animated") &&
                            (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
                    );
                },
                updateCursor: function (t, e) {
                    var o,
                        i,
                        a = this,
                        s = a.current,
                        r = a.$refs.container;
                    s &&
                        !a.isClosing &&
                        a.Guestures &&
                        (r.removeClass(
                            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"
                        ),
                        (o = a.canPan(t, e)),
                        (i = !!o || a.isZoomable()),
                        r.toggleClass("fancybox-is-zoomable", i),
                        n("[data-fancybox-zoom]").prop("disabled", !i),
                        o
                            ? r.addClass("fancybox-can-pan")
                            : i &&
                                ("zoom" === s.opts.clickContent ||
                                    (n.isFunction(s.opts.clickContent) && "zoom" == s.opts.clickContent(s)))
                              ? r.addClass("fancybox-can-zoomIn")
                              : s.opts.touch &&
                                (s.opts.touch.vertical || a.group.length > 1) &&
                                "video" !== s.contentType &&
                                r.addClass("fancybox-can-swipe"));
                },
                isZoomable: function () {
                    var t,
                        e = this,
                        n = e.current;
                    if (n && !e.isClosing && "image" === n.type && !n.hasError) {
                        if (!n.isLoaded) return !0;
                        if ((t = e.getFitPos(n)) && (n.width > t.width || n.height > t.height)) return !0;
                    }
                    return !1;
                },
                isScaledDown: function (t, e) {
                    var o = this,
                        i = !1,
                        a = o.current,
                        s = a.$content;
                    return (
                        void 0 !== t && void 0 !== e
                            ? (i = t < a.width && e < a.height)
                            : s && ((i = n.fancybox.getTranslate(s)), (i = i.width < a.width && i.height < a.height)),
                        i
                    );
                },
                canPan: function (t, e) {
                    var o = this,
                        i = o.current,
                        a = null,
                        s = !1;
                    return (
                        "image" === i.type &&
                            (i.isComplete || (t && e)) &&
                            !i.hasError &&
                            ((s = o.getFitPos(i)),
                            void 0 !== t && void 0 !== e
                                ? (a = { width: t, height: e })
                                : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
                            a && s && (s = Math.abs(a.width - s.width) > 1.5 || Math.abs(a.height - s.height) > 1.5)),
                        s
                    );
                },
                loadSlide: function (t) {
                    var e,
                        o,
                        i,
                        a = this;
                    if (!t.isLoading && !t.isLoaded) {
                        if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t))) return (t.isLoading = !1), !1;
                        switch (
                            ((e = t.type),
                            (o = t.$slide),
                            o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
                            e)
                        ) {
                            case "image":
                                a.setImage(t);
                                break;
                            case "iframe":
                                a.setIframe(t);
                                break;
                            case "html":
                                a.setContent(t, t.src || t.content);
                                break;
                            case "video":
                                a.setContent(
                                    t,
                                    t.opts.video.tpl
                                        .replace(/\{\{src\}\}/gi, t.src)
                                        .replace("{{format}}", t.opts.videoFormat || t.opts.video.format || "")
                                        .replace("{{poster}}", t.thumb || "")
                                );
                                break;
                            case "inline":
                                n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
                                break;
                            case "ajax":
                                a.showLoading(t),
                                    (i = n.ajax(
                                        n.extend({}, t.opts.ajax.settings, {
                                            url: t.src,
                                            success: function (e, n) {
                                                "success" === n && a.setContent(t, e);
                                            },
                                            error: function (e, n) {
                                                e && "abort" !== n && a.setError(t);
                                            },
                                        })
                                    )),
                                    o.one("onReset", function () {
                                        i.abort();
                                    });
                                break;
                            default:
                                a.setError(t);
                        }
                        return !0;
                    }
                },
                setImage: function (t) {
                    var o,
                        i = this;
                    setTimeout(function () {
                        var e = t.$image;
                        i.isClosing ||
                            !t.isLoading ||
                            (e && e.length && e[0].complete) ||
                            t.hasError ||
                            i.showLoading(t);
                    }, 50),
                        i.checkSrcset(t),
                        (t.$content = n('<div class="fancybox-content"></div>')
                            .addClass("fancybox-is-hidden")
                            .appendTo(t.$slide.addClass("fancybox-slide--image"))),
                        !1 !== t.opts.preload &&
                            t.opts.width &&
                            t.opts.height &&
                            t.thumb &&
                            ((t.width = t.opts.width),
                            (t.height = t.opts.height),
                            (o = e.createElement("img")),
                            (o.onerror = function () {
                                n(this).remove(), (t.$ghost = null);
                            }),
                            (o.onload = function () {
                                i.afterLoad(t);
                            }),
                            (t.$ghost = n(o).addClass("fancybox-image").appendTo(t.$content).attr("src", t.thumb))),
                        i.setBigImage(t);
                },
                checkSrcset: function (e) {
                    var n,
                        o,
                        i,
                        a,
                        s = e.opts.srcset || e.opts.image.srcset;
                    if (s) {
                        (i = t.devicePixelRatio || 1),
                            (a = t.innerWidth * i),
                            (o = s.split(",").map(function (t) {
                                var e = {};
                                return (
                                    t
                                        .trim()
                                        .split(/\s+/)
                                        .forEach(function (t, n) {
                                            var o = parseInt(t.substring(0, t.length - 1), 10);
                                            if (0 === n) return (e.url = t);
                                            o && ((e.value = o), (e.postfix = t[t.length - 1]));
                                        }),
                                    e
                                );
                            })),
                            o.sort(function (t, e) {
                                return t.value - e.value;
                            });
                        for (var r = 0; r < o.length; r++) {
                            var c = o[r];
                            if (("w" === c.postfix && c.value >= a) || ("x" === c.postfix && c.value >= i)) {
                                n = c;
                                break;
                            }
                        }
                        !n && o.length && (n = o[o.length - 1]),
                            n &&
                                ((e.src = n.url),
                                e.width &&
                                    e.height &&
                                    "w" == n.postfix &&
                                    ((e.height = (e.width / e.height) * n.value), (e.width = n.value)),
                                (e.opts.srcset = s));
                    }
                },
                setBigImage: function (t) {
                    var o = this,
                        i = e.createElement("img"),
                        a = n(i);
                    (t.$image = a
                        .one("error", function () {
                            o.setError(t);
                        })
                        .one("load", function () {
                            var e;
                            t.$ghost ||
                                (o.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight), o.afterLoad(t)),
                                o.isClosing ||
                                    (t.opts.srcset &&
                                        ((e = t.opts.sizes),
                                        (e && "auto" !== e) ||
                                            (e =
                                                (t.width / t.height > 1 && s.width() / s.height() > 1
                                                    ? "100"
                                                    : Math.round((t.width / t.height) * 100)) + "vw"),
                                        a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                                    t.$ghost &&
                                        setTimeout(
                                            function () {
                                                t.$ghost && !o.isClosing && t.$ghost.hide();
                                            },
                                            Math.min(300, Math.max(1e3, t.height / 1600))
                                        ),
                                    o.hideLoading(t));
                        })
                        .addClass("fancybox-image")
                        .attr("src", t.src)
                        .appendTo(t.$content)),
                        (i.complete || "complete" == i.readyState) && a.naturalWidth && a.naturalHeight
                            ? a.trigger("load")
                            : i.error && a.trigger("error");
                },
                resolveImageSlideSize: function (t, e, n) {
                    var o = parseInt(t.opts.width, 10),
                        i = parseInt(t.opts.height, 10);
                    (t.width = e),
                        (t.height = n),
                        o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))),
                        i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
                },
                setIframe: function (t) {
                    var e,
                        o = this,
                        i = t.opts.iframe,
                        a = t.$slide;
                    (t.$content = n(
                        '<div class="fancybox-content' + (i.preload ? " fancybox-is-hidden" : "") + '"></div>'
                    )
                        .css(i.css)
                        .appendTo(a)),
                        a.addClass("fancybox-slide--" + t.contentType),
                        (t.$iframe = e =
                            n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                                .attr(i.attr)
                                .appendTo(t.$content)),
                        i.preload
                            ? (o.showLoading(t),
                              e.on("load.fb error.fb", function (e) {
                                  (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
                              }),
                              a.on("refresh.fb", function () {
                                  var n,
                                      o,
                                      s = t.$content,
                                      r = i.css.width,
                                      c = i.css.height;
                                  if (1 === e[0].isReady) {
                                      try {
                                          (n = e.contents()), (o = n.find("body"));
                                      } catch (t) {}
                                      o &&
                                          o.length &&
                                          o.children().length &&
                                          (a.css("overflow", "visible"),
                                          s.css({ width: "100%", "max-width": "100%", height: "9999px" }),
                                          void 0 === r && (r = Math.ceil(Math.max(o[0].clientWidth, o.outerWidth(!0)))),
                                          s.css("width", r || "").css("max-width", ""),
                                          void 0 === c &&
                                              (c = Math.ceil(Math.max(o[0].clientHeight, o.outerHeight(!0)))),
                                          s.css("height", c || ""),
                                          a.css("overflow", "auto")),
                                          s.removeClass("fancybox-is-hidden");
                                  }
                              }))
                            : o.afterLoad(t),
                        e.attr("src", t.src),
                        a.one("onReset", function () {
                            try {
                                n(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                            } catch (t) {}
                            n(this).off("refresh.fb").empty(), (t.isLoaded = !1), (t.isRevealed = !1);
                        });
                },
                setContent: function (t, e) {
                    var o = this;
                    o.isClosing ||
                        (o.hideLoading(t),
                        t.$content && n.fancybox.stop(t.$content),
                        t.$slide.empty(),
                        l(e) && e.parent().length
                            ? ((e.hasClass("fancybox-content") || e.parent().hasClass("fancybox-content")) &&
                                  e.parents(".fancybox-slide").trigger("onReset"),
                              (t.$placeholder = n("<div>").hide().insertAfter(e)),
                              e.css("display", "inline-block"))
                            : t.hasError ||
                              ("string" === n.type(e) && (e = n("<div>").append(n.trim(e)).contents()),
                              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
                        t.$slide.one("onReset", function () {
                            n(this).find("video,audio").trigger("pause"),
                                t.$placeholder &&
                                    (t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),
                                    (t.$placeholder = null)),
                                t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
                                t.hasError || (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
                        }),
                        n(e).appendTo(t.$slide),
                        n(e).is("video,audio") &&
                            (n(e).addClass("fancybox-video"),
                            n(e).wrap("<div></div>"),
                            (t.contentType = "video"),
                            (t.opts.width = t.opts.width || n(e).attr("width")),
                            (t.opts.height = t.opts.height || n(e).attr("height"))),
                        (t.$content = t.$slide
                            .children()
                            .filter("div,form,main,video,audio,article,.fancybox-content")
                            .first()),
                        t.$content.siblings().hide(),
                        t.$content.length || (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
                        t.$content.addClass("fancybox-content"),
                        t.$slide.addClass("fancybox-slide--" + t.contentType),
                        o.afterLoad(t));
                },
                setError: function (t) {
                    (t.hasError = !0),
                        t.$slide
                            .trigger("onReset")
                            .removeClass("fancybox-slide--" + t.contentType)
                            .addClass("fancybox-slide--error"),
                        (t.contentType = "html"),
                        this.setContent(t, this.translate(t, t.opts.errorTpl)),
                        t.pos === this.currPos && (this.isAnimating = !1);
                },
                showLoading: function (t) {
                    var e = this;
                    (t = t || e.current) &&
                        !t.$spinner &&
                        (t.$spinner = n(e.translate(e, e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"));
                },
                hideLoading: function (t) {
                    var e = this;
                    (t = t || e.current) && t.$spinner && (t.$spinner.stop().remove(), delete t.$spinner);
                },
                afterLoad: function (t) {
                    var e = this;
                    e.isClosing ||
                        ((t.isLoading = !1),
                        (t.isLoaded = !0),
                        e.trigger("afterLoad", t),
                        e.hideLoading(t),
                        !t.opts.smallBtn ||
                            (t.$smallBtn && t.$smallBtn.length) ||
                            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)),
                        t.opts.protect &&
                            t.$content &&
                            !t.hasError &&
                            (t.$content.on("contextmenu.fb", function (t) {
                                return 2 == t.button && t.preventDefault(), !0;
                            }),
                            "image" === t.type && n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
                        e.adjustCaption(t),
                        e.adjustLayout(t),
                        t.pos === e.currPos && e.updateCursor(),
                        e.revealContent(t));
                },
                adjustCaption: function (t) {
                    var e,
                        n = this,
                        o = t || n.current,
                        i = o.opts.caption,
                        a = o.opts.preventCaptionOverlap,
                        s = n.$refs.caption,
                        r = !1;
                    s.toggleClass("fancybox-caption--separate", a),
                        a &&
                            i &&
                            i.length &&
                            (o.pos !== n.currPos
                                ? ((e = s.clone().appendTo(s.parent())),
                                  e.children().eq(0).empty().html(i),
                                  (r = e.outerHeight(!0)),
                                  e.empty().remove())
                                : n.$caption && (r = n.$caption.outerHeight(!0)),
                            o.$slide.css("padding-bottom", r || ""));
                },
                adjustLayout: function (t) {
                    var e,
                        n,
                        o,
                        i,
                        a = this,
                        s = t || a.current;
                    s.isLoaded &&
                        !0 !== s.opts.disableLayoutFix &&
                        (s.$content.css("margin-bottom", ""),
                        s.$content.outerHeight() > s.$slide.height() + 0.5 &&
                            ((o = s.$slide[0].style["padding-bottom"]),
                            (i = s.$slide.css("padding-bottom")),
                            parseFloat(i) > 0 &&
                                ((e = s.$slide[0].scrollHeight),
                                s.$slide.css("padding-bottom", 0),
                                Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
                                s.$slide.css("padding-bottom", o))),
                        s.$content.css("margin-bottom", n));
                },
                revealContent: function (t) {
                    var e,
                        o,
                        i,
                        a,
                        s = this,
                        r = t.$slide,
                        c = !1,
                        l = !1,
                        d = s.isMoved(t),
                        u = t.isRevealed;
                    return (
                        (t.isRevealed = !0),
                        (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
                        (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
                        (i = parseInt(void 0 === t.forcedDuration ? i : t.forcedDuration, 10)),
                        (!d && t.pos === s.currPos && i) || (e = !1),
                        "zoom" === e &&
                            (t.pos === s.currPos && i && "image" === t.type && !t.hasError && (l = s.getThumbPos(t))
                                ? (c = s.getFitPos(t))
                                : (e = "fade")),
                        "zoom" === e
                            ? ((s.isAnimating = !0),
                              (c.scaleX = c.width / l.width),
                              (c.scaleY = c.height / l.height),
                              (a = t.opts.zoomOpacity),
                              "auto" == a && (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
                              a && ((l.opacity = 0.1), (c.opacity = 1)),
                              n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), l),
                              p(t.$content),
                              void n.fancybox.animate(t.$content, c, i, function () {
                                  (s.isAnimating = !1), s.complete();
                              }))
                            : (s.updateSlide(t),
                              e
                                  ? (n.fancybox.stop(r),
                                    (o =
                                        "fancybox-slide--" +
                                        (t.pos >= s.prevPos ? "next" : "previous") +
                                        " fancybox-animated fancybox-fx-" +
                                        e),
                                    r.addClass(o).removeClass("fancybox-slide--current"),
                                    t.$content.removeClass("fancybox-is-hidden"),
                                    p(r),
                                    "image" !== t.type && t.$content.hide().show(0),
                                    void n.fancybox.animate(
                                        r,
                                        "fancybox-slide--current",
                                        i,
                                        function () {
                                            r.removeClass(o).css({ transform: "", opacity: "" }),
                                                t.pos === s.currPos && s.complete();
                                        },
                                        !0
                                    ))
                                  : (t.$content.removeClass("fancybox-is-hidden"),
                                    u || !d || "image" !== t.type || t.hasError || t.$content.hide().fadeIn("fast"),
                                    void (t.pos === s.currPos && s.complete())))
                    );
                },
                getThumbPos: function (t) {
                    var e,
                        o,
                        i,
                        a,
                        s,
                        r = !1,
                        c = t.$thumb;
                    return (
                        !(!c || !g(c[0])) &&
                        ((e = n.fancybox.getTranslate(c)),
                        (o = parseFloat(c.css("border-top-width") || 0)),
                        (i = parseFloat(c.css("border-right-width") || 0)),
                        (a = parseFloat(c.css("border-bottom-width") || 0)),
                        (s = parseFloat(c.css("border-left-width") || 0)),
                        (r = {
                            top: e.top + o,
                            left: e.left + s,
                            width: e.width - i - s,
                            height: e.height - o - a,
                            scaleX: 1,
                            scaleY: 1,
                        }),
                        e.width > 0 && e.height > 0 && r)
                    );
                },
                complete: function () {
                    var t,
                        e = this,
                        o = e.current,
                        i = {};
                    !e.isMoved() &&
                        o.isLoaded &&
                        (o.isComplete ||
                            ((o.isComplete = !0),
                            o.$slide.siblings().trigger("onReset"),
                            e.preload("inline"),
                            p(o.$slide),
                            o.$slide.addClass("fancybox-slide--complete"),
                            n.each(e.slides, function (t, o) {
                                o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                                    ? (i[o.pos] = o)
                                    : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
                            }),
                            (e.slides = i)),
                        (e.isAnimating = !1),
                        e.updateCursor(),
                        e.trigger("afterShow"),
                        o.opts.video.autoStart &&
                            o.$slide
                                .find("video,audio")
                                .filter(":visible:first")
                                .trigger("play")
                                .one("ended", function () {
                                    Document.exitFullscreen
                                        ? Document.exitFullscreen()
                                        : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                                        e.next();
                                }),
                        o.opts.autoFocus &&
                            "html" === o.contentType &&
                            ((t = o.$content.find("input[autofocus]:enabled:visible:first")),
                            t.length ? t.trigger("focus") : e.focus(null, !0)),
                        o.$slide.scrollTop(0).scrollLeft(0));
                },
                preload: function (t) {
                    var e,
                        n,
                        o = this;
                    o.group.length < 2 ||
                        ((n = o.slides[o.currPos + 1]),
                        (e = o.slides[o.currPos - 1]),
                        e && e.type === t && o.loadSlide(e),
                        n && n.type === t && o.loadSlide(n));
                },
                focus: function (t, o) {
                    var i,
                        a,
                        s = this,
                        r = [
                            "a[href]",
                            "area[href]",
                            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                            "select:not([disabled]):not([aria-hidden])",
                            "textarea:not([disabled]):not([aria-hidden])",
                            "button:not([disabled]):not([aria-hidden])",
                            "iframe",
                            "object",
                            "embed",
                            "video",
                            "audio",
                            "[contenteditable]",
                            '[tabindex]:not([tabindex^="-"])',
                        ].join(",");
                    s.isClosing ||
                        ((i =
                            !t && s.current && s.current.isComplete
                                ? s.current.$slide.find("*:visible" + (o ? ":not(.fancybox-close-small)" : ""))
                                : s.$refs.container.find("*:visible")),
                        (i = i.filter(r).filter(function () {
                            return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled");
                        })),
                        i.length
                            ? ((a = i.index(e.activeElement)),
                              t && t.shiftKey
                                  ? (a < 0 || 0 == a) && (t.preventDefault(), i.eq(i.length - 1).trigger("focus"))
                                  : (a < 0 || a == i.length - 1) && (t && t.preventDefault(), i.eq(0).trigger("focus")))
                            : s.$refs.container.trigger("focus"));
                },
                activate: function () {
                    var t = this;
                    n(".fancybox-container").each(function () {
                        var e = n(this).data("FancyBox");
                        e &&
                            e.id !== t.id &&
                            !e.isClosing &&
                            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
                    }),
                        (t.isVisible = !0),
                        (t.current || t.isIdle) && (t.update(), t.updateControls()),
                        t.trigger("onActivate"),
                        t.addEvents();
                },
                close: function (t, e) {
                    var o,
                        i,
                        a,
                        s,
                        r,
                        c,
                        l,
                        u = this,
                        f = u.current,
                        h = function () {
                            u.cleanUp(t);
                        };
                    return (
                        !u.isClosing &&
                        ((u.isClosing = !0),
                        !1 === u.trigger("beforeClose", t)
                            ? ((u.isClosing = !1),
                              d(function () {
                                  u.update();
                              }),
                              !1)
                            : (u.removeEvents(),
                              (a = f.$content),
                              (o = f.opts.animationEffect),
                              (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
                              f.$slide.removeClass(
                                  "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
                              ),
                              !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
                              f.$slide.siblings().trigger("onReset").remove(),
                              i &&
                                  u.$refs.container
                                      .removeClass("fancybox-is-open")
                                      .addClass("fancybox-is-closing")
                                      .css("transition-duration", i + "ms"),
                              u.hideLoading(f),
                              u.hideControls(!0),
                              u.updateCursor(),
                              "zoom" !== o ||
                                  (a &&
                                      i &&
                                      "image" === f.type &&
                                      !u.isMoved() &&
                                      !f.hasError &&
                                      (l = u.getThumbPos(f))) ||
                                  (o = "fade"),
                              "zoom" === o
                                  ? (n.fancybox.stop(a),
                                    (s = n.fancybox.getTranslate(a)),
                                    (c = {
                                        top: s.top,
                                        left: s.left,
                                        scaleX: s.width / l.width,
                                        scaleY: s.height / l.height,
                                        width: l.width,
                                        height: l.height,
                                    }),
                                    (r = f.opts.zoomOpacity),
                                    "auto" == r && (r = Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                                    r && (l.opacity = 0),
                                    n.fancybox.setTranslate(a, c),
                                    p(a),
                                    n.fancybox.animate(a, l, i, h),
                                    !0)
                                  : (o && i
                                        ? n.fancybox.animate(
                                              f.$slide
                                                  .addClass("fancybox-slide--previous")
                                                  .removeClass("fancybox-slide--current"),
                                              "fancybox-animated fancybox-fx-" + o,
                                              i,
                                              h
                                          )
                                        : !0 === t
                                          ? setTimeout(h, i)
                                          : h(),
                                    !0)))
                    );
                },
                cleanUp: function (e) {
                    var o,
                        i,
                        a,
                        s = this,
                        r = s.current.opts.$orig;
                    s.current.$slide.trigger("onReset"),
                        s.$refs.container.empty().remove(),
                        s.trigger("afterClose", e),
                        s.current.opts.backFocus &&
                            ((r && r.length && r.is(":visible")) || (r = s.$trigger),
                            r &&
                                r.length &&
                                ((i = t.scrollX),
                                (a = t.scrollY),
                                r.trigger("focus"),
                                n("html, body").scrollTop(a).scrollLeft(i))),
                        (s.current = null),
                        (o = n.fancybox.getInstance()),
                        o
                            ? o.activate()
                            : (n("body").removeClass("fancybox-active compensate-for-scrollbar"),
                              n("#fancybox-style-noscroll").remove());
                },
                trigger: function (t, e) {
                    var o,
                        i = Array.prototype.slice.call(arguments, 1),
                        a = this,
                        s = e && e.opts ? e : a.current;
                    if (
                        (s ? i.unshift(s) : (s = a),
                        i.unshift(a),
                        n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
                        !1 === o)
                    )
                        return o;
                    "afterClose" !== t && a.$refs ? a.$refs.container.trigger(t + ".fb", i) : r.trigger(t + ".fb", i);
                },
                updateControls: function () {
                    var t = this,
                        o = t.current,
                        i = o.index,
                        a = t.$refs.container,
                        s = t.$refs.caption,
                        r = o.opts.caption;
                    o.$slide.trigger("refresh"),
                        r && r.length ? ((t.$caption = s), s.children().eq(0).html(r)) : (t.$caption = null),
                        t.hasHiddenControls || t.isIdle || t.showControls(),
                        a.find("[data-fancybox-count]").html(t.group.length),
                        a.find("[data-fancybox-index]").html(i + 1),
                        a.find("[data-fancybox-prev]").prop("disabled", !o.opts.loop && i <= 0),
                        a.find("[data-fancybox-next]").prop("disabled", !o.opts.loop && i >= t.group.length - 1),
                        "image" === o.type
                            ? a
                                  .find("[data-fancybox-zoom]")
                                  .show()
                                  .end()
                                  .find("[data-fancybox-download]")
                                  .attr("href", o.opts.image.src || o.src)
                                  .show()
                            : o.opts.toolbar && a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
                        n(e.activeElement).is(":hidden,[disabled]") && t.$refs.container.trigger("focus");
                },
                hideControls: function (t) {
                    var e = this,
                        n = ["infobar", "toolbar", "nav"];
                    (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
                        this.$refs.container.removeClass(
                            n
                                .map(function (t) {
                                    return "fancybox-show-" + t;
                                })
                                .join(" ")
                        ),
                        (this.hasHiddenControls = !0);
                },
                showControls: function () {
                    var t = this,
                        e = t.current ? t.current.opts : t.opts,
                        n = t.$refs.container;
                    (t.hasHiddenControls = !1),
                        (t.idleSecondsCounter = 0),
                        n
                            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
                            .toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1))
                            .toggleClass("fancybox-show-caption", !!t.$caption)
                            .toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1))
                            .toggleClass("fancybox-is-modal", !!e.modal);
                },
                toggleControls: function () {
                    this.hasHiddenControls ? this.showControls() : this.hideControls();
                },
            }),
                (n.fancybox = {
                    version: "3.5.7",
                    defaults: a,
                    getInstance: function (t) {
                        var e = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
                            o = Array.prototype.slice.call(arguments, 1);
                        return (
                            e instanceof b &&
                            ("string" === n.type(t) ? e[t].apply(e, o) : "function" === n.type(t) && t.apply(e, o), e)
                        );
                    },
                    open: function (t, e, n) {
                        return new b(t, e, n);
                    },
                    close: function (t) {
                        var e = this.getInstance();
                        e && (e.close(), !0 === t && this.close(t));
                    },
                    destroy: function () {
                        this.close(!0), r.add("body").off("click.fb-start", "**");
                    },
                    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                        navigator.userAgent
                    ),
                    use3d: (function () {
                        var n = e.createElement("div");
                        return (
                            t.getComputedStyle &&
                            t.getComputedStyle(n) &&
                            t.getComputedStyle(n).getPropertyValue("transform") &&
                            !(e.documentMode && e.documentMode < 11)
                        );
                    })(),
                    getTranslate: function (t) {
                        var e;
                        return (
                            !(!t || !t.length) &&
                            ((e = t[0].getBoundingClientRect()),
                            {
                                top: e.top || 0,
                                left: e.left || 0,
                                width: e.width,
                                height: e.height,
                                opacity: parseFloat(t.css("opacity")),
                            })
                        );
                    },
                    setTranslate: function (t, e) {
                        var n = "",
                            o = {};
                        if (t && e)
                            return (
                                (void 0 === e.left && void 0 === e.top) ||
                                    ((n =
                                        (void 0 === e.left ? t.position().left : e.left) +
                                        "px, " +
                                        (void 0 === e.top ? t.position().top : e.top) +
                                        "px"),
                                    (n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")")),
                                void 0 !== e.scaleX && void 0 !== e.scaleY
                                    ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                                    : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
                                n.length && (o.transform = n),
                                void 0 !== e.opacity && (o.opacity = e.opacity),
                                void 0 !== e.width && (o.width = e.width),
                                void 0 !== e.height && (o.height = e.height),
                                t.css(o)
                            );
                    },
                    animate: function (t, e, o, i, a) {
                        var s,
                            r = this;
                        n.isFunction(o) && ((i = o), (o = null)),
                            r.stop(t),
                            (s = r.getTranslate(t)),
                            t.on(f, function (c) {
                                (!c ||
                                    !c.originalEvent ||
                                    (t.is(c.originalEvent.target) && "z-index" != c.originalEvent.propertyName)) &&
                                    (r.stop(t),
                                    n.isNumeric(o) && t.css("transition-duration", ""),
                                    n.isPlainObject(e)
                                        ? void 0 !== e.scaleX &&
                                          void 0 !== e.scaleY &&
                                          r.setTranslate(t, {
                                              top: e.top,
                                              left: e.left,
                                              width: s.width * e.scaleX,
                                              height: s.height * e.scaleY,
                                              scaleX: 1,
                                              scaleY: 1,
                                          })
                                        : !0 !== a && t.removeClass(e),
                                    n.isFunction(i) && i(c));
                            }),
                            n.isNumeric(o) && t.css("transition-duration", o + "ms"),
                            n.isPlainObject(e)
                                ? (void 0 !== e.scaleX &&
                                      void 0 !== e.scaleY &&
                                      (delete e.width,
                                      delete e.height,
                                      t.parent().hasClass("fancybox-slide--image") &&
                                          t.parent().addClass("fancybox-is-scaling")),
                                  n.fancybox.setTranslate(t, e))
                                : t.addClass(e),
                            t.data(
                                "timer",
                                setTimeout(function () {
                                    t.trigger(f);
                                }, o + 33)
                            );
                    },
                    stop: function (t, e) {
                        t &&
                            t.length &&
                            (clearTimeout(t.data("timer")),
                            e && t.trigger(f),
                            t.off(f).css("transition-duration", ""),
                            t.parent().removeClass("fancybox-is-scaling"));
                    },
                }),
                (n.fn.fancybox = function (t) {
                    var e;
                    return (
                        (t = t || {}),
                        (e = t.selector || !1),
                        e
                            ? n("body").off("click.fb-start", e).on("click.fb-start", e, { options: t }, i)
                            : this.off("click.fb-start").on("click.fb-start", { items: this, options: t }, i),
                        this
                    );
                }),
                r.on("click.fb-start", "[data-fancybox]", i),
                r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
                    n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
                        .eq(n(this).attr("data-fancybox-index") || 0)
                        .trigger("click.fb-start", { $trigger: n(this) });
                }),
                (function () {
                    var t = null;
                    r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
                        switch (e.type) {
                            case "mousedown":
                                t = n(this);
                                break;
                            case "mouseup":
                                t = null;
                                break;
                            case "focusin":
                                n(".fancybox-button").removeClass("fancybox-focus"),
                                    n(this).is(t) || n(this).is("[disabled]") || n(this).addClass("fancybox-focus");
                                break;
                            case "focusout":
                                n(".fancybox-button").removeClass("fancybox-focus");
                        }
                    });
                })();
        }
    })(window, document, jQuery),
    (function (t) {
        "use strict";
        var e = {
                youtube: {
                    matcher:
                        /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                    params: {
                        autoplay: 1,
                        autohide: 1,
                        fs: 1,
                        rel: 0,
                        hd: 1,
                        wmode: "transparent",
                        enablejsapi: 1,
                        html5: 1,
                    },
                    paramPlace: 8,
                    type: "iframe",
                    url: "https://www.youtube-nocookie.com/embed/$4",
                    thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
                },
                vimeo: {
                    matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
                    params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1 },
                    paramPlace: 3,
                    type: "iframe",
                    url: "//player.vimeo.com/video/$2",
                },
                instagram: {
                    matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
                    type: "image",
                    url: "//$1/p/$2/media/?size=l",
                },
                gmap_place: {
                    matcher:
                        /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                    type: "iframe",
                    url: function (t) {
                        return (
                            "//maps.google." +
                            t[2] +
                            "/?ll=" +
                            (t[9]
                                ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "")
                                : t[12] + ""
                            ).replace(/\?/, "&") +
                            "&output=" +
                            (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
                        );
                    },
                },
                gmap_search: {
                    matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                    type: "iframe",
                    url: function (t) {
                        return (
                            "//maps.google." +
                            t[2] +
                            "/maps?q=" +
                            t[5].replace("query=", "q=").replace("api=1", "") +
                            "&output=embed"
                        );
                    },
                },
            },
            n = function (e, n, o) {
                if (e)
                    return (
                        (o = o || ""),
                        "object" === t.type(o) && (o = t.param(o, !0)),
                        t.each(n, function (t, n) {
                            e = e.replace("$" + t, n || "");
                        }),
                        o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
                        e
                    );
            };
        t(document).on("objectNeedsType.fb", function (o, i, a) {
            var s,
                r,
                c,
                l,
                d,
                u,
                f,
                p = a.src || "",
                h = !1;
            (s = t.extend(!0, {}, e, a.opts.media)),
                t.each(s, function (e, o) {
                    if ((c = p.match(o.matcher))) {
                        if (((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])) {
                            (d = c[o.paramPlace]), "?" == d[0] && (d = d.substring(1)), (d = d.split("&"));
                            for (var i = 0; i < d.length; ++i) {
                                var s = d[i].split("=", 2);
                                2 == s.length && (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
                            }
                        }
                        return (
                            (l = t.extend(!0, {}, o.params, a.opts[e], u)),
                            (p = "function" === t.type(o.url) ? o.url.call(this, c, l, a) : n(o.url, c, l)),
                            (r = "function" === t.type(o.thumb) ? o.thumb.call(this, c, l, a) : n(o.thumb, c)),
                            "youtube" === e
                                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                                      return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10));
                                  }))
                                : "vimeo" === e && (p = p.replace("&%23", "#")),
                            !1
                        );
                    }
                }),
                h
                    ? (a.opts.thumb || (a.opts.$thumb && a.opts.$thumb.length) || (a.opts.thumb = r),
                      "iframe" === h &&
                          (a.opts = t.extend(!0, a.opts, { iframe: { preload: !1, attr: { scrolling: "no" } } })),
                      t.extend(a, {
                          type: h,
                          src: p,
                          origSrc: a.src,
                          contentSource: f,
                          contentType:
                              "image" === h ? "image" : "gmap_place" == f || "gmap_search" == f ? "map" : "video",
                      }))
                    : p && (a.type = a.opts.defaultType);
        });
        var o = {
            youtube: { src: "https://www.youtube.com/iframe_api", class: "YT", loading: !1, loaded: !1 },
            vimeo: { src: "https://player.vimeo.com/api/player.js", class: "Vimeo", loading: !1, loaded: !1 },
            load: function (t) {
                var e,
                    n = this;
                if (this[t].loaded)
                    return void setTimeout(function () {
                        n.done(t);
                    });
                this[t].loading ||
                    ((this[t].loading = !0),
                    (e = document.createElement("script")),
                    (e.type = "text/javascript"),
                    (e.src = this[t].src),
                    "youtube" === t
                        ? (window.onYouTubeIframeAPIReady = function () {
                              (n[t].loaded = !0), n.done(t);
                          })
                        : (e.onload = function () {
                              (n[t].loaded = !0), n.done(t);
                          }),
                    document.body.appendChild(e));
            },
            done: function (e) {
                var n, o, i;
                "youtube" === e && delete window.onYouTubeIframeAPIReady,
                    (n = t.fancybox.getInstance()) &&
                        ((o = n.current.$content.find("iframe")),
                        "youtube" === e && void 0 !== YT && YT
                            ? (i = new YT.Player(o.attr("id"), {
                                  events: {
                                      onStateChange: function (t) {
                                          0 == t.data && n.next();
                                      },
                                  },
                              }))
                            : "vimeo" === e &&
                              void 0 !== Vimeo &&
                              Vimeo &&
                              ((i = new Vimeo.Player(o)),
                              i.on("ended", function () {
                                  n.next();
                              })));
            },
        };
        t(document).on({
            "afterShow.fb": function (t, e, n) {
                e.group.length > 1 &&
                    ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
                    o.load(n.contentSource);
            },
        });
    })(jQuery),
    (function (t, e, n) {
        "use strict";
        var o = (function () {
                return (
                    t.requestAnimationFrame ||
                    t.webkitRequestAnimationFrame ||
                    t.mozRequestAnimationFrame ||
                    t.oRequestAnimationFrame ||
                    function (e) {
                        return t.setTimeout(e, 1e3 / 60);
                    }
                );
            })(),
            i = (function () {
                return (
                    t.cancelAnimationFrame ||
                    t.webkitCancelAnimationFrame ||
                    t.mozCancelAnimationFrame ||
                    t.oCancelAnimationFrame ||
                    function (e) {
                        t.clearTimeout(e);
                    }
                );
            })(),
            a = function (e) {
                var n = [];
                (e = e.originalEvent || e || t.e),
                    (e =
                        e.touches && e.touches.length
                            ? e.touches
                            : e.changedTouches && e.changedTouches.length
                              ? e.changedTouches
                              : [e]);
                for (var o in e)
                    e[o].pageX
                        ? n.push({ x: e[o].pageX, y: e[o].pageY })
                        : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
                return n;
            },
            s = function (t, e, n) {
                return e && t
                    ? "x" === n
                        ? t.x - e.x
                        : "y" === n
                          ? t.y - e.y
                          : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
                    : 0;
            },
            r = function (t) {
                if (
                    t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') ||
                    n.isFunction(t.get(0).onclick) ||
                    t.data("selectable")
                )
                    return !0;
                for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++)
                    if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
                return !1;
            },
            c = function (e) {
                var n = t.getComputedStyle(e)["overflow-y"],
                    o = t.getComputedStyle(e)["overflow-x"],
                    i = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
                    a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
                return i || a;
            },
            l = function (t) {
                for (var e = !1; ; ) {
                    if ((e = c(t.get(0)))) break;
                    if (((t = t.parent()), !t.length || t.hasClass("fancybox-stage") || t.is("body"))) break;
                }
                return e;
            },
            d = function (t) {
                var e = this;
                (e.instance = t),
                    (e.$bg = t.$refs.bg),
                    (e.$stage = t.$refs.stage),
                    (e.$container = t.$refs.container),
                    e.destroy(),
                    e.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(e, "ontouchstart"));
            };
        (d.prototype.destroy = function () {
            var t = this;
            t.$container.off(".fb.touch"),
                n(e).off(".fb.touch"),
                t.requestId && (i(t.requestId), (t.requestId = null)),
                t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
        }),
            (d.prototype.ontouchstart = function (o) {
                var i = this,
                    c = n(o.target),
                    d = i.instance,
                    u = d.current,
                    f = u.$slide,
                    p = u.$content,
                    h = "touchstart" == o.type;
                if (
                    (h && i.$container.off("mousedown.fb.touch"),
                    (!o.originalEvent || 2 != o.originalEvent.button) &&
                        f.length &&
                        c.length &&
                        !r(c) &&
                        !r(c.parent()) &&
                        (c.is("img") || !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
                ) {
                    if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
                        return o.stopPropagation(), void o.preventDefault();
                    (i.realPoints = i.startPoints = a(o)),
                        i.startPoints.length &&
                            (u.touch && o.stopPropagation(),
                            (i.startEvent = o),
                            (i.canTap = !0),
                            (i.$target = c),
                            (i.$content = p),
                            (i.opts = u.opts.touch),
                            (i.isPanning = !1),
                            (i.isSwiping = !1),
                            (i.isZooming = !1),
                            (i.isScrolling = !1),
                            (i.canPan = d.canPan()),
                            (i.startTime = new Date().getTime()),
                            (i.distanceX = i.distanceY = i.distance = 0),
                            (i.canvasWidth = Math.round(f[0].clientWidth)),
                            (i.canvasHeight = Math.round(f[0].clientHeight)),
                            (i.contentLastPos = null),
                            (i.contentStartPos = n.fancybox.getTranslate(i.$content) || { top: 0, left: 0 }),
                            (i.sliderStartPos = n.fancybox.getTranslate(f)),
                            (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
                            (i.sliderStartPos.top -= i.stagePos.top),
                            (i.sliderStartPos.left -= i.stagePos.left),
                            (i.contentStartPos.top -= i.stagePos.top),
                            (i.contentStartPos.left -= i.stagePos.left),
                            n(e)
                                .off(".fb.touch")
                                .on(
                                    h
                                        ? "touchend.fb.touch touchcancel.fb.touch"
                                        : "mouseup.fb.touch mouseleave.fb.touch",
                                    n.proxy(i, "ontouchend")
                                )
                                .on(h ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(i, "ontouchmove")),
                            n.fancybox.isMobile && e.addEventListener("scroll", i.onscroll, !0),
                            (((i.opts || i.canPan) && (c.is(i.$stage) || i.$stage.find(c).length)) ||
                                (c.is(".fancybox-image") && o.preventDefault(),
                                n.fancybox.isMobile && c.parents(".fancybox-caption").length)) &&
                                ((i.isScrollable = l(c) || l(c.parent())),
                                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                                (1 === i.startPoints.length || u.hasError) &&
                                    (i.canPan ? (n.fancybox.stop(i.$content), (i.isPanning = !0)) : (i.isSwiping = !0),
                                    i.$container.addClass("fancybox-is-grabbing")),
                                2 === i.startPoints.length &&
                                    "image" === u.type &&
                                    (u.isLoaded || u.$ghost) &&
                                    ((i.canTap = !1),
                                    (i.isSwiping = !1),
                                    (i.isPanning = !1),
                                    (i.isZooming = !0),
                                    n.fancybox.stop(i.$content),
                                    (i.centerPointStartX =
                                        0.5 * (i.startPoints[0].x + i.startPoints[1].x) - n(t).scrollLeft()),
                                    (i.centerPointStartY =
                                        0.5 * (i.startPoints[0].y + i.startPoints[1].y) - n(t).scrollTop()),
                                    (i.percentageOfImageAtPinchPointX =
                                        (i.centerPointStartX - i.contentStartPos.left) / i.contentStartPos.width),
                                    (i.percentageOfImageAtPinchPointY =
                                        (i.centerPointStartY - i.contentStartPos.top) / i.contentStartPos.height),
                                    (i.startDistanceBetweenFingers = s(i.startPoints[0], i.startPoints[1])))));
                }
            }),
            (d.prototype.onscroll = function (t) {
                var n = this;
                (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
            }),
            (d.prototype.ontouchmove = function (t) {
                var e = this;
                return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons
                    ? void e.ontouchend(t)
                    : e.isScrolling
                      ? void (e.canTap = !1)
                      : ((e.newPoints = a(t)),
                        void (
                            (e.opts || e.canPan) &&
                            e.newPoints.length &&
                            e.newPoints.length &&
                            ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
                            (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
                            (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
                            (e.distance = s(e.newPoints[0], e.startPoints[0])),
                            e.distance > 0 &&
                                (e.isSwiping ? e.onSwipe(t) : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()))
                        ));
            }),
            (d.prototype.onSwipe = function (e) {
                var a,
                    s = this,
                    r = s.instance,
                    c = s.isSwiping,
                    l = s.sliderStartPos.left || 0;
                if (!0 !== c)
                    "x" == c &&
                        (s.distanceX > 0 &&
                        (s.instance.group.length < 2 ||
                            (0 === s.instance.current.index && !s.instance.current.opts.loop))
                            ? (l += Math.pow(s.distanceX, 0.8))
                            : s.distanceX < 0 &&
                                (s.instance.group.length < 2 ||
                                    (s.instance.current.index === s.instance.group.length - 1 &&
                                        !s.instance.current.opts.loop))
                              ? (l -= Math.pow(-s.distanceX, 0.8))
                              : (l += s.distanceX)),
                        (s.sliderLastPos = { top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY, left: l }),
                        s.requestId && (i(s.requestId), (s.requestId = null)),
                        (s.requestId = o(function () {
                            s.sliderLastPos &&
                                (n.each(s.instance.slides, function (t, e) {
                                    var o = e.pos - s.instance.currPos;
                                    n.fancybox.setTranslate(e.$slide, {
                                        top: s.sliderLastPos.top,
                                        left: s.sliderLastPos.left + o * s.canvasWidth + o * e.opts.gutter,
                                    });
                                }),
                                s.$container.addClass("fancybox-is-sliding"));
                        }));
                else if (Math.abs(s.distance) > 10) {
                    if (
                        ((s.canTap = !1),
                        r.group.length < 2 && s.opts.vertical
                            ? (s.isSwiping = "y")
                            : r.isDragging ||
                                !1 === s.opts.vertical ||
                                ("auto" === s.opts.vertical && n(t).width() > 800)
                              ? (s.isSwiping = "x")
                              : ((a = Math.abs((180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI)),
                                (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
                        "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
                    )
                        return void (s.isScrolling = !0);
                    (r.isDragging = s.isSwiping),
                        (s.startPoints = s.newPoints),
                        n.each(r.slides, function (t, e) {
                            var o, i;
                            n.fancybox.stop(e.$slide),
                                (o = n.fancybox.getTranslate(e.$slide)),
                                (i = n.fancybox.getTranslate(r.$refs.stage)),
                                e.$slide
                                    .css({ transform: "", opacity: "", "transition-duration": "" })
                                    .removeClass("fancybox-animated")
                                    .removeClass(function (t, e) {
                                        return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                    }),
                                e.pos === r.current.pos &&
                                    ((s.sliderStartPos.top = o.top - i.top), (s.sliderStartPos.left = o.left - i.left)),
                                n.fancybox.setTranslate(e.$slide, { top: o.top - i.top, left: o.left - i.left });
                        }),
                        r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
                }
            }),
            (d.prototype.onPan = function () {
                var t = this;
                if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
                    return void (t.startPoints = t.newPoints);
                (t.canTap = !1),
                    (t.contentLastPos = t.limitMovement()),
                    t.requestId && i(t.requestId),
                    (t.requestId = o(function () {
                        n.fancybox.setTranslate(t.$content, t.contentLastPos);
                    }));
            }),
            (d.prototype.limitMovement = function () {
                var t,
                    e,
                    n,
                    o,
                    i,
                    a,
                    s = this,
                    r = s.canvasWidth,
                    c = s.canvasHeight,
                    l = s.distanceX,
                    d = s.distanceY,
                    u = s.contentStartPos,
                    f = u.left,
                    p = u.top,
                    h = u.width,
                    g = u.height;
                return (
                    (i = h > r ? f + l : f),
                    (a = p + d),
                    (t = Math.max(0, 0.5 * r - 0.5 * h)),
                    (e = Math.max(0, 0.5 * c - 0.5 * g)),
                    (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
                    (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
                    l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
                    l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
                    d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
                    d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
                    { top: a, left: i }
                );
            }),
            (d.prototype.limitPosition = function (t, e, n, o) {
                var i = this,
                    a = i.canvasWidth,
                    s = i.canvasHeight;
                return (
                    n > a ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t)) : (t = Math.max(0, a / 2 - n / 2)),
                    o > s ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e)) : (e = Math.max(0, s / 2 - o / 2)),
                    { top: e, left: t }
                );
            }),
            (d.prototype.onZoom = function () {
                var e = this,
                    a = e.contentStartPos,
                    r = a.width,
                    c = a.height,
                    l = a.left,
                    d = a.top,
                    u = s(e.newPoints[0], e.newPoints[1]),
                    f = u / e.startDistanceBetweenFingers,
                    p = Math.floor(r * f),
                    h = Math.floor(c * f),
                    g = (r - p) * e.percentageOfImageAtPinchPointX,
                    b = (c - h) * e.percentageOfImageAtPinchPointY,
                    m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
                    v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
                    y = m - e.centerPointStartX,
                    x = v - e.centerPointStartY,
                    w = l + (g + y),
                    $ = d + (b + x),
                    S = { top: $, left: w, scaleX: f, scaleY: f };
                (e.canTap = !1),
                    (e.newWidth = p),
                    (e.newHeight = h),
                    (e.contentLastPos = S),
                    e.requestId && i(e.requestId),
                    (e.requestId = o(function () {
                        n.fancybox.setTranslate(e.$content, e.contentLastPos);
                    }));
            }),
            (d.prototype.ontouchend = function (t) {
                var o = this,
                    s = o.isSwiping,
                    r = o.isPanning,
                    c = o.isZooming,
                    l = o.isScrolling;
                if (
                    ((o.endPoints = a(t)),
                    (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
                    o.$container.removeClass("fancybox-is-grabbing"),
                    n(e).off(".fb.touch"),
                    e.removeEventListener("scroll", o.onscroll, !0),
                    o.requestId && (i(o.requestId), (o.requestId = null)),
                    (o.isSwiping = !1),
                    (o.isPanning = !1),
                    (o.isZooming = !1),
                    (o.isScrolling = !1),
                    (o.instance.isDragging = !1),
                    o.canTap)
                )
                    return o.onTap(t);
                (o.speed = 100),
                    (o.velocityX = (o.distanceX / o.dMs) * 0.5),
                    (o.velocityY = (o.distanceY / o.dMs) * 0.5),
                    r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
            }),
            (d.prototype.endSwiping = function (t, e) {
                var o = this,
                    i = !1,
                    a = o.instance.group.length,
                    s = Math.abs(o.distanceX),
                    r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
                (o.sliderLastPos = null),
                    "y" == t && !e && Math.abs(o.distanceY) > 50
                        ? (n.fancybox.animate(
                              o.instance.current.$slide,
                              { top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY, opacity: 0 },
                              200
                          ),
                          (i = o.instance.close(!0, 250)))
                        : r && o.distanceX > 0
                          ? (i = o.instance.previous(300))
                          : r && o.distanceX < 0 && (i = o.instance.next(300)),
                    !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
                    o.$container.removeClass("fancybox-is-sliding");
            }),
            (d.prototype.endPanning = function () {
                var t,
                    e,
                    o,
                    i = this;
                i.contentLastPos &&
                    (!1 === i.opts.momentum || i.dMs > 350
                        ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top))
                        : ((t = i.contentLastPos.left + 500 * i.velocityX),
                          (e = i.contentLastPos.top + 500 * i.velocityY)),
                    (o = i.limitPosition(t, e, i.contentStartPos.width, i.contentStartPos.height)),
                    (o.width = i.contentStartPos.width),
                    (o.height = i.contentStartPos.height),
                    n.fancybox.animate(i.$content, o, 366));
            }),
            (d.prototype.endZooming = function () {
                var t,
                    e,
                    o,
                    i,
                    a = this,
                    s = a.instance.current,
                    r = a.newWidth,
                    c = a.newHeight;
                a.contentLastPos &&
                    ((t = a.contentLastPos.left),
                    (e = a.contentLastPos.top),
                    (i = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
                    n.fancybox.setTranslate(a.$content, i),
                    r < a.canvasWidth && c < a.canvasHeight
                        ? a.instance.scaleToFit(150)
                        : r > s.width || c > s.height
                          ? a.instance.scaleToActual(a.centerPointStartX, a.centerPointStartY, 150)
                          : ((o = a.limitPosition(t, e, r, c)), n.fancybox.animate(a.$content, o, 150)));
            }),
            (d.prototype.onTap = function (e) {
                var o,
                    i = this,
                    s = n(e.target),
                    r = i.instance,
                    c = r.current,
                    l = (e && a(e)) || i.startPoints,
                    d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
                    u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
                    f = function (t) {
                        var o = c.opts[t];
                        if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
                            switch (o) {
                                case "close":
                                    r.close(i.startEvent);
                                    break;
                                case "toggleControls":
                                    r.toggleControls();
                                    break;
                                case "next":
                                    r.next();
                                    break;
                                case "nextOrClose":
                                    r.group.length > 1 ? r.next() : r.close(i.startEvent);
                                    break;
                                case "zoom":
                                    "image" == c.type &&
                                        (c.isLoaded || c.$ghost) &&
                                        (r.canPan()
                                            ? r.scaleToFit()
                                            : r.isScaledDown()
                                              ? r.scaleToActual(d, u)
                                              : r.group.length < 2 && r.close(i.startEvent));
                            }
                    };
                if (
                    (!e.originalEvent || 2 != e.originalEvent.button) &&
                    (s.is("img") || !(d > s[0].clientWidth + s.offset().left))
                ) {
                    if (s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) o = "Outside";
                    else if (s.is(".fancybox-slide")) o = "Slide";
                    else {
                        if (!r.current.$content || !r.current.$content.find(s).addBack().filter(s).length) return;
                        o = "Content";
                    }
                    if (i.tapped) {
                        if (
                            (clearTimeout(i.tapped),
                            (i.tapped = null),
                            Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
                        )
                            return this;
                        f("dblclick" + o);
                    } else
                        (i.tapX = d),
                            (i.tapY = u),
                            c.opts["dblclick" + o] && c.opts["dblclick" + o] !== c.opts["click" + o]
                                ? (i.tapped = setTimeout(function () {
                                      (i.tapped = null), r.isAnimating || f("click" + o);
                                  }, 500))
                                : f("click" + o);
                    return this;
                }
            }),
            n(e)
                .on("onActivate.fb", function (t, e) {
                    e && !e.Guestures && (e.Guestures = new d(e));
                })
                .on("beforeClose.fb", function (t, e) {
                    e && e.Guestures && e.Guestures.destroy();
                });
    })(window, document, jQuery),
    (function (t, e) {
        "use strict";
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                slideShow:
                    '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
            },
            slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
        });
        var n = function (t) {
            (this.instance = t), this.init();
        };
        e.extend(n.prototype, {
            timer: null,
            isActive: !1,
            $button: null,
            init: function () {
                var t = this,
                    n = t.instance,
                    o = n.group[n.currIndex].opts.slideShow;
                (t.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function () {
                    t.toggle();
                })),
                    n.group.length < 2 || !o
                        ? t.$button.hide()
                        : o.progress &&
                          (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner));
            },
            set: function (t) {
                var n = this,
                    o = n.instance,
                    i = o.current;
                i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
                    ? n.isActive &&
                      "video" !== i.contentType &&
                      (n.$progress && e.fancybox.animate(n.$progress.show(), { scaleX: 1 }, i.opts.slideShow.speed),
                      (n.timer = setTimeout(function () {
                          o.current.opts.loop || o.current.index != o.group.length - 1 ? o.next() : o.jumpTo(0);
                      }, i.opts.slideShow.speed)))
                    : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
            },
            clear: function () {
                var t = this;
                clearTimeout(t.timer), (t.timer = null), t.$progress && t.$progress.removeAttr("style").hide();
            },
            start: function () {
                var t = this,
                    e = t.instance.current;
                e &&
                    (t.$button
                        .attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP)
                        .removeClass("fancybox-button--play")
                        .addClass("fancybox-button--pause"),
                    (t.isActive = !0),
                    e.isComplete && t.set(!0),
                    t.instance.trigger("onSlideShowChange", !0));
            },
            stop: function () {
                var t = this,
                    e = t.instance.current;
                t.clear(),
                    t.$button
                        .attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START)
                        .removeClass("fancybox-button--pause")
                        .addClass("fancybox-button--play"),
                    (t.isActive = !1),
                    t.instance.trigger("onSlideShowChange", !1),
                    t.$progress && t.$progress.removeAttr("style").hide();
            },
            toggle: function () {
                var t = this;
                t.isActive ? t.stop() : t.start();
            },
        }),
            e(t).on({
                "onInit.fb": function (t, e) {
                    e && !e.SlideShow && (e.SlideShow = new n(e));
                },
                "beforeShow.fb": function (t, e, n, o) {
                    var i = e && e.SlideShow;
                    o ? i && n.opts.slideShow.autoStart && i.start() : i && i.isActive && i.clear();
                },
                "afterShow.fb": function (t, e, n) {
                    var o = e && e.SlideShow;
                    o && o.isActive && o.set();
                },
                "afterKeydown.fb": function (n, o, i, a, s) {
                    var r = o && o.SlideShow;
                    !r ||
                        !i.opts.slideShow ||
                        (80 !== s && 32 !== s) ||
                        e(t.activeElement).is("button,a,input") ||
                        (a.preventDefault(), r.toggle());
                },
                "beforeClose.fb onDeactivate.fb": function (t, e) {
                    var n = e && e.SlideShow;
                    n && n.stop();
                },
            }),
            e(t).on("visibilitychange", function () {
                var n = e.fancybox.getInstance(),
                    o = n && n.SlideShow;
                o && o.isActive && (t.hidden ? o.clear() : o.set());
            });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        var n = (function () {
            for (
                var e = [
                        [
                            "requestFullscreen",
                            "exitFullscreen",
                            "fullscreenElement",
                            "fullscreenEnabled",
                            "fullscreenchange",
                            "fullscreenerror",
                        ],
                        [
                            "webkitRequestFullscreen",
                            "webkitExitFullscreen",
                            "webkitFullscreenElement",
                            "webkitFullscreenEnabled",
                            "webkitfullscreenchange",
                            "webkitfullscreenerror",
                        ],
                        [
                            "webkitRequestFullScreen",
                            "webkitCancelFullScreen",
                            "webkitCurrentFullScreenElement",
                            "webkitCancelFullScreen",
                            "webkitfullscreenchange",
                            "webkitfullscreenerror",
                        ],
                        [
                            "mozRequestFullScreen",
                            "mozCancelFullScreen",
                            "mozFullScreenElement",
                            "mozFullScreenEnabled",
                            "mozfullscreenchange",
                            "mozfullscreenerror",
                        ],
                        [
                            "msRequestFullscreen",
                            "msExitFullscreen",
                            "msFullscreenElement",
                            "msFullscreenEnabled",
                            "MSFullscreenChange",
                            "MSFullscreenError",
                        ],
                    ],
                    n = {},
                    o = 0;
                o < e.length;
                o++
            ) {
                var i = e[o];
                if (i && i[1] in t) {
                    for (var a = 0; a < i.length; a++) n[e[0][a]] = i[a];
                    return n;
                }
            }
            return !1;
        })();
        if (n) {
            var o = {
                request: function (e) {
                    (e = e || t.documentElement), e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
                },
                exit: function () {
                    t[n.exitFullscreen]();
                },
                toggle: function (e) {
                    (e = e || t.documentElement), this.isFullscreen() ? this.exit() : this.request(e);
                },
                isFullscreen: function () {
                    return Boolean(t[n.fullscreenElement]);
                },
                enabled: function () {
                    return Boolean(t[n.fullscreenEnabled]);
                },
            };
            e.extend(!0, e.fancybox.defaults, {
                btnTpl: {
                    fullScreen:
                        '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
                },
                fullScreen: { autoStart: !1 },
            }),
                e(t).on(n.fullscreenchange, function () {
                    var t = o.isFullscreen(),
                        n = e.fancybox.getInstance();
                    n &&
                        (n.current &&
                            "image" === n.current.type &&
                            n.isAnimating &&
                            ((n.isAnimating = !1), n.update(!0, !0, 0), n.isComplete || n.complete()),
                        n.trigger("onFullscreenChange", t),
                        n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
                        n.$refs.toolbar
                            .find("[data-fancybox-fullscreen]")
                            .toggleClass("fancybox-button--fsenter", !t)
                            .toggleClass("fancybox-button--fsexit", t));
                });
        }
        e(t).on({
            "onInit.fb": function (t, e) {
                var i;
                if (!n) return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
                e && e.group[e.currIndex].opts.fullScreen
                    ? ((i = e.$refs.container),
                      i.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (t) {
                          t.stopPropagation(), t.preventDefault(), o.toggle();
                      }),
                      e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && o.request(),
                      (e.FullScreen = o))
                    : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
            },
            "afterKeydown.fb": function (t, e, n, o, i) {
                e && e.FullScreen && 70 === i && (o.preventDefault(), e.FullScreen.toggle());
            },
            "beforeClose.fb": function (t, e) {
                e && e.FullScreen && e.$refs.container.hasClass("fancybox-is-fullscreen") && o.exit();
            },
        });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        var n = "fancybox-thumbs";
        e.fancybox.defaults = e.extend(
            !0,
            {
                btnTpl: {
                    thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
                },
                thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
            },
            e.fancybox.defaults
        );
        var o = function (t) {
            this.init(t);
        };
        e.extend(o.prototype, {
            $button: null,
            $grid: null,
            $list: null,
            isVisible: !1,
            isActive: !1,
            init: function (t) {
                var e = this,
                    n = t.group,
                    o = 0;
                (e.instance = t),
                    (e.opts = n[t.currIndex].opts.thumbs),
                    (t.Thumbs = e),
                    (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));
                for (var i = 0, a = n.length; i < a && (n[i].thumb && o++, !(o > 1)); i++);
                o > 1 && e.opts
                    ? (e.$button.removeAttr("style").on("click", function () {
                          e.toggle();
                      }),
                      (e.isActive = !0))
                    : e.$button.hide();
            },
            create: function () {
                var t,
                    o = this,
                    i = o.instance,
                    a = o.opts.parentEl,
                    s = [];
                o.$grid ||
                    ((o.$grid = e('<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>').appendTo(
                        i.$refs.container.find(a).addBack().filter(a)
                    )),
                    o.$grid.on("click", "a", function () {
                        i.jumpTo(e(this).attr("data-index"));
                    })),
                    o.$list || (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
                    e.each(i.group, function (e, n) {
                        (t = n.thumb),
                            t || "image" !== n.type || (t = n.src),
                            s.push(
                                '<a href="javascript:;" tabindex="0" data-index="' +
                                    e +
                                    '"' +
                                    (t && t.length
                                        ? ' style="background-image:url(' + t + ')"'
                                        : 'class="fancybox-thumbs-missing"') +
                                    "></a>"
                            );
                    }),
                    (o.$list[0].innerHTML = s.join("")),
                    "x" === o.opts.axis &&
                        o.$list.width(
                            parseInt(o.$grid.css("padding-right"), 10) +
                                i.group.length * o.$list.children().eq(0).outerWidth(!0)
                        );
            },
            focus: function (t) {
                var e,
                    n,
                    o = this,
                    i = o.$list,
                    a = o.$grid;
                o.instance.current &&
                    ((e = i
                        .children()
                        .removeClass("fancybox-thumbs-active")
                        .filter('[data-index="' + o.instance.current.index + '"]')
                        .addClass("fancybox-thumbs-active")),
                    (n = e.position()),
                    "y" === o.opts.axis && (n.top < 0 || n.top > i.height() - e.outerHeight())
                        ? i.stop().animate({ scrollTop: i.scrollTop() + n.top }, t)
                        : "x" === o.opts.axis &&
                          (n.left < a.scrollLeft() || n.left > a.scrollLeft() + (a.width() - e.outerWidth())) &&
                          i.parent().stop().animate({ scrollLeft: n.left }, t));
            },
            update: function () {
                var t = this;
                t.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
                    t.isVisible
                        ? (t.$grid || t.create(), t.instance.trigger("onThumbsShow"), t.focus(0))
                        : t.$grid && t.instance.trigger("onThumbsHide"),
                    t.instance.update();
            },
            hide: function () {
                (this.isVisible = !1), this.update();
            },
            show: function () {
                (this.isVisible = !0), this.update();
            },
            toggle: function () {
                (this.isVisible = !this.isVisible), this.update();
            },
        }),
            e(t).on({
                "onInit.fb": function (t, e) {
                    var n;
                    e && !e.Thumbs && ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
                },
                "beforeShow.fb": function (t, e, n, o) {
                    var i = e && e.Thumbs;
                    i && i.isVisible && i.focus(o ? 0 : 250);
                },
                "afterKeydown.fb": function (t, e, n, o, i) {
                    var a = e && e.Thumbs;
                    a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
                },
                "beforeClose.fb": function (t, e) {
                    var n = e && e.Thumbs;
                    n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
                },
            });
    })(document, jQuery),
    (function (t, e) {
        "use strict";
        function n(t) {
            var e = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
                "/": "&#x2F;",
                "`": "&#x60;",
                "=": "&#x3D;",
            };
            return String(t).replace(/[&<>"'`=\/]/g, function (t) {
                return e[t];
            });
        }
        e.extend(!0, e.fancybox.defaults, {
            btnTpl: {
                share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
            },
            share: {
                url: function (t, e) {
                    return (
                        (!t.currentHash && "inline" !== e.type && "html" !== e.type && (e.origSrc || e.src)) ||
                        window.location
                    );
                },
                tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
            },
        }),
            e(t).on("click", "[data-fancybox-share]", function () {
                var t,
                    o,
                    i = e.fancybox.getInstance(),
                    a = i.current || null;
                a &&
                    ("function" === e.type(a.opts.share.url) && (t = a.opts.share.url.apply(a, [i, a])),
                    (o = a.opts.share.tpl
                        .replace(/\{\{media\}\}/g, "image" === a.type ? encodeURIComponent(a.src) : "")
                        .replace(/\{\{url\}\}/g, encodeURIComponent(t))
                        .replace(/\{\{url_raw\}\}/g, n(t))
                        .replace(/\{\{descr\}\}/g, i.$caption ? encodeURIComponent(i.$caption.text()) : "")),
                    e.fancybox.open({
                        src: i.translate(i, o),
                        type: "html",
                        opts: {
                            touch: !1,
                            animationEffect: !1,
                            afterLoad: function (t, e) {
                                i.$refs.container.one("beforeClose.fb", function () {
                                    t.close(null, 0);
                                }),
                                    e.$content.find(".fancybox-share__button").click(function () {
                                        return window.open(this.href, "Share", "width=550, height=450"), !1;
                                    });
                            },
                            mobile: { autoFocus: !1 },
                        },
                    }));
            });
    })(document, jQuery),
    (function (t, e, n) {
        "use strict";
        function o() {
            var e = t.location.hash.substr(1),
                n = e.split("-"),
                o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
                i = n.join("-");
            return { hash: e, index: o < 1 ? 1 : o, gallery: i };
        }
        function i(t) {
            "" !== t.gallery &&
                n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
                    .eq(t.index - 1)
                    .focus()
                    .trigger("click.fb-start");
        }
        function a(t) {
            var e, n;
            return (
                !!t &&
                ((e = t.current ? t.current.opts : t.opts),
                "" !== (n = e.hash || (e.$orig ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger") : "")) &&
                    n)
            );
        }
        n.escapeSelector ||
            (n.escapeSelector = function (t) {
                return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (t, e) {
                    return e
                        ? "\0" === t
                            ? "�"
                            : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " "
                        : "\\" + t;
                });
            }),
            n(function () {
                !1 !== n.fancybox.defaults.hash &&
                    (n(e).on({
                        "onInit.fb": function (t, e) {
                            var n, i;
                            !1 !== e.group[e.currIndex].opts.hash &&
                                ((n = o()), (i = a(e)) && n.gallery && i == n.gallery && (e.currIndex = n.index - 1));
                        },
                        "beforeShow.fb": function (n, o, i, s) {
                            var r;
                            i &&
                                !1 !== i.opts.hash &&
                                (r = a(o)) &&
                                ((o.currentHash = r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                                t.location.hash !== "#" + o.currentHash &&
                                    (s && !o.origHash && (o.origHash = t.location.hash),
                                    o.hashTimer && clearTimeout(o.hashTimer),
                                    (o.hashTimer = setTimeout(function () {
                                        "replaceState" in t.history
                                            ? (t.history[s ? "pushState" : "replaceState"](
                                                  {},
                                                  e.title,
                                                  t.location.pathname + t.location.search + "#" + o.currentHash
                                              ),
                                              s && (o.hasCreatedHistory = !0))
                                            : (t.location.hash = o.currentHash),
                                            (o.hashTimer = null);
                                    }, 300))));
                        },
                        "beforeClose.fb": function (n, o, i) {
                            i &&
                                !1 !== i.opts.hash &&
                                (clearTimeout(o.hashTimer),
                                o.currentHash && o.hasCreatedHistory
                                    ? t.history.back()
                                    : o.currentHash &&
                                      ("replaceState" in t.history
                                          ? t.history.replaceState(
                                                {},
                                                e.title,
                                                t.location.pathname + t.location.search + (o.origHash || "")
                                            )
                                          : (t.location.hash = o.origHash)),
                                (o.currentHash = null));
                        },
                    }),
                    n(t).on("hashchange.fb", function () {
                        var t = o(),
                            e = null;
                        n.each(n(".fancybox-container").get().reverse(), function (t, o) {
                            var i = n(o).data("FancyBox");
                            if (i && i.currentHash) return (e = i), !1;
                        }),
                            e
                                ? e.currentHash === t.gallery + "-" + t.index ||
                                  (1 === t.index && e.currentHash == t.gallery) ||
                                  ((e.currentHash = null), e.close())
                                : "" !== t.gallery && i(t);
                    }),
                    setTimeout(function () {
                        n.fancybox.getInstance() || i(o());
                    }, 50));
            });
    })(window, document, jQuery),
    (function (t, e) {
        "use strict";
        var n = new Date().getTime();
        e(t).on({
            "onInit.fb": function (t, e, o) {
                e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function (t) {
                    var o = e.current,
                        i = new Date().getTime();
                    e.group.length < 2 ||
                        !1 === o.opts.wheel ||
                        ("auto" === o.opts.wheel && "image" !== o.type) ||
                        (t.preventDefault(),
                        t.stopPropagation(),
                        o.$slide.hasClass("fancybox-animated") ||
                            ((t = t.originalEvent || t),
                            i - n < 250 ||
                                ((n = i),
                                e[(-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? "next" : "previous"]())));
                });
            },
        });
    })(document, jQuery) /*!

/*!
 * Bootstrap v4.0.0 (https://getbootstrap.com)
 * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */,
    !(function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? e(exports, require("jquery"), require("popper.js"))
            : "function" == typeof define && define.amd
              ? define(["exports", "jquery", "popper.js"], e)
              : e((t.bootstrap = {}), t.jQuery, t.Popper);
    })(this, function (t, e, n) {
        "use strict";
        function i(t, e) {
            for (var n = 0; n < e.length; n++) {
                var i = e[n];
                (i.enumerable = i.enumerable || !1),
                    (i.configurable = !0),
                    "value" in i && (i.writable = !0),
                    Object.defineProperty(t, i.key, i);
            }
        }
        function s(t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
        }
        function r() {
            return (r =
                Object.assign ||
                function (t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var n = arguments[e];
                        for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
                    }
                    return t;
                }).apply(this, arguments);
        }
        (e = e && e.hasOwnProperty("default") ? e.default : e), (n = n && n.hasOwnProperty("default") ? n.default : n);
        var o,
            a,
            l,
            h,
            c,
            u,
            f,
            d,
            _,
            g,
            p,
            m,
            v,
            E,
            T,
            y,
            C,
            I,
            A,
            b,
            D,
            S,
            w,
            N,
            O,
            k,
            P = (function (t) {
                var e = !1;
                function n(e) {
                    var n = this,
                        s = !1;
                    return (
                        t(this).one(i.TRANSITION_END, function () {
                            s = !0;
                        }),
                        setTimeout(function () {
                            s || i.triggerTransitionEnd(n);
                        }, e),
                        this
                    );
                }
                var i = {
                    TRANSITION_END: "bsTransitionEnd",
                    getUID: function (t) {
                        do {
                            t += ~~(1e6 * Math.random());
                        } while (document.getElementById(t));
                        return t;
                    },
                    getSelectorFromElement: function (e) {
                        var n,
                            i = e.getAttribute("data-target");
                        (i && "#" !== i) || (i = e.getAttribute("href") || ""),
                            "#" === i.charAt(0) &&
                                ((n = i),
                                (i = n =
                                    "function" == typeof t.escapeSelector
                                        ? t.escapeSelector(n).substr(1)
                                        : n.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1")));
                        try {
                            return t(document).find(i).length > 0 ? i : null;
                        } catch (t) {
                            return null;
                        }
                    },
                    reflow: function (t) {
                        return t.offsetHeight;
                    },
                    triggerTransitionEnd: function (n) {
                        t(n).trigger(e.end);
                    },
                    supportsTransitionEnd: function () {
                        return Boolean(e);
                    },
                    isElement: function (t) {
                        return (t[0] || t).nodeType;
                    },
                    typeCheckConfig: function (t, e, n) {
                        for (var s in n)
                            if (Object.prototype.hasOwnProperty.call(n, s)) {
                                var r = n[s],
                                    o = e[s],
                                    a =
                                        o && i.isElement(o)
                                            ? "element"
                                            : ((l = o),
                                              {}.toString
                                                  .call(l)
                                                  .match(/\s([a-zA-Z]+)/)[1]
                                                  .toLowerCase());
                                if (!new RegExp(r).test(a))
                                    throw new Error(
                                        t.toUpperCase() +
                                            ': Option "' +
                                            s +
                                            '" provided type "' +
                                            a +
                                            '" but expected type "' +
                                            r +
                                            '".'
                                    );
                            }
                        var l;
                    },
                };
                return (
                    (e = ("undefined" == typeof window || !window.QUnit) && { end: "transitionend" }),
                    (t.fn.emulateTransitionEnd = n),
                    i.supportsTransitionEnd() &&
                        (t.event.special[i.TRANSITION_END] = {
                            bindType: e.end,
                            delegateType: e.end,
                            handle: function (e) {
                                if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
                            },
                        }),
                    i
                );
            })(e),
            L =
                ((a = "alert"),
                (h = "." + (l = "bs.alert")),
                (c = (o = e).fn[a]),
                (u = { CLOSE: "close" + h, CLOSED: "closed" + h, CLICK_DATA_API: "click" + h + ".data-api" }),
                (f = "alert"),
                (d = "fade"),
                (_ = "show"),
                (g = (function () {
                    function t(t) {
                        this._element = t;
                    }
                    var e = t.prototype;
                    return (
                        (e.close = function (t) {
                            t = t || this._element;
                            var e = this._getRootElement(t);
                            this._triggerCloseEvent(e).isDefaultPrevented() || this._removeElement(e);
                        }),
                        (e.dispose = function () {
                            o.removeData(this._element, l), (this._element = null);
                        }),
                        (e._getRootElement = function (t) {
                            var e = P.getSelectorFromElement(t),
                                n = !1;
                            return e && (n = o(e)[0]), n || (n = o(t).closest("." + f)[0]), n;
                        }),
                        (e._triggerCloseEvent = function (t) {
                            var e = o.Event(u.CLOSE);
                            return o(t).trigger(e), e;
                        }),
                        (e._removeElement = function (t) {
                            var e = this;
                            o(t).removeClass(_),
                                P.supportsTransitionEnd() && o(t).hasClass(d)
                                    ? o(t)
                                          .one(P.TRANSITION_END, function (n) {
                                              return e._destroyElement(t, n);
                                          })
                                          .emulateTransitionEnd(150)
                                    : this._destroyElement(t);
                        }),
                        (e._destroyElement = function (t) {
                            o(t).detach().trigger(u.CLOSED).remove();
                        }),
                        (t._jQueryInterface = function (e) {
                            return this.each(function () {
                                var n = o(this),
                                    i = n.data(l);
                                i || ((i = new t(this)), n.data(l, i)), "close" === e && i[e](this);
                            });
                        }),
                        (t._handleDismiss = function (t) {
                            return function (e) {
                                e && e.preventDefault(), t.close(this);
                            };
                        }),
                        s(t, null, [
                            {
                                key: "VERSION",
                                get: function () {
                                    return "4.0.0";
                                },
                            },
                        ]),
                        t
                    );
                })()),
                o(document).on(u.CLICK_DATA_API, '[data-dismiss="alert"]', g._handleDismiss(new g())),
                (o.fn[a] = g._jQueryInterface),
                (o.fn[a].Constructor = g),
                (o.fn[a].noConflict = function () {
                    return (o.fn[a] = c), g._jQueryInterface;
                }),
                g),
            R =
                ((m = "button"),
                (E = "." + (v = "bs.button")),
                (T = ".data-api"),
                (y = (p = e).fn[m]),
                (C = "active"),
                (I = "btn"),
                (A = "focus"),
                (b = '[data-toggle^="button"]'),
                (D = '[data-toggle="buttons"]'),
                (S = "input"),
                (w = ".active"),
                (N = ".btn"),
                (O = { CLICK_DATA_API: "click" + E + T, FOCUS_BLUR_DATA_API: "focus" + E + T + " blur" + E + T }),
                (k = (function () {
                    function t(t) {
                        this._element = t;
                    }
                    var e = t.prototype;
                    return (
                        (e.toggle = function () {
                            var t = !0,
                                e = !0,
                                n = p(this._element).closest(D)[0];
                            if (n) {
                                var i = p(this._element).find(S)[0];
                                if (i) {
                                    if ("radio" === i.type)
                                        if (i.checked && p(this._element).hasClass(C)) t = !1;
                                        else {
                                            var s = p(n).find(w)[0];
                                            s && p(s).removeClass(C);
                                        }
                                    if (t) {
                                        if (
                                            i.hasAttribute("disabled") ||
                                            n.hasAttribute("disabled") ||
                                            i.classList.contains("disabled") ||
                                            n.classList.contains("disabled")
                                        )
                                            return;
                                        (i.checked = !p(this._element).hasClass(C)), p(i).trigger("change");
                                    }
                                    i.focus(), (e = !1);
                                }
                            }
                            e && this._element.setAttribute("aria-pressed", !p(this._element).hasClass(C)),
                                t && p(this._element).toggleClass(C);
                        }),
                        (e.dispose = function () {
                            p.removeData(this._element, v), (this._element = null);
                        }),
                        (t._jQueryInterface = function (e) {
                            return this.each(function () {
                                var n = p(this).data(v);
                                n || ((n = new t(this)), p(this).data(v, n)), "toggle" === e && n[e]();
                            });
                        }),
                        s(t, null, [
                            {
                                key: "VERSION",
                                get: function () {
                                    return "4.0.0";
                                },
                            },
                        ]),
                        t
                    );
                })()),
                p(document)
                    .on(O.CLICK_DATA_API, b, function (t) {
                        t.preventDefault();
                        var e = t.target;
                        p(e).hasClass(I) || (e = p(e).closest(N)), k._jQueryInterface.call(p(e), "toggle");
                    })
                    .on(O.FOCUS_BLUR_DATA_API, b, function (t) {
                        var e = p(t.target).closest(N)[0];
                        p(e).toggleClass(A, /^focus(in)?$/.test(t.type));
                    }),
                (p.fn[m] = k._jQueryInterface),
                (p.fn[m].Constructor = k),
                (p.fn[m].noConflict = function () {
                    return (p.fn[m] = y), k._jQueryInterface;
                }),
                k),
            j = (function (t) {
                var e = "carousel",
                    n = "bs.carousel",
                    i = "." + n,
                    o = t.fn[e],
                    a = { interval: 5e3, keyboard: !0, slide: !1, pause: "hover", wrap: !0 },
                    l = {
                        interval: "(number|boolean)",
                        keyboard: "boolean",
                        slide: "(boolean|string)",
                        pause: "(string|boolean)",
                        wrap: "boolean",
                    },
                    h = "next",
                    c = "prev",
                    u = "left",
                    f = "right",
                    d = {
                        SLIDE: "slide" + i,
                        SLID: "slid" + i,
                        KEYDOWN: "keydown" + i,
                        MOUSEENTER: "mouseenter" + i,
                        MOUSELEAVE: "mouseleave" + i,
                        TOUCHEND: "touchend" + i,
                        LOAD_DATA_API: "load" + i + ".data-api",
                        CLICK_DATA_API: "click" + i + ".data-api",
                    },
                    _ = "carousel",
                    g = "active",
                    p = "slide",
                    m = "carousel-item-right",
                    v = "carousel-item-left",
                    E = "carousel-item-next",
                    T = "carousel-item-prev",
                    y = {
                        ACTIVE: ".active",
                        ACTIVE_ITEM: ".active.carousel-item",
                        ITEM: ".carousel-item",
                        NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
                        INDICATORS: ".carousel-indicators",
                        DATA_SLIDE: "[data-slide], [data-slide-to]",
                        DATA_RIDE: '[data-ride="carousel"]',
                    },
                    C = (function () {
                        function o(e, n) {
                            (this._items = null),
                                (this._interval = null),
                                (this._activeElement = null),
                                (this._isPaused = !1),
                                (this._isSliding = !1),
                                (this.touchTimeout = null),
                                (this._config = this._getConfig(n)),
                                (this._element = t(e)[0]),
                                (this._indicatorsElement = t(this._element).find(y.INDICATORS)[0]),
                                this._addEventListeners();
                        }
                        var C = o.prototype;
                        return (
                            (C.next = function () {
                                this._isSliding || this._slide(h);
                            }),
                            (C.nextWhenVisible = function () {
                                !document.hidden &&
                                    t(this._element).is(":visible") &&
                                    "hidden" !== t(this._element).css("visibility") &&
                                    this.next();
                            }),
                            (C.prev = function () {
                                this._isSliding || this._slide(c);
                            }),
                            (C.pause = function (e) {
                                e || (this._isPaused = !0),
                                    t(this._element).find(y.NEXT_PREV)[0] &&
                                        P.supportsTransitionEnd() &&
                                        (P.triggerTransitionEnd(this._element), this.cycle(!0)),
                                    clearInterval(this._interval),
                                    (this._interval = null);
                            }),
                            (C.cycle = function (t) {
                                t || (this._isPaused = !1),
                                    this._interval && (clearInterval(this._interval), (this._interval = null)),
                                    this._config.interval &&
                                        !this._isPaused &&
                                        (this._interval = setInterval(
                                            (document.visibilityState ? this.nextWhenVisible : this.next).bind(this),
                                            this._config.interval
                                        ));
                            }),
                            (C.to = function (e) {
                                var n = this;
                                this._activeElement = t(this._element).find(y.ACTIVE_ITEM)[0];
                                var i = this._getItemIndex(this._activeElement);
                                if (!(e > this._items.length - 1 || e < 0))
                                    if (this._isSliding)
                                        t(this._element).one(d.SLID, function () {
                                            return n.to(e);
                                        });
                                    else {
                                        if (i === e) return this.pause(), void this.cycle();
                                        var s = e > i ? h : c;
                                        this._slide(s, this._items[e]);
                                    }
                            }),
                            (C.dispose = function () {
                                t(this._element).off(i),
                                    t.removeData(this._element, n),
                                    (this._items = null),
                                    (this._config = null),
                                    (this._element = null),
                                    (this._interval = null),
                                    (this._isPaused = null),
                                    (this._isSliding = null),
                                    (this._activeElement = null),
                                    (this._indicatorsElement = null);
                            }),
                            (C._getConfig = function (t) {
                                return (t = r({}, a, t)), P.typeCheckConfig(e, t, l), t;
                            }),
                            (C._addEventListeners = function () {
                                var e = this;
                                this._config.keyboard &&
                                    t(this._element).on(d.KEYDOWN, function (t) {
                                        return e._keydown(t);
                                    }),
                                    "hover" === this._config.pause &&
                                        (t(this._element)
                                            .on(d.MOUSEENTER, function (t) {
                                                return e.pause(t);
                                            })
                                            .on(d.MOUSELEAVE, function (t) {
                                                return e.cycle(t);
                                            }),
                                        "ontouchstart" in document.documentElement &&
                                            t(this._element).on(d.TOUCHEND, function () {
                                                e.pause(),
                                                    e.touchTimeout && clearTimeout(e.touchTimeout),
                                                    (e.touchTimeout = setTimeout(function (t) {
                                                        return e.cycle(t);
                                                    }, 500 + e._config.interval));
                                            }));
                            }),
                            (C._keydown = function (t) {
                                if (!/input|textarea/i.test(t.target.tagName))
                                    switch (t.which) {
                                        case 37:
                                            t.preventDefault(), this.prev();
                                            break;
                                        case 39:
                                            t.preventDefault(), this.next();
                                    }
                            }),
                            (C._getItemIndex = function (e) {
                                return (this._items = t.makeArray(t(e).parent().find(y.ITEM))), this._items.indexOf(e);
                            }),
                            (C._getItemByDirection = function (t, e) {
                                var n = t === h,
                                    i = t === c,
                                    s = this._getItemIndex(e),
                                    r = this._items.length - 1;
                                if (((i && 0 === s) || (n && s === r)) && !this._config.wrap) return e;
                                var o = (s + (t === c ? -1 : 1)) % this._items.length;
                                return -1 === o ? this._items[this._items.length - 1] : this._items[o];
                            }),
                            (C._triggerSlideEvent = function (e, n) {
                                var i = this._getItemIndex(e),
                                    s = this._getItemIndex(t(this._element).find(y.ACTIVE_ITEM)[0]),
                                    r = t.Event(d.SLIDE, { relatedTarget: e, direction: n, from: s, to: i });
                                return t(this._element).trigger(r), r;
                            }),
                            (C._setActiveIndicatorElement = function (e) {
                                if (this._indicatorsElement) {
                                    t(this._indicatorsElement).find(y.ACTIVE).removeClass(g);
                                    var n = this._indicatorsElement.children[this._getItemIndex(e)];
                                    n && t(n).addClass(g);
                                }
                            }),
                            (C._slide = function (e, n) {
                                var i,
                                    s,
                                    r,
                                    o = this,
                                    a = t(this._element).find(y.ACTIVE_ITEM)[0],
                                    l = this._getItemIndex(a),
                                    c = n || (a && this._getItemByDirection(e, a)),
                                    _ = this._getItemIndex(c),
                                    C = Boolean(this._interval);
                                if (
                                    (e === h ? ((i = v), (s = E), (r = u)) : ((i = m), (s = T), (r = f)),
                                    c && t(c).hasClass(g))
                                )
                                    this._isSliding = !1;
                                else if (!this._triggerSlideEvent(c, r).isDefaultPrevented() && a && c) {
                                    (this._isSliding = !0), C && this.pause(), this._setActiveIndicatorElement(c);
                                    var I = t.Event(d.SLID, { relatedTarget: c, direction: r, from: l, to: _ });
                                    P.supportsTransitionEnd() && t(this._element).hasClass(p)
                                        ? (t(c).addClass(s),
                                          P.reflow(c),
                                          t(a).addClass(i),
                                          t(c).addClass(i),
                                          t(a)
                                              .one(P.TRANSITION_END, function () {
                                                  t(c)
                                                      .removeClass(i + " " + s)
                                                      .addClass(g),
                                                      t(a).removeClass(g + " " + s + " " + i),
                                                      (o._isSliding = !1),
                                                      setTimeout(function () {
                                                          return t(o._element).trigger(I);
                                                      }, 0);
                                              })
                                              .emulateTransitionEnd(600))
                                        : (t(a).removeClass(g),
                                          t(c).addClass(g),
                                          (this._isSliding = !1),
                                          t(this._element).trigger(I)),
                                        C && this.cycle();
                                }
                            }),
                            (o._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var i = t(this).data(n),
                                        s = r({}, a, t(this).data());
                                    "object" == typeof e && (s = r({}, s, e));
                                    var l = "string" == typeof e ? e : s.slide;
                                    if ((i || ((i = new o(this, s)), t(this).data(n, i)), "number" == typeof e))
                                        i.to(e);
                                    else if ("string" == typeof l) {
                                        if ("undefined" == typeof i[l])
                                            throw new TypeError('No method named "' + l + '"');
                                        i[l]();
                                    } else s.interval && (i.pause(), i.cycle());
                                });
                            }),
                            (o._dataApiClickHandler = function (e) {
                                var i = P.getSelectorFromElement(this);
                                if (i) {
                                    var s = t(i)[0];
                                    if (s && t(s).hasClass(_)) {
                                        var a = r({}, t(s).data(), t(this).data()),
                                            l = this.getAttribute("data-slide-to");
                                        l && (a.interval = !1),
                                            o._jQueryInterface.call(t(s), a),
                                            l && t(s).data(n).to(l),
                                            e.preventDefault();
                                    }
                                }
                            }),
                            s(o, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return a;
                                    },
                                },
                            ]),
                            o
                        );
                    })();
                return (
                    t(document).on(d.CLICK_DATA_API, y.DATA_SLIDE, C._dataApiClickHandler),
                    t(window).on(d.LOAD_DATA_API, function () {
                        t(y.DATA_RIDE).each(function () {
                            var e = t(this);
                            C._jQueryInterface.call(e, e.data());
                        });
                    }),
                    (t.fn[e] = C._jQueryInterface),
                    (t.fn[e].Constructor = C),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = o), C._jQueryInterface;
                    }),
                    C
                );
            })(e),
            H = (function (t) {
                var e = "collapse",
                    n = "bs.collapse",
                    i = "." + n,
                    o = t.fn[e],
                    a = { toggle: !0, parent: "" },
                    l = { toggle: "boolean", parent: "(string|element)" },
                    h = {
                        SHOW: "show" + i,
                        SHOWN: "shown" + i,
                        HIDE: "hide" + i,
                        HIDDEN: "hidden" + i,
                        CLICK_DATA_API: "click" + i + ".data-api",
                    },
                    c = "show",
                    u = "collapse",
                    f = "collapsing",
                    d = "collapsed",
                    _ = "width",
                    g = "height",
                    p = { ACTIVES: ".show, .collapsing", DATA_TOGGLE: '[data-toggle="collapse"]' },
                    m = (function () {
                        function i(e, n) {
                            (this._isTransitioning = !1),
                                (this._element = e),
                                (this._config = this._getConfig(n)),
                                (this._triggerArray = t.makeArray(
                                    t(
                                        '[data-toggle="collapse"][href="#' +
                                            e.id +
                                            '"],[data-toggle="collapse"][data-target="#' +
                                            e.id +
                                            '"]'
                                    )
                                ));
                            for (var i = t(p.DATA_TOGGLE), s = 0; s < i.length; s++) {
                                var r = i[s],
                                    o = P.getSelectorFromElement(r);
                                null !== o &&
                                    t(o).filter(e).length > 0 &&
                                    ((this._selector = o), this._triggerArray.push(r));
                            }
                            (this._parent = this._config.parent ? this._getParent() : null),
                                this._config.parent ||
                                    this._addAriaAndCollapsedClass(this._element, this._triggerArray),
                                this._config.toggle && this.toggle();
                        }
                        var o = i.prototype;
                        return (
                            (o.toggle = function () {
                                t(this._element).hasClass(c) ? this.hide() : this.show();
                            }),
                            (o.show = function () {
                                var e,
                                    s,
                                    r = this;
                                if (
                                    !this._isTransitioning &&
                                    !t(this._element).hasClass(c) &&
                                    (this._parent &&
                                        0 ===
                                            (e = t.makeArray(
                                                t(this._parent)
                                                    .find(p.ACTIVES)
                                                    .filter('[data-parent="' + this._config.parent + '"]')
                                            )).length &&
                                        (e = null),
                                    !(e && (s = t(e).not(this._selector).data(n)) && s._isTransitioning))
                                ) {
                                    var o = t.Event(h.SHOW);
                                    if ((t(this._element).trigger(o), !o.isDefaultPrevented())) {
                                        e &&
                                            (i._jQueryInterface.call(t(e).not(this._selector), "hide"),
                                            s || t(e).data(n, null));
                                        var a = this._getDimension();
                                        t(this._element).removeClass(u).addClass(f),
                                            (this._element.style[a] = 0),
                                            this._triggerArray.length > 0 &&
                                                t(this._triggerArray).removeClass(d).attr("aria-expanded", !0),
                                            this.setTransitioning(!0);
                                        var l = function () {
                                            t(r._element).removeClass(f).addClass(u).addClass(c),
                                                (r._element.style[a] = ""),
                                                r.setTransitioning(!1),
                                                t(r._element).trigger(h.SHOWN);
                                        };
                                        if (P.supportsTransitionEnd()) {
                                            var _ = "scroll" + (a[0].toUpperCase() + a.slice(1));
                                            t(this._element).one(P.TRANSITION_END, l).emulateTransitionEnd(600),
                                                (this._element.style[a] = this._element[_] + "px");
                                        } else l();
                                    }
                                }
                            }),
                            (o.hide = function () {
                                var e = this;
                                if (!this._isTransitioning && t(this._element).hasClass(c)) {
                                    var n = t.Event(h.HIDE);
                                    if ((t(this._element).trigger(n), !n.isDefaultPrevented())) {
                                        var i = this._getDimension();
                                        if (
                                            ((this._element.style[i] = this._element.getBoundingClientRect()[i] + "px"),
                                            P.reflow(this._element),
                                            t(this._element).addClass(f).removeClass(u).removeClass(c),
                                            this._triggerArray.length > 0)
                                        )
                                            for (var s = 0; s < this._triggerArray.length; s++) {
                                                var r = this._triggerArray[s],
                                                    o = P.getSelectorFromElement(r);
                                                if (null !== o)
                                                    t(o).hasClass(c) || t(r).addClass(d).attr("aria-expanded", !1);
                                            }
                                        this.setTransitioning(!0);
                                        var a = function () {
                                            e.setTransitioning(!1),
                                                t(e._element).removeClass(f).addClass(u).trigger(h.HIDDEN);
                                        };
                                        (this._element.style[i] = ""),
                                            P.supportsTransitionEnd()
                                                ? t(this._element).one(P.TRANSITION_END, a).emulateTransitionEnd(600)
                                                : a();
                                    }
                                }
                            }),
                            (o.setTransitioning = function (t) {
                                this._isTransitioning = t;
                            }),
                            (o.dispose = function () {
                                t.removeData(this._element, n),
                                    (this._config = null),
                                    (this._parent = null),
                                    (this._element = null),
                                    (this._triggerArray = null),
                                    (this._isTransitioning = null);
                            }),
                            (o._getConfig = function (t) {
                                return ((t = r({}, a, t)).toggle = Boolean(t.toggle)), P.typeCheckConfig(e, t, l), t;
                            }),
                            (o._getDimension = function () {
                                return t(this._element).hasClass(_) ? _ : g;
                            }),
                            (o._getParent = function () {
                                var e = this,
                                    n = null;
                                P.isElement(this._config.parent)
                                    ? ((n = this._config.parent),
                                      "undefined" != typeof this._config.parent.jquery && (n = this._config.parent[0]))
                                    : (n = t(this._config.parent)[0]);
                                var s = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
                                return (
                                    t(n)
                                        .find(s)
                                        .each(function (t, n) {
                                            e._addAriaAndCollapsedClass(i._getTargetFromElement(n), [n]);
                                        }),
                                    n
                                );
                            }),
                            (o._addAriaAndCollapsedClass = function (e, n) {
                                if (e) {
                                    var i = t(e).hasClass(c);
                                    n.length > 0 && t(n).toggleClass(d, !i).attr("aria-expanded", i);
                                }
                            }),
                            (i._getTargetFromElement = function (e) {
                                var n = P.getSelectorFromElement(e);
                                return n ? t(n)[0] : null;
                            }),
                            (i._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var s = t(this),
                                        o = s.data(n),
                                        l = r({}, a, s.data(), "object" == typeof e && e);
                                    if (
                                        (!o && l.toggle && /show|hide/.test(e) && (l.toggle = !1),
                                        o || ((o = new i(this, l)), s.data(n, o)),
                                        "string" == typeof e)
                                    ) {
                                        if ("undefined" == typeof o[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        o[e]();
                                    }
                                });
                            }),
                            s(i, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return a;
                                    },
                                },
                            ]),
                            i
                        );
                    })();
                return (
                    t(document).on(h.CLICK_DATA_API, p.DATA_TOGGLE, function (e) {
                        "A" === e.currentTarget.tagName && e.preventDefault();
                        var i = t(this),
                            s = P.getSelectorFromElement(this);
                        t(s).each(function () {
                            var e = t(this),
                                s = e.data(n) ? "toggle" : i.data();
                            m._jQueryInterface.call(e, s);
                        });
                    }),
                    (t.fn[e] = m._jQueryInterface),
                    (t.fn[e].Constructor = m),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = o), m._jQueryInterface;
                    }),
                    m
                );
            })(e),
            W = (function (t) {
                var e = "dropdown",
                    i = "bs.dropdown",
                    o = "." + i,
                    a = ".data-api",
                    l = t.fn[e],
                    h = new RegExp("38|40|27"),
                    c = {
                        HIDE: "hide" + o,
                        HIDDEN: "hidden" + o,
                        SHOW: "show" + o,
                        SHOWN: "shown" + o,
                        CLICK: "click" + o,
                        CLICK_DATA_API: "click" + o + a,
                        KEYDOWN_DATA_API: "keydown" + o + a,
                        KEYUP_DATA_API: "keyup" + o + a,
                    },
                    u = "disabled",
                    f = "show",
                    d = "dropup",
                    _ = "dropright",
                    g = "dropleft",
                    p = "dropdown-menu-right",
                    m = "dropdown-menu-left",
                    v = "position-static",
                    E = '[data-toggle="dropdown"]',
                    T = ".dropdown form",
                    y = ".dropdown-menu",
                    C = ".navbar-nav",
                    I = ".dropdown-menu .dropdown-item:not(.disabled)",
                    A = "top-start",
                    b = "top-end",
                    D = "bottom-start",
                    S = "bottom-end",
                    w = "right-start",
                    N = "left-start",
                    O = { offset: 0, flip: !0, boundary: "scrollParent" },
                    k = { offset: "(number|string|function)", flip: "boolean", boundary: "(string|element)" },
                    L = (function () {
                        function a(t, e) {
                            (this._element = t),
                                (this._popper = null),
                                (this._config = this._getConfig(e)),
                                (this._menu = this._getMenuElement()),
                                (this._inNavbar = this._detectNavbar()),
                                this._addEventListeners();
                        }
                        var l = a.prototype;
                        return (
                            (l.toggle = function () {
                                if (!this._element.disabled && !t(this._element).hasClass(u)) {
                                    var e = a._getParentFromElement(this._element),
                                        i = t(this._menu).hasClass(f);
                                    if ((a._clearMenus(), !i)) {
                                        var s = { relatedTarget: this._element },
                                            r = t.Event(c.SHOW, s);
                                        if ((t(e).trigger(r), !r.isDefaultPrevented())) {
                                            if (!this._inNavbar) {
                                                if ("undefined" == typeof n)
                                                    throw new TypeError(
                                                        "Bootstrap dropdown require Popper.js (https://popper.js.org)"
                                                    );
                                                var o = this._element;
                                                t(e).hasClass(d) &&
                                                    (t(this._menu).hasClass(m) || t(this._menu).hasClass(p)) &&
                                                    (o = e),
                                                    "scrollParent" !== this._config.boundary && t(e).addClass(v),
                                                    (this._popper = new n(o, this._menu, this._getPopperConfig()));
                                            }
                                            "ontouchstart" in document.documentElement &&
                                                0 === t(e).closest(C).length &&
                                                t("body").children().on("mouseover", null, t.noop),
                                                this._element.focus(),
                                                this._element.setAttribute("aria-expanded", !0),
                                                t(this._menu).toggleClass(f),
                                                t(e).toggleClass(f).trigger(t.Event(c.SHOWN, s));
                                        }
                                    }
                                }
                            }),
                            (l.dispose = function () {
                                t.removeData(this._element, i),
                                    t(this._element).off(o),
                                    (this._element = null),
                                    (this._menu = null),
                                    null !== this._popper && (this._popper.destroy(), (this._popper = null));
                            }),
                            (l.update = function () {
                                (this._inNavbar = this._detectNavbar()),
                                    null !== this._popper && this._popper.scheduleUpdate();
                            }),
                            (l._addEventListeners = function () {
                                var e = this;
                                t(this._element).on(c.CLICK, function (t) {
                                    t.preventDefault(), t.stopPropagation(), e.toggle();
                                });
                            }),
                            (l._getConfig = function (n) {
                                return (
                                    (n = r({}, this.constructor.Default, t(this._element).data(), n)),
                                    P.typeCheckConfig(e, n, this.constructor.DefaultType),
                                    n
                                );
                            }),
                            (l._getMenuElement = function () {
                                if (!this._menu) {
                                    var e = a._getParentFromElement(this._element);
                                    this._menu = t(e).find(y)[0];
                                }
                                return this._menu;
                            }),
                            (l._getPlacement = function () {
                                var e = t(this._element).parent(),
                                    n = D;
                                return (
                                    e.hasClass(d)
                                        ? ((n = A), t(this._menu).hasClass(p) && (n = b))
                                        : e.hasClass(_)
                                          ? (n = w)
                                          : e.hasClass(g)
                                            ? (n = N)
                                            : t(this._menu).hasClass(p) && (n = S),
                                    n
                                );
                            }),
                            (l._detectNavbar = function () {
                                return t(this._element).closest(".navbar").length > 0;
                            }),
                            (l._getPopperConfig = function () {
                                var t = this,
                                    e = {};
                                return (
                                    "function" == typeof this._config.offset
                                        ? (e.fn = function (e) {
                                              return (
                                                  (e.offsets = r({}, e.offsets, t._config.offset(e.offsets) || {})), e
                                              );
                                          })
                                        : (e.offset = this._config.offset),
                                    {
                                        placement: this._getPlacement(),
                                        modifiers: {
                                            offset: e,
                                            flip: { enabled: this._config.flip },
                                            preventOverflow: { boundariesElement: this._config.boundary },
                                        },
                                    }
                                );
                            }),
                            (a._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var n = t(this).data(i);
                                    if (
                                        (n || ((n = new a(this, "object" == typeof e ? e : null)), t(this).data(i, n)),
                                        "string" == typeof e)
                                    ) {
                                        if ("undefined" == typeof n[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        n[e]();
                                    }
                                });
                            }),
                            (a._clearMenus = function (e) {
                                if (!e || (3 !== e.which && ("keyup" !== e.type || 9 === e.which)))
                                    for (var n = t.makeArray(t(E)), s = 0; s < n.length; s++) {
                                        var r = a._getParentFromElement(n[s]),
                                            o = t(n[s]).data(i),
                                            l = { relatedTarget: n[s] };
                                        if (o) {
                                            var h = o._menu;
                                            if (
                                                t(r).hasClass(f) &&
                                                !(
                                                    e &&
                                                    (("click" === e.type && /input|textarea/i.test(e.target.tagName)) ||
                                                        ("keyup" === e.type && 9 === e.which)) &&
                                                    t.contains(r, e.target)
                                                )
                                            ) {
                                                var u = t.Event(c.HIDE, l);
                                                t(r).trigger(u),
                                                    u.isDefaultPrevented() ||
                                                        ("ontouchstart" in document.documentElement &&
                                                            t("body").children().off("mouseover", null, t.noop),
                                                        n[s].setAttribute("aria-expanded", "false"),
                                                        t(h).removeClass(f),
                                                        t(r).removeClass(f).trigger(t.Event(c.HIDDEN, l)));
                                            }
                                        }
                                    }
                            }),
                            (a._getParentFromElement = function (e) {
                                var n,
                                    i = P.getSelectorFromElement(e);
                                return i && (n = t(i)[0]), n || e.parentNode;
                            }),
                            (a._dataApiKeydownHandler = function (e) {
                                if (
                                    (/input|textarea/i.test(e.target.tagName)
                                        ? !(
                                              32 === e.which ||
                                              (27 !== e.which &&
                                                  ((40 !== e.which && 38 !== e.which) || t(e.target).closest(y).length))
                                          )
                                        : h.test(e.which)) &&
                                    (e.preventDefault(), e.stopPropagation(), !this.disabled && !t(this).hasClass(u))
                                ) {
                                    var n = a._getParentFromElement(this),
                                        i = t(n).hasClass(f);
                                    if (
                                        (i || (27 === e.which && 32 === e.which)) &&
                                        (!i || (27 !== e.which && 32 !== e.which))
                                    ) {
                                        var s = t(n).find(I).get();
                                        if (0 !== s.length) {
                                            var r = s.indexOf(e.target);
                                            38 === e.which && r > 0 && r--,
                                                40 === e.which && r < s.length - 1 && r++,
                                                r < 0 && (r = 0),
                                                s[r].focus();
                                        }
                                    } else {
                                        if (27 === e.which) {
                                            var o = t(n).find(E)[0];
                                            t(o).trigger("focus");
                                        }
                                        t(this).trigger("click");
                                    }
                                }
                            }),
                            s(a, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return O;
                                    },
                                },
                                {
                                    key: "DefaultType",
                                    get: function () {
                                        return k;
                                    },
                                },
                            ]),
                            a
                        );
                    })();
                return (
                    t(document)
                        .on(c.KEYDOWN_DATA_API, E, L._dataApiKeydownHandler)
                        .on(c.KEYDOWN_DATA_API, y, L._dataApiKeydownHandler)
                        .on(c.CLICK_DATA_API + " " + c.KEYUP_DATA_API, L._clearMenus)
                        .on(c.CLICK_DATA_API, E, function (e) {
                            e.preventDefault(), e.stopPropagation(), L._jQueryInterface.call(t(this), "toggle");
                        })
                        .on(c.CLICK_DATA_API, T, function (t) {
                            t.stopPropagation();
                        }),
                    (t.fn[e] = L._jQueryInterface),
                    (t.fn[e].Constructor = L),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = l), L._jQueryInterface;
                    }),
                    L
                );
            })(e),
            M = (function (t) {
                var e = "modal",
                    n = "bs.modal",
                    i = "." + n,
                    o = t.fn.modal,
                    a = { backdrop: !0, keyboard: !0, focus: !0, show: !0 },
                    l = { backdrop: "(boolean|string)", keyboard: "boolean", focus: "boolean", show: "boolean" },
                    h = {
                        HIDE: "hide" + i,
                        HIDDEN: "hidden" + i,
                        SHOW: "show" + i,
                        SHOWN: "shown" + i,
                        FOCUSIN: "focusin" + i,
                        RESIZE: "resize" + i,
                        CLICK_DISMISS: "click.dismiss" + i,
                        KEYDOWN_DISMISS: "keydown.dismiss" + i,
                        MOUSEUP_DISMISS: "mouseup.dismiss" + i,
                        MOUSEDOWN_DISMISS: "mousedown.dismiss" + i,
                        CLICK_DATA_API: "click" + i + ".data-api",
                    },
                    c = "modal-scrollbar-measure",
                    u = "modal-backdrop",
                    f = "modal-open",
                    d = "fade",
                    _ = "show",
                    g = {
                        DIALOG: ".modal-dialog",
                        DATA_TOGGLE: '[data-toggle="modal"]',
                        DATA_DISMISS: '[data-dismiss="modal"]',
                        FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
                        STICKY_CONTENT: ".sticky-top",
                        NAVBAR_TOGGLER: ".navbar-toggler",
                    },
                    p = (function () {
                        function o(e, n) {
                            (this._config = this._getConfig(n)),
                                (this._element = e),
                                (this._dialog = t(e).find(g.DIALOG)[0]),
                                (this._backdrop = null),
                                (this._isShown = !1),
                                (this._isBodyOverflowing = !1),
                                (this._ignoreBackdropClick = !1),
                                (this._originalBodyPadding = 0),
                                (this._scrollbarWidth = 0);
                        }
                        var p = o.prototype;
                        return (
                            (p.toggle = function (t) {
                                return this._isShown ? this.hide() : this.show(t);
                            }),
                            (p.show = function (e) {
                                var n = this;
                                if (!this._isTransitioning && !this._isShown) {
                                    P.supportsTransitionEnd() &&
                                        t(this._element).hasClass(d) &&
                                        (this._isTransitioning = !0);
                                    var i = t.Event(h.SHOW, { relatedTarget: e });
                                    t(this._element).trigger(i),
                                        this._isShown ||
                                            i.isDefaultPrevented() ||
                                            ((this._isShown = !0),
                                            this._checkScrollbar(),
                                            this._setScrollbar(),
                                            this._adjustDialog(),
                                            t(document.body).addClass(f),
                                            this._setEscapeEvent(),
                                            this._setResizeEvent(),
                                            t(this._element).on(h.CLICK_DISMISS, g.DATA_DISMISS, function (t) {
                                                return n.hide(t);
                                            }),
                                            t(this._dialog).on(h.MOUSEDOWN_DISMISS, function () {
                                                t(n._element).one(h.MOUSEUP_DISMISS, function (e) {
                                                    t(e.target).is(n._element) && (n._ignoreBackdropClick = !0);
                                                });
                                            }),
                                            this._showBackdrop(function () {
                                                return n._showElement(e);
                                            }));
                                }
                            }),
                            (p.hide = function (e) {
                                var n = this;
                                if ((e && e.preventDefault(), !this._isTransitioning && this._isShown)) {
                                    var i = t.Event(h.HIDE);
                                    if ((t(this._element).trigger(i), this._isShown && !i.isDefaultPrevented())) {
                                        this._isShown = !1;
                                        var s = P.supportsTransitionEnd() && t(this._element).hasClass(d);
                                        s && (this._isTransitioning = !0),
                                            this._setEscapeEvent(),
                                            this._setResizeEvent(),
                                            t(document).off(h.FOCUSIN),
                                            t(this._element).removeClass(_),
                                            t(this._element).off(h.CLICK_DISMISS),
                                            t(this._dialog).off(h.MOUSEDOWN_DISMISS),
                                            s
                                                ? t(this._element)
                                                      .one(P.TRANSITION_END, function (t) {
                                                          return n._hideModal(t);
                                                      })
                                                      .emulateTransitionEnd(300)
                                                : this._hideModal();
                                    }
                                }
                            }),
                            (p.dispose = function () {
                                t.removeData(this._element, n),
                                    t(window, document, this._element, this._backdrop).off(i),
                                    (this._config = null),
                                    (this._element = null),
                                    (this._dialog = null),
                                    (this._backdrop = null),
                                    (this._isShown = null),
                                    (this._isBodyOverflowing = null),
                                    (this._ignoreBackdropClick = null),
                                    (this._scrollbarWidth = null);
                            }),
                            (p.handleUpdate = function () {
                                this._adjustDialog();
                            }),
                            (p._getConfig = function (t) {
                                return (t = r({}, a, t)), P.typeCheckConfig(e, t, l), t;
                            }),
                            (p._showElement = function (e) {
                                var n = this,
                                    i = P.supportsTransitionEnd() && t(this._element).hasClass(d);
                                (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
                                    document.body.appendChild(this._element),
                                    (this._element.style.display = "block"),
                                    this._element.removeAttribute("aria-hidden"),
                                    (this._element.scrollTop = 0),
                                    i && P.reflow(this._element),
                                    t(this._element).addClass(_),
                                    this._config.focus && this._enforceFocus();
                                var s = t.Event(h.SHOWN, { relatedTarget: e }),
                                    r = function () {
                                        n._config.focus && n._element.focus(),
                                            (n._isTransitioning = !1),
                                            t(n._element).trigger(s);
                                    };
                                i ? t(this._dialog).one(P.TRANSITION_END, r).emulateTransitionEnd(300) : r();
                            }),
                            (p._enforceFocus = function () {
                                var e = this;
                                t(document)
                                    .off(h.FOCUSIN)
                                    .on(h.FOCUSIN, function (n) {
                                        document !== n.target &&
                                            e._element !== n.target &&
                                            0 === t(e._element).has(n.target).length &&
                                            e._element.focus();
                                    });
                            }),
                            (p._setEscapeEvent = function () {
                                var e = this;
                                this._isShown && this._config.keyboard
                                    ? t(this._element).on(h.KEYDOWN_DISMISS, function (t) {
                                          27 === t.which && (t.preventDefault(), e.hide());
                                      })
                                    : this._isShown || t(this._element).off(h.KEYDOWN_DISMISS);
                            }),
                            (p._setResizeEvent = function () {
                                var e = this;
                                this._isShown
                                    ? t(window).on(h.RESIZE, function (t) {
                                          return e.handleUpdate(t);
                                      })
                                    : t(window).off(h.RESIZE);
                            }),
                            (p._hideModal = function () {
                                var e = this;
                                (this._element.style.display = "none"),
                                    this._element.setAttribute("aria-hidden", !0),
                                    (this._isTransitioning = !1),
                                    this._showBackdrop(function () {
                                        t(document.body).removeClass(f),
                                            e._resetAdjustments(),
                                            e._resetScrollbar(),
                                            t(e._element).trigger(h.HIDDEN);
                                    });
                            }),
                            (p._removeBackdrop = function () {
                                this._backdrop && (t(this._backdrop).remove(), (this._backdrop = null));
                            }),
                            (p._showBackdrop = function (e) {
                                var n = this,
                                    i = t(this._element).hasClass(d) ? d : "";
                                if (this._isShown && this._config.backdrop) {
                                    var s = P.supportsTransitionEnd() && i;
                                    if (
                                        ((this._backdrop = document.createElement("div")),
                                        (this._backdrop.className = u),
                                        i && t(this._backdrop).addClass(i),
                                        t(this._backdrop).appendTo(document.body),
                                        t(this._element).on(h.CLICK_DISMISS, function (t) {
                                            n._ignoreBackdropClick
                                                ? (n._ignoreBackdropClick = !1)
                                                : t.target === t.currentTarget &&
                                                  ("static" === n._config.backdrop ? n._element.focus() : n.hide());
                                        }),
                                        s && P.reflow(this._backdrop),
                                        t(this._backdrop).addClass(_),
                                        !e)
                                    )
                                        return;
                                    if (!s) return void e();
                                    t(this._backdrop).one(P.TRANSITION_END, e).emulateTransitionEnd(150);
                                } else if (!this._isShown && this._backdrop) {
                                    t(this._backdrop).removeClass(_);
                                    var r = function () {
                                        n._removeBackdrop(), e && e();
                                    };
                                    P.supportsTransitionEnd() && t(this._element).hasClass(d)
                                        ? t(this._backdrop).one(P.TRANSITION_END, r).emulateTransitionEnd(150)
                                        : r();
                                } else e && e();
                            }),
                            (p._adjustDialog = function () {
                                var t = this._element.scrollHeight > document.documentElement.clientHeight;
                                !this._isBodyOverflowing &&
                                    t &&
                                    (this._element.style.paddingLeft = this._scrollbarWidth + "px"),
                                    this._isBodyOverflowing &&
                                        !t &&
                                        (this._element.style.paddingRight = this._scrollbarWidth + "px");
                            }),
                            (p._resetAdjustments = function () {
                                (this._element.style.paddingLeft = ""), (this._element.style.paddingRight = "");
                            }),
                            (p._checkScrollbar = function () {
                                var t = document.body.getBoundingClientRect();
                                (this._isBodyOverflowing = t.left + t.right < window.innerWidth),
                                    (this._scrollbarWidth = this._getScrollbarWidth());
                            }),
                            (p._setScrollbar = function () {
                                var e = this;
                                if (this._isBodyOverflowing) {
                                    t(g.FIXED_CONTENT).each(function (n, i) {
                                        var s = t(i)[0].style.paddingRight,
                                            r = t(i).css("padding-right");
                                        t(i)
                                            .data("padding-right", s)
                                            .css("padding-right", parseFloat(r) + e._scrollbarWidth + "px");
                                    }),
                                        t(g.STICKY_CONTENT).each(function (n, i) {
                                            var s = t(i)[0].style.marginRight,
                                                r = t(i).css("margin-right");
                                            t(i)
                                                .data("margin-right", s)
                                                .css("margin-right", parseFloat(r) - e._scrollbarWidth + "px");
                                        }),
                                        t(g.NAVBAR_TOGGLER).each(function (n, i) {
                                            var s = t(i)[0].style.marginRight,
                                                r = t(i).css("margin-right");
                                            t(i)
                                                .data("margin-right", s)
                                                .css("margin-right", parseFloat(r) + e._scrollbarWidth + "px");
                                        });
                                    var n = document.body.style.paddingRight,
                                        i = t("body").css("padding-right");
                                    t("body")
                                        .data("padding-right", n)
                                        .css("padding-right", parseFloat(i) + this._scrollbarWidth + "px");
                                }
                            }),
                            (p._resetScrollbar = function () {
                                t(g.FIXED_CONTENT).each(function (e, n) {
                                    var i = t(n).data("padding-right");
                                    "undefined" != typeof i && t(n).css("padding-right", i).removeData("padding-right");
                                }),
                                    t(g.STICKY_CONTENT + ", " + g.NAVBAR_TOGGLER).each(function (e, n) {
                                        var i = t(n).data("margin-right");
                                        "undefined" != typeof i &&
                                            t(n).css("margin-right", i).removeData("margin-right");
                                    });
                                var e = t("body").data("padding-right");
                                "undefined" != typeof e &&
                                    t("body").css("padding-right", e).removeData("padding-right");
                            }),
                            (p._getScrollbarWidth = function () {
                                var t = document.createElement("div");
                                (t.className = c), document.body.appendChild(t);
                                var e = t.getBoundingClientRect().width - t.clientWidth;
                                return document.body.removeChild(t), e;
                            }),
                            (o._jQueryInterface = function (e, i) {
                                return this.each(function () {
                                    var s = t(this).data(n),
                                        a = r({}, o.Default, t(this).data(), "object" == typeof e && e);
                                    if ((s || ((s = new o(this, a)), t(this).data(n, s)), "string" == typeof e)) {
                                        if ("undefined" == typeof s[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        s[e](i);
                                    } else a.show && s.show(i);
                                });
                            }),
                            s(o, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return a;
                                    },
                                },
                            ]),
                            o
                        );
                    })();
                return (
                    t(document).on(h.CLICK_DATA_API, g.DATA_TOGGLE, function (e) {
                        var i,
                            s = this,
                            o = P.getSelectorFromElement(this);
                        o && (i = t(o)[0]);
                        var a = t(i).data(n) ? "toggle" : r({}, t(i).data(), t(this).data());
                        ("A" !== this.tagName && "AREA" !== this.tagName) || e.preventDefault();
                        var l = t(i).one(h.SHOW, function (e) {
                            e.isDefaultPrevented() ||
                                l.one(h.HIDDEN, function () {
                                    t(s).is(":visible") && s.focus();
                                });
                        });
                        p._jQueryInterface.call(t(i), a, this);
                    }),
                    (t.fn.modal = p._jQueryInterface),
                    (t.fn.modal.Constructor = p),
                    (t.fn.modal.noConflict = function () {
                        return (t.fn.modal = o), p._jQueryInterface;
                    }),
                    p
                );
            })(e),
            U = (function (t) {
                var e = "tooltip",
                    i = "bs.tooltip",
                    o = "." + i,
                    a = t.fn[e],
                    l = new RegExp("(^|\\s)bs-tooltip\\S+", "g"),
                    h = {
                        animation: "boolean",
                        template: "string",
                        title: "(string|element|function)",
                        trigger: "string",
                        delay: "(number|object)",
                        html: "boolean",
                        selector: "(string|boolean)",
                        placement: "(string|function)",
                        offset: "(number|string)",
                        container: "(string|element|boolean)",
                        fallbackPlacement: "(string|array)",
                        boundary: "(string|element)",
                    },
                    c = { AUTO: "auto", TOP: "top", RIGHT: "right", BOTTOM: "bottom", LEFT: "left" },
                    u = {
                        animation: !0,
                        template:
                            '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
                        trigger: "hover focus",
                        title: "",
                        delay: 0,
                        html: !1,
                        selector: !1,
                        placement: "top",
                        offset: 0,
                        container: !1,
                        fallbackPlacement: "flip",
                        boundary: "scrollParent",
                    },
                    f = "show",
                    d = "out",
                    _ = {
                        HIDE: "hide" + o,
                        HIDDEN: "hidden" + o,
                        SHOW: "show" + o,
                        SHOWN: "shown" + o,
                        INSERTED: "inserted" + o,
                        CLICK: "click" + o,
                        FOCUSIN: "focusin" + o,
                        FOCUSOUT: "focusout" + o,
                        MOUSEENTER: "mouseenter" + o,
                        MOUSELEAVE: "mouseleave" + o,
                    },
                    g = "fade",
                    p = "show",
                    m = ".tooltip-inner",
                    v = ".arrow",
                    E = "hover",
                    T = "focus",
                    y = "click",
                    C = "manual",
                    I = (function () {
                        function a(t, e) {
                            if ("undefined" == typeof n)
                                throw new TypeError("Bootstrap tooltips require Popper.js (https://popper.js.org)");
                            (this._isEnabled = !0),
                                (this._timeout = 0),
                                (this._hoverState = ""),
                                (this._activeTrigger = {}),
                                (this._popper = null),
                                (this.element = t),
                                (this.config = this._getConfig(e)),
                                (this.tip = null),
                                this._setListeners();
                        }
                        var I = a.prototype;
                        return (
                            (I.enable = function () {
                                this._isEnabled = !0;
                            }),
                            (I.disable = function () {
                                this._isEnabled = !1;
                            }),
                            (I.toggleEnabled = function () {
                                this._isEnabled = !this._isEnabled;
                            }),
                            (I.toggle = function (e) {
                                if (this._isEnabled)
                                    if (e) {
                                        var n = this.constructor.DATA_KEY,
                                            i = t(e.currentTarget).data(n);
                                        i ||
                                            ((i = new this.constructor(e.currentTarget, this._getDelegateConfig())),
                                            t(e.currentTarget).data(n, i)),
                                            (i._activeTrigger.click = !i._activeTrigger.click),
                                            i._isWithActiveTrigger() ? i._enter(null, i) : i._leave(null, i);
                                    } else {
                                        if (t(this.getTipElement()).hasClass(p)) return void this._leave(null, this);
                                        this._enter(null, this);
                                    }
                            }),
                            (I.dispose = function () {
                                clearTimeout(this._timeout),
                                    t.removeData(this.element, this.constructor.DATA_KEY),
                                    t(this.element).off(this.constructor.EVENT_KEY),
                                    t(this.element).closest(".modal").off("hide.bs.modal"),
                                    this.tip && t(this.tip).remove(),
                                    (this._isEnabled = null),
                                    (this._timeout = null),
                                    (this._hoverState = null),
                                    (this._activeTrigger = null),
                                    null !== this._popper && this._popper.destroy(),
                                    (this._popper = null),
                                    (this.element = null),
                                    (this.config = null),
                                    (this.tip = null);
                            }),
                            (I.show = function () {
                                var e = this;
                                if ("none" === t(this.element).css("display"))
                                    throw new Error("Please use show on visible elements");
                                var i = t.Event(this.constructor.Event.SHOW);
                                if (this.isWithContent() && this._isEnabled) {
                                    t(this.element).trigger(i);
                                    var s = t.contains(this.element.ownerDocument.documentElement, this.element);
                                    if (i.isDefaultPrevented() || !s) return;
                                    var r = this.getTipElement(),
                                        o = P.getUID(this.constructor.NAME);
                                    r.setAttribute("id", o),
                                        this.element.setAttribute("aria-describedby", o),
                                        this.setContent(),
                                        this.config.animation && t(r).addClass(g);
                                    var l =
                                            "function" == typeof this.config.placement
                                                ? this.config.placement.call(this, r, this.element)
                                                : this.config.placement,
                                        h = this._getAttachment(l);
                                    this.addAttachmentClass(h);
                                    var c = !1 === this.config.container ? document.body : t(this.config.container);
                                    t(r).data(this.constructor.DATA_KEY, this),
                                        t.contains(this.element.ownerDocument.documentElement, this.tip) ||
                                            t(r).appendTo(c),
                                        t(this.element).trigger(this.constructor.Event.INSERTED),
                                        (this._popper = new n(this.element, r, {
                                            placement: h,
                                            modifiers: {
                                                offset: { offset: this.config.offset },
                                                flip: { behavior: this.config.fallbackPlacement },
                                                arrow: { element: v },
                                                preventOverflow: { boundariesElement: this.config.boundary },
                                            },
                                            onCreate: function (t) {
                                                t.originalPlacement !== t.placement &&
                                                    e._handlePopperPlacementChange(t);
                                            },
                                            onUpdate: function (t) {
                                                e._handlePopperPlacementChange(t);
                                            },
                                        })),
                                        t(r).addClass(p),
                                        "ontouchstart" in document.documentElement &&
                                            t("body").children().on("mouseover", null, t.noop);
                                    var u = function () {
                                        e.config.animation && e._fixTransition();
                                        var n = e._hoverState;
                                        (e._hoverState = null),
                                            t(e.element).trigger(e.constructor.Event.SHOWN),
                                            n === d && e._leave(null, e);
                                    };
                                    P.supportsTransitionEnd() && t(this.tip).hasClass(g)
                                        ? t(this.tip)
                                              .one(P.TRANSITION_END, u)
                                              .emulateTransitionEnd(a._TRANSITION_DURATION)
                                        : u();
                                }
                            }),
                            (I.hide = function (e) {
                                var n = this,
                                    i = this.getTipElement(),
                                    s = t.Event(this.constructor.Event.HIDE),
                                    r = function () {
                                        n._hoverState !== f && i.parentNode && i.parentNode.removeChild(i),
                                            n._cleanTipClass(),
                                            n.element.removeAttribute("aria-describedby"),
                                            t(n.element).trigger(n.constructor.Event.HIDDEN),
                                            null !== n._popper && n._popper.destroy(),
                                            e && e();
                                    };
                                t(this.element).trigger(s),
                                    s.isDefaultPrevented() ||
                                        (t(i).removeClass(p),
                                        "ontouchstart" in document.documentElement &&
                                            t("body").children().off("mouseover", null, t.noop),
                                        (this._activeTrigger[y] = !1),
                                        (this._activeTrigger[T] = !1),
                                        (this._activeTrigger[E] = !1),
                                        P.supportsTransitionEnd() && t(this.tip).hasClass(g)
                                            ? t(i).one(P.TRANSITION_END, r).emulateTransitionEnd(150)
                                            : r(),
                                        (this._hoverState = ""));
                            }),
                            (I.update = function () {
                                null !== this._popper && this._popper.scheduleUpdate();
                            }),
                            (I.isWithContent = function () {
                                return Boolean(this.getTitle());
                            }),
                            (I.addAttachmentClass = function (e) {
                                t(this.getTipElement()).addClass("bs-tooltip-" + e);
                            }),
                            (I.getTipElement = function () {
                                return (this.tip = this.tip || t(this.config.template)[0]), this.tip;
                            }),
                            (I.setContent = function () {
                                var e = t(this.getTipElement());
                                this.setElementContent(e.find(m), this.getTitle()), e.removeClass(g + " " + p);
                            }),
                            (I.setElementContent = function (e, n) {
                                var i = this.config.html;
                                "object" == typeof n && (n.nodeType || n.jquery)
                                    ? i
                                        ? t(n).parent().is(e) || e.empty().append(n)
                                        : e.text(t(n).text())
                                    : e[i ? "html" : "text"](n);
                            }),
                            (I.getTitle = function () {
                                var t = this.element.getAttribute("data-original-title");
                                return (
                                    t ||
                                        (t =
                                            "function" == typeof this.config.title
                                                ? this.config.title.call(this.element)
                                                : this.config.title),
                                    t
                                );
                            }),
                            (I._getAttachment = function (t) {
                                return c[t.toUpperCase()];
                            }),
                            (I._setListeners = function () {
                                var e = this;
                                this.config.trigger.split(" ").forEach(function (n) {
                                    if ("click" === n)
                                        t(e.element).on(e.constructor.Event.CLICK, e.config.selector, function (t) {
                                            return e.toggle(t);
                                        });
                                    else if (n !== C) {
                                        var i = n === E ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN,
                                            s = n === E ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                                        t(e.element)
                                            .on(i, e.config.selector, function (t) {
                                                return e._enter(t);
                                            })
                                            .on(s, e.config.selector, function (t) {
                                                return e._leave(t);
                                            });
                                    }
                                    t(e.element)
                                        .closest(".modal")
                                        .on("hide.bs.modal", function () {
                                            return e.hide();
                                        });
                                }),
                                    this.config.selector
                                        ? (this.config = r({}, this.config, { trigger: "manual", selector: "" }))
                                        : this._fixTitle();
                            }),
                            (I._fixTitle = function () {
                                var t = typeof this.element.getAttribute("data-original-title");
                                (this.element.getAttribute("title") || "string" !== t) &&
                                    (this.element.setAttribute(
                                        "data-original-title",
                                        this.element.getAttribute("title") || ""
                                    ),
                                    this.element.setAttribute("title", ""));
                            }),
                            (I._enter = function (e, n) {
                                var i = this.constructor.DATA_KEY;
                                (n = n || t(e.currentTarget).data(i)) ||
                                    ((n = new this.constructor(e.currentTarget, this._getDelegateConfig())),
                                    t(e.currentTarget).data(i, n)),
                                    e && (n._activeTrigger["focusin" === e.type ? T : E] = !0),
                                    t(n.getTipElement()).hasClass(p) || n._hoverState === f
                                        ? (n._hoverState = f)
                                        : (clearTimeout(n._timeout),
                                          (n._hoverState = f),
                                          n.config.delay && n.config.delay.show
                                              ? (n._timeout = setTimeout(function () {
                                                    n._hoverState === f && n.show();
                                                }, n.config.delay.show))
                                              : n.show());
                            }),
                            (I._leave = function (e, n) {
                                var i = this.constructor.DATA_KEY;
                                (n = n || t(e.currentTarget).data(i)) ||
                                    ((n = new this.constructor(e.currentTarget, this._getDelegateConfig())),
                                    t(e.currentTarget).data(i, n)),
                                    e && (n._activeTrigger["focusout" === e.type ? T : E] = !1),
                                    n._isWithActiveTrigger() ||
                                        (clearTimeout(n._timeout),
                                        (n._hoverState = d),
                                        n.config.delay && n.config.delay.hide
                                            ? (n._timeout = setTimeout(function () {
                                                  n._hoverState === d && n.hide();
                                              }, n.config.delay.hide))
                                            : n.hide());
                            }),
                            (I._isWithActiveTrigger = function () {
                                for (var t in this._activeTrigger) if (this._activeTrigger[t]) return !0;
                                return !1;
                            }),
                            (I._getConfig = function (n) {
                                return (
                                    "number" ==
                                        typeof (n = r({}, this.constructor.Default, t(this.element).data(), n)).delay &&
                                        (n.delay = { show: n.delay, hide: n.delay }),
                                    "number" == typeof n.title && (n.title = n.title.toString()),
                                    "number" == typeof n.content && (n.content = n.content.toString()),
                                    P.typeCheckConfig(e, n, this.constructor.DefaultType),
                                    n
                                );
                            }),
                            (I._getDelegateConfig = function () {
                                var t = {};
                                if (this.config)
                                    for (var e in this.config)
                                        this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
                                return t;
                            }),
                            (I._cleanTipClass = function () {
                                var e = t(this.getTipElement()),
                                    n = e.attr("class").match(l);
                                null !== n && n.length > 0 && e.removeClass(n.join(""));
                            }),
                            (I._handlePopperPlacementChange = function (t) {
                                this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement));
                            }),
                            (I._fixTransition = function () {
                                var e = this.getTipElement(),
                                    n = this.config.animation;
                                null === e.getAttribute("x-placement") &&
                                    (t(e).removeClass(g),
                                    (this.config.animation = !1),
                                    this.hide(),
                                    this.show(),
                                    (this.config.animation = n));
                            }),
                            (a._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var n = t(this).data(i),
                                        s = "object" == typeof e && e;
                                    if (
                                        (n || !/dispose|hide/.test(e)) &&
                                        (n || ((n = new a(this, s)), t(this).data(i, n)), "string" == typeof e)
                                    ) {
                                        if ("undefined" == typeof n[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        n[e]();
                                    }
                                });
                            }),
                            s(a, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return u;
                                    },
                                },
                                {
                                    key: "NAME",
                                    get: function () {
                                        return e;
                                    },
                                },
                                {
                                    key: "DATA_KEY",
                                    get: function () {
                                        return i;
                                    },
                                },
                                {
                                    key: "Event",
                                    get: function () {
                                        return _;
                                    },
                                },
                                {
                                    key: "EVENT_KEY",
                                    get: function () {
                                        return o;
                                    },
                                },
                                {
                                    key: "DefaultType",
                                    get: function () {
                                        return h;
                                    },
                                },
                            ]),
                            a
                        );
                    })();
                return (
                    (t.fn[e] = I._jQueryInterface),
                    (t.fn[e].Constructor = I),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = a), I._jQueryInterface;
                    }),
                    I
                );
            })(e),
            x = (function (t) {
                var e = "popover",
                    n = "bs.popover",
                    i = "." + n,
                    o = t.fn[e],
                    a = new RegExp("(^|\\s)bs-popover\\S+", "g"),
                    l = r({}, U.Default, {
                        placement: "right",
                        trigger: "click",
                        content: "",
                        template:
                            '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
                    }),
                    h = r({}, U.DefaultType, { content: "(string|element|function)" }),
                    c = "fade",
                    u = "show",
                    f = ".popover-header",
                    d = ".popover-body",
                    _ = {
                        HIDE: "hide" + i,
                        HIDDEN: "hidden" + i,
                        SHOW: "show" + i,
                        SHOWN: "shown" + i,
                        INSERTED: "inserted" + i,
                        CLICK: "click" + i,
                        FOCUSIN: "focusin" + i,
                        FOCUSOUT: "focusout" + i,
                        MOUSEENTER: "mouseenter" + i,
                        MOUSELEAVE: "mouseleave" + i,
                    },
                    g = (function (r) {
                        var o, g;
                        function p() {
                            return r.apply(this, arguments) || this;
                        }
                        (g = r),
                            ((o = p).prototype = Object.create(g.prototype)),
                            (o.prototype.constructor = o),
                            (o.__proto__ = g);
                        var m = p.prototype;
                        return (
                            (m.isWithContent = function () {
                                return this.getTitle() || this._getContent();
                            }),
                            (m.addAttachmentClass = function (e) {
                                t(this.getTipElement()).addClass("bs-popover-" + e);
                            }),
                            (m.getTipElement = function () {
                                return (this.tip = this.tip || t(this.config.template)[0]), this.tip;
                            }),
                            (m.setContent = function () {
                                var e = t(this.getTipElement());
                                this.setElementContent(e.find(f), this.getTitle());
                                var n = this._getContent();
                                "function" == typeof n && (n = n.call(this.element)),
                                    this.setElementContent(e.find(d), n),
                                    e.removeClass(c + " " + u);
                            }),
                            (m._getContent = function () {
                                return this.element.getAttribute("data-content") || this.config.content;
                            }),
                            (m._cleanTipClass = function () {
                                var e = t(this.getTipElement()),
                                    n = e.attr("class").match(a);
                                null !== n && n.length > 0 && e.removeClass(n.join(""));
                            }),
                            (p._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var i = t(this).data(n),
                                        s = "object" == typeof e ? e : null;
                                    if (
                                        (i || !/destroy|hide/.test(e)) &&
                                        (i || ((i = new p(this, s)), t(this).data(n, i)), "string" == typeof e)
                                    ) {
                                        if ("undefined" == typeof i[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        i[e]();
                                    }
                                });
                            }),
                            s(p, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return l;
                                    },
                                },
                                {
                                    key: "NAME",
                                    get: function () {
                                        return e;
                                    },
                                },
                                {
                                    key: "DATA_KEY",
                                    get: function () {
                                        return n;
                                    },
                                },
                                {
                                    key: "Event",
                                    get: function () {
                                        return _;
                                    },
                                },
                                {
                                    key: "EVENT_KEY",
                                    get: function () {
                                        return i;
                                    },
                                },
                                {
                                    key: "DefaultType",
                                    get: function () {
                                        return h;
                                    },
                                },
                            ]),
                            p
                        );
                    })(U);
                return (
                    (t.fn[e] = g._jQueryInterface),
                    (t.fn[e].Constructor = g),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = o), g._jQueryInterface;
                    }),
                    g
                );
            })(e),
            K = (function (t) {
                var e = "scrollspy",
                    n = "bs.scrollspy",
                    i = "." + n,
                    o = t.fn[e],
                    a = { offset: 10, method: "auto", target: "" },
                    l = { offset: "number", method: "string", target: "(string|element)" },
                    h = { ACTIVATE: "activate" + i, SCROLL: "scroll" + i, LOAD_DATA_API: "load" + i + ".data-api" },
                    c = "dropdown-item",
                    u = "active",
                    f = {
                        DATA_SPY: '[data-spy="scroll"]',
                        ACTIVE: ".active",
                        NAV_LIST_GROUP: ".nav, .list-group",
                        NAV_LINKS: ".nav-link",
                        NAV_ITEMS: ".nav-item",
                        LIST_ITEMS: ".list-group-item",
                        DROPDOWN: ".dropdown",
                        DROPDOWN_ITEMS: ".dropdown-item",
                        DROPDOWN_TOGGLE: ".dropdown-toggle",
                    },
                    d = "offset",
                    _ = "position",
                    g = (function () {
                        function o(e, n) {
                            var i = this;
                            (this._element = e),
                                (this._scrollElement = "BODY" === e.tagName ? window : e),
                                (this._config = this._getConfig(n)),
                                (this._selector =
                                    this._config.target +
                                    " " +
                                    f.NAV_LINKS +
                                    "," +
                                    this._config.target +
                                    " " +
                                    f.LIST_ITEMS +
                                    "," +
                                    this._config.target +
                                    " " +
                                    f.DROPDOWN_ITEMS),
                                (this._offsets = []),
                                (this._targets = []),
                                (this._activeTarget = null),
                                (this._scrollHeight = 0),
                                t(this._scrollElement).on(h.SCROLL, function (t) {
                                    return i._process(t);
                                }),
                                this.refresh(),
                                this._process();
                        }
                        var g = o.prototype;
                        return (
                            (g.refresh = function () {
                                var e = this,
                                    n = this._scrollElement === this._scrollElement.window ? d : _,
                                    i = "auto" === this._config.method ? n : this._config.method,
                                    s = i === _ ? this._getScrollTop() : 0;
                                (this._offsets = []),
                                    (this._targets = []),
                                    (this._scrollHeight = this._getScrollHeight()),
                                    t
                                        .makeArray(t(this._selector))
                                        .map(function (e) {
                                            var n,
                                                r = P.getSelectorFromElement(e);
                                            if ((r && (n = t(r)[0]), n)) {
                                                var o = n.getBoundingClientRect();
                                                if (o.width || o.height) return [t(n)[i]().top + s, r];
                                            }
                                            return null;
                                        })
                                        .filter(function (t) {
                                            return t;
                                        })
                                        .sort(function (t, e) {
                                            return t[0] - e[0];
                                        })
                                        .forEach(function (t) {
                                            e._offsets.push(t[0]), e._targets.push(t[1]);
                                        });
                            }),
                            (g.dispose = function () {
                                t.removeData(this._element, n),
                                    t(this._scrollElement).off(i),
                                    (this._element = null),
                                    (this._scrollElement = null),
                                    (this._config = null),
                                    (this._selector = null),
                                    (this._offsets = null),
                                    (this._targets = null),
                                    (this._activeTarget = null),
                                    (this._scrollHeight = null);
                            }),
                            (g._getConfig = function (n) {
                                if ("string" != typeof (n = r({}, a, n)).target) {
                                    var i = t(n.target).attr("id");
                                    i || ((i = P.getUID(e)), t(n.target).attr("id", i)), (n.target = "#" + i);
                                }
                                return P.typeCheckConfig(e, n, l), n;
                            }),
                            (g._getScrollTop = function () {
                                return this._scrollElement === window
                                    ? this._scrollElement.pageYOffset
                                    : this._scrollElement.scrollTop;
                            }),
                            (g._getScrollHeight = function () {
                                return (
                                    this._scrollElement.scrollHeight ||
                                    Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                                );
                            }),
                            (g._getOffsetHeight = function () {
                                return this._scrollElement === window
                                    ? window.innerHeight
                                    : this._scrollElement.getBoundingClientRect().height;
                            }),
                            (g._process = function () {
                                var t = this._getScrollTop() + this._config.offset,
                                    e = this._getScrollHeight(),
                                    n = this._config.offset + e - this._getOffsetHeight();
                                if ((this._scrollHeight !== e && this.refresh(), t >= n)) {
                                    var i = this._targets[this._targets.length - 1];
                                    this._activeTarget !== i && this._activate(i);
                                } else {
                                    if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0)
                                        return (this._activeTarget = null), void this._clear();
                                    for (var s = this._offsets.length; s--; ) {
                                        this._activeTarget !== this._targets[s] &&
                                            t >= this._offsets[s] &&
                                            ("undefined" == typeof this._offsets[s + 1] || t < this._offsets[s + 1]) &&
                                            this._activate(this._targets[s]);
                                    }
                                }
                            }),
                            (g._activate = function (e) {
                                (this._activeTarget = e), this._clear();
                                var n = this._selector.split(",");
                                n = n.map(function (t) {
                                    return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]';
                                });
                                var i = t(n.join(","));
                                i.hasClass(c)
                                    ? (i.closest(f.DROPDOWN).find(f.DROPDOWN_TOGGLE).addClass(u), i.addClass(u))
                                    : (i.addClass(u),
                                      i
                                          .parents(f.NAV_LIST_GROUP)
                                          .prev(f.NAV_LINKS + ", " + f.LIST_ITEMS)
                                          .addClass(u),
                                      i.parents(f.NAV_LIST_GROUP).prev(f.NAV_ITEMS).children(f.NAV_LINKS).addClass(u)),
                                    t(this._scrollElement).trigger(h.ACTIVATE, { relatedTarget: e });
                            }),
                            (g._clear = function () {
                                t(this._selector).filter(f.ACTIVE).removeClass(u);
                            }),
                            (o._jQueryInterface = function (e) {
                                return this.each(function () {
                                    var i = t(this).data(n);
                                    if (
                                        (i || ((i = new o(this, "object" == typeof e && e)), t(this).data(n, i)),
                                        "string" == typeof e)
                                    ) {
                                        if ("undefined" == typeof i[e])
                                            throw new TypeError('No method named "' + e + '"');
                                        i[e]();
                                    }
                                });
                            }),
                            s(o, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                                {
                                    key: "Default",
                                    get: function () {
                                        return a;
                                    },
                                },
                            ]),
                            o
                        );
                    })();
                return (
                    t(window).on(h.LOAD_DATA_API, function () {
                        for (var e = t.makeArray(t(f.DATA_SPY)), n = e.length; n--; ) {
                            var i = t(e[n]);
                            g._jQueryInterface.call(i, i.data());
                        }
                    }),
                    (t.fn[e] = g._jQueryInterface),
                    (t.fn[e].Constructor = g),
                    (t.fn[e].noConflict = function () {
                        return (t.fn[e] = o), g._jQueryInterface;
                    }),
                    g
                );
            })(e),
            V = (function (t) {
                var e = "bs.tab",
                    n = "." + e,
                    i = t.fn.tab,
                    r = {
                        HIDE: "hide" + n,
                        HIDDEN: "hidden" + n,
                        SHOW: "show" + n,
                        SHOWN: "shown" + n,
                        CLICK_DATA_API: "click.bs.tab.data-api",
                    },
                    o = "dropdown-menu",
                    a = "active",
                    l = "disabled",
                    h = "fade",
                    c = "show",
                    u = ".dropdown",
                    f = ".nav, .list-group",
                    d = ".active",
                    _ = "> li > .active",
                    g = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
                    p = ".dropdown-toggle",
                    m = "> .dropdown-menu .active",
                    v = (function () {
                        function n(t) {
                            this._element = t;
                        }
                        var i = n.prototype;
                        return (
                            (i.show = function () {
                                var e = this;
                                if (
                                    !(
                                        (this._element.parentNode &&
                                            this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
                                            t(this._element).hasClass(a)) ||
                                        t(this._element).hasClass(l)
                                    )
                                ) {
                                    var n,
                                        i,
                                        s = t(this._element).closest(f)[0],
                                        o = P.getSelectorFromElement(this._element);
                                    if (s) {
                                        var h = "UL" === s.nodeName ? _ : d;
                                        i = (i = t.makeArray(t(s).find(h)))[i.length - 1];
                                    }
                                    var c = t.Event(r.HIDE, { relatedTarget: this._element }),
                                        u = t.Event(r.SHOW, { relatedTarget: i });
                                    if (
                                        (i && t(i).trigger(c),
                                        t(this._element).trigger(u),
                                        !u.isDefaultPrevented() && !c.isDefaultPrevented())
                                    ) {
                                        o && (n = t(o)[0]), this._activate(this._element, s);
                                        var g = function () {
                                            var n = t.Event(r.HIDDEN, { relatedTarget: e._element }),
                                                s = t.Event(r.SHOWN, { relatedTarget: i });
                                            t(i).trigger(n), t(e._element).trigger(s);
                                        };
                                        n ? this._activate(n, n.parentNode, g) : g();
                                    }
                                }
                            }),
                            (i.dispose = function () {
                                t.removeData(this._element, e), (this._element = null);
                            }),
                            (i._activate = function (e, n, i) {
                                var s = this,
                                    r = ("UL" === n.nodeName ? t(n).find(_) : t(n).children(d))[0],
                                    o = i && P.supportsTransitionEnd() && r && t(r).hasClass(h),
                                    a = function () {
                                        return s._transitionComplete(e, r, i);
                                    };
                                r && o ? t(r).one(P.TRANSITION_END, a).emulateTransitionEnd(150) : a();
                            }),
                            (i._transitionComplete = function (e, n, i) {
                                if (n) {
                                    t(n).removeClass(c + " " + a);
                                    var s = t(n.parentNode).find(m)[0];
                                    s && t(s).removeClass(a),
                                        "tab" === n.getAttribute("role") && n.setAttribute("aria-selected", !1);
                                }
                                if (
                                    (t(e).addClass(a),
                                    "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0),
                                    P.reflow(e),
                                    t(e).addClass(c),
                                    e.parentNode && t(e.parentNode).hasClass(o))
                                ) {
                                    var r = t(e).closest(u)[0];
                                    r && t(r).find(p).addClass(a), e.setAttribute("aria-expanded", !0);
                                }
                                i && i();
                            }),
                            (n._jQueryInterface = function (i) {
                                return this.each(function () {
                                    var s = t(this),
                                        r = s.data(e);
                                    if ((r || ((r = new n(this)), s.data(e, r)), "string" == typeof i)) {
                                        if ("undefined" == typeof r[i])
                                            throw new TypeError('No method named "' + i + '"');
                                        r[i]();
                                    }
                                });
                            }),
                            s(n, null, [
                                {
                                    key: "VERSION",
                                    get: function () {
                                        return "4.0.0";
                                    },
                                },
                            ]),
                            n
                        );
                    })();
                return (
                    t(document).on(r.CLICK_DATA_API, g, function (e) {
                        e.preventDefault(), v._jQueryInterface.call(t(this), "show");
                    }),
                    (t.fn.tab = v._jQueryInterface),
                    (t.fn.tab.Constructor = v),
                    (t.fn.tab.noConflict = function () {
                        return (t.fn.tab = i), v._jQueryInterface;
                    }),
                    v
                );
            })(e);
        !(function (t) {
            if ("undefined" == typeof t)
                throw new TypeError(
                    "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript."
                );
            var e = t.fn.jquery.split(" ")[0].split(".");
            if ((e[0] < 2 && e[1] < 9) || (1 === e[0] && 9 === e[1] && e[2] < 1) || e[0] >= 4)
                throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        })(e),
            (t.Util = P),
            (t.Alert = L),
            (t.Button = R),
            (t.Carousel = j),
            (t.Collapse = H),
            (t.Dropdown = W),
            (t.Modal = M),
            (t.Popover = x),
            (t.Scrollspy = K),
            (t.Tab = V),
            (t.Tooltip = U),
            Object.defineProperty(t, "__esModule", { value: !0 });
    }) /*!

/**
 * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
 * https://github.com/iconic/SVGInjector
 *
 * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
 * @license MIT
 */,
    !(function (t, e) {
        "use strict";
        var r = "file:" === t.location.protocol,
            n = e.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
        var i =
                Array.prototype.forEach ||
                function (t, e) {
                    if (null == this || "function" != typeof t) throw new TypeError();
                    var r,
                        n = this.length >>> 0;
                    for (r = 0; r < n; ++r) r in this && t.call(e, this[r], r, this);
                },
            o = {},
            a = 0,
            l = [],
            s = [],
            u = {},
            c = function (t) {
                return t.cloneNode(!0);
            },
            f = function (t, e) {
                (s[t] = s[t] || []), s[t].push(e);
            },
            p = function (e, n) {
                if (void 0 !== o[e]) o[e] instanceof SVGSVGElement ? n(c(o[e])) : f(e, n);
                else {
                    if (!t.XMLHttpRequest) return n("Browser does not support XMLHttpRequest"), !1;
                    (o[e] = {}), f(e, n);
                    var i = new XMLHttpRequest();
                    (i.onreadystatechange = function () {
                        if (4 === i.readyState) {
                            if (404 === i.status || null === i.responseXML)
                                return (
                                    n("Unable to load SVG file: " + e),
                                    r &&
                                        n(
                                            "Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver."
                                        ),
                                    n(),
                                    !1
                                );
                            if (!(200 === i.status || (r && 0 === i.status)))
                                return n("There was a problem injecting the SVG: " + i.status + " " + i.statusText), !1;
                            if (i.responseXML instanceof Document) o[e] = i.responseXML.documentElement;
                            else if (DOMParser && DOMParser instanceof Function) {
                                var t;
                                try {
                                    t = new DOMParser().parseFromString(i.responseText, "text/xml");
                                } catch (e) {
                                    t = void 0;
                                }
                                if (!t || t.getElementsByTagName("parsererror").length)
                                    return n("Unable to parse SVG file: " + e), !1;
                                o[e] = t.documentElement;
                            }
                            !(function (t) {
                                for (var e = 0, r = s[t].length; e < r; e++)
                                    !(function (e) {
                                        setTimeout(function () {
                                            s[t][e](c(o[t]));
                                        }, 0);
                                    })(e);
                            })(e);
                        }
                    }),
                        i.open("GET", e),
                        i.overrideMimeType && i.overrideMimeType("text/xml"),
                        i.send();
                }
            },
            d = function (e, r, o, s) {
                var c = e.getAttribute("data-src") || e.getAttribute("src");
                if (/\.svg/i.test(c))
                    if (n)
                        -1 === l.indexOf(e) &&
                            (l.push(e),
                            e.setAttribute("src", ""),
                            p(c, function (n) {
                                if (void 0 === n || "string" == typeof n) return s(n), !1;
                                var o = e.getAttribute("id");
                                o && n.setAttribute("id", o);
                                var f = e.getAttribute("title");
                                f && n.setAttribute("title", f);
                                var p = []
                                    .concat(
                                        n.getAttribute("class") || [],
                                        "injected-svg",
                                        e.getAttribute("class") || []
                                    )
                                    .join(" ");
                                n.setAttribute(
                                    "class",
                                    (function (t) {
                                        for (var e = {}, r = (t = t.split(" ")).length, n = []; r--; )
                                            e.hasOwnProperty(t[r]) || ((e[t[r]] = 1), n.unshift(t[r]));
                                        return n.join(" ");
                                    })(p)
                                );
                                var d = e.getAttribute("style");
                                d && n.setAttribute("style", d);
                                var v = [].filter.call(e.attributes, function (t) {
                                    return /^data-\w[\w\-]*$/.test(t.name);
                                });
                                i.call(v, function (t) {
                                    t.name && t.value && n.setAttribute(t.name, t.value);
                                });
                                var g,
                                    h,
                                    m,
                                    b,
                                    y,
                                    A = {
                                        clipPath: ["clip-path"],
                                        "color-profile": ["color-profile"],
                                        cursor: ["cursor"],
                                        filter: ["filter"],
                                        linearGradient: ["fill", "stroke"],
                                        marker: ["marker", "marker-start", "marker-mid", "marker-end"],
                                        mask: ["mask"],
                                        pattern: ["fill", "stroke"],
                                        radialGradient: ["fill", "stroke"],
                                    };
                                Object.keys(A).forEach(function (t) {
                                    (g = t), (m = A[t]);
                                    for (
                                        var e = 0, r = (h = n.querySelectorAll("defs " + g + "[id]")).length;
                                        e < r;
                                        e++
                                    ) {
                                        var o;
                                        (b = h[e].id),
                                            (y = b + "-" + a),
                                            i.call(m, function (t) {
                                                for (
                                                    var e = 0,
                                                        r = (o = n.querySelectorAll("[" + t + '*="' + b + '"]')).length;
                                                    e < r;
                                                    e++
                                                )
                                                    o[e].setAttribute(t, "url(#" + y + ")");
                                            }),
                                            (h[e].id = y);
                                    }
                                }),
                                    n.removeAttribute("xmlns:a");
                                for (
                                    var w, x, S = n.querySelectorAll("script"), k = [], j = 0, G = S.length;
                                    j < G;
                                    j++
                                )
                                    ((x = S[j].getAttribute("type")) &&
                                        "application/ecmascript" !== x &&
                                        "application/javascript" !== x) ||
                                        ((w = S[j].innerText || S[j].textContent), k.push(w), n.removeChild(S[j]));
                                if (k.length > 0 && ("always" === r || ("once" === r && !u[c]))) {
                                    for (var T = 0, M = k.length; T < M; T++) new Function(k[T])(t);
                                    u[c] = !0;
                                }
                                var V = n.querySelectorAll("style");
                                i.call(V, function (t) {
                                    t.textContent += "";
                                }),
                                    e.parentNode.replaceChild(n, e),
                                    delete l[l.indexOf(e)],
                                    (e = null),
                                    a++,
                                    s(n);
                            }));
                    else {
                        var f = e.getAttribute("data-fallback") || e.getAttribute("data-png");
                        f
                            ? (e.setAttribute("src", f), s(null))
                            : o
                              ? (e.setAttribute("src", o + "/" + c.split("/").pop().replace(".svg", ".png")), s(null))
                              : s("This browser does not support SVG and no PNG fallback was defined.");
                    }
                else s("Attempted to inject a file with a non-svg extension: " + c);
            },
            v = function (t, e, r) {
                var n = (e = e || {}).evalScripts || "always",
                    o = e.pngFallback || !1,
                    a = e.each;
                if (void 0 !== t.length) {
                    var l = 0;
                    i.call(t, function (e) {
                        d(e, n, o, function (e) {
                            a && "function" == typeof a && a(e), r && t.length === ++l && r(l);
                        });
                    });
                } else
                    t
                        ? d(t, n, o, function (e) {
                              a && "function" == typeof a && a(e), r && r(1), (t = null);
                          })
                        : r && r(0);
            };
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = exports = v)
            : "function" == typeof define && define.amd
              ? define(function () {
                    return v;
                })
              : "object" == typeof t && (t.SVGInjector = v);
    })(window, document) /*!

/*!
 * History js
 *
 */,
    (function (e, t) {
        "use strict";
        var n = (e.History = e.History || {}),
            r = e.jQuery;
        if (typeof n.Adapter != "undefined") throw new Error("History.js Adapter has already been loaded...");
        (n.Adapter = {
            bind: function (e, t, n) {
                r(e).bind(t, n);
            },
            trigger: function (e, t, n) {
                r(e).trigger(t, n);
            },
            extractEventData: function (e, n, r) {
                var i = (n && n.originalEvent && n.originalEvent[e]) || (r && r[e]) || t;
                return i;
            },
            onDomLoad: function (e) {
                r(e);
            },
        }),
            typeof n.init != "undefined" && n.init();
    })(window),
    (function (e, t) {
        "use strict";
        var n = e.console || t,
            r = e.document,
            i = e.navigator,
            s = !1,
            o = e.setTimeout,
            u = e.clearTimeout,
            a = e.setInterval,
            f = e.clearInterval,
            l = e.JSON,
            c = e.alert,
            h = (e.History = e.History || {}),
            p = e.history;
        try {
            (s = e.sessionStorage), s.setItem("TEST", "1"), s.removeItem("TEST");
        } catch (d) {
            s = !1;
        }
        (l.stringify = l.stringify || l.encode), (l.parse = l.parse || l.decode);
        if (typeof h.init != "undefined") throw new Error("History.js Core has already been loaded...");
        (h.init = function (e) {
            return typeof h.Adapter == "undefined"
                ? !1
                : (typeof h.initCore != "undefined" && h.initCore(),
                  typeof h.initHtml4 != "undefined" && h.initHtml4(),
                  !0);
        }),
            (h.initCore = function (d) {
                if (typeof h.initCore.initialized != "undefined") return !1;
                (h.initCore.initialized = !0),
                    (h.options = h.options || {}),
                    (h.options.hashChangeInterval = h.options.hashChangeInterval || 100),
                    (h.options.safariPollInterval = h.options.safariPollInterval || 500),
                    (h.options.doubleCheckInterval = h.options.doubleCheckInterval || 500),
                    (h.options.disableSuid = h.options.disableSuid || !1),
                    (h.options.storeInterval = h.options.storeInterval || 1e3),
                    (h.options.busyDelay = h.options.busyDelay || 250),
                    (h.options.debug = h.options.debug || !1),
                    (h.options.initialTitle = h.options.initialTitle || r.title),
                    (h.options.html4Mode = h.options.html4Mode || !1),
                    (h.options.delayInit = h.options.delayInit || !1),
                    (h.intervalList = []),
                    (h.clearAllIntervals = function () {
                        var e,
                            t = h.intervalList;
                        if (typeof t != "undefined" && t !== null) {
                            for (e = 0; e < t.length; e++) f(t[e]);
                            h.intervalList = null;
                        }
                    }),
                    (h.debug = function () {
                        (h.options.debug || !1) && h.log.apply(h, arguments);
                    }),
                    (h.log = function () {
                        var e =
                                typeof n != "undefined" &&
                                typeof n.log != "undefined" &&
                                typeof n.log.apply != "undefined",
                            t = r.getElementById("log"),
                            i,
                            s,
                            o,
                            u,
                            a;
                        e
                            ? ((u = Array.prototype.slice.call(arguments)),
                              (i = u.shift()),
                              typeof n.debug != "undefined" ? n.debug.apply(n, [i, u]) : n.log.apply(n, [i, u]))
                            : (i = "\n" + arguments[0] + "\n");
                        for (s = 1, o = arguments.length; s < o; ++s) {
                            a = arguments[s];
                            if (typeof a == "object" && typeof l != "undefined")
                                try {
                                    a = l.stringify(a);
                                } catch (f) {}
                            i += "\n" + a + "\n";
                        }
                        return (
                            t
                                ? ((t.value += i + "\n-----\n"), (t.scrollTop = t.scrollHeight - t.clientHeight))
                                : e || c(i),
                            !0
                        );
                    }),
                    (h.getInternetExplorerMajorVersion = function () {
                        var e = (h.getInternetExplorerMajorVersion.cached =
                            typeof h.getInternetExplorerMajorVersion.cached != "undefined"
                                ? h.getInternetExplorerMajorVersion.cached
                                : (function () {
                                      var e = 3,
                                          t = r.createElement("div"),
                                          n = t.getElementsByTagName("i");
                                      while ((t.innerHTML = "<!--[if gt IE " + ++e + "]><i></i><![endif]-->") && n[0]);
                                      return e > 4 ? e : !1;
                                  })());
                        return e;
                    }),
                    (h.isInternetExplorer = function () {
                        var e = (h.isInternetExplorer.cached =
                            typeof h.isInternetExplorer.cached != "undefined"
                                ? h.isInternetExplorer.cached
                                : Boolean(h.getInternetExplorerMajorVersion()));
                        return e;
                    }),
                    h.options.html4Mode
                        ? (h.emulated = { pushState: !0, hashChange: !0 })
                        : (h.emulated = {
                              pushState: !Boolean(
                                  e.history &&
                                      e.history.pushState &&
                                      e.history.replaceState &&
                                      !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(i.userAgent) &&
                                      !/AppleWebKit\/5([0-2]|3[0-2])/i.test(i.userAgent)
                              ),
                              hashChange: Boolean(
                                  !("onhashchange" in e || "onhashchange" in r) ||
                                      (h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8)
                              ),
                          }),
                    (h.enabled = !h.emulated.pushState),
                    (h.bugs = {
                        setHash: Boolean(
                            !h.emulated.pushState &&
                                i.vendor === "Apple Computer, Inc." &&
                                /AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)
                        ),
                        safariPoll: Boolean(
                            !h.emulated.pushState &&
                                i.vendor === "Apple Computer, Inc." &&
                                /AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)
                        ),
                        ieDoubleCheck: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8),
                        hashEscape: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 7),
                    }),
                    (h.isEmptyObject = function (e) {
                        for (var t in e) if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    }),
                    (h.cloneObject = function (e) {
                        var t, n;
                        return e ? ((t = l.stringify(e)), (n = l.parse(t))) : (n = {}), n;
                    }),
                    (h.getRootUrl = function () {
                        var e = r.location.protocol + "//" + (r.location.hostname || r.location.host);
                        if (r.location.port || !1) e += ":" + r.location.port;
                        return (e += "/"), e;
                    }),
                    (h.getBaseHref = function () {
                        var e = r.getElementsByTagName("base"),
                            t = null,
                            n = "";
                        return (
                            e.length === 1 && ((t = e[0]), (n = t.href.replace(/[^\/]+$/, ""))),
                            (n = n.replace(/\/+$/, "")),
                            n && (n += "/"),
                            n
                        );
                    }),
                    (h.getBaseUrl = function () {
                        var e = h.getBaseHref() || h.getBasePageUrl() || h.getRootUrl();
                        return e;
                    }),
                    (h.getPageUrl = function () {
                        var e = h.getState(!1, !1),
                            t = (e || {}).url || h.getLocationHref(),
                            n;
                        return (
                            (n = t.replace(/\/+$/, "").replace(/[^\/]+$/, function (e, t, n) {
                                return /\./.test(e) ? e : e + "/";
                            })),
                            n
                        );
                    }),
                    (h.getBasePageUrl = function () {
                        var e =
                            h
                                .getLocationHref()
                                .replace(/[#\?].*/, "")
                                .replace(/[^\/]+$/, function (e, t, n) {
                                    return /[^\/]$/.test(e) ? "" : e;
                                })
                                .replace(/\/+$/, "") + "/";
                        return e;
                    }),
                    (h.getFullUrl = function (e, t) {
                        var n = e,
                            r = e.substring(0, 1);
                        return (
                            (t = typeof t == "undefined" ? !0 : t),
                            /[a-z]+\:\/\//.test(e) ||
                                (r === "/"
                                    ? (n = h.getRootUrl() + e.replace(/^\/+/, ""))
                                    : r === "#"
                                      ? (n = h.getPageUrl().replace(/#.*/, "") + e)
                                      : r === "?"
                                        ? (n = h.getPageUrl().replace(/[\?#].*/, "") + e)
                                        : t
                                          ? (n = h.getBaseUrl() + e.replace(/^(\.\/)+/, ""))
                                          : (n = h.getBasePageUrl() + e.replace(/^(\.\/)+/, ""))),
                            n.replace(/\#$/, "")
                        );
                    }),
                    (h.getShortUrl = function (e) {
                        var t = e,
                            n = h.getBaseUrl(),
                            r = h.getRootUrl();
                        return (
                            h.emulated.pushState && (t = t.replace(n, "")),
                            (t = t.replace(r, "/")),
                            h.isTraditionalAnchor(t) && (t = "./" + t),
                            (t = t.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")),
                            t
                        );
                    }),
                    (h.getLocationHref = function (e) {
                        return (
                            (e = e || r),
                            e.URL === e.location.href
                                ? e.location.href
                                : e.location.href === decodeURIComponent(e.URL)
                                  ? e.URL
                                  : e.location.hash &&
                                      decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) === e.location.hash
                                    ? e.location.href
                                    : e.URL.indexOf("#") == -1 && e.location.href.indexOf("#") != -1
                                      ? e.location.href
                                      : e.URL || e.location.href
                        );
                    }),
                    (h.store = {}),
                    (h.idToState = h.idToState || {}),
                    (h.stateToId = h.stateToId || {}),
                    (h.urlToId = h.urlToId || {}),
                    (h.storedStates = h.storedStates || []),
                    (h.savedStates = h.savedStates || []),
                    (h.normalizeStore = function () {
                        (h.store.idToState = h.store.idToState || {}),
                            (h.store.urlToId = h.store.urlToId || {}),
                            (h.store.stateToId = h.store.stateToId || {});
                    }),
                    (h.getState = function (e, t) {
                        typeof e == "undefined" && (e = !0), typeof t == "undefined" && (t = !0);
                        var n = h.getLastSavedState();
                        return (
                            !n && t && (n = h.createStateObject()),
                            e && ((n = h.cloneObject(n)), (n.url = n.cleanUrl || n.url)),
                            n
                        );
                    }),
                    (h.getIdByState = function (e) {
                        var t = h.extractId(e.url),
                            n;
                        if (!t) {
                            n = h.getStateString(e);
                            if (typeof h.stateToId[n] != "undefined") t = h.stateToId[n];
                            else if (typeof h.store.stateToId[n] != "undefined") t = h.store.stateToId[n];
                            else {
                                for (;;) {
                                    t = new Date().getTime() + String(Math.random()).replace(/\D/g, "");
                                    if (
                                        typeof h.idToState[t] == "undefined" &&
                                        typeof h.store.idToState[t] == "undefined"
                                    )
                                        break;
                                }
                                (h.stateToId[n] = t), (h.idToState[t] = e);
                            }
                        }
                        return t;
                    }),
                    (h.normalizeState = function (e) {
                        var t, n;
                        if (!e || typeof e != "object") e = {};
                        if (typeof e.normalized != "undefined") return e;
                        if (!e.data || typeof e.data != "object") e.data = {};
                        return (
                            (t = {}),
                            (t.normalized = !0),
                            (t.title = e.title || ""),
                            (t.url = h.getFullUrl(e.url ? e.url : h.getLocationHref())),
                            (t.hash = h.getShortUrl(t.url)),
                            (t.data = h.cloneObject(e.data)),
                            (t.id = h.getIdByState(t)),
                            (t.cleanUrl = t.url.replace(/\??\&_suid.*/, "")),
                            (t.url = t.cleanUrl),
                            (n = !h.isEmptyObject(t.data)),
                            (t.title || n) &&
                                h.options.disableSuid !== !0 &&
                                ((t.hash = h.getShortUrl(t.url).replace(/\??\&_suid.*/, "")),
                                /\?/.test(t.hash) || (t.hash += "?"),
                                (t.hash += "&_suid=" + t.id)),
                            (t.hashedUrl = h.getFullUrl(t.hash)),
                            (h.emulated.pushState || h.bugs.safariPoll) &&
                                h.hasUrlDuplicate(t) &&
                                (t.url = t.hashedUrl),
                            t
                        );
                    }),
                    (h.createStateObject = function (e, t, n) {
                        var r = { data: e, title: t, url: n };
                        return (r = h.normalizeState(r)), r;
                    }),
                    (h.getStateById = function (e) {
                        e = String(e);
                        var n = h.idToState[e] || h.store.idToState[e] || t;
                        return n;
                    }),
                    (h.getStateString = function (e) {
                        var t, n, r;
                        return (
                            (t = h.normalizeState(e)),
                            (n = { data: t.data, title: e.title, url: e.url }),
                            (r = l.stringify(n)),
                            r
                        );
                    }),
                    (h.getStateId = function (e) {
                        var t, n;
                        return (t = h.normalizeState(e)), (n = t.id), n;
                    }),
                    (h.getHashByState = function (e) {
                        var t, n;
                        return (t = h.normalizeState(e)), (n = t.hash), n;
                    }),
                    (h.extractId = function (e) {
                        var t, n, r, i;
                        return (
                            e.indexOf("#") != -1 ? (i = e.split("#")[0]) : (i = e),
                            (n = /(.*)\&_suid=([0-9]+)$/.exec(i)),
                            (r = n ? n[1] || e : e),
                            (t = n ? String(n[2] || "") : ""),
                            t || !1
                        );
                    }),
                    (h.isTraditionalAnchor = function (e) {
                        var t = !/[\/\?\.]/.test(e);
                        return t;
                    }),
                    (h.extractState = function (e, t) {
                        var n = null,
                            r,
                            i;
                        return (
                            (t = t || !1),
                            (r = h.extractId(e)),
                            r && (n = h.getStateById(r)),
                            n ||
                                ((i = h.getFullUrl(e)),
                                (r = h.getIdByUrl(i) || !1),
                                r && (n = h.getStateById(r)),
                                !n && t && !h.isTraditionalAnchor(e) && (n = h.createStateObject(null, null, i))),
                            n
                        );
                    }),
                    (h.getIdByUrl = function (e) {
                        var n = h.urlToId[e] || h.store.urlToId[e] || t;
                        return n;
                    }),
                    (h.getLastSavedState = function () {
                        return h.savedStates[h.savedStates.length - 1] || t;
                    }),
                    (h.getLastStoredState = function () {
                        return h.storedStates[h.storedStates.length - 1] || t;
                    }),
                    (h.hasUrlDuplicate = function (e) {
                        var t = !1,
                            n;
                        return (n = h.extractState(e.url)), (t = n && n.id !== e.id), t;
                    }),
                    (h.storeState = function (e) {
                        return (h.urlToId[e.url] = e.id), h.storedStates.push(h.cloneObject(e)), e;
                    }),
                    (h.isLastSavedState = function (e) {
                        var t = !1,
                            n,
                            r,
                            i;
                        return (
                            h.savedStates.length &&
                                ((n = e.id), (r = h.getLastSavedState()), (i = r.id), (t = n === i)),
                            t
                        );
                    }),
                    (h.saveState = function (e) {
                        return h.isLastSavedState(e) ? !1 : (h.savedStates.push(h.cloneObject(e)), !0);
                    }),
                    (h.getStateByIndex = function (e) {
                        var t = null;
                        return (
                            typeof e == "undefined"
                                ? (t = h.savedStates[h.savedStates.length - 1])
                                : e < 0
                                  ? (t = h.savedStates[h.savedStates.length + e])
                                  : (t = h.savedStates[e]),
                            t
                        );
                    }),
                    (h.getCurrentIndex = function () {
                        var e = null;
                        return h.savedStates.length < 1 ? (e = 0) : (e = h.savedStates.length - 1), e;
                    }),
                    (h.getHash = function (e) {
                        var t = h.getLocationHref(e),
                            n;
                        return (n = h.getHashByUrl(t)), n;
                    }),
                    (h.unescapeHash = function (e) {
                        var t = h.normalizeHash(e);
                        return (t = decodeURIComponent(t)), t;
                    }),
                    (h.normalizeHash = function (e) {
                        var t = e.replace(/[^#]*#/, "").replace(/#.*/, "");
                        return t;
                    }),
                    (h.setHash = function (e, t) {
                        var n, i;
                        return t !== !1 && h.busy()
                            ? (h.pushQueue({ scope: h, callback: h.setHash, args: arguments, queue: t }), !1)
                            : (h.busy(!0),
                              (n = h.extractState(e, !0)),
                              n && !h.emulated.pushState
                                  ? h.pushState(n.data, n.title, n.url, !1)
                                  : h.getHash() !== e &&
                                    (h.bugs.setHash
                                        ? ((i = h.getPageUrl()), h.pushState(null, null, i + "#" + e, !1))
                                        : (r.location.hash = e)),
                              h);
                    }),
                    (h.escapeHash = function (t) {
                        var n = h.normalizeHash(t);
                        return (
                            (n = e.encodeURIComponent(n)),
                            h.bugs.hashEscape ||
                                (n = n
                                    .replace(/\%21/g, "!")
                                    .replace(/\%26/g, "&")
                                    .replace(/\%3D/g, "=")
                                    .replace(/\%3F/g, "?")),
                            n
                        );
                    }),
                    (h.getHashByUrl = function (e) {
                        var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
                        return (t = h.unescapeHash(t)), t;
                    }),
                    (h.setTitle = function (e) {
                        var t = e.title,
                            n;
                        t ||
                            ((n = h.getStateByIndex(0)),
                            n && n.url === e.url && (t = n.title || h.options.initialTitle));
                        try {
                            r.getElementsByTagName("title")[0].innerHTML = t
                                .replace("<", "&lt;")
                                .replace(">", "&gt;")
                                .replace(" & ", " &amp; ");
                        } catch (i) {}
                        return (r.title = t), h;
                    }),
                    (h.queues = []),
                    (h.busy = function (e) {
                        typeof e != "undefined"
                            ? (h.busy.flag = e)
                            : typeof h.busy.flag == "undefined" && (h.busy.flag = !1);
                        if (!h.busy.flag) {
                            u(h.busy.timeout);
                            var t = function () {
                                var e, n, r;
                                if (h.busy.flag) return;
                                for (e = h.queues.length - 1; e >= 0; --e) {
                                    n = h.queues[e];
                                    if (n.length === 0) continue;
                                    (r = n.shift()), h.fireQueueItem(r), (h.busy.timeout = o(t, h.options.busyDelay));
                                }
                            };
                            h.busy.timeout = o(t, h.options.busyDelay);
                        }
                        return h.busy.flag;
                    }),
                    (h.busy.flag = !1),
                    (h.fireQueueItem = function (e) {
                        return e.callback.apply(e.scope || h, e.args || []);
                    }),
                    (h.pushQueue = function (e) {
                        return (
                            (h.queues[e.queue || 0] = h.queues[e.queue || 0] || []), h.queues[e.queue || 0].push(e), h
                        );
                    }),
                    (h.queue = function (e, t) {
                        return (
                            typeof e == "function" && (e = { callback: e }),
                            typeof t != "undefined" && (e.queue = t),
                            h.busy() ? h.pushQueue(e) : h.fireQueueItem(e),
                            h
                        );
                    }),
                    (h.clearQueue = function () {
                        return (h.busy.flag = !1), (h.queues = []), h;
                    }),
                    (h.stateChanged = !1),
                    (h.doubleChecker = !1),
                    (h.doubleCheckComplete = function () {
                        return (h.stateChanged = !0), h.doubleCheckClear(), h;
                    }),
                    (h.doubleCheckClear = function () {
                        return h.doubleChecker && (u(h.doubleChecker), (h.doubleChecker = !1)), h;
                    }),
                    (h.doubleCheck = function (e) {
                        return (
                            (h.stateChanged = !1),
                            h.doubleCheckClear(),
                            h.bugs.ieDoubleCheck &&
                                (h.doubleChecker = o(function () {
                                    return h.doubleCheckClear(), h.stateChanged || e(), !0;
                                }, h.options.doubleCheckInterval)),
                            h
                        );
                    }),
                    (h.safariStatePoll = function () {
                        var t = h.extractState(h.getLocationHref()),
                            n;
                        if (!h.isLastSavedState(t))
                            return (n = t), n || (n = h.createStateObject()), h.Adapter.trigger(e, "popstate"), h;
                        return;
                    }),
                    (h.back = function (e) {
                        return e !== !1 && h.busy()
                            ? (h.pushQueue({ scope: h, callback: h.back, args: arguments, queue: e }), !1)
                            : (h.busy(!0),
                              h.doubleCheck(function () {
                                  h.back(!1);
                              }),
                              p.go(-1),
                              !0);
                    }),
                    (h.forward = function (e) {
                        return e !== !1 && h.busy()
                            ? (h.pushQueue({ scope: h, callback: h.forward, args: arguments, queue: e }), !1)
                            : (h.busy(!0),
                              h.doubleCheck(function () {
                                  h.forward(!1);
                              }),
                              p.go(1),
                              !0);
                    }),
                    (h.go = function (e, t) {
                        var n;
                        if (e > 0) for (n = 1; n <= e; ++n) h.forward(t);
                        else {
                            if (!(e < 0))
                                throw new Error(
                                    "History.go: History.go requires a positive or negative integer passed."
                                );
                            for (n = -1; n >= e; --n) h.back(t);
                        }
                        return h;
                    });
                if (h.emulated.pushState) {
                    var v = function () {};
                    (h.pushState = h.pushState || v), (h.replaceState = h.replaceState || v);
                } else
                    (h.onPopState = function (t, n) {
                        var r = !1,
                            i = !1,
                            s,
                            o;
                        return (
                            h.doubleCheckComplete(),
                            (s = h.getHash()),
                            s
                                ? ((o = h.extractState(s || h.getLocationHref(), !0)),
                                  o
                                      ? h.replaceState(o.data, o.title, o.url, !1)
                                      : (h.Adapter.trigger(e, "anchorchange"), h.busy(!1)),
                                  (h.expectedStateId = !1),
                                  !1)
                                : ((r = h.Adapter.extractEventData("state", t, n) || !1),
                                  r
                                      ? (i = h.getStateById(r))
                                      : h.expectedStateId
                                        ? (i = h.getStateById(h.expectedStateId))
                                        : (i = h.extractState(h.getLocationHref())),
                                  i || (i = h.createStateObject(null, null, h.getLocationHref())),
                                  (h.expectedStateId = !1),
                                  h.isLastSavedState(i)
                                      ? (h.busy(!1), !1)
                                      : (h.storeState(i),
                                        h.saveState(i),
                                        h.setTitle(i),
                                        h.Adapter.trigger(e, "statechange"),
                                        h.busy(!1),
                                        !0))
                        );
                    }),
                        h.Adapter.bind(e, "popstate", h.onPopState),
                        (h.pushState = function (t, n, r, i) {
                            if (h.getHashByUrl(r) && h.emulated.pushState)
                                throw new Error(
                                    "History.js does not support states with fragement-identifiers (hashes/anchors)."
                                );
                            if (i !== !1 && h.busy())
                                return h.pushQueue({ scope: h, callback: h.pushState, args: arguments, queue: i }), !1;
                            h.busy(!0);
                            var s = h.createStateObject(t, n, r);
                            return (
                                h.isLastSavedState(s)
                                    ? h.busy(!1)
                                    : (h.storeState(s),
                                      (h.expectedStateId = s.id),
                                      p.pushState(s.id, s.title, s.url),
                                      h.Adapter.trigger(e, "popstate")),
                                !0
                            );
                        }),
                        (h.replaceState = function (t, n, r, i) {
                            if (h.getHashByUrl(r) && h.emulated.pushState)
                                throw new Error(
                                    "History.js does not support states with fragement-identifiers (hashes/anchors)."
                                );
                            if (i !== !1 && h.busy())
                                return (
                                    h.pushQueue({ scope: h, callback: h.replaceState, args: arguments, queue: i }), !1
                                );
                            h.busy(!0);
                            var s = h.createStateObject(t, n, r);
                            return (
                                h.isLastSavedState(s)
                                    ? h.busy(!1)
                                    : (h.storeState(s),
                                      (h.expectedStateId = s.id),
                                      p.replaceState(s.id, s.title, s.url),
                                      h.Adapter.trigger(e, "popstate")),
                                !0
                            );
                        });
                if (s) {
                    try {
                        h.store = l.parse(s.getItem("History.store")) || {};
                    } catch (m) {
                        h.store = {};
                    }
                    h.normalizeStore();
                } else (h.store = {}), h.normalizeStore();
                h.Adapter.bind(e, "unload", h.clearAllIntervals),
                    h.saveState(h.storeState(h.extractState(h.getLocationHref(), !0))),
                    s &&
                        ((h.onUnload = function () {
                            var e, t, n;
                            try {
                                e = l.parse(s.getItem("History.store")) || {};
                            } catch (r) {
                                e = {};
                            }
                            (e.idToState = e.idToState || {}),
                                (e.urlToId = e.urlToId || {}),
                                (e.stateToId = e.stateToId || {});
                            for (t in h.idToState) {
                                if (!h.idToState.hasOwnProperty(t)) continue;
                                e.idToState[t] = h.idToState[t];
                            }
                            for (t in h.urlToId) {
                                if (!h.urlToId.hasOwnProperty(t)) continue;
                                e.urlToId[t] = h.urlToId[t];
                            }
                            for (t in h.stateToId) {
                                if (!h.stateToId.hasOwnProperty(t)) continue;
                                e.stateToId[t] = h.stateToId[t];
                            }
                            (h.store = e), h.normalizeStore(), (n = l.stringify(e));
                            try {
                                s.setItem("History.store", n);
                            } catch (i) {
                                if (i.code !== DOMException.QUOTA_EXCEEDED_ERR) throw i;
                                s.length && (s.removeItem("History.store"), s.setItem("History.store", n));
                            }
                        }),
                        h.intervalList.push(a(h.onUnload, h.options.storeInterval)),
                        h.Adapter.bind(e, "beforeunload", h.onUnload),
                        h.Adapter.bind(e, "unload", h.onUnload));
                if (!h.emulated.pushState) {
                    h.bugs.safariPoll && h.intervalList.push(a(h.safariStatePoll, h.options.safariPollInterval));
                    if (i.vendor === "Apple Computer, Inc." || (i.appCodeName || "") === "Mozilla")
                        h.Adapter.bind(e, "hashchange", function () {
                            h.Adapter.trigger(e, "popstate");
                        }),
                            h.getHash() &&
                                h.Adapter.onDomLoad(function () {
                                    h.Adapter.trigger(e, "hashchange");
                                });
                }
            }),
            (!h.options || !h.options.delayInit) && h.init();
    })(window) /*!

/*!
 * template7.js
 * 
 */,
    !(function (e, t) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = t())
            : "function" == typeof define && define.amd
              ? define(t)
              : (e.Template7 = t());
    })(this, function () {
        "use strict";
        var t7ctx;
        t7ctx = "undefined" != typeof window ? window : "undefined" != typeof global ? global : void 0;
        var Template7Context = t7ctx,
            Template7Utils = {
                quoteSingleRexExp: new RegExp("'", "g"),
                quoteDoubleRexExp: new RegExp('"', "g"),
                isFunction: function (e) {
                    return "function" == typeof e;
                },
                escape: function (e) {
                    return void 0 !== Template7Context && Template7Context.escape
                        ? Template7Context.escape(e)
                        : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                },
                helperToSlices: function (e) {
                    var t,
                        i,
                        r,
                        n = Template7Utils.quoteDoubleRexExp,
                        l = Template7Utils.quoteSingleRexExp,
                        a = e
                            .replace(/[{}#}]/g, "")
                            .trim()
                            .split(" "),
                        s = [];
                    for (i = 0; i < a.length; i += 1) {
                        var o = a[i],
                            p = void 0,
                            c = void 0;
                        if (0 === i) s.push(o);
                        else if (0 === o.indexOf('"') || 0 === o.indexOf("'"))
                            if (
                                ((p = 0 === o.indexOf('"') ? n : l),
                                (c = 0 === o.indexOf('"') ? '"' : "'"),
                                2 === o.match(p).length)
                            )
                                s.push(o);
                            else {
                                for (t = 0, r = i + 1; r < a.length; r += 1)
                                    if (((o += " " + a[r]), a[r].indexOf(c) >= 0)) {
                                        (t = r), s.push(o);
                                        break;
                                    }
                                t && (i = t);
                            }
                        else if (o.indexOf("=") > 0) {
                            var u = o.split("="),
                                f = u[0],
                                m = u[1];
                            if (
                                (p || ((p = 0 === m.indexOf('"') ? n : l), (c = 0 === m.indexOf('"') ? '"' : "'")),
                                2 !== m.match(p).length)
                            ) {
                                for (t = 0, r = i + 1; r < a.length; r += 1)
                                    if (((m += " " + a[r]), a[r].indexOf(c) >= 0)) {
                                        t = r;
                                        break;
                                    }
                                t && (i = t);
                            }
                            var d = [f, m.replace(p, "")];
                            s.push(d);
                        } else s.push(o);
                    }
                    return s;
                },
                stringToBlocks: function (e) {
                    var t,
                        i,
                        r = [];
                    if (!e) return [];
                    var n = e.split(/({{[^{^}]*}})/);
                    for (t = 0; t < n.length; t += 1) {
                        var l = n[t];
                        if ("" !== l)
                            if (l.indexOf("{{") < 0) r.push({ type: "plain", content: l });
                            else {
                                if (l.indexOf("{/") >= 0) continue;
                                if (
                                    (l = l.replace(/{{([#\/])*([ ])*/, "{{$1").replace(/([ ])*}}/, "}}")).indexOf(
                                        "{#"
                                    ) < 0 &&
                                    l.indexOf(" ") < 0 &&
                                    l.indexOf("else") < 0
                                ) {
                                    r.push({ type: "variable", contextName: l.replace(/[{}]/g, "") });
                                    continue;
                                }
                                var a = Template7Utils.helperToSlices(l),
                                    s = a[0],
                                    o = ">" === s,
                                    p = [],
                                    c = {};
                                for (i = 1; i < a.length; i += 1) {
                                    var u = a[i];
                                    Array.isArray(u) ? (c[u[0]] = "false" !== u[1] && u[1]) : p.push(u);
                                }
                                if (l.indexOf("{#") >= 0) {
                                    var f = "",
                                        m = "",
                                        d = 0,
                                        g = void 0,
                                        h = !1,
                                        x = !1,
                                        v = 0;
                                    for (i = t + 1; i < n.length; i += 1)
                                        if (
                                            (n[i].indexOf("{{#") >= 0 && (v += 1),
                                            n[i].indexOf("{{/") >= 0 && (v -= 1),
                                            n[i].indexOf("{{#" + s) >= 0)
                                        )
                                            (f += n[i]), x && (m += n[i]), (d += 1);
                                        else if (n[i].indexOf("{{/" + s) >= 0) {
                                            if (!(d > 0)) {
                                                (g = i), (h = !0);
                                                break;
                                            }
                                            (d -= 1), (f += n[i]), x && (m += n[i]);
                                        } else
                                            n[i].indexOf("else") >= 0 && 0 === v
                                                ? (x = !0)
                                                : (x || (f += n[i]), x && (m += n[i]));
                                    h &&
                                        (g && (t = g),
                                        "raw" === s
                                            ? r.push({ type: "plain", content: f })
                                            : r.push({
                                                  type: "helper",
                                                  helperName: s,
                                                  contextName: p,
                                                  content: f,
                                                  inverseContent: m,
                                                  hash: c,
                                              }));
                                } else
                                    l.indexOf(" ") > 0 &&
                                        (o &&
                                            ((s = "_partial"),
                                            p[0] &&
                                                (0 === p[0].indexOf("[")
                                                    ? (p[0] = p[0].replace(/[[\]]/g, ""))
                                                    : (p[0] = '"' + p[0].replace(/"|'/g, "") + '"'))),
                                        r.push({ type: "helper", helperName: s, contextName: p, hash: c }));
                            }
                    }
                    return r;
                },
                parseJsVariable: function (e, t, i) {
                    return e
                        .split(/([+ \-*\/^])/g)
                        .map(function (e) {
                            if (e.indexOf(t) < 0) return e;
                            if (!i) return JSON.stringify("");
                            var r = i;
                            return (
                                e.indexOf(t + ".") >= 0 &&
                                    e
                                        .split(t + ".")[1]
                                        .split(".")
                                        .forEach(function (e) {
                                            r = e in r ? r[e] : void 0;
                                        }),
                                "string" == typeof r && (r = JSON.stringify(r)),
                                void 0 === r && (r = "undefined"),
                                r
                            );
                        })
                        .join("");
                },
                parseJsParents: function (e, t) {
                    return e
                        .split(/([+ \-*^])/g)
                        .map(function (e) {
                            if (e.indexOf("../") < 0) return e;
                            if (!t || 0 === t.length) return JSON.stringify("");
                            var i = e.split("../").length - 1,
                                r = i > t.length ? t[t.length - 1] : t[i - 1];
                            return (
                                e
                                    .replace(/..\//g, "")
                                    .split(".")
                                    .forEach(function (e) {
                                        r = r[e] ? r[e] : "undefined";
                                    }),
                                JSON.stringify(r)
                            );
                        })
                        .join("");
                },
                getCompileVar: function (e, t, i) {
                    void 0 === i && (i = "data_1");
                    var r,
                        n,
                        l = t,
                        a = 0;
                    0 === e.indexOf("../")
                        ? ((a = e.split("../").length - 1),
                          (n = l.split("_")[1] - a),
                          (l = "ctx_" + (n >= 1 ? n : 1)),
                          (r = e.split("../")[a].split(".")))
                        : 0 === e.indexOf("@global")
                          ? ((l = "Template7.global"), (r = e.split("@global.")[1].split(".")))
                          : 0 === e.indexOf("@root")
                            ? ((l = "root"), (r = e.split("@root.")[1].split(".")))
                            : (r = e.split("."));
                    for (var s = 0; s < r.length; s += 1) {
                        var o = r[s];
                        if (0 === o.indexOf("@")) {
                            var p = i.split("_")[1];
                            a > 0 && (p = n),
                                s > 0
                                    ? (l += "[(data_" + p + " && data_" + p + "." + o.replace("@", "") + ")]")
                                    : (l = "(data_" + p + " && data_" + p + "." + o.replace("@", "") + ")");
                        } else
                            (Number.isFinite ? Number.isFinite(o) : Template7Context.isFinite(o))
                                ? (l += "[" + o + "]")
                                : "this" === o ||
                                    o.indexOf("this.") >= 0 ||
                                    o.indexOf("this[") >= 0 ||
                                    o.indexOf("this(") >= 0
                                  ? (l = o.replace("this", t))
                                  : (l += "." + o);
                    }
                    return l;
                },
                getCompiledArguments: function (e, t, i) {
                    for (var r = [], n = 0; n < e.length; n += 1)
                        /^['"]/.test(e[n])
                            ? r.push(e[n])
                            : /^(true|false|\d+)$/.test(e[n])
                              ? r.push(e[n])
                              : r.push(Template7Utils.getCompileVar(e[n], t, i));
                    return r.join(", ");
                },
            },
            Template7Helpers = {
                _partial: function (e, t) {
                    var i = this,
                        r = Template7Class.partials[e];
                    return !r || (r && !r.template)
                        ? ""
                        : (r.compiled || (r.compiled = new Template7Class(r.template).compile()),
                          Object.keys(t.hash).forEach(function (e) {
                              i[e] = t.hash[e];
                          }),
                          r.compiled(i, t.data, t.root));
                },
                escape: function (e) {
                    if ("string" != typeof e)
                        throw new Error('Template7: Passed context to "escape" helper should be a string');
                    return Template7Utils.escape(e);
                },
                if: function (e, t) {
                    var i = e;
                    return (
                        Template7Utils.isFunction(i) && (i = i.call(this)),
                        i ? t.fn(this, t.data) : t.inverse(this, t.data)
                    );
                },
                unless: function (e, t) {
                    var i = e;
                    return (
                        Template7Utils.isFunction(i) && (i = i.call(this)),
                        i ? t.inverse(this, t.data) : t.fn(this, t.data)
                    );
                },
                each: function (e, t) {
                    var i = e,
                        r = "",
                        n = 0;
                    if ((Template7Utils.isFunction(i) && (i = i.call(this)), Array.isArray(i))) {
                        for (t.hash.reverse && (i = i.reverse()), n = 0; n < i.length; n += 1)
                            r += t.fn(i[n], { first: 0 === n, last: n === i.length - 1, index: n });
                        t.hash.reverse && (i = i.reverse());
                    } else for (var l in i) (n += 1), (r += t.fn(i[l], { key: l }));
                    return n > 0 ? r : t.inverse(this);
                },
                with: function (e, t) {
                    var i = e;
                    return Template7Utils.isFunction(i) && (i = e.call(this)), t.fn(i);
                },
                join: function (e, t) {
                    var i = e;
                    return (
                        Template7Utils.isFunction(i) && (i = i.call(this)), i.join(t.hash.delimiter || t.hash.delimeter)
                    );
                },
                js: function js(expression, options) {
                    var data = options.data,
                        func,
                        execute = expression;
                    return (
                        "index first last key".split(" ").forEach(function (e) {
                            if (void 0 !== data[e]) {
                                var t = new RegExp("this.@" + e, "g"),
                                    i = new RegExp("@" + e, "g");
                                execute = execute
                                    .replace(t, JSON.stringify(data[e]))
                                    .replace(i, JSON.stringify(data[e]));
                            }
                        }),
                        options.root &&
                            execute.indexOf("@root") >= 0 &&
                            (execute = Template7Utils.parseJsVariable(execute, "@root", options.root)),
                        execute.indexOf("@global") >= 0 &&
                            (execute = Template7Utils.parseJsVariable(
                                execute,
                                "@global",
                                Template7Context.Template7.global
                            )),
                        execute.indexOf("../") >= 0 &&
                            (execute = Template7Utils.parseJsParents(execute, options.parents)),
                        (func =
                            execute.indexOf("return") >= 0
                                ? "(function(){" + execute + "})"
                                : "(function(){return (" + execute + ")})"),
                        eval(func).call(this)
                    );
                },
                js_if: function js_if(expression, options) {
                    var data = options.data,
                        func,
                        execute = expression;
                    "index first last key".split(" ").forEach(function (e) {
                        if (void 0 !== data[e]) {
                            var t = new RegExp("this.@" + e, "g"),
                                i = new RegExp("@" + e, "g");
                            execute = execute.replace(t, JSON.stringify(data[e])).replace(i, JSON.stringify(data[e]));
                        }
                    }),
                        options.root &&
                            execute.indexOf("@root") >= 0 &&
                            (execute = Template7Utils.parseJsVariable(execute, "@root", options.root)),
                        execute.indexOf("@global") >= 0 &&
                            (execute = Template7Utils.parseJsVariable(
                                execute,
                                "@global",
                                Template7Context.Template7.global
                            )),
                        execute.indexOf("../") >= 0 &&
                            (execute = Template7Utils.parseJsParents(execute, options.parents)),
                        (func =
                            execute.indexOf("return") >= 0
                                ? "(function(){" + execute + "})"
                                : "(function(){return (" + execute + ")})");
                    var condition = eval(func).call(this);
                    return condition ? options.fn(this, options.data) : options.inverse(this, options.data);
                },
            };
        Template7Helpers.js_compare = Template7Helpers.js_if;
        var Template7Options = {},
            Template7Partials = {},
            Template7Class = function (e) {
                this.template = e;
            },
            staticAccessors = {
                options: { configurable: !0 },
                partials: { configurable: !0 },
                helpers: { configurable: !0 },
            };
        function Template7() {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i = e[0],
                r = e[1];
            if (2 === e.length) {
                var n = new Template7Class(i),
                    l = n.compile()(r);
                return (n = null), l;
            }
            return new Template7Class(i);
        }
        return (
            (Template7Class.prototype.compile = function compile(template, depth) {
                void 0 === template && (template = this.template), void 0 === depth && (depth = 1);
                var t = this;
                if (t.compiled) return t.compiled;
                if ("string" != typeof template) throw new Error("Template7: Template must be a string");
                var stringToBlocks = Template7Utils.stringToBlocks,
                    getCompileVar = Template7Utils.getCompileVar,
                    getCompiledArguments = Template7Utils.getCompiledArguments,
                    blocks = stringToBlocks(template),
                    ctx = "ctx_" + depth,
                    data = "data_" + depth;
                if (0 === blocks.length)
                    return function () {
                        return "";
                    };
                function getCompileFn(e, i) {
                    return e.content
                        ? t.compile(e.content, i)
                        : function () {
                              return "";
                          };
                }
                function getCompileInverse(e, i) {
                    return e.inverseContent
                        ? t.compile(e.inverseContent, i)
                        : function () {
                              return "";
                          };
                }
                var resultString = "",
                    i;
                for (
                    resultString +=
                        1 === depth
                            ? "(function (" + ctx + ", " + data + ", root) {\n"
                            : "(function (" + ctx + ", " + data + ") {\n",
                        1 === depth &&
                            ((resultString += "function isArray(arr){return Array.isArray(arr);}\n"),
                            (resultString += "function isFunction(func){return (typeof func === 'function');}\n"),
                            (resultString +=
                                'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n'),
                            (resultString += "root = root || ctx_1 || {};\n")),
                        resultString += "var r = '';\n",
                        i = 0;
                    i < blocks.length;
                    i += 1
                ) {
                    var block = blocks[i];
                    if ("plain" !== block.type) {
                        var variable = void 0,
                            compiledArguments = void 0;
                        if (
                            ("variable" === block.type &&
                                ((variable = getCompileVar(block.contextName, ctx, data)),
                                (resultString += "r += c(" + variable + ", " + ctx + ");")),
                            "helper" === block.type)
                        ) {
                            var parents = void 0;
                            if ("ctx_1" !== ctx) {
                                for (
                                    var level = ctx.split("_")[1], parentsString = "ctx_" + (level - 1), j = level - 2;
                                    j >= 1;
                                    j -= 1
                                )
                                    parentsString += ", ctx_" + j;
                                parents = "[" + parentsString + "]";
                            } else parents = "[" + ctx + "]";
                            var dynamicHelper = void 0;
                            if (
                                (0 === block.helperName.indexOf("[") &&
                                    ((block.helperName = getCompileVar(
                                        block.helperName.replace(/[[\]]/g, ""),
                                        ctx,
                                        data
                                    )),
                                    (dynamicHelper = !0)),
                                dynamicHelper || block.helperName in Template7Helpers)
                            )
                                (compiledArguments = getCompiledArguments(block.contextName, ctx, data)),
                                    (resultString +=
                                        "r += (Template7Helpers" +
                                        (dynamicHelper ? "[" + block.helperName + "]" : "." + block.helperName) +
                                        ").call(" +
                                        ctx +
                                        ", " +
                                        (compiledArguments && compiledArguments + ", ") +
                                        "{hash:" +
                                        JSON.stringify(block.hash) +
                                        ", data: " +
                                        data +
                                        " || {}, fn: " +
                                        getCompileFn(block, depth + 1) +
                                        ", inverse: " +
                                        getCompileInverse(block, depth + 1) +
                                        ", root: root, parents: " +
                                        parents +
                                        "});");
                            else {
                                if (block.contextName.length > 0)
                                    throw new Error('Template7: Missing helper: "' + block.helperName + '"');
                                (variable = getCompileVar(block.helperName, ctx, data)),
                                    (resultString += "if (" + variable + ") {"),
                                    (resultString += "if (isArray(" + variable + ")) {"),
                                    (resultString +=
                                        "r += (Template7Helpers.each).call(" +
                                        ctx +
                                        ", " +
                                        variable +
                                        ", {hash:" +
                                        JSON.stringify(block.hash) +
                                        ", data: " +
                                        data +
                                        " || {}, fn: " +
                                        getCompileFn(block, depth + 1) +
                                        ", inverse: " +
                                        getCompileInverse(block, depth + 1) +
                                        ", root: root, parents: " +
                                        parents +
                                        "});"),
                                    (resultString += "}else {"),
                                    (resultString +=
                                        "r += (Template7Helpers.with).call(" +
                                        ctx +
                                        ", " +
                                        variable +
                                        ", {hash:" +
                                        JSON.stringify(block.hash) +
                                        ", data: " +
                                        data +
                                        " || {}, fn: " +
                                        getCompileFn(block, depth + 1) +
                                        ", inverse: " +
                                        getCompileInverse(block, depth + 1) +
                                        ", root: root, parents: " +
                                        parents +
                                        "});"),
                                    (resultString += "}}");
                            }
                        }
                    } else
                        resultString +=
                            "r +='" +
                            block.content.replace(/\r/g, "\\r").replace(/\n/g, "\\n").replace(/'/g, "\\'") +
                            "';";
                }
                return (
                    (resultString += "\nreturn r;})"),
                    1 === depth ? ((t.compiled = eval(resultString)), t.compiled) : resultString
                );
            }),
            (staticAccessors.options.get = function () {
                return Template7Options;
            }),
            (staticAccessors.partials.get = function () {
                return Template7Partials;
            }),
            (staticAccessors.helpers.get = function () {
                return Template7Helpers;
            }),
            Object.defineProperties(Template7Class, staticAccessors),
            (Template7.registerHelper = function (e, t) {
                Template7Class.helpers[e] = t;
            }),
            (Template7.unregisterHelper = function (e) {
                (Template7Class.helpers[e] = void 0), delete Template7Class.helpers[e];
            }),
            (Template7.registerPartial = function (e, t) {
                Template7Class.partials[e] = { template: t };
            }),
            (Template7.unregisterPartial = function (e) {
                Template7Class.partials[e] &&
                    ((Template7Class.partials[e] = void 0), delete Template7Class.partials[e]);
            }),
            (Template7.compile = function (e, t) {
                return new Template7Class(e, t).compile();
            }),
            (Template7.options = Template7Class.options),
            (Template7.helpers = Template7Class.helpers),
            (Template7.partials = Template7Class.partials),
            Template7
        );
    }) /*!

/*!
 * Search bar
 * 
 */,
    !(function (e) {
        function t(t) {
            (this.headerSearch = e(t)),
                (this.headerSearchForm = this.headerSearch.find(".header-search__form")),
                (this.headerInput = this.headerSearch.find(".header-search__input")),
                (this.headerSearchResults = this.headerSearch.find(".header-search__results-wrapper")),
                (this.searchResultsTemplate = Template7.compile(e("#search-results-template").html())),
                (this.PopularProducts = this.headerSearch.find(".header-search__product")),
                (this.searchMode = "product"),
                (this.searchTrending = e(".quickSearchResultsWrap .header-search__trending .item-tag")),
                (this.trending = e(".header-search__trending")),
                (this.searchWrapper = this.headerSearch.find(".quickSearchResultsWrap")),
                this.headerInput.focus(function (t) {
                    t.stopPropagation(),
                        e(this).closest(".header-search").find(".quickSearchResultsWrap").show(),
                        e(".highlight").on("click", function (t) {
                            t.preventDefault();
                            var r = e(t.target).attr("href");
                            window.location.href = r;
                        });
                }),
                e(document).mouseup(function (t) {
                    var r = e(".search-form");
                    r.is(t.target) || 0 !== r.has(t.target).length || r.find(".quickSearchResultsWrap").hide();
                }),
                this.headerInput.on("focusin", e.proxy(this._focusin, this)),
                this.headerInput.on("keyup", e.proxy(this._initSearch, this));
        }
        (t.prototype._initSearch = function (t) {
            var r = e(t.target);
            13 != (t.keyCode ? t.keyCode : t.which) &&
                (clearTimeout(r.data("timeout")), r.data("timeout", setTimeout(e.proxy(this._doSearch, this), 250)));
        }),
            (t.prototype._doSearch = function (e) {
                if ("" === this.headerInput.val().trim())
                    return (
                        this.headerSearchResults.empty(),
                        this.searchTrending.show(),
                        this.PopularProducts.show(),
                        this.searchWrapper.show(),
                        void this.trending.show()
                    );
                this.headerSearchResults.html(this.searchResultsTemplate({ is_loading: !0 })),
                    this.headerInput.val().length > 2
                        ? (this.searchWrapper.hide(), this._doCompleteSearch())
                        : (this.headerSearchResults.html(this.searchResultsTemplate({ is_show: !1 })),
                          this.searchTrending.show(),
                          this.PopularProducts.show(),
                          this.searchWrapper.show()),
                    "none" == this.searchTrending.css("display") ? this.trending.hide() : this.trending.show();
            }),
            (t.prototype._doCompleteSearch = function (t) {
                var r = this;
                e.ajax({
                    method: "GET",
                    url: window.router + "/search?view=json",
                    dataType: "json",
                    data: { q: this.headerInput.val() + "*", type: this.searchMode },
                }).then(function (t) {
                    r.headerSearchResults.html(
                        r.searchResultsTemplate({
                            is_show: !0,
                            is_loading: !1,
                            results: t.results.map(function (item) {
                                return {
                                    ...item,
                                    url: item.url.split("?")[0]
                                };
                            }),
                            has_results: t.results.length > 0,
                            results_count: t.results_count,
                            results_label: t.results_label,
                            results_url: t.url + "&type=" + r.searchMode,
                        })
                    ),
                        r.PopularProducts.hide();
                    var h = r.headerInput.val().toLowerCase();
                    t && t.length
                        ? (r.searchTrending.filter(function (t) {
                              e(this).toggle(e(this).find(".highlight span").text().toLowerCase().indexOf(h) > -1);
                          }),
                          r.trending.show())
                        : r.trending.hide(),
                        r.searchWrapper.show(),
                        ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) ||
                            window.show_auto_currency) &&
                            Currency.convertAll(
                                window.shop_currency,
                                $("#currencies .active").attr("data-currency"),
                                "span.money",
                                "money_format"
                            );
                });
            }),
            (e.fn.Search = function (r) {
                var h = !1,
                    s = arguments;
                return (
                    "string" == typeof r && (h = r),
                    this.each(function () {
                        var a = e.data(this, "plugin_Search");
                        a || h
                            ? h && callMethod(a, h, Array.prototype.slice.call(s, 1))
                            : e.data(this, "plugin_Search", new t(this, r));
                    })
                );
            }),
            e("[data-ajax-search]").Search();
    })(jQuery) /*!

/*
 * tmpl JS
 */,
    (function (a) {
        var r = a.fn.domManip,
            d = "_tmplitem",
            q = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,
            b = {},
            f = {},
            e,
            p = { key: 0, data: {} },
            h = 0,
            c = 0,
            l = [];
        function g(e, d, g, i) {
            var c = {
                data: i || (d ? d.data : {}),
                _wrap: d ? d._wrap : null,
                tmpl: null,
                parent: d || null,
                nodes: [],
                calls: u,
                nest: w,
                wrap: x,
                html: v,
                update: t,
            };
            e && a.extend(c, e, { nodes: [], parent: d });
            if (g) {
                c.tmpl = g;
                c._ctnt = c._ctnt || c.tmpl(a, c);
                c.key = ++h;
                (l.length ? f : b)[h] = c;
            }
            return c;
        }
        a.each(
            {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
            },
            function (f, d) {
                a.fn[f] = function (n) {
                    var g = [],
                        i = a(n),
                        k,
                        h,
                        m,
                        l,
                        j = this.length === 1 && this[0].parentNode;
                    e = b || {};
                    if (j && j.nodeType === 11 && j.childNodes.length === 1 && i.length === 1) {
                        i[d](this[0]);
                        g = this;
                    } else {
                        for (h = 0, m = i.length; h < m; h++) {
                            c = h;
                            k = (h > 0 ? this.clone(true) : this).get();
                            a.fn[d].apply(a(i[h]), k);
                            g = g.concat(k);
                        }
                        c = 0;
                        g = this.pushStack(g, f, i.selector);
                    }
                    l = e;
                    e = null;
                    a.tmpl.complete(l);
                    return g;
                };
            }
        );
        a.fn.extend({
            tmpl: function (d, c, b) {
                return a.tmpl(this[0], d, c, b);
            },
            tmplItem: function () {
                return a.tmplItem(this[0]);
            },
            template: function (b) {
                return a.template(b, this[0]);
            },
            domManip: function (d, l, j) {
                if (d[0] && d[0].nodeType) {
                    var f = a.makeArray(arguments),
                        g = d.length,
                        i = 0,
                        h;
                    while (i < g && !(h = a.data(d[i++], "tmplItem")));
                    if (g > 1) f[0] = [a.makeArray(d)];
                    if (h && c)
                        f[2] = function (b) {
                            a.tmpl.afterManip(this, b, j);
                        };
                    r.apply(this, f);
                } else r.apply(this, arguments);
                c = 0;
                !e && a.tmpl.complete(b);
                return this;
            },
        });
        a.extend({
            tmpl: function (d, h, e, c) {
                var j,
                    k = !c;
                if (k) {
                    c = p;
                    d = a.template[d] || a.template(null, d);
                    f = {};
                } else if (!d) {
                    d = c.tmpl;
                    b[c.key] = c;
                    c.nodes = [];
                    c.wrapped && n(c, c.wrapped);
                    return a(i(c, null, c.tmpl(a, c)));
                }
                if (!d) return [];
                if (typeof h === "function") h = h.call(c || {});
                e && e.wrapped && n(e, e.wrapped);
                j = a.isArray(h)
                    ? a.map(h, function (a) {
                          return a ? g(e, c, d, a) : null;
                      })
                    : [g(e, c, d, h)];
                return k ? a(i(c, null, j)) : j;
            },
            tmplItem: function (b) {
                var c;
                if (b instanceof a) b = b[0];
                while (b && b.nodeType === 1 && !(c = a.data(b, "tmplItem")) && (b = b.parentNode));
                return c || p;
            },
            template: function (c, b) {
                if (b) {
                    if (typeof b === "string") b = o(b);
                    else if (b instanceof a) b = b[0] || {};
                    if (b.nodeType) b = a.data(b, "tmpl") || a.data(b, "tmpl", o(b.innerHTML));
                    return typeof c === "string" ? (a.template[c] = b) : b;
                }
                return c
                    ? typeof c !== "string"
                        ? a.template(null, c)
                        : a.template[c] || a.template(null, q.test(c) ? c : a(c))
                    : null;
            },
            encode: function (a) {
                return ("" + a)
                    .split("<")
                    .join("&lt;")
                    .split(">")
                    .join("&gt;")
                    .split('"')
                    .join("&#34;")
                    .split("'")
                    .join("&#39;");
            },
        });
        a.extend(a.tmpl, {
            tag: {
                tmpl: { _default: { $2: "null" }, open: "if($notnull_1){_=_.concat($item.nest($1,$2));}" },
                wrap: {
                    _default: { $2: "null" },
                    open: "$item.calls(_,$1,$2);_=[];",
                    close: "call=$item.calls();_=call._.concat($item.wrap(call,_));",
                },
                each: {
                    _default: { $2: "$index, $value" },
                    open: "if($notnull_1){$.each($1a,function($2){with(this){",
                    close: "}});}",
                },
                if: { open: "if(($notnull_1) && $1a){", close: "}" },
                else: { _default: { $1: "true" }, open: "}else if(($notnull_1) && $1a){" },
                html: { open: "if($notnull_1){_.push($1a);}" },
                "=": { _default: { $1: "$data" }, open: "if($notnull_1){_.push($.encode($1a));}" },
                "!": { open: "" },
            },
            complete: function () {
                b = {};
            },
            afterManip: function (f, b, d) {
                var e = b.nodeType === 11 ? a.makeArray(b.childNodes) : b.nodeType === 1 ? [b] : [];
                d.call(f, b);
                m(e);
                c++;
            },
        });
        function i(e, g, f) {
            var b,
                c = f
                    ? a.map(f, function (a) {
                          return typeof a === "string"
                              ? e.key
                                  ? a.replace(
                                        /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g,
                                        "$1 " + d + '="' + e.key + '" $2'
                                    )
                                  : a
                              : i(a, e, a._ctnt);
                      })
                    : e;
            if (g) return c;
            c = c.join("");
            c.replace(/^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/, function (f, c, e, d) {
                b = a(e).get();
                m(b);
                if (c) b = j(c).concat(b);
                if (d) b = b.concat(j(d));
            });
            return b ? b : j(c);
        }
        function j(c) {
            var b = document.createElement("div");
            b.innerHTML = c;
            return a.makeArray(b.childNodes);
        }
        function o(b) {
            return new Function(
                "jQuery",
                "$item",
                "var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('" +
                    a
                        .trim(b)
                        .replace(/([\\'])/g, "\\$1")
                        .replace(/[\r\t\n]/g, " ")
                        .replace(/\$\{([^\}]*)\}/g, "{{= $1}}")
                        .replace(
                            /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
                            function (m, l, j, d, b, c, e) {
                                var i = a.tmpl.tag[j],
                                    h,
                                    f,
                                    g;
                                if (!i) throw "Template command not found: " + j;
                                h = i._default || [];
                                if (c && !/\w$/.test(b)) {
                                    b += c;
                                    c = "";
                                }
                                if (b) {
                                    b = k(b);
                                    e = e ? "," + k(e) + ")" : c ? ")" : "";
                                    f = c ? (b.indexOf(".") > -1 ? b + c : "(" + b + ").call($item" + e) : b;
                                    g = c ? f : "(typeof(" + b + ")==='function'?(" + b + ").call($item):(" + b + "))";
                                } else g = f = h.$1 || "null";
                                d = k(d);
                                return (
                                    "');" +
                                    i[l ? "close" : "open"]
                                        .split("$notnull_1")
                                        .join(b ? "typeof(" + b + ")!=='undefined' && (" + b + ")!=null" : "true")
                                        .split("$1a")
                                        .join(g)
                                        .split("$1")
                                        .join(f)
                                        .split("$2")
                                        .join(
                                            d
                                                ? d.replace(/\s*([^\(]+)\s*(\((.*?)\))?/g, function (d, c, b, a) {
                                                      a = a ? "," + a + ")" : b ? ")" : "";
                                                      return a ? "(" + c + ").call($item" + a : d;
                                                  })
                                                : h.$2 || ""
                                        ) +
                                    "_.push('"
                                );
                            }
                        ) +
                    "');}return _;"
            );
        }
        function n(c, b) {
            c._wrap = i(c, true, a.isArray(b) ? b : [q.test(b) ? b : a(b).html()]).join("");
        }
        function k(a) {
            return a ? a.replace(/\\'/g, "'").replace(/\\\\/g, "\\") : null;
        }
        function s(b) {
            var a = document.createElement("div");
            a.appendChild(b.cloneNode(true));
            return a.innerHTML;
        }
        function m(o) {
            var n = "_" + c,
                k,
                j,
                l = {},
                e,
                p,
                i;
            for (e = 0, p = o.length; e < p; e++) {
                if ((k = o[e]).nodeType !== 1) continue;
                j = k.getElementsByTagName("*");
                for (i = j.length - 1; i >= 0; i--) m(j[i]);
                m(k);
            }
            function m(j) {
                var p,
                    i = j,
                    k,
                    e,
                    m;
                if ((m = j.getAttribute(d))) {
                    while (i.parentNode && (i = i.parentNode).nodeType === 1 && !(p = i.getAttribute(d)));
                    if (p !== m) {
                        i = i.parentNode ? (i.nodeType === 11 ? 0 : i.getAttribute(d) || 0) : 0;
                        if (!(e = b[m])) {
                            e = f[m];
                            e = g(e, b[i] || f[i], null, true);
                            e.key = ++h;
                            b[h] = e;
                        }
                        c && o(m);
                    }
                    j.removeAttribute(d);
                } else if (c && (e = a.data(j, "tmplItem"))) {
                    o(e.key);
                    b[e.key] = e;
                    i = a.data(j.parentNode, "tmplItem");
                    i = i ? i.key : 0;
                }
                if (e) {
                    k = e;
                    while (k && k.key != i) {
                        k.nodes.push(j);
                        k = k.parent;
                    }
                    delete e._ctnt;
                    delete e._wrap;
                    a.data(j, "tmplItem", e);
                }
                function o(a) {
                    a = a + n;
                    e = l[a] = l[a] || g(e, b[e.parent.key + n] || e.parent, null, true);
                }
            }
        }
        function u(a, d, c, b) {
            if (!a) return l.pop();
            l.push({ _: a, tmpl: d, item: this, data: c, options: b });
        }
        function w(d, c, b) {
            return a.tmpl(a.template(d), c, b, this);
        }
        function x(b, d) {
            var c = b.options || {};
            c.wrapped = d;
            return a.tmpl(a.template(b.tmpl), b.data, c, b.item);
        }
        function v(d, c) {
            var b = this._wrap;
            return a.map(a(a.isArray(b) ? b.join("") : b).filter(d || "*"), function (a) {
                return c ? a.innerText || a.textContent : a.outerHTML || s(a);
            });
        }
        function t() {
            var b = this.nodes;
            a.tmpl(null, null, null, this).insertBefore(b[0]);
            a(b).remove();
        }
    })(jQuery);
